//include('../../index.api.js');
//$log.log('..................../////////////////////// ');
//$log.log(rangeProvider);
//console.log(api.Url);
(function () {
    'use strict';

    angular
        .module('app.dashboard',
            [
                // 3rd Party Dependencies
                'datatables',
                'flow',
                'nvd3',
                'textAngular',
                'uiGmapgoogle-maps',
                'xeditable',
                'chart.js'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
        // List of Apis used by each widget
        var apiList = {
            cardData: 'dashboard.cardData',
            get_summary: 'dashboard.get_summary',
            get_sales_summary: 'dashboard.get_sales_summary',
            get_coverage_summury: 'dashboard.get_coverage_summury',
            get_outlet_summary: 'dashboard.get_outlet_summary',
            get_users_summary: 'dashboard.get_users_summary',
            get_top5skus: 'dashboard.get_top5skus',
            get_sales_by_retailer_class: 'dashboard.get_sales_by_retailer_class',
            get_sales_by_retailer_list: 'dashboard.get_sales_by_retailer_list',
            get_sales_by_retailer_type: 'dashboard.get_sales_by_retailer_type',
            get_skuIds_of_range: 'dashboard.get_skuIds_of_range',
            get_focus_products_sales: 'dashboard.get_focus_products_sales',
            get_skuId_product_list: 'dashboard.get_skuId_product_list',
            get_product_placement_for_range: 'dashboard.get_product_placement_for_range',
            focusProductSales: 'dashboard.focusProductSales',
            productPlacement: 'dashboard.productPlacement',
            get_team: 'dashboard.get_team',
            get_zone: 'dashboard.get_zone',
            get_users: 'dashboard.get_users',
            get_res_partner_types: 'dashboard.get_res_partner_types',
            get_mss_sales: 'dashboard.get_mss_sales',
            get_zero_sales_report: 'dashboard.get_zero_sales_report',
            get_new_outlet_report: 'dashboard.get_new_outlet_report',
            get_sku_dispersion_report: 'dashboard.get_sku_dispersion_report',
            get_revenue_dispersion_report: 'dashboard.get_revenue_dispersion_report',
            get_beat: 'dashboard.get_beat',
            coverage_and_productivity: 'dashboard.coverage_and_productivity',
            mss_sales_by_outlet: 'dashboard.mss_sales_by_outlet',
            get_distributor_by_name: 'dashboard.get_distributor_by_name',
            get_distributor_by_code: 'dashboard.get_distributor_by_code',
            get_partner_by_name: 'dashboard.get_partner_by_name',
            get_emp_code: 'dashboard.get_emp_code',
            salesman_productivity_measures: 'dashboard.salesman_productivity_measures',
            no_sales_consecutive_visits: 'dashboard.no_sales_consecutive_visits',
            sales_by_customer_type: 'dashboard.sales_by_customer_type',
            outletwise_sales: 'dashboard.outletwise_sales',
            sr_score_card: 'dashboard.sr_score_card',
            weekly_sales_report: 'dashboard.weekly_sales_report',
            get_zero_sales_report_graph1: "dashboard.get_zero_sales_report_graph1",
            get_zero_sales_report_graph2: "dashboard.get_zero_sales_report_graph2",
            coverage_and_productivity_graph: "dashboard.coverage_and_productivity_graph",
            sales_by_customer_type_graph: "dashboard.sales_by_customer_type_graph",
            get_product_brand: "dashboard.get_product_brand",
            get_product_category: "dashboard.get_product_category",
            no_sales_visits_outlet_graph: "dashboard.no_sales_visits_outlet_graph",
            get_new_outlet_by_zone_graph: "dashboard.get_new_outlet_by_zone_graph",
            get_new_outlet_by_retailer_type_graph: "dashboard.get_new_outlet_by_retailer_type_graph",
            get_new_outlet_zero_sales_graph:"dashboard.get_new_outlet_zero_sales_graph",
            no_sales_visits_zone_graph: "dashboard.no_sales_visits_zone_graph"
        };


        // LOCAL Environment
        // List of States for which API routes must be generated
        //var statesDbList = [ 'nrrska', 'nrrsap', 'nrrstn' ];


        //  State List
        var stateList = [
            {
                "key": "nrrne",
                "port": "4001",
                "name": "North East"
            },
            {
                "key": "nrror",
                "port": "4002",
                "name": "Odhisa"
            },
            {
                "key": "nrrka",
                "port": "4004",
                "name": "Karnataka"
            },
            {
                "key": "nrrkl",
                "port": "4005",
                "name": "Kerala"
            },
            {
                "key": "nrrtn",
                "port": "4006",
                "name": "Tamil Nadu"
            },
            {
                "key": "nrrap",

                "port": "4007",
                "name": "Andhra Pradesh"
            },
            {
                "key": "nrrmb",
                "port": "4008",
                "name": "Mumbai"
            },
            {
                "key": "nrrmh",
                "port": "4009",
                "name": "Maharashtra"
            },
            {
                "key": "nrrgj",
                "port": "4010",
                "name": "Gujarat"
            },
            {
                "key": "nrrwb",
                "port": "4011",
                "name": "West Bengal"
            },
            {
                "key": "nrrdl",
                "port": "4012",
                "name": "Delhi"
            },
            {
                "key": "nrrbr",
                "port": "4013",
                "name": "Bihar"
            },
            {
                "key": "nrrup",
                "port": "4014",
                "name": "Uttar Pradesh"
            },
            {
                "key": "nrrrj",
                "port": "4016",
                "name": "Rajasthan"
            },
            {
                "key": "nrrpb",
                "port": "4017",
                "name": "Punjab"
            },
            {
                "key": "nrrmp",
                "port": "4018",
                "name": "Madhya Pradesh"
            }
        ];


        var API_URL = 'salesdiary.in:';// Production Server
        // var API_URL = '192.168.0.103:'
        // Function to build the list of Api routes for a specific state based on the apiList
        // by appending '.stateId' to the value of each route in apiList
        function buildApiList(stateId) {
            var apiListForCurrentState = {};
            angular.forEach(apiList, function (value, key) {
                apiListForCurrentState[key] = value // Development
                var URL = 'https://'  + stateId['key'] + '.' + API_URL + stateId['port'] + '/api/sale_reports/' + key; // Live URL
                // var URL = 'https://' + stateId['key'] + '.' + API_URL + stateId['port'] + '/api/res_zones/' + key; // Live URL
                // var URL = API_URL + 'api/res_zones/' + key; // Local
                msApiProvider.register(value, [URL, {},
                    {
                        post: {
                            method: 'POST'
                        }
                    }
                ]);
                //  console.log(apiListForCurrentState[key]);
            });
            // alert(apiListForCurrentState);
            return apiListForCurrentState;

        }


        /* For Local Server */

        /*

         // Function to build the list of Api routes for a specific state based on the apiList
         // by appending '.stateId' to the value of each route in apiList
         var API_URL = 'http://0.0.0.0:5001/'; // Local Development Server
         function buildApiList(stateId) {
         var apiListForCurrentState = {};
         angular.forEach(apiList, function (value, key) {
         // apiListForCurrentState[key] = value + '.' + stateId; // Production
         apiListForCurrentState[key] = value // Development
         console.log(apiListForCurrentState[key]);
         });
         // alert(apiListForCurrentState);
         return apiListForCurrentState;

         }

         // Local URL Builder

         angular.forEach(stateList, function (stateId) {
         angular.forEach(apiList, function (routeApiValue, routeNameKey) {
         //   alert(routeNameKey);
         var URL = API_URL + 'api/res_zones/' + routeNameKey;
         //$log.log("////////////////////////////////");
         //$log.log(URL);
         // alert(routeApiValue);
         msApiProvider.register(routeApiValue, [URL, {},
         {
         post: {
         method: 'POST'
         }
         }
         ]); // Development
         });
         });


         */

        // $stateProvider for Dashboard
        $stateProvider
            .state('app.dashboard', {
                abstract: true,
                url: '/dashboard'
            })


        // Translation
        $translatePartialLoaderProvider.addPart('app/main/dashboard');


        // Navigation for Dashboard
        msNavigationServiceProvider.saveItem('dashboard', {
            title: 'Dashboard',
            icon: 'icon-view-dashboard',
            state: 'app.dashboard.dashboard-nrrup',
            weight: 2
        });

        // Function to build Navigation and $stateProvider for each State
        angular.forEach(stateList, function (stateId) {
            var name = stateId['name'];
            var tabUrl = '/dashboard-' + stateId['key'];
            var appState = 'app.dashboard.dashboard-' + stateId['key'];
            $stateProvider
                .state(appState, {
                    url: tabUrl,
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/dashboard/views/dashboard/dashboard.html',
                            controller: 'DashboardController as vm'
                        }
                    },
                    resolve: {
                        Api: function () {
                            return buildApiList(stateId);
                        }
                    },
                    bodyClass: 'dashboard'
                })
            msNavigationServiceProvider.saveItem('dashboard.dashboard-' + stateId['key'], {
                title: name,
                icon: stateId['icon'],
                state: 'app.dashboard.dashboard-' + stateId['key']
            });
        });

    }
})();

(function () {
    'use strict';

    angular
        .module('app.dashboard')
        .controller('DashboardController', DashboardController);

    /** @ngInject */
    function DashboardController(Api, msApi, $scope, $log, $cookies, $state, $filter,share) {
        var username = $cookies.get('username');
        if (username) {
            var vm = this;

            /*vm.end_date= new Date($filter('date')(new Date(),'yyyy-MM-dd'));
             vm.start_date= new Date(vm.end_date);
             vm.start_date.setMonth(vm.start_date.getMonth()-1);*/

            var date = new Date();
            vm.start_date = new Date($filter('date')(new Date(date.getFullYear(), date.getMonth() - 1, 1), 'yyyy-MM-dd'));
            vm.end_date = new Date($filter('date')(new Date(date.getFullYear(), date.getMonth(), 0), 'yyyy-MM-dd'));

            /* var date = new Date();
             vm.start_date = new Date(date.getFullYear(), date.getMonth(), 1);
             vm.end_date = new Date(date.getFullYear(), date.getMonth() + 1, 0);*/

            // Function to convert a Number to Indian Currency format as a String
            function formatCurrency(value) {
                if (angular.isNumber(value) === 'number') {
                    value = Math.round(value);
                }
                var valueStr = String(value);
                var formattedValueStr = '';
                if (valueStr.length > 3) {
                    formattedValueStr = valueStr.slice(valueStr.length - 3, valueStr.length);
                    valueStr = valueStr.substr(0, valueStr.length - 3);
                    while (valueStr.length > 2) {
                        formattedValueStr = valueStr.slice(valueStr.length - 2, valueStr.length) + ',' + formattedValueStr;
                        valueStr = valueStr.substr(0, valueStr.length - 2);
                    }
                    if (valueStr.length > 0) {
                        formattedValueStr = valueStr + ',' + formattedValueStr;
                    }
                }
                else {
                    formattedValueStr = valueStr;
                }
                return formattedValueStr;
            }


            vm.DateFilter = {
                ranges: {
                    TD: "Today",
                    WK: "Week",
                    TM: "This Month",
                    LM: "Last Month",
                    "2M": "2 Months Ago",
                    "3M": "3 Months Ago"
                },

                currentRange: "TM",

                loadData: function (rangeIdToLoad) {

                    vm.DateFilter.currentRange = rangeIdToLoad;
                    reloadWidgets();
                }
            };

            vm.summary_data = {
                loaded: false,
                visited_count: 0,
                visited_count_beat: 0,
                total_sku_beat: 0,
                unique_sku_beat: 0,
                prod_call_beat: 0,
                revenue_beat: 0,
                schedule_target: 0,
                planned_visit: 0,
                planned_beat: 0,
                total_beat: 0,
                total_retailer: 0,
                total_sku: 0,
                unique_sku: 0,
                revenue: 0,
                productive_calls: 0,
                avg_sku_per_order: 0,
                avg_sales_per_order: 0,
                achivement_pct: 0,
                not_visited: 0,
                coverage_pct: 0,
                new_outlets: 0,
                new_outlet_sales: 0,
                active_users: 0,
                sr_user_count: 0,
                so_user_count: 0,
                avg_sales_per_user: 0,
                previous_achivement_pct: 0,
                previous_revenue: 0,
                previous_visited_count: 0,
                previous_coverage_pct: 0,
                population: 0

            }


            vm.widget1 = {

                data: {
                    label: "ACHIEVEMENT",
                    count: {},
                    change: {
                        value: {}
                    },
                    extra: {
                        target: {
                            label: "Target",
                            count: {}
                        },
                        achieved: {
                            label: "Achieved",
                            count: {}
                        }
                    },
                    previous: {
                        target: {
                            label: "TARGET",
                            count: {}
                        },
                        achieved: {
                            label: "ACHIEVED",
                            count: {}
                        }
                    }
                },
                detail: "Target vs. Achieved data.",
                getChangeTickerArrow: function () {
                    if (vm.widget1.data) {
                        var changeValue = vm.widget1.data.change.value[vm.widget1.currentRange];
                        if (changeValue > 0) {
                            return 'ticker-arrow-up';
                        }
                        else {
                            return 'ticker-arrow-down';
                        }
                    }
                },
                getChangeTextColor: function () {
                    if (vm.widget1.data) {
                        var changeValue = vm.summary_data.previous_achivement_pct;
                        //$log.log("..............................");
                        //$log.log(changeValue);
                        if (changeValue > 0) {
                            return 'green-fg';
                        }
                        else {
                            return 'red-fg';
                        }
                    }
                },
                loadData: function (rangeIdToLoad) {

                    msApi.request(Api.get_sales_summary + '@post',
                        {
                            period_code: rangeIdToLoad,
                            team_id: vm.overviewteamFilter.getSelectedTeamId(),
                            zone_id: vm.overviewzoneFilter.getSelectedZoneId()
                        },
                        // Success
                        function (data) {
                            //$log.log('Received Widget 1 data for range id ' + rangeIdToLoad);
                            //$log.log(data);
                            // Set new values for widget1 based on the new data
                            vm.widget1.currentRange = rangeIdToLoad;
                            vm.widget1.data.extra.target.count[rangeIdToLoad] = formatCurrency(data.result[0].target) || 0;
                            vm.widget1.data.extra.achieved.count[rangeIdToLoad] = formatCurrency(data.result[0].achieved) || 0;
                            // Compute target vs achieved percentage
                            vm.widget2.data.extra.planned_visit.count[rangeIdToLoad] = formatCurrency(Number(data.result[0].plannedvisit)) || 0;

                            if (vm.widget1.data.extra.target.count[rangeIdToLoad] == 0) {
                                vm.widget1.data.count[rangeIdToLoad] = 0;
                            }
                            else {
                                vm.widget1.data.count[rangeIdToLoad] = Math.round((data.result[0].achieved) /
                                    (data.result[0].target) * 100);
                            }

                            vm.widget1.loaded = true;
                        },
                        // Error
                        function (data) {
                            // TODO Show a notificatoin to the user, or replace the cards with an error message.
                            //$log.log('Unable to fetch widget1: ' + data);
                        }
                    );

                    var previousRangeIdToLoad;
                    if (rangeIdToLoad === 'TD') {
                        previousRangeIdToLoad = 'YD';
                    }
                    else if (rangeIdToLoad === 'WK') {
                        previousRangeIdToLoad = 'LW';
                    }
                    else if (rangeIdToLoad === 'TM') {
                        previousRangeIdToLoad = 'LM';
                    }

                    msApi.request(Api.get_sales_summary + '@post',
                        {
                            period_code: previousRangeIdToLoad,
                            team_id: vm.overviewteamFilter.getSelectedTeamId(),
                            zone_id: vm.overviewzoneFilter.getSelectedZoneId()
                        },
                        // Success
                        function (data) {
                            //$log.log('Received Widget 1 previous data for range id ' + rangeIdToLoad);
                            //$log.log(data);
                            // Set new values for widget1 based on the new data
                            var previousTarget = formatCurrency(Number(data.result[0].target)) || 0;
                            var previousAchieved = formatCurrency(data.result[0].achieved) || 0;

                            // Compute target vs achieved percentage
                            if (previousAchieved === 0) {
                                vm.widget1.data.change.value[rangeIdToLoad] = 0;
                            }
                            else {
                                vm.widget1.data.change.value[rangeIdToLoad] = Math.round((previousTarget /
                                    previousAchieved) * 100);
                            }
                        },
                        // Error
                        function (data) {
                            // TODO Show a notificatoin to the user, or replace the cards with an error message.
                            //$log.log('Unable to fetch widget1: ' + data);
                        }
                    );
                },
                init: function () {
                    vm.widget1.loadData('TM')
                }
            };


            vm.widget2 = {
                ranges: {
                    TM: "This Month",
                    LM: "Last Month",
                    "2M": "2 Months Ago"
                },
                currentRange: "TM",
                data: {
                    label: "Productive Calls : ",
                    count: {},
                    count_pc: {},
                    change: {
                        value: {}
                    },
                    extra: {
                        visited: {
                            label: "Visited",
                            count: {}
                        },
                        not_visited: {
                            label: "Not Visited : ",
                            count: {}
                        },
                        planned_visit: {
                            label: "Planned Visits",
                            count: {}
                        }
                    },

                },
                detail: "Get Coverage Summury.",

                getChangeTextColor: function () {
                    if (vm.widget2.data) {
                        var changeValue = vm.summary_data.previous_coverage_pct;
                        if (changeValue > 0) {
                            return 'green-fg';
                        }
                        else {
                            return 'red-fg';
                        }
                    }
                },

                loadData: function (rangeIdToLoad) {
                    vm.widget2.loaded = false;


                    msApi.request(Api.get_coverage_summury + '@post',
                        {
                            period_code: rangeIdToLoad,
                            team_id: vm.overviewteamFilter.getSelectedTeamId(),
                            zone_id: vm.overviewzoneFilter.getSelectedZoneId()
                        },
                        // Success
                        function (data) {
                            $log.log('Received Widget 2 data for Productive Calls');
                            $log.log(data);
                            // Set new values for widget3 based on the new data
                            vm.widget2.data.count_pc[rangeIdToLoad] = Number(data.result[0].pc_pct) || 0;
                            vm.widget2.data.extra.visited.count[rangeIdToLoad] = formatCurrency(Number(data.result[0].total_visited_count)) || 0;
                            vm.widget2.data.extra.not_visited.count[rangeIdToLoad] = formatCurrency(Number(data.result[0].not_visited)) || 0;
                            vm.widget2.data.extra.planned_visit.count[rangeIdToLoad] = formatCurrency(Number(data.result[0].planned_count)) || 0;
                            vm.widget2.data.count[rangeIdToLoad] = formatCurrency(Number(data.result[0].productive_count)) || 0;


                            vm.widget2.loaded = true;
                        },
                        // Error
                        function (data) {
                            // TODO Show a notificatoin to the user, or replace the cards with an error message.
                            //$log.log('Unable to fetch widget2: ' + data);
                        }
                    );


                },
                init: function () {
                    vm.widget2.loadData('TM')
                }
            };

            vm.widget3 = {
                ranges: {
                    TM: "This Month",
                    LM: "Last Month",
                    "2M": "2 Months Ago"
                },
                currentRange: "TM",
                data: {
                    label: "Active",
                    count: {},
                    extra: {
                        label: "Total User Count",
                        count: 0
                    }
                },
                detail: "Count of active users.",
                loadData: function (rangeIdToLoad) {
                    vm.widget3.loaded = false;
                    msApi.request(Api.get_users_summary + '@post',
                        {
                            period_code: rangeIdToLoad,
                            team_id: vm.overviewteamFilter.getSelectedTeamId(),
                            zone_id: vm.overviewzoneFilter.getSelectedZoneId()
                        },
                        // Success
                        function (data) {
                            //$log.log('Received Widget 3 data for active users');
                            //$log.log(data);
                            // Set new values for widget3 based on the new data
                            vm.widget3.data.count[rangeIdToLoad] = Number(data.result[0].active_user_count) || 0;
                            vm.widget3.loaded = true;
                        },
                        // Error
                        function (data) {
                            // TODO Show a notificatoin to the user, or replace the cards with an error message.
                            //$log.log('Unable to fetch widget3: ' + data);
                        }
                    );

                    // msApi.request(Api.get_total_users_count + '@get',
                    //     // Success
                    //     function (data) {
                    //         //$log.log('Received Widget 3 data for total users');
                    //         //$log.log(data);
                    //         // Set new values for widget3 based on the new data
                    //         vm.widget3.data.extra.count = Number(data.result[0].total_user_count) || 0;
                    //         vm.widget3.loaded = true;
                    //     },
                    //     // Error
                    //     function (data) {
                    //         // TODO Show a notificatoin to the user, or replace the cards with an error message.
                    //         //$log.log('Unable to fetch widget3: ' + data);
                    //     }
                    // );
                },
                init: function () {
                    vm.widget3.loadData('TM')
                }
            };

            vm.widget4 = {
                ranges: {
                    TM: "This Month",
                    LM: "Last Month",
                    "2M": "2 Months Ago"
                },
                currentRange: "TM",
                data: {

                    label: "New Outlets",
                    count: {},
                    extra: {
                        total_outlets: {
                            label: "Total",
                            count: {}
                        },
                        sales: {
                            label: "Sales",
                            count: {}
                        }
                    },
                },


                detail: "New Outlets Overview.",

                loadData: function (rangeIdToLoad) {
                    vm.widget4.loaded = false;

                    msApi.request(Api.get_outlet_summary + '@post',
                        {
                            period_code: rangeIdToLoad,
                            team_id: vm.overviewteamFilter.getSelectedTeamId(),
                            zone_id: vm.overviewzoneFilter.getSelectedZoneId()
                        },
                        // Success
                        function (data) {
                            $log.log('Received Widget 4 data for range id ' + rangeIdToLoad);
                            $log.log(data);
                            // Set new values for widget4 based on the new data
                            vm.widget4.data.count[rangeIdToLoad] = Number(data.result[0].new_outlets) || 0;
                            vm.widget4.data.extra.sales.count[rangeIdToLoad] = formatCurrency(Number(data.result[0].new_outlets_revenue)) || 0;
                            vm.widget4.data.extra.total_outlets.count[rangeIdToLoad] = formatCurrency(Number(data.result[0].total_new_outlets)) || 0;
                            //vm.widget4.data.extra.planned_visit.count[rangeIdToLoad] = formatCurrency(Number(data.result[0].planned_count)) || 0;
                            // vm.widget2.data.count[rangeIdToLoad] = formatCurrency(Number(data.result[0].productive_count)) || 0;

                            vm.widget4.loaded = true;
                        },
                        // Error
                        function (data) {
                            // TODO Show a notificatoin to the user, or replace the cards with an error message.
                            //$log.log('Unable to fetch widget4: ' + data);
                        }
                    );

                },
                init: function () {
                    vm.widget4.loadData('TM');
                }
            };


            // Widget 5 Pie Chart
            vm.widget5 = {
                title: "Top 5 SKUs",
                ranges: {
                    TM: "This Month",
                    LM: "Last Month",
                    "2M": "2 Months Ago"
                },
                footerLeft: {
                    title: "Total Sales",
                    count: 0
                },
                footerRight: {
                    title: "Sales From Top 5 SKUs",
                    count: 0
                },
                mainChart: {
                    config: {
                        refreshDataOnly: true,
                        deepWatchData: true
                    },
                    options: {
                        chart: {
                            type: 'pieChart',
                            color: ['#f44336', '#9c27b0', '#03a9f4', '#e91e63', '#c8b550'],
                            height: 400,
                            margin: {
                                top: 0,
                                right: 0,
                                bottom: 0,
                                left: 0
                            },
                            donut: true,
                            clipEdge: true,
                            cornerRadius: 0,
                            labelType: 'percent',
                            padAngle: 0.02,
                            x: function (d) {
                                return d.label;
                            },
                            y: function (d) {
                                return d.value;
                            },
                            tooltip: {
                                gravity: 's',
                                classes: 'gravity-s'
                            }
                        }
                    },
                    data: []
                },
                currentRange: '',
                changeRange: function (range, data) {
                    vm.widget5.currentRange = range;


                    // * Update main chart data by iterating through the
                    // * chart dataset and separately adding every single
                    // * dataset by hand.
                    // *
                    // * You MUST NOT swap the entire data object by doing
                    // * something similar to this:
                    // * vm.widget.mainChart.data = chartData
                    // *
                    // * It would be easier but it won't work with the
                    // * live updating / animated charts due to how d3
                    // * works.
                    // *
                    // * If you don't need animated / live updating charts,
                    // * you can simplify these greatly.

                    //$log.log('Reloading widget5 data');
                    //$log.log(data);
                    vm.widget5.mainChart.data.length = 0; // Remove all previous chart data on reload

                    angular.forEach(data.result[0], function (sku, index) {
                        vm.widget5.mainChart.data[index] = {
                            label: sku.product_name,
                            value: sku.sales_amount
                        };
                    });
                },
                loadData: function (rangeIdToLoad) {
                    vm.widget5.mainChart.data.length = 0; // Clear existing data
                    msApi.request(Api.get_top5skus + '@post',
                        {
                            date_range: rangeIdToLoad,
                            team_id: vm.overviewteamFilter.getSelectedTeamId(),
                            zone_id: vm.overviewzoneFilter.getSelectedZoneId()
                        },
                        // Success
                        function (data) {
                            //$log.log('Received Widget 5 data for range ' + rangeIdToLoad);
                            //$log.log(data);
                            // Set new values for widget5 based on the new data
                            if (data.result[0]) {
                                vm.widget5.footerLeft.count = formatCurrency(data.result[1][0].total_sales) || 0;
                                var top5sales = 0;
                                angular.forEach(data.result[0], function (sku) {
                                    top5sales += Number(sku.sales_amount) || 0;
                                })
                                vm.widget5.footerRight.count = formatCurrency(top5sales);
                                vm.widget5.changeRange(rangeIdToLoad, data);
                            }
                            else {
                                //$log.log('No records for widget5 for the selected filters found');
                                vm.widget5.footerLeft.count = 0;
                                vm.widget5.footerRight.count = 0;
                                vm.widget5.mainChart.data.length = 0; // Remove all previous chart data on reload
                            }
                            vm.widget5.loaded = true;
                        },
                        // Error
                        function (data) {
                            // TODO Show a notificatoin to the user, or replace the cards with an error message.
                            //$log.log('Unable to fetch widget5 data: ' + data);
                        }
                    );
                },
                init: function () {
                    // Run this function once to initialize widget


                    // Update the data for the first time

                    vm.widget5.loadData('TM');
                }
            };

            // Widget 6 Bar Chart
            vm.widget6 = {
                title: "Sales by Retailer Class",
                ranges: {
                    TM: "This Month",
                    LM: "Last Month",
                    "2M": "2 Months Ago"
                },
                mainChart: {
                    config: {
                        refreshDataOnly: true,
                        deepWatchData: true
                    },
                    options: {
                        chart: {
                            type: 'multiBarChart',
                            color: ['#03a9f4', '#b3e5fc'],
                            height: 420,
                            margin: {
                                top: 8,
                                right: 16,
                                bottom: 32,
                                left: 64
                            },
                            clipEdge: true,
                            groupSpacing: 0.3,
                            reduceXTicks: false,
                            stacked: true,
                            duration: 250,
                            x: function (d) {
                                return d.x;
                            },
                            y: function (d) {
                                return d.y;
                            },
                            xAxis: {
                                tickFormat: function (d) {
                                    return d;
                                }
                            },
                            yAxis: {
                                tickFormat: function (d) {
                                    return d3.format('.02f')(d / 100000) + ' Lacs';
                                }
                            },
                            legend: {
                                margin: {
                                    top: 8,
                                    bottom: 32
                                }
                            },
                            controls: {
                                margin: {
                                    top: 8,
                                    bottom: 32
                                }
                            },
                            tooltip: {
                                gravity: 's',
                                classes: 'gravity-s'
                            }
                        }
                    },
                    data: []
                },
                currentRange: '',
                changeRange: function (range, result) {
                    vm.widget6.currentRange = range;

                    // **
                    //  * Update main chart data by iterating through the
                    //  * chart dataset and separately adding every single
                    //  * dataset by hand.
                    //  *
                    //  * You MUST NOT swap the entire data object by doing
                    //  * something similar to this:
                    //  * vm.widget.mainChart.data = chartData
                    //  *
                    //  * It would be easier but it won't work with the
                    //  * live updating / animated charts due to how d3
                    //  * works.
                    //  *
                    //  * If you don't need animated / live updating charts,
                    //  * you can simplify these greatly.


                    vm.widget6.mainChart.data.length = 0; // Remove all previous chart data on reload

                    if (result) {

                        var salesValues = []

                        angular.forEach(result, function (chartData, index) {
                            salesValues[index] = {
                                x: chartData.class_type,
                                y: Number(chartData.sales_amount) || 0
                            };
                        });

                        vm.widget6.mainChart.data[0] = {
                            key: "Sales",
                            values: salesValues
                        };
                    }
                },
                loadData: function (rangeIdToLoad) {
                    // console.log(rangeIdToLoad);
                    // console.log(vm.teamFilter.getSelectedTeamId());
                    // console.log(vm.zoneFilter.getSelectedZoneId());
                    vm.widget6.mainChart.data.length = 0; // Clear existing data
                    msApi.request(Api.get_sales_by_retailer_class + '@post',
                        {
                            date_range: rangeIdToLoad,
                            team_id: vm.overviewteamFilter.getSelectedTeamId(),
                            zone_id: vm.overviewzoneFilter.getSelectedZoneId()
                        },
                        // Success
                        function (data) {
                            // console.log(data);
                            //$log.log('Received Widget 6 data for range id ' + rangeIdToLoad);
                            //$log.log(data);
                            // Set new values for widget6 based on the new data
                            vm.widget6.changeRange(rangeIdToLoad, data.result); // Load the chart with recieved data on first load
                            vm.widget6.loaded = true;
                        },
                        // Error
                        function (data) {

                            // console.log(data);
                            // TODO Show a notificatoin to the user, or replace the cards with an error message.
                            //$log.log('Unable to fetch widget6: ' + data);
                        }
                    );
                },
                init: function () {
                    // Run this function once to initialize widget


                    vm.widget6.loadData('TM');
                }
            };


            // Widget 7 Sales Line Chart
            vm.widget7 = {
                title: "Sales by Retailer Type",
                ranges: {
                    TM: "This Month",
                    LM: "Last Month",
                    "2M": "2 Months Ago"
                },
                mainChart: {
                    options: {
                        chart: {
                            type: 'lineChart',
                            height: 420,
                            margin: {
                                top: 32,
                                right: 32,
                                bottom: 32,
                                left: 72
                            },
                            useInteractiveGuideline: true,
                            clipVoronoi: false,
                            interpolate: 'cardinal',
                            x: function (d) {
                                if (d) {
                                    return d.x;
                                }
                                return 0; // Assume value zero if the respective day has no data
                            },
                            y: function (d) {
                                if (d) {
                                    return d.y;
                                }
                                return 0; // Assume value zero if the respective day has no data
                            },
                            xAxis: {
                                tickFormat: function (d) {
                                    return 'Day ' + d;
                                },
                                showMaxMin: false
                            },
                            yAxis: {
                                tickFormat: function (d) {
                                    return d3.format('.02f')(d / 100000) + ' Lacs';
                                }
                            },
                            interactiveLayer: {
                                tooltip: {
                                    gravity: 's',
                                    classes: 'gravity-s'
                                }
                            },
                            legend: {
                                margin: {
                                    top: 8,
                                    right: 0,
                                    bottom: 32,
                                    left: 0
                                },
                                rightAlign: false
                            }
                        }
                    },
                    data: []
                },
                currentRange: '',
                retailerCountSet: 0,
                changeRange: function (range, retailerName, data) {
                    vm.widget7.currentRange = range;


                    // * Update main chart data by iterating through the
                    // * chart dataset and separately adding every single
                    // * dataset by hand.
                    // *
                    // * You MUST NOT swap the entire data object by doing
                    // * something similar to this:
                    // * vm.widget.mainChart.data = chartData
                    // *
                    // * It would be easier but it won't work with the
                    // * live updating / animated charts due to how d3
                    // * works.
                    // *
                    // * If you don't need animated / live updating charts,
                    // * you can simplify these greatly.


                    // vm.widget7.mainChart.data.length = 0; // Remove all previous chart data on reload

                    var values = [];

                    angular.forEach(data.result, function (record, index) {
                        values.push({
                            x: Number(record.sale_day) || 0,
                            y: Number(record.sales_amount) || 0
                        });

                    });
                    vm.widget7.mainChart.data[vm.widget7.retailerCountSet++] = {
                        key: retailerName,
                        values: values
                    };
                },
                loadData: function (rangeIdToLoad) {
                    vm.widget7.retailerCountSet = 0; // Clear existing data
                    vm.widget7.mainChart.length = 0;
                    msApi.request(Api.get_sales_by_retailer_list + '@get',
                        // Success
                        function (data) {
                            //$log.log('Received Widget 7 retailer list data for range id ' + rangeIdToLoad);
                            //$log.log(data);
                            // Fetch chart data for each retailer in the retailer list

                            angular.forEach(data.result, function (retailer, index) {

                                msApi.request(Api.get_sales_by_retailer_type + '@post',
                                    {
                                        date_range: rangeIdToLoad,
                                        team_id: vm.overviewteamFilter.getSelectedTeamId(),
                                        zone_id: vm.overviewzoneFilter.getSelectedZoneId(),
                                        retailer_id: retailer.id
                                    },
                                    // Success
                                    function (data) {
                                        //$log.log('Received Widget 7 retailer type data for range id ' + rangeIdToLoad);
                                        //$log.log(data);
                                        // Fetch chart data for each retailer in the retailer list

                                        vm.widget7.changeRange(rangeIdToLoad, retailer.name, data);

                                        vm.widget7.loaded = true;
                                    },
                                    // Error
                                    function (data) {
                                        // TODO Show a notificatoin to the user, or replace the cards with an error message.
                                        //$log.log('Unable to fetch widget7: ' + data);
                                    }
                                );
                            });

                            vm.widget7.loaded = true;
                        },
                        // Error
                        function (data) {
                            // TODO Show a notificatoin to the user, or replace the cards with an error message.
                            //$log.log('Unable to fetch widget7: ' + data);
                        }
                    );
                },
                init: function () {
                    // Run this function once to initialize widget


                    vm.widget7.loadData('TM');
                }
            };

            vm.widget8 = {
                title: "MSS Sales",
                ranges: {
                    TM: "This Month",
                    LM: "Last Month",
                    "2M": "2 Months Ago"
                },
                mainChart: {
                    config: {
                        refreshDataOnly: true,
                        deepWatchData: true
                    },
                    options: {
                        chart: {
                            type: 'multiBarChart',
                            color: ['#3f51b5', '#3f51b5'],
                            height: 420,
                            margin: {
                                top: 8,
                                right: 16,
                                bottom: 32,
                                left: 64
                            },
                            clipEdge: true,
                            groupSpacing: 0.3,
                            reduceXTicks: false,
                            stacked: true,
                            duration: 250,
                            x: function (d) {
                                return d.x;
                            },
                            y: function (d) {
                                return d.y;
                            },
                            xAxis: {
                                tickFormat: function (d) {
                                    return d;
                                }
                            },
                            yAxis: {
                                tickFormat: function (d) {
                                    return d3.format('.02f')(d / 100000) + ' Lacs';
                                }
                            },
                            legend: {
                                margin: {
                                    top: 8,
                                    bottom: 32
                                }
                            },
                            controls: {
                                margin: {
                                    top: 8,
                                    bottom: 32
                                }
                            },
                            tooltip: {
                                gravity: 's',
                                classes: 'gravity-s'
                            }
                        }
                    },
                    data: []
                },
                currentRange: '',
                changeRange: function (range, result) {
                    vm.widget8.currentRange = range;

                    // **
                    //  * Update main chart data by iterating through the
                    //  * chart dataset and separately adding every single
                    //  * dataset by hand.
                    //  *
                    //  * You MUST NOT swap the entire data object by doing
                    //  * something similar to this:
                    //  * vm.widget.mainChart.data = chartData
                    //  *
                    //  * It would be easier but it won't work with the
                    //  * live updating / animated charts due to how d3
                    //  * works.
                    //  *
                    //  * If you don't need animated / live updating charts,
                    //  * you can simplify these greatly.


                    vm.widget8.mainChart.data.length = 0; // Remove all previous chart data on reload

                    if (result) {

                        var salesValues = []

                        angular.forEach(result, function (chartData, index) {
                            salesValues[index] = {
                                x: chartData.default_code,
                                y: Number(chartData.price_total) || 0
                            };
                        });

                        vm.widget8.mainChart.data[0] = {
                            key: "Sales",
                            values: salesValues
                        };
                    }
                },
                loadData: function (rangeIdToLoad) {
                    vm.widget8.loaded = false;
                    // console.log(rangeIdToLoad);
                    // console.log(vm.teamFilter.getSelectedTeamId());
                    // console.log(vm.zoneFilter.getSelectedZoneId());
                    vm.widget8.mainChart.data.length = 0; // Clear existing data
                    msApi.request(Api.get_mss_sales + '@post',
                        {
                            date_range: rangeIdToLoad,
                            team_id: vm.overviewteamFilter.getSelectedTeamId(),
                            zone_id: vm.overviewzoneFilter.getSelectedZoneId()
                        },
                        // Success
                        function (data) {
                            // console.log(data);
                            //$log.log('Received Widget 6 data for range id ' + rangeIdToLoad);
                            //$log.log(data);
                            // Set new values for widget8 based on the new data
                            vm.widget8.changeRange(rangeIdToLoad, data.result); // Load the chart with recieved data on first load
                            vm.widget8.loaded = true;
                        },
                        // Error
                        function (data) {

                            // console.log(data);
                            // TODO Show a notificatoin to the user, or replace the cards with an error message.
                            //$log.log('Unable to fetch widget8: ' + data);
                        }
                    );
                },
                init: function () {
                    // Run this function once to initialize widget


                    vm.widget8.loadData('TM');
                }
            };

            // Widget 9 Product Placement Chart
            vm.widget9 = {
                title: "Product Placement",
                ranges: {
                    TM: "This Month",
                    LM: "Last Month",
                    "2M": "2 Months Ago"
                },
                mainChart: {
                    options: {
                        chart: {
                            type: 'radarChart',
                            //color                  : ['#4caf50', '#3f51b5', '#ff5722'],
                            height: 420,
                            margin: {
                                top: 32,
                                right: 32,
                                bottom: 32,
                                left: 72
                            },
                            useInteractiveGuideline: true,
                            clipVoronoi: false,
                            interpolate: 'cardinal',
                            x: function (d) {
                                return d.x;
                            },
                            y: function (d) {
                                return d.y;
                            },
                            xAxis: {
                                tickFormat: function (d) {
                                    return 'Day ' + d;
                                },
                                showMaxMin: false
                            },
                            yAxis: {
                                tickFormat: function (d) {
                                    return d3.format('.02f')(d / 100000) + ' Lacs';
                                }
                            },
                            interactiveLayer: {
                                tooltip: {
                                    gravity: 's',
                                    classes: 'gravity-s'
                                }
                            },
                            legend: {
                                margin: {
                                    top: 8,
                                    right: 0,
                                    bottom: 32,
                                    left: 0
                                },
                                rightAlign: false
                            }
                        }
                    },
                    data: []
                },
                currentRange: '',
                //retailerCountSet: 0,
                changeRange: function (range, skuRetailerData, skuNamesList, retailerNamesList) {
                    vm.widget9.currentRange = range;

                    // * Update main chart data by iterating through the
                    // * chart dataset and separately adding every single
                    // * dataset by hand.
                    // *
                    // * You MUST NOT swap the entire data object by doing
                    // * something similar to this:
                    // * vm.widget.mainChart.data = chartData
                    // *
                    // * It would be easier but it won't work with the
                    // * live updating / animated charts due to how d3
                    // * works.
                    // *
                    // * If you don't need animated / live updating charts,
                    // * you can simplify these greatly.

                    vm.widget9.mainChart.data = skuRetailerData;
                    vm.widget9.retailerTypeNames = retailerNamesList;
                    vm.widget9.productNames = skuNamesList;


                    // var values = [];

                    // angular.forEach(chart_data.result, function (record, index)
                    // {
                    //     values.push({
                    //         x: Number(record.sale_date) || 0,
                    //         y: Number(record.sales_amount) || 0
                    //     });

                    // });
                    // vm.widget9.mainChart.data[vm.widget9.retailerCountSet++] = {
                    //     key   : retailerName,
                    //     values: values
                    // };

                    // vm.widget9.mainChart.data.length = 0; // Remove all previous chart data on reload

                    // angular.forEach(vm.widget8.allRangeChartData[range], function (chartData, index)
                    // {
                    //     vm.widget9.mainChart.data[index] = {
                    //         key   : chartData.key,
                    //         values: chartData.values
                    //     };
                    // });
                },
                loadData: function (rangeIdToLoad) {
                    vm.widget9.retailerCountSet = 0; // Clear existing data
                    vm.widget9.mainChart.length = 0;
                    msApi.request(Api.get_skuIds_of_range + '@post',
                        {
                            date_range: rangeIdToLoad,
                            team_id: vm.overviewteamFilter.getSelectedTeamId(),
                            zone_id: vm.overviewzoneFilter.getSelectedZoneId()
                        },
                        // Success
                        function (data) {
                            //$log.log('Received Widget 9 sku_id list data for range id ' + rangeIdToLoad);
                            //$log.log(data);
                            // Fetch chart data for each retailer in the retailer list

                            var retailerNameRemapping = {};
                            var newRetailerNameRemappingCounter = 0;

                            var skuNamesList = [];
                            var skuRetailerData = [];

                            angular.forEach(data.result, function (sku, skuIndex) {

                                msApi.request(Api.get_product_placement_for_range + '@post',
                                    {
                                        date_range: rangeIdToLoad,
                                        team_id: vm.overviewteamFilter.getSelectedTeamId(),
                                        zone_id: vm.overviewzoneFilter.getSelectedZoneId(),
                                        product_id: sku.sku_id
                                    },
                                    // Success
                                    function (chart_data) {
                                        //$log.log('Received Widget 9 focus type data for sku id ' + sku.sku_id);
                                        //$log.log(data);
                                        // Fetch chart data for each sku in the sku list

                                        // We must fetch the sku name by making a request to the get_skuId_product_list api
                                        msApi.request(Api.get_skuId_product_list + '@post',
                                            {sku_id: sku.sku_id},
                                            // Success
                                            function (data) {
                                                //$log.log('...............................................');
                                                //$log.log(data);
                                                //$log.log(data.result[0]);
                                                //  vm.widget9.changeRange(rangeIdToLoad, retailer_name, chart_data);

                                                var skuName = data.result[0].name;

                                                var currentSkuValues = [];

                                                angular.forEach(chart_data.result, function (retailer) {

                                                    var retailerName = retailer.retailer_name;
                                                    if (!(retailerName in retailerNameRemapping)) {
                                                        retailerNameRemapping[retailerName] = newRetailerNameRemappingCounter++;
                                                    }

                                                    var remappedRetailerColumn = retailerNameRemapping[retailerName];
                                                    currentSkuValues[remappedRetailerColumn] = retailer.sales_amount;

                                                });

                                                // Fill in undefined currentProductValues to zeros
                                                for (var i = 0; i < currentSkuValues.length; i++) {
                                                    if (typeof currentSkuValues[i] === 'undefined') {
                                                        currentSkuValues[i] = 0;
                                                    }
                                                }

                                                // Insert data row
                                                skuRetailerData[skuIndex] = currentSkuValues;
                                                // Insert sku name
                                                skuNamesList[skuIndex] = skuName;

                                                var retailerNamesList = [];
                                                // Build Retailer names list based on the remapping
                                                angular.forEach(Object.keys(retailerNameRemapping), function (retailerName) {
                                                    retailerNamesList[retailerNameRemapping[retailerName]] = retailerName;
                                                });


                                                vm.widget9.changeRange(rangeIdToLoad, skuRetailerData, skuNamesList, retailerNamesList);

                                                vm.widget9.loaded = true;
                                            },
                                            // Error
                                            function (data) {
                                                // TODO Show a notificatoin to the user, or replace the cards with an error message.
                                                //$log.log('Unable to fetch widget9: ' + data);
                                            }
                                        );


                                    },
                                    // Error
                                    function (data) {
                                        // TODO Show a notificatoin to the user, or replace the cards with an error message.
                                        //$log.log('Unable to fetch widget9: ' + data);
                                    }
                                );
                            });

                            vm.widget9.loaded = true;
                        },
                        // Error
                        function (data) {
                            // TODO Show a notificatoin to the user, or replace the cards with an error message.
                            //$log.log('Unable to fetch widget9: ' + data);
                        }
                    );
                },
                init: function () {
                    // Run this function once to initialize widget


                    vm.widget9.loadData('TM');
                }
            };


            // Salesman Filter
            vm.SalesmanFilter = {
                isDisabled: false,
                salespersons: {},

                searchTextChange: function (text) {
                    //$log.info('Text changed to ' + text);
                },

                selectedUserChange: function (salesman) {
                    //$log.info('Team changed to ' + salesman);
                    // reloadAllWidgets();
                    // reloadWidgets();
                },

                querySearch: function (query) {
                    if (query) {
                        return vm.SalesmanFilter.salespersons
                            .filter(function (salesman) {
                                return salesman.name.toLowerCase().indexOf(query.toLowerCase()) === 0;
                            });
                    }
                    else {
                        return vm.SalesmanFilter.salespersons;
                    }
                },

                loadUsers: function () {
                    msApi.request(Api.get_users + '@get',
                        // Success
                        function (data) {
                            //$log.log('Received teams data ', data);
                            vm.SalesmanFilter.salespersons = data.result; // Set filter data
                        },
                        // Error
                        function (data) {
                            // TODO Show a notificatoin to the user, or replace the cards with an error message.
                            //$log.log('Unable to fetch team filter data: ' + data);
                        }
                    );
                },

                resetUsers: function () {
                    delete vm.SalesmanFilter.selectedUser;
                    delete vm.SalesmanFilter.searchText;
                    // reloadWidgets();
                },

                getSelectedUserId: function () {
                    return vm.SalesmanFilter.selectedUser ? vm.SalesmanFilter.selectedUser.id : undefined;
                },

                init: function () {
                    // Fetch team names and Ids from the server
                    vm.SalesmanFilter.loadUsers();
                }
            };


            // Product Brand Filter
            vm.BrandFilter = {
                isDisabled: false,
                brands: {},
                searchTextChange: function (text) {
                    //$log.info('Text changed to ' + text);
                },
                selectedBrandChange: function (brand) {
                },

                querySearch: function (query) {
                    if (query) {
                        return vm.BrandFilter.brands
                            .filter(function (brand) {
                                return brand.name.toLowerCase().indexOf(query.toLowerCase()) === 0;
                            });
                    }
                    else {
                        return vm.BrandFilter.brands;
                    }
                },

                loadBrands: function () {
                    msApi.request(Api.get_product_brand + '@get',
                        // Success
                        function (data) {
                            //$log.log('Received brands data ', data);
                            vm.BrandFilter.brands = data.result; // Set filter data
                        },
                        function (data) {
                            // TODO Show a notificatoin to the user, or replace the cards with an error message.
                        }
                    );
                },
                resetBrands: function () {
                    delete vm.BrandFilter.selectedBrand;
                    delete vm.BrandFilter.searchText;
                },
                getSelectedBrandId: function () {
                    return vm.BrandFilter.selectedBrand ? vm.BrandFilter.selectedBrand.id : undefined;
                },
                init: function () {
                    // Fetch Brand names and Ids from the server
                    vm.BrandFilter.loadBrands();
                }
            };

            // Product Category Filter
            vm.CategoryFilter = {
                isDisabled: false,
                categories: {},
                searchTextChange: function (text) {
                    //$log.info('Text changed to ' + text);
                },
                selectedCategoryChange: function (category) {
                },

                querySearch: function (query) {
                    if (query) {
                        return vm.CategoryFilter.categories
                            .filter(function (category) {
                                return category.name.toLowerCase().indexOf(query.toLowerCase()) === 0;
                            });
                    }
                    else {
                        return vm.CategoryFilter.categories;
                    }
                },

                loadCategories: function () {
                    msApi.request(Api.get_product_category + '@get',
                        // Success
                        function (data) {
                            //$log.log('Received brands data ', data);
                            vm.CategoryFilter.categories = data.result; // Set filter data
                        },
                        function (data) {
                            // TODO Show a notificatoin to the user, or replace the cards with an error message.
                        }
                    );
                },
                resetCategories: function () {
                    delete vm.CategoryFilter.selectedCategory;
                    delete vm.CategoryFilter.searchText;
                },
                getSelectedCategoryId: function () {
                    return vm.CategoryFilter.selectedCategory ? vm.CategoryFilter.selectedCategory.id : undefined;
                },
                init: function () {
                    // Fetch Brand names and Ids from the server
                    vm.CategoryFilter.loadCategories();
                }
            };

            // Overview Salesman Filter
            vm.overviewSalesmanFilter = {
                isDisabled: false,
                salespersons: {},

                searchTextChange: function (text) {
                    //$log.info('Text changed to ' + text);
                },

                selectedUserChange: function (salesman) {
                    //$log.info('Team changed to ' + salesman);
                    // reloadAllWidgets();
                    reloadWidgets();
                },

                querySearch: function (query) {
                    if (query) {
                        return vm.overviewSalesmanFilter.salespersons
                            .filter(function (salesman) {
                                return salesman.name.toLowerCase().indexOf(query.toLowerCase()) === 0;
                            });
                    }
                    else {
                        return vm.overviewSalesmanFilter.salespersons;
                    }
                },

                loadUsers: function () {
                    msApi.request(Api.get_users + '@get',
                        // Success
                        function (data) {
                            //$log.log('Received teams data ', data);
                            vm.overviewSalesmanFilter.salespersons = data.result; // Set filter data
                        },
                        // Error
                        function (data) {
                            // TODO Show a notificatoin to the user, or replace the cards with an error message.
                            //$log.log('Unable to fetch team filter data: ' + data);
                        }
                    );
                },

                resetUsers: function () {
                    delete vm.overviewSalesmanFilter.selectedUser;
                    delete vm.overviewSalesmanFilter.searchText;
                    reloadWidgets();
                },

                getSelectedUserId: function () {
                    return vm.overviewSalesmanFilter.selectedUser ? vm.overviewSalesmanFilter.selectedUser.id : undefined;
                },

                init: function () {
                    // Fetch team names and Ids from the server
                    vm.overviewSalesmanFilter.loadUsers();
                }
            };


            // Team Filter
            vm.teamFilter = {
                isDisabled: false,
                teams: {},


                searchTextChange: function (text) {
                    //$log.info('Text changed to ' + text);
                },

                selectedTeamChange: function (team) {
                    //$log.info('Team changed to ' + team);
                    //   reloadAllWidgets();
                    //  reloadWidgets();
                },

                querySearch: function (query) {
                    if (query) {
                        return vm.teamFilter.teams
                            .filter(function (team) {
                                return team.name.toLowerCase().indexOf(query.toLowerCase()) === 0;
                            });
                    }
                    else {
                        return vm.teamFilter.teams;
                    }
                },

                loadTeams: function () {
                    msApi.request(Api.get_team + '@get',
                        // Success
                        function (data) {
                            //$log.log('Received teams data ', data);
                            vm.teamFilter.teams = data.result; // Set filter data
                        },
                        // Error
                        function (data) {
                            // TODO Show a notificatoin to the user, or replace the cards with an error message.
                            //$log.log('Unable to fetch team filter data: ' + data);
                        }
                    );
                },

                resetTeams: function () {
                    delete vm.teamFilter.selectedTeam;
                    delete vm.teamFilter.searchText;
                    //    reloadAllWidgets();
                    //    reloadWidgets();
                },

                getSelectedTeamId: function () {
                    return vm.teamFilter.selectedTeam ? vm.teamFilter.selectedTeam.id : undefined;
                },

                getUserIds: function () {
                    if (vm.SalesmanFilter.selectedUser) {
                        var user_ids = [];
                        user_ids.push(vm.SalesmanFilter.selectedUser.id);
                        return user_ids;
                    } else {
                        if (vm.teamFilter.selectedTeam) {
                            var user_ids = [];
                            for (var i = 0; i < vm.SalesmanFilter.salespersons.length; i++) {
                                if (vm.SalesmanFilter.salespersons[i].team_id == vm.teamFilter.selectedTeam.id) {
                                    user_ids.push(vm.SalesmanFilter.salespersons[i].id);
                                }
                            }
                            return user_ids;
                        } else {
                            return undefined;
                        }

                    }

                },


                init: function () {
                    // Fetch team names and Ids from the server
                    vm.teamFilter.loadTeams();
                }
            };

            // Overview Team Filter
            vm.overviewteamFilter = {
                isDisabled: false,
                teams: {},


                searchTextChange: function (text) {
                    //$log.info('Text changed to ' + text);
                },

                selectedTeamChange: function (team) {
                    //$log.info('Team changed to ' + team);
                    reloadAllWidgets();
                    reloadWidgets();
                },

                querySearch: function (query) {
                    if (query) {
                        return vm.overviewteamFilter.teams
                            .filter(function (team) {
                                return team.name.toLowerCase().indexOf(query.toLowerCase()) === 0;
                            });
                    }
                    else {
                        return vm.overviewteamFilter.teams;
                    }
                },

                loadTeams: function () {
                    msApi.request(Api.get_team + '@get',
                        // Success
                        function (data) {
                            //$log.log('Received teams data ', data);
                            vm.overviewteamFilter.teams = data.result; // Set filter data
                        },
                        // Error
                        function (data) {
                            // TODO Show a notificatoin to the user, or replace the cards with an error message.
                            //$log.log('Unable to fetch team filter data: ' + data);
                        }
                    );
                },

                resetTeams: function () {
                    delete vm.overviewteamFilter.selectedTeam;
                    delete vm.overviewteamFilter.searchText;
                    reloadAllWidgets();
                    reloadWidgets();
                },

                getSelectedTeamId: function () {
                    return vm.overviewteamFilter.selectedTeam ? vm.overviewteamFilter.selectedTeam.id : undefined;
                },

                getUserIds: function () {
                    if (vm.overviewSalesmanFilter.selectedUser) {
                        var user_ids = [];
                        user_ids.push(vm.overviewSalesmanFilter.selectedUser.id);
                        return user_ids;
                    } else {
                        if (vm.overviewteamFilter.selectedTeam) {
                            var user_ids = [];
                            for (var i = 0; i < vm.overviewSalesmanFilter.salespersons.length; i++) {
                                if (vm.overviewSalesmanFilter.salespersons[i].team_id == vm.overviewteamFilter.selectedTeam.id) {
                                    user_ids.push(vm.overviewSalesmanFilter.salespersons[i].id);
                                }
                            }
                            return user_ids;
                        } else {
                            return undefined;
                        }

                    }

                },


                init: function () {
                    // Fetch team names and Ids from the server
                    vm.overviewteamFilter.loadTeams();
                }
            };

            // Zone Filter
            vm.zoneFilter = {
                isDisabled: false,
                zones: {},

                searchTextChange: function (text) {
                    //$log.info('Zone changed to ' + text);
                },

                selectedZoneChange: function (zone) {
                    //$log.info('Zone changed to ' + zone);
                    //     reloadAllWidgets();
                    //   reloadWidgets();
                },

                querySearch: function (query) {
                    if (query) {
                        return vm.zoneFilter.zones
                            .filter(function (zone) {
                                return zone.name.toLowerCase().indexOf(query.toLowerCase()) === 0;
                            });
                    }
                    else {
                        return vm.zoneFilter.zones;
                    }
                },

                loadZones: function () {
                    msApi.request(Api.get_zone + '@get',
                        // Success
                        function (data) {
                            //$log.log('Received zones data ', data);
                            vm.zoneFilter.zones = data.result; // Set filter data
                        },
                        // Error
                        function (data) {
                            // TODO Show a notificatoin to the user, or replace the cards with an error message.
                            //$log.log('Unable to fetch zone filter data: ' + data);
                        }
                    );
                },

                resetZones: function () {
                    delete vm.zoneFilter.selectedZone;
                    delete vm.zoneFilter.searchText;
                    //  reloadAllWidgets();
                },

                getSelectedZoneId: function () {
                    return vm.zoneFilter.selectedZone ? vm.zoneFilter.selectedZone.id : undefined;
                },

                init: function () {
                    // Fetch zone names and Ids from the server
                    vm.zoneFilter.loadZones();
                }
            };

            // Overview Zone Filter
            vm.overviewzoneFilter = {
                isDisabled: false,
                zones: {},

                searchTextChange: function (text) {
                    //$log.info('Zone changed to ' + text);
                },

                selectedZoneChange: function (zone) {
                    //$log.info('Zone changed to ' + zone);
                    reloadAllWidgets();
                    reloadWidgets();
                },

                querySearch: function (query) {
                    if (query) {
                        return vm.overviewzoneFilter.zones
                            .filter(function (zone) {
                                return zone.name.toLowerCase().indexOf(query.toLowerCase()) === 0;
                            });
                    }
                    else {
                        return vm.overviewzoneFilter.zones;
                    }
                },

                loadZones: function () {
                    msApi.request(Api.get_zone + '@get',
                        // Success
                        function (data) {
                            //$log.log('Received zones data ', data);
                            vm.overviewzoneFilter.zones = data.result; // Set filter data
                        },
                        // Error
                        function (data) {
                            // TODO Show a notificatoin to the user, or replace the cards with an error message.
                            //$log.log('Unable to fetch zone filter data: ' + data);
                        }
                    );
                },

                resetZones: function () {
                    delete vm.overviewzoneFilter.selectedZone;
                    delete vm.overviewzoneFilter.searchText;
                    reloadAllWidgets();
                },

                getSelectedZoneId: function () {
                    return vm.overviewzoneFilter.selectedZone ? vm.overviewzoneFilter.selectedZone.id : undefined;
                },

                init: function () {
                    // Fetch zone names and Ids from the server
                    vm.overviewzoneFilter.loadZones();
                }
            };



            /*Beat Filter*/

            vm.beatFilter = {
                isDisabled: false,
                beats: {},

                searchTextChange: function (text) {
                    //$log.info('beat changed to ' + text);
                },

                selectedBeatChange: function (beat) {
                    //$log.info('Beat changed to ' + beat);
                    //   reloadAllWidgets();
                    //   reloadWidgets();
                },

                querySearch: function (query) {
                    if (query) {
                        return vm.beatFilter.beats
                            .filter(function (beat) {
                                return beat.name.toLowerCase().indexOf(query.toLowerCase()) === 0;
                            });
                    }
                    else {
                        return vm.beatFilter.beats;
                    }
                },

                loadBeats: function () {
                    msApi.request(Api.get_beat + '@get',
                        // Success
                        function (data) {
                            // $log(data);
                            //$log.log('Received beats data ', data);
                            vm.beatFilter.beats = data.result; // Set filter data
                        },
                        // Error
                        function (data) {
                            // TODO Show a notificatoin to the user, or replace the cards with an error message.
                            //$log.log('Unable to fetch beat filter data: ' + data);
                        }
                    );
                },

                resetBeats: function () {
                    delete vm.beatFilter.selectedBeat;
                    delete vm.beatFilter.searchText;
                    //    reloadAllWidgets();
                },

                getSelectedBeatId: function () {
                    return vm.beatFilter.selectedBeat ? vm.beatFilter.selectedBeat.id : undefined;
                },

                init: function () {
                    // Fetch beat names and Ids from the server
                    vm.beatFilter.loadBeats();
                }
            };

            /*Distributor Name Filter*/

            vm.distnameFilter = {
                isDisabled: false,
                distributors: {},

                searchTextChange: function (text) {
                    //$log.info('distributor changed to ' + text);
                },

                selectedDistributorChange: function (distributor) {
                    //$log.info('distributor changed to ' + distributor);
                    //      reloadAllWidgets();
                    //     reloadWidgets();
                },

                querySearch: function (query) {
                    if (query) {
                        return vm.distnameFilter.distributors
                            .filter(function (distributor) {
                                return distributor.name.toLowerCase().indexOf(query.toLowerCase()) === 0;
                            });
                    }
                    else {
                        return vm.distnameFilter.distributors;
                    }
                },

                loadDistributors: function () {
                    msApi.request(Api.get_distributor_by_name + '@get',
                        // Success
                        function (data) {
                            // $log(data);
                            //$log.log('Received distributors data ', data);
                            vm.distnameFilter.distributors = data.result; // Set filter data
                        },
                        // Error
                        function (data) {
                            // TODO Show a notificatoin to the user, or replace the cards with an error message.
                            //$log.log('Unable to fetch distributor filter data: ' + data);
                        }
                    );
                },

                resetDistributors: function () {
                    delete vm.distnameFilter.selectedDistributor;
                    delete vm.distnameFilter.searchText;
                    //    reloadAllWidgets();
                },

                getSelectedDistributorId: function () {
                    return vm.distnameFilter.selectedDistributor ? vm.distnameFilter.selectedDistributor.id : undefined;
                },

                init: function () {
                    // Fetch beat names and Ids from the server
                    vm.distnameFilter.loadDistributors();
                }
            };

            /*Distributor Code Filter*/

            vm.distcodeFilter = {
                isDisabled: false,
                distributors: {},

                searchTextChange: function (text) {
                    //$log.info('distributor changed to ' + text);
                },

                selectedDistributorChange: function (distributor) {
                    //$log.info('distributor changed to ' + distributor);
                    //      reloadAllWidgets();
                    //     reloadWidgets();
                },

                querySearch: function (query) {
                    if (query) {
                        return vm.distcodeFilter.distributors
                            .filter(function (distributor) {
                                return distributor.code.toLowerCase().indexOf(query.toLowerCase()) === 0;
                            });
                    }
                    else {
                        return vm.distcodeFilter.distributors;
                    }
                },

                loadDistributors: function () {
                    msApi.request(Api.get_distributor_by_code + '@get',
                        // Success
                        function (data) {
                            // $log(data);
                            //$log.log('Received distributors data ', data);
                            vm.distcodeFilter.distributors = data.result; // Set filter data
                        },
                        // Error
                        function (data) {
                            // TODO Show a notificatoin to the user, or replace the cards with an error message.
                            //$log.log('Unable to fetch distributor filter data: ' + data);
                        }
                    );
                },

                resetDistributors: function () {
                    delete vm.distcodeFilter.selectedDistributor;
                    delete vm.distcodeFilter.searchText;
                    //   reloadAllWidgets();
                },

                getSelectedDistributorId: function () {
                    return vm.distcodeFilter.selectedDistributor ? vm.distcodeFilter.selectedDistributor.id : undefined;
                },

                init: function () {
                    // Fetch beat names and Ids from the server
                    vm.distcodeFilter.loadDistributors();
                }
            };


            /*Emp Code Filter*/

            vm.empcodeFilter = {
                isDisabled: false,
                employees: {},

                searchTextChange: function (text) {
                    //$log.info('employee changed to ' + text);
                },

                selectedEmployeeChange: function (employee) {
                    //$log.info('employee changed to ' + employee);
                    //      reloadAllWidgets();
                    //      reloadWidgets();
                },

                querySearch: function (query) {
                    if (query) {
                        return vm.empcodeFilter.employees
                            .filter(function (employee) {
                                return employee.identification_id.toLowerCase().indexOf(query.toLowerCase()) === 0;
                            });
                    }
                    else {
                        return vm.empcodeFilter.employees;
                    }
                },

                loadEmployees: function () {
                    msApi.request(Api.get_emp_code + '@get',
                        // Success
                        function (data) {
                            // $log(data);
                            //$log.log('Received distributors data ', data);
                            vm.empcodeFilter.employees = data.result; // Set filter data
                        },
                        // Error
                        function (data) {
                            // TODO Show a notificatoin to the user, or replace the cards with an error message.
                            //$log.log('Unable to fetch distributor filter data: ' + data);
                        }
                    );
                },

                resetEmployees: function () {
                    delete vm.empcodeFilter.selectedEmployee;
                    delete vm.empcodeFilter.searchText;
                    //     reloadAllWidgets();
                },

                getSelectedEmployeeId: function () {
                    return vm.empcodeFilter.selectedEmployee ? vm.empcodeFilter.selectedEmployee.id : undefined;
                },

                init: function () {
                    // Fetch beat names and Ids from the server
                    vm.empcodeFilter.loadEmployees();
                }
            };

            /*Partner Name Filter*/

            vm.partnerFilter = {
                isDisabled: false,
                partners: {},

                searchTextChange: function (text) {
                    //$log.info('partner changed to ' + text);
                },

                selectedPartnerChange: function (partner) {
                    //$log.info('partner changed to ' + partner);
                    //      reloadAllWidgets();
                    //      reloadWidgets();
                },

                querySearch: function (query) {
                    if (query) {
                        return vm.partnerFilter.partners
                            .filter(function (partner) {
                                return partner.name.toLowerCase().indexOf(query.toLowerCase()) === 0;
                            });
                    }
                    else {
                        return vm.partnerFilter.partners;
                    }
                },

                loadPartners: function () {
                    msApi.request(Api.get_partner_by_name + '@get',
                        // Success
                        function (data) {
                            // $log(data);
                            //$log.log('Received partners data ', data);
                            vm.partnerFilter.partners = data.result; // Set filter data
                        },
                        // Error
                        function (data) {
                            // TODO Show a notificatoin to the user, or replace the cards with an error message.
                            //$log.log('Unable to fetch distributor filter data: ' + data);
                        }
                    );
                },

                resetPartners: function () {
                    delete vm.partnerFilter.selectedPartner;
                    delete vm.partnerFilter.searchText;
                    //     reloadAllWidgets();
                },

                getSelectedPartnerId: function () {
                    return vm.partnerFilter.selectedPartner ? vm.partnerFilter.selectedPartner.id : undefined;
                },

                init: function () {
                    // Fetch beat names and Ids from the server
                    vm.partnerFilter.loadPartners();
                }
            };

            // Partner Type Filter
            vm.partnerTypeFilter = {
                isDisabled: false,
                partnerTypes: {},
                searchTextChange: function (text) {
                },

                selectedPartnerTypeChange: function (partnerType) {
                    //      reloadAllWidgets();
                    //      reloadWidgets();
                },

                querySearch: function (query) {
                    if (query) {
                        return vm.partnerTypeFilter.partnerTypes
                            .filter(function (partnerType) {
                                return partnerType.name.toLowerCase().indexOf(query.toLowerCase()) === 0;
                            });
                    }
                    else {
                        return vm.partnerTypeFilter.partnerTypes;
                    }
                },

                loadPartnerTypes: function () {
                    msApi.request(Api.get_res_partner_types + '@get',
                        // Success
                        function (data) {
                            //$log.log('Received Partner Types data ', data);
                            vm.partnerTypeFilter.partnerTypes = data.result; // Set filter data
                        },
                        // Error
                        function (data) {
                            // TODO Show a notificatoin to the user, or replace the cards with an error message.
                            //$log.log('Unable to fetch Partner Type filter data: ' + data);
                        }
                    );
                },

                resetPartnerTypes: function () {
                    delete vm.partnerTypeFilter.selectedPartnerType;
                    delete vm.partnerTypeFilter.searchText;
                    //      reloadAllWidgets();
                },

                getSelectedPartnerTypeId: function () {
                    return vm.partnerTypeFilter.selectedPartnerType ? vm.partnerTypeFilter.selectedPartnerType.id : undefined;
                },

                init: function () {
                    // Fetch Partner Type names and Ids from the server
                    vm.partnerTypeFilter.loadPartnerTypes();
                }
            };

            // Function to reload all widget data on changing filter, etc.
            function reloadAllWidgets() {
                //$log.log('Reloading all widget data.');
                // vm.widget1.loadData(vm.widget1.currentRange);
                // vm.widget2.loadData(vm.widget2.currentRange);
                // vm.widget3.loadData(vm.widget3.currentRange);
                // vm.widget4.loadData(vm.widget4.currentRange);
                vm.widget5.loadData(vm.widget5.currentRange);
                vm.widget6.loadData(vm.widget6.currentRange);
                vm.widget7.loadData(vm.widget7.currentRange);
                vm.widget8.loadData(vm.widget8.currentRange);
                vm.widget9.loadData(vm.widget9.currentRange);
                //vm.widget10.loadData(vm.widget10.currentRange);
                // vm.widget11.loadData(vm.widget11.currentRange);
                //vm.widget12.loadData(vm.widget12.currentRange);
                vm.widget13.loadData(vm.widget13.currentRange);
            }

            function reloadWidgets() {

                vm.summary_data.loaded = false;

                //console.log("reload widgets");
                // console.log(vm.zoneFilter.getSelectedZoneId());
                // console.log(vm.teamFilter.getUserIds());

                msApi.request(Api.get_summary + '@post',
                    {
                        period_code: vm.DateFilter.currentRange,
                        zone_id: vm.overviewzoneFilter.getSelectedZoneId(),
                        user_ids: vm.overviewteamFilter.getUserIds()
                    },
                    // Success
                    function (data) {

                        //console.log(data);
                        formatCurrency(data.result[0].previous_revenue);

                        if (data.hasOwnProperty("result")) {

                            vm.summary_data = data.result[0];
                            vm.summary_data.population = 'N/A';

                            if (data.result[0].schedule_target > 0) {
                                vm.summary_data.achivement_pct = Number(((data.result[0].revenue / data.result[0].schedule_target) * 100).toFixed(1));
                                //console.log(vm.summary_data.achivement_pct);
                            }
                            else {
                                vm.summary_data.achivement_pct = 'N/A';
                            }
                            if (data.result[0].planned_visit > 0) {
                                vm.summary_data.coverage_pct = Number(((data.result[0].visited_count / data.result[0].planned_visit) * 100).toFixed(1));
                            }
                            else {
                                vm.summary_data.coverage_pct = 'N/A';
                            }

                            if (data.result[0].previous_visited_count > 0) {
                                vm.summary_data.previous_coverage_pct = Number((((data.result[0].visited_count - data.result[0].previous_visited_count) / data.result[0].previous_visited_count) * 100).toFixed(1));
                            }
                            else {
                                vm.summary_data.previous_coverage_pct = 'N/A';
                            }

                            if (data.result[0].previous_revenue > 0) {
                                vm.summary_data.previous_achivement_pct = Number((((data.result[0].revenue - data.result[0].previous_revenue) / data.result[0].previous_revenue) * 100).toFixed(1));
                            }
                            else {
                                vm.summary_data.previous_achivement_pct = 'N/A';
                            }

                            if (data.result[0].active_users > 0) {
                                data.result[0].avg_sales_per_user = Number(((data.result[0].revenue / data.result[0].active_users)).toFixed(1));
                            }
                            else {
                                vm.summary_data.avg_sales_per_user = 'N/A';
                            }

                            vm.summary_data.previous_revenue = formatCurrency(data.result[0].previous_revenue);
                            vm.summary_data.schedule_target = formatCurrency(data.result[0].schedule_target);
                            vm.summary_data.revenue = formatCurrency(data.result[0].revenue);
                            vm.summary_data.previous_visited_count = formatCurrency(data.result[0].previous_visited_count);
                            vm.summary_data.visited_count = formatCurrency(data.result[0].visited_count);
                            vm.summary_data.planned_visit = formatCurrency(data.result[0].planned_visit);
                            vm.summary_data.avg_sales_per_user = formatCurrency(Math.round(data.result[0].avg_sales_per_user));
                            vm.summary_data.total_retailer = formatCurrency(data.result[0].total_retailer);
                            vm.summary_data.new_outlet_sales = formatCurrency(data.result[0].new_outlet_sales);
                            vm.summary_data.active_users = formatCurrency(data.result[0].active_users);
                            vm.summary_data.loaded = true;

                        }
                    },
                    // Error
                    function (data) {
                        // TODO Show a notificatoin to the user, or replace the cards with an error message.
                        //$log.log('Unable to fetch widget1: ' + data);
                    });
            }

            //............ Report 1 ...........


            /* ag-grid */

            var gridcolumns;
            var gridcolumns1;

            var zerosalescolumns = [
                {headerName: "EMP Code", field: "emp_code", sort: 'asc'},
                {headerName: "Salesman", field: "salesman"},
                {headerName: "Retailer ID", field: "retailer_id"},
                {headerName: "Retailer", field: "retailer_name"},
                {headerName: "Zone", field: "zone"},
                {headerName: "Area", field: "area"},
                {headerName: "Type", field: "type"},
                {headerName: "Reason", field: "reason"},
                {headerName: "Date", field: "date"},

            ];

            var salesbycustomertypegraphcolumns = [
                {headerName: "Outlet Type", field: "outlet_type", sort: 'asc'},
                {headerName: "Sales", field: "type_sales"},
            ];

            var nosalesvisitsoutletgraphcolumns = [
                {headerName: "Outlet Type", field: "outlet_type", sort: 'asc'},
                {headerName: "Outlet Count %", field: "outlet_count_pct"},
            ];


            var newoutletcolumns = [
                {headerName: "EMP Code", field: "emp_code", sort: 'asc'},
                {headerName: "Salesman", field: "salesman"},
                {headerName: "Zone", field: "zone"},
                {headerName: "Area", field: "area"},
                {headerName: "Beat", field: "beat_plan"},
                {headerName: "Outlet ID", field: "retailer_id"},
                {headerName: "Outlet Name", field: "retailer_name"},
                {headerName: "Outlet Type", field: "retailer_type"},
                {headerName: "VC %", field: "vc_percentage"},
                {headerName: "Total Sales", field: "total_amount"},
                {headerName: "PC %", field: "pc_percentage"},
                {headerName: "Average SKUs Sold", field: "avg_lines"},
                {headerName: "Unique SKUs Sold", field: "unique_lines"},
                {headerName: "Average Order Value", field: "avg_order_value"},
                {headerName: "Not Billed", field: "not_billed"},
                {headerName: "Not Visited", field: "not_visited"}
            ];

            var skudispersioncolumns = [
                {headerName: "Distinct Lines", field: "sol_range"},
                {headerName: "No of Customers", field: "customer_count"},
                {headerName: "No of Invoices", field: "invoice_count"},
                {headerName: "%", field: "percentage"}
            ];

            var revenuedispersioncolumns = [
                {headerName: "Revenue", field: "sol_range"},
                {headerName: "No of Customers", field: "customer_count"},
                {headerName: "No of Invoices", field: "invoice_count"},
                {headerName: "%", field: "percentage"}
            ];

            var coverageandprodcolumns = [
                {headerName: "EMP Code", field: "emp_code", sort: 'asc'},
                {headerName: "Salesman", field: "login"},
                {headerName: "Total Outlets", field: "unique_retailers"},
                {headerName: "TC", field: "retailer_count"},
                {headerName: "VC", field: "visited_count"},
                {headerName: "VC %", field: "coverage"},
                {headerName: "Unique VC", field: "unique_vc"},
                {headerName: "Unique VC %", field: "unique_vc_pct"},
                {headerName: "PC", field: "productive_calls"},
                {headerName: "PC %", field: "prod_pct"},
                {headerName: "Unique PC", field: "unique_pc"},
                {headerName: "Unique PC %", field: "unique_pc_pct"},
                {headerName: "Unscheduled PC", field: "unscheduled_order"}
            ];


            var srscorecardcolumns = [
                {headerName: "EMP Code", field: "emp_code"},
                {headerName: "Salesman", field: "salesman"},
                {headerName: "Target", field: "target"},
                {headerName: "Achieved", field: "achieved"},
                {headerName: "Achieved %", field: "achieved_pct"},
                {headerName: "JP  adherence %", field: "jp_adherence_pct"},
                {headerName: "Unique PC %", field: "unique_outlet_billed_pct"},
                {headerName: "PC %", field: "bills_cut_pct"},
                {headerName: "Avg SKUs %", field: "average_lines_cut"},
                {headerName: "Avg Order Val", field: "average_bill_value"},
                {headerName: "MSS Achieved", field: "mss_sales"},
                {headerName: "MSS Achieved %", field: "mss_achieved_pct"},
                {headerName: "Rank", field: "rank"}
            ];

            var msssalesbyoutletcolumns = [
                {headerName: "Zone", field: "zone_id", sort: 'asc'},
                {headerName: "Dist Code", field: "distributor_code"},
                {headerName: "Dist Name", field: "distributor_name"},
                {headerName: "Outlet ID", field: "partner_id"},
                {headerName: "Outlet Name", field: "partner_name"},
                {headerName: "Outlet Type", field: "retailer_type"},
                {headerName: "Total Sales", field: "total_sales"},
                {headerName: "MSS Sales", field: "mss_sales"},
                {headerName: "% Contribution", field: "mss_ach"}
            ];


            var salesmanproductivitymeasurescolumns = [
                {headerName: "Emp Code", field: "emp_code", sort: 'asc'},
                {headerName: "Salesman", field: "login"},
                // {headerName: "Zone", field: "zone_id"},
                {headerName: "Total Outlets", field: "unique_retailers"},
                {headerName: "TC", field: "retailer_count"},
                {headerName: "VC", field: "visited_count"},
                {headerName: "VC%", field: "coverage"},
                {headerName: "PC", field: "productive_calls"},
                {headerName: "PC%", field: "prod_pct"},
                {headerName: "Revenue", field: "revenue"},
                {headerName: "Total SKU", field: "total_sku"},
                {headerName: "Unique VC", field: "unique_vc"},
                {headerName: "Unique PC", field: "unique_pc"},
                {headerName: "Unique VC %", field: "unique_vc_pct"},
                {headerName: "Unique PC %", field: "unique_pc_pct"},
                {headerName: "AVG SKU", field: "avg_sku_per_order"},
                {headerName: "Unique SKU", field: "unique_sku"},
                {headerName: "Avg Order Value", field: "avg_revenue_per_order"},
            ];

            var nosalesconsecutivevisitscolumns = [

                {headerName: "EMP Code", field: "emp_code", sort: 'asc'},
                {headerName: "Emp Name", field: "salesman"},
                {headerName: "Zone", field: "zone"},
                {headerName: "OutletId", field: "outlet_id"},
                {headerName: "Outlet Name", field: "retailer_name"},
                {headerName: "Outlet Type", field: "outlet_type"}
               // {headerName: "VC", field: "visit_count"}
            ]

            var salesbycustomertypecolumns = [

                {headerName: "EMP Code", field: "emp_code", sort: 'asc'},
                {headerName: "Emp Name", field: "salesman"},
                {headerName: "Zone", field: "zone"},
                {headerName: "Dist Code", field: "dist_code"},
                {headerName: "Dist Name", field: "dist_name"},
                // {headerName: "Category", field: "categ_name"},
                // {headerName: "Brand", field: "brand_name"},
                {headerName: "Outlet Type", field: "outlet_type"},
                {headerName: "Net Sales", field: "type_sales"},
                {headerName: "Contribution %", field: "contribution_pct"}
            ]

            var outletwisesalescolumns = [
                {headerName: "EMP Code", field: "emp_code", sort: 'asc'},
                {headerName: "Emp Name", field: "login"},
                {headerName: "Zone", field: "zone"},
                {headerName: "Dist Code", field: "distributor_code"},
                {headerName: "Dist Name", field: "distributor"},
                {headerName: "Outlet ID", field: "partner_id"},
                {headerName: "Outlet Name", field: "partner_name"},
                {headerName: "Outlet Type", field: "partner_type"},
                {headerName: "SKU Code", field: "sku_code"},
                {headerName: "SKU Name", field: "sku_name"},
                {headerName: "Qty", field: "product_uom_qty"},
                {headerName: "Sales", field: "total_sales"},
                {headerName: "Date", field: "date_order"}

            ]

            var weeklysalesreportcolumns = [
                {headerName: "WEEK", field: "name"},
                {headerName: "Target", field: "month_target"},
                {headerName: "Revenue", field: "month_value"},
                {headerName: "Achievement", field: "month_ach"},
                {headerName: "TC", field: "retailer_count"},
                {headerName: "VC", field: "visited_count"},
                {headerName: "Coverage", field: "coverage"},
                {headerName: "PC", field: "productive_calls"},
                {headerName: "PC %", field: "pc_ach"},
                {headerName: "Total SKU", field: "total_sku"},
                {headerName: "Unique SKU", field: "unique_sku"},
                {headerName: "Avg Order Value", field: "avg_order_value"},
                {headerName: "Beat Count", field: "beat_count"},
                {headerName: "PC / Beat", field: "pc_per_beat"},
                {headerName: "TC / Beat", field: "tc_per_beat"},
                {headerName: "Order / Beat", field: "avg_order_per_beat"},
                {headerName: "Total SKU/Beat", field: "sku_per_beat"},
                {headerName: "Unique SKU/Beat", field: "us_per_beat"},
                {headerName: "Mss Ach", field: "mss_achievement"},
                {headerName: "Focus Target", field: "focus_target"},
                {headerName: "Focus Ach", field: "focus_ach"}
            ]


            vm.gridOptions = {
                columnDefs: gridcolumns,
                rowData: [],
                enableColResize: true,
                pagination: true,
                enableSorting: true,
                /*onGridReady: function (params) {
                    params.api.sizeColumnsToFit();
                 }*/
            };

            vm.searchGrid = function(){
                vm.gridOptions.api.setQuickFilter(vm.searchaggrid);
            }


            vm.gridOptions1 = {
                columnDefs: gridcolumns,
                rowData: [],
                enableColResize: true,
                pagination: true,
                enableSorting: true,
                /*onGridReady: function (params) {
                 params.api.sizeColumnsToFit();
                 }*/
            };

            vm.searchGrid = function () {
                vm.gridOptions1.api.setQuickFilter(vm.searchaggrid);
            }
            /* ag-grid */

            vm.zerosales = {
                data: [],

                loadData: function () {

                    vm.zerosales.loaded = false;
                    vm.loadZsalesGrid = false;
                    vm.zerosales1.loadData();
                    vm.zerosales2.loadData();
                    gridcolumns = zerosalescolumns;
                    vm.searchGrid = function () {
                        vm.gridOptions.api.setQuickFilter(vm.searchaggrid);
                    }

                    msApi.request(Api.get_zero_sales_report + '@get',
                        {
                            start_date: vm.start_date,
                            end_date: vm.end_date,
                            zone_id: vm.zoneFilter.getSelectedZoneId(),
                            salesman_id: vm.SalesmanFilter.getSelectedUserId(),
                            emp_code: vm.empcodeFilter.getSelectedEmployeeId(),
                        },
                        // Success
                        function (data) {
                            $log.log(vm.zone);
                            $log.log('Received zero sales data');
                            $log.log(data);
                            // Set new values for widget4 based on the new data
                            vm.zerosales.data = data.result;
                            // Array build to export As CSV
                            var zSalesArray = [];  // export csv array
                            var rowDataNew = [];  // ag-grid row data
                            var i = 0;

                            for (var key in vm.zerosales.data) {
                                if (vm.zerosales.data.hasOwnProperty(key)) {
                                    //  if(i<30000){
                                    zSalesArray.push({
                                        'SL No': i + 1,
                                        'EMP Code': vm.zerosales.data[key].emp_code,
                                        'Salesman': vm.zerosales.data[key].salesman,
                                        'Retailer ID': vm.zerosales.data[key].retailer_id,
                                        'Retailer': vm.zerosales.data[key].retailer_name,
                                        'Zone': vm.zerosales.data[key].zone,
                                        'Area': vm.zerosales.data[key].area,
                                        'Type': vm.zerosales.data[key].type,
                                        'Reason': vm.zerosales.data[key].reason,
                                        'Date': vm.zerosales.data[key].date
                                    });

                                    rowDataNew.push({
                                        'emp_code': vm.zerosales.data[key].emp_code,
                                        'salesman': vm.zerosales.data[key].salesman,
                                        'retailer_id': vm.zerosales.data[key].retailer_id,
                                        'retailer_name': vm.zerosales.data[key].retailer_name,
                                        'zone': vm.zerosales.data[key].zone,
                                        'area': vm.zerosales.data[key].area,
                                        'type': vm.zerosales.data[key].type,
                                        'reason': vm.zerosales.data[key].reason,
                                        'date': vm.zerosales.data[key].date
                                    });
                                    //  }
                                    i++;
                                }
                            }


                            vm.excelArray = zSalesArray;
                            vm.gridOptions.rowData = rowDataNew;
                            vm.gridOptions.columnDefs = gridcolumns;
                            vm.loadZsalesGrid = true;
                            vm.zerosales.loaded = true;
                        },
                        // Error
                        function (data) {
                            // TODO Show a notificatoin to the user, or replace the cards with an error message.
                            //$log.log('Unable to fetch widget4: ' + data);
                        }
                    );

                },


                init: function () {
                    vm.zerosales.loadData();
                }
            };


            /*Zero sales Outlet Graph 1*/

            vm.zerosales1 = {
                data: [],
                // Widget 1 Pie Chart
                widget2: {
                    title: "Zero Sales Outlet - Not visited/Not Billed",
                    mainChart: {
                        config: {
                            refreshDataOnly: true,
                            deepWatchData: true
                        },
                        options: {
                            chart: {
                                type: 'pieChart',
                                color: ['#f44336', '#9c27b0', '#03a9f4', '#e91e63', '#c8b550', '#cc6699', '#ffcc00', '#6699ff', '#0099cc', '#9966ff'],
                                height: 400,
                                margin: {
                                    top: 0,
                                    right: 0,
                                    bottom: 0,
                                    left: 0
                                },
                                donut: true,
                                clipEdge: true,
                                cornerRadius: 0,
                                labelType: 'percent',
                                padAngle: 0.02,
                                x: function (d) {
                                    return d.label;
                                },
                                y: function (d) {
                                    return d.value;
                                },
                                tooltip: {
                                    gravity: 's',
                                    classes: 'gravity-s'
                                }
                            }
                        },
                        data: []
                    }
                },

                loadData: function (rangeIdToLoad) {
                    vm.zerosales1.loaded = false;
                    vm.zerosales1.widget2.mainChart.data.length = 0; // Remove all previous chart data on reload
                    msApi.request(Api.get_zero_sales_report_graph1 + '@get',
                        {
                            start_date: vm.start_date,
                            end_date: vm.end_date,
                            zone_id: vm.zoneFilter.getSelectedZoneId(),
                            salesman_id: vm.SalesmanFilter.getSelectedUserId(),
                            emp_code: vm.empcodeFilter.getSelectedEmployeeId()
                        },
                        // Success
                        function (data) {
                            vm.zerosales1.data = data.result;
                            vm.zerosales1.widget2.mainChart.data.length = 0; // Remove all previous chart data on reload
                            //Assigning Data to pieChart -widget2
                            angular.forEach(data.result, function (outlet, index) {
                                vm.zerosales1.widget2.mainChart.data[index] = {
                                    label: outlet.type,
                                    value: outlet.percentage
                                };
                            });
                            vm.zerosales1.loaded = true;
                        },
                        function (data) {
                        }
                    );
                },
                init: function () {
                    vm.zerosales1.loadData();
                }
            };
            /*Ends Here*/


            /*Zero sales Outlet Graph 1*/

            vm.zerosales2 = {
                data: [],
                // Widget 1 Pie Chart
                widget2: {
                    title: "Zero Sales Outlet Type%",
                    ranges: {
                        TM: "This Month",
                        LM: "Last Month",
                        "2M": "2 Months Ago"
                    },
                    mainChart: {
                        config: {
                            refreshDataOnly: true,
                            deepWatchData: true
                        },
                        options: {
                            chart: {
                                type: 'pieChart',
                                color: ['#f44336', '#9c27b0', '#03a9f4', '#e91e63', '#c8b550', '#cc6699', '#ffcc00', '#6699ff', '#0099cc', '#9966ff', '#00cc66', '#333300'],
                                height: 400,
                                margin: {
                                    top: 0,
                                    right: 0,
                                    bottom: 0,
                                    left: 0
                                },
                                donut: true,
                                clipEdge: true,
                                cornerRadius: 0,
                                labelType: 'percent',
                                padAngle: 0.02,
                                x: function (d) {
                                    return d.label;
                                },
                                y: function (d) {
                                    return d.value;
                                },
                                tooltip: {
                                    gravity: 's',
                                    classes: 'gravity-s'
                                }
                            }
                        },
                        data: []
                    }
                },

                loadData: function (rangeIdToLoad) {
                    vm.zerosales2.loaded = false;
                    vm.zerosales2.widget2.mainChart.data.length = 0; // Remove all previous chart data on reload
                    msApi.request(Api.get_zero_sales_report_graph2 + '@get',
                        {
                            start_date: vm.start_date,
                            end_date: vm.end_date,
                            zone_id: vm.zoneFilter.getSelectedZoneId(),
                            salesman_id: vm.SalesmanFilter.getSelectedUserId(),
                            emp_code: vm.empcodeFilter.getSelectedEmployeeId(),
                        },
                        // Success
                        function (data) {
                            vm.zerosales2.data = data.result;
                            vm.zerosales2.widget2.mainChart.data.length = 0; // Remove all previous chart data on reload
                            //Assigning Data to pieChart -widget2
                            angular.forEach(data.result, function (outlet, index) {
                                vm.zerosales2.widget2.mainChart.data[index] = {
                                    label: outlet.res,
                                    value: outlet.percentage
                                };
                            });
                            vm.zerosales2.loaded = true;
                        },
                        function (data) {
                        }
                    );
                },
                init: function () {
                    vm.zerosales2.loadData();
                }
            };
            /*Ends Here*/

            /*Sales By Cusotmer Type Graph widget*/

            vm.salesbycustomertypegraph = {
                data: [],
                // Widget 1 Pie Chart
                widget2: {
                    title: "Sales By Cusotmer Type - Type %",
                    mainChart: {
                        config: {
                            refreshDataOnly: true,
                            deepWatchData: true
                        },
                        options: {
                            chart: {
                                type: 'pieChart',
                                color: ['#f44336', '#9c27b0', '#03a9f4', '#e91e63', '#c8b550', '#cc6699', '#ffcc00', '#6699ff', '#0099cc', '#9966ff', '#00cc66', '#333300'],
                                height: 400,
                                margin: {
                                    top: 0,
                                    right: 0,
                                    bottom: 0,
                                    left: 0
                                },
                                donut: true,
                                clipEdge: true,
                                cornerRadius: 0,
                                labelType: 'percent',
                                padAngle: 0.02,
                                x: function (d) {
                                    return d.label;
                                },
                                y: function (d) {
                                    return d.value;
                                },
                                tooltip: {
                                    gravity: 's',
                                    classes: 'gravity-s'
                                }
                            }
                        },
                        data: []
                    }
                },
                loadData: function () {
                    vm.salesbycustomertypegraph.loaded = false;
                    vm.loadsalesbycustomertypegraphGrid = false;
                    vm.salesbycustomertypegraph.widget2.mainChart.data.length = 0; // Remove all previous chart data on reload
                    gridcolumns1 = salesbycustomertypegraphcolumns;

                    msApi.request(Api.sales_by_customer_type_graph + '@get',
                        {
                            start_date: vm.start_date,
                            end_date: vm.end_date,
                            zone_id: vm.zoneFilter.getSelectedZoneId(),
                            salesman_id: vm.SalesmanFilter.getSelectedUserId(),
                            emp_code: vm.empcodeFilter.getSelectedEmployeeId(),
                            brand_id: vm.BrandFilter.getSelectedBrandId(),
                            categ_id: vm.CategoryFilter.getSelectedCategoryId(),
                            dist_id: vm.distnameFilter.getSelectedDistributorId(),
                            dist_code: vm.distcodeFilter.getSelectedDistributorId()
                        },
                        // Success
                        function (data) {
                            vm.salesbycustomertypegraph.data = data.result;
                            //Assigning Data to pieChart -widget2
                            vm.salesbycustomertypegraph.widget2.mainChart.data.length = 0; // Remove all previous chart data on reload
                            angular.forEach(data.result, function (outlet, index) {
                                vm.salesbycustomertypegraph.widget2.mainChart.data[index] = {
                                    label: outlet.outlet_type,
                                    value: outlet.contribution_pct
                                };
                            });


                            var rowDataNew1 = [];  // ag-grid row data
                            var i = 0;
                            for (var key in vm.salesbycustomertypegraph.data) {
                                if (vm.salesbycustomertypegraph.data.hasOwnProperty(key)) {
                                    rowDataNew1.push({
                                        'outlet_type': vm.salesbycustomertypegraph.data[key].outlet_type,
                                        'type_sales': vm.salesbycustomertypegraph.data[key].type_sales
                                    });
                                    i++;
                                }
                            }
                            vm.gridOptions1.rowData = rowDataNew1;
                            vm.gridOptions1.columnDefs = gridcolumns1;
                            vm.salesbycustomertypegraph.loaded = true;
                            vm.loadsalesbycustomertypegraphGrid = true;
                        },
                        // Error
                        function (data) {
                            // TODO Show a notificatoin to the user, or replace the cards with an error message.
                        }
                    );
                },
                init: function () {
                    vm.salesbycustomertypegraph.loadData();
                }
            };
            /**/


            vm.exportAsCsv = function (name) {
                //alert("Okay.......");
                share.JSONToCSVConvertor(vm.excelArray, name, true);
            }

            vm.newoutlet = {
                data: [],

                loadData: function () {
                    vm.newoutlet.loaded = false;
                    vm.loadnewoutletGrid = false;
                    gridcolumns = newoutletcolumns;
                    vm.newoutletzonegraph.loadData();
                    vm.newoutlettypegraph.loadData();
                    vm.newoutletinstancegraph.loadData();

                    vm.searchGrid = function () {
                        vm.gridOptions.api.setQuickFilter(vm.searchaggrid);
                    }

                    msApi.request(Api.get_new_outlet_report + '@get',
                        {
                            start_date: vm.start_date,
                            end_date: vm.end_date,
                            zone_id: vm.zoneFilter.getSelectedZoneId(),
                            salesman_id: vm.SalesmanFilter.getSelectedUserId(),
                            // area_id: vm.SalesmanFilter.getSelectedUserId()
                            emp_code: vm.empcodeFilter.getSelectedEmployeeId(),
                            beat_id: vm.beatFilter.getSelectedBeatId()
                        },
                        // Success
                        function (data) {
                            //   $log.log(vm.zone);
                            $log.log('Received new outlet data');
                            $log.log(data);
                            // Set new values for widget4 based on the new data

                            vm.newoutlet.data = data.result;

                            // Array build to export As CSV
                            var newoutletArray = [];  // export csv array
                            var rowDataNew = [];  // ag-grid row data
                            var i = 0;
                            for (var key in vm.newoutlet.data) {
                                if (vm.newoutlet.data.hasOwnProperty(key)) {
                                    //  if(i<30000){
                                    newoutletArray.push({
                                        'SL No': i + 1,
                                        'Emp Code': vm.newoutlet.data[key].emp_code,
                                        'Salesman': vm.newoutlet.data[key].salesman,
                                        'Zone': vm.newoutlet.data[key].zone,
                                        'Area': vm.newoutlet.data[key].area,
                                        'Beat': vm.newoutlet.data[key].beat_plan,
                                        'Outlet ID': vm.newoutlet.data[key].retailer_id,
                                        'Outlet Name': vm.newoutlet.data[key].retailer_name,
                                        'Outlet Type': vm.newoutlet.data[key].retailer_type,
                                        'VC%': vm.newoutlet.data[key].vc_percentage,
                                        'Total Sales': vm.newoutlet.data[key].total_amount,
                                        'PC%': vm.newoutlet.data[key].pc_percentage,
                                        'Average SKUs Sold': vm.newoutlet.data[key].avg_lines,
                                        'Unique SKUs Sold': vm.newoutlet.data[key].unique_lines,
                                        'Average Order Value': vm.newoutlet.data[key].avg_order_value,
                                        'Not Billed': vm.newoutlet.data[key].not_billed,
                                        'Not Visited': vm.newoutlet.data[key].not_visited
                                    });


                                    rowDataNew.push({
                                        'emp_code': vm.newoutlet.data[key].emp_code,
                                        'salesman': vm.newoutlet.data[key].salesman,
                                        'zone': vm.newoutlet.data[key].zone,
                                        'area': vm.newoutlet.data[key].area,
                                        'beat_plan': vm.newoutlet.data[key].beat_plan,
                                        'retailer_id': vm.newoutlet.data[key].retailer_id,
                                        'retailer_name': vm.newoutlet.data[key].retailer_name,
                                        'retailer_type': vm.newoutlet.data[key].retailer_type,
                                        'vc_percentage': vm.newoutlet.data[key].vc_percentage,
                                        'total_amount': vm.newoutlet.data[key].total_amount,
                                        'pc_percentage': vm.newoutlet.data[key].pc_percentage,
                                        'avg_lines': vm.newoutlet.data[key].avg_lines,
                                        'unique_lines': vm.newoutlet.data[key].unique_lines,
                                        'avg_order_value': vm.newoutlet.data[key].avg_order_value,
                                        'not_billed': vm.newoutlet.data[key].not_billed,
                                        'not_visited': vm.newoutlet.data[key].not_visited
                                    });
                                    i++;
                                }
                            }
                            vm.excelArray = newoutletArray;
                            vm.gridOptions.rowData = rowDataNew;
                            vm.gridOptions.columnDefs = gridcolumns;
                            vm.newoutlet.loaded = true;
                            vm.loadnewoutletGrid = true;


                        },
                        // Error
                        function (data) {
                            // TODO Show a notificatoin to the user, or replace the cards with an error message.
                            //$log.log('Unable to fetch widget4: ' + data);
                        }
                    );
                },


                init: function () {
                    vm.newoutlet.loadData();
                }
            };

            /*New Outlet Report Zonewise Graph*/


            vm.newoutletzonegraph = {
                data: [],

                widget2: {
                    title: "Zonewise Analysis",
                    mainChart: {
                        config: {
                            refreshDataOnly: true,
                            deepWatchData: true
                        },
                        options: {
                            chart: {
                                type: 'multiBarChart',
                                color: ["#529CD6", '#A5ADA5', '#EFB500', "#529C5A", "#29528C"],
                                height: 600,
                                // width:3000 ,
                                rotateLabels: 45,
                                axisLabelDistance: 10,
                                forceY: [0, 200],
                                margin: {
                                    top: 64,
                                    right: 16,
                                    bottom: 64,
                                    left: 64
                                },
                                padding: {
                                    top: 10
                                },
                                clipEdge: true,
                                groupSpacing: 0.4,
                                reduceXTicks: false,
                                stacked: false,
                                duration: 250,
                                x: function (d) {
                                    return d.x;
                                },
                                y: function (d) {
                                    return d.y;
                                },
                                xAxis: {
                                    tickFormat: function (d) {
                                        return d;
                                    },
                                    tickPadding: 7

                                },
                                yAxis: {
                                    tickFormat: function (d) {
                                        return d;
                                    }
                                },
                                legend: {
                                    margin: {
                                        top: 32,
                                        bottom: 32,
                                        left: 50
                                    },
                                    rightAlign: false
                                },
                                controls: {
                                    margin: {
                                        top: 32,
                                        bottom: 32
                                    }
                                },
                                tooltip: {
                                    gravity: 's',
                                    classes: 'gravity-s'
                                }
                            }
                        },
                        data: [],
                    }
                },
                loadData: function () {

                    vm.newoutletzonegraph.loaded = false;
                    vm.newoutletzonegraph.widget2.mainChart.data.length = 0; // Remove all previous chart data on reload
                    vm.newoutletzonegraph.widget2.mainChart.options.chart.width = 1200 ;

                    msApi.request(Api.get_new_outlet_by_zone_graph + '@get',
                        {
                            start_date: vm.start_date,
                            end_date: vm.end_date,
                            zone_id: vm.zoneFilter.getSelectedZoneId(),
                            salesman_id: vm.SalesmanFilter.getSelectedUserId(),
                            emp_code: vm.empcodeFilter.getSelectedEmployeeId(),
                            beat_id: vm.beatFilter.getSelectedBeatId()
                        },
                        // Success
                        function (data) {
                            vm.newoutletzonegraph.data = data.result;
                            if ((data.result.length) > 20) {
                                vm.newoutletzonegraph.widget2.mainChart.options.chart.width = 3000;
                            }
                            vm.newoutletzonegraph.widget2.mainChart.data.length = 0;

                            //Assigning Data to BarChart -widget1

                            var VC = []
                            var PC = []
                            angular.forEach(data.result, function (chartData, index) {
                                VC[index] = {
                                    x: chartData.zone,
                                    y: chartData.vc
                                };
                            });
                            angular.forEach(data.result, function (chartData, index) {
                                PC[index] = {
                                    x: chartData.zone,
                                    y: chartData.pc
                                };
                            });


                            vm.newoutletzonegraph.widget2.mainChart.data[0] = {
                                key: "VC %",
                                values: VC
                            };
                            vm.newoutletzonegraph.widget2.mainChart.data[1] = {
                                key: "PC %",
                                values: PC
                            };

                        },
                        function (data) {
                        }
                    );
                },
                init: function () {
                    vm.newoutletzonegraph.loadData();
                }
            };

            /**/

            /*New Outlet Report Type Graph*/

            vm.newoutlettypegraph = {
                data: [],

                widget2: {
                    title: "Outlet Type Analysis",
                    mainChart: {
                        config: {
                            refreshDataOnly: true,
                            deepWatchData: true
                        },
                        options: {
                            chart: {
                                type: 'multiBarChart',
                                color: ["#529CD6", '#A5ADA5', '#EFB500', "#529C5A", "#29528C"],
                                height: 600,
                                rotateLabels: 45,
                                axisLabelDistance: 10,
                                forceY: [0, 200],
                                margin: {
                                    top: 64,
                                    right: 16,
                                    bottom: 64,
                                    left: 64
                                },
                                padding: {
                                    top: 10
                                },
                                clipEdge: true,
                                groupSpacing: 0.4,
                                reduceXTicks: false,
                                stacked: false,
                                duration: 250,
                                x: function (d) {
                                    return d.x;
                                },
                                y: function (d) {
                                    return d.y;
                                },
                                xAxis: {
                                    tickFormat: function (d) {
                                        return d;
                                    },
                                    tickPadding: 7

                                },
                                yAxis: {
                                    tickFormat: function (d) {
                                        return d;
                                    }
                                },
                                legend: {
                                    margin: {
                                        top: 32,
                                        bottom: 32,
                                        left: 50
                                    },
                                    rightAlign: false
                                },
                                controls: {
                                    margin: {
                                        top: 32,
                                        bottom: 32
                                    }
                                },
                                tooltip: {
                                    gravity: 's',
                                    classes: 'gravity-s'
                                }
                            }
                        },
                        data: [],
                    }
                },
                loadData: function () {

                    vm.newoutlettypegraph.loaded = false;
                    vm.newoutlettypegraph.widget2.mainChart.data.length = 0; // Remove all previous chart data on reload
                    vm.newoutlettypegraph.widget2.mainChart.options.chart.width = 1200 ;

                    msApi.request(Api.get_new_outlet_by_retailer_type_graph + '@get',
                        {
                            start_date: vm.start_date,
                            end_date: vm.end_date,
                            zone_id: vm.zoneFilter.getSelectedZoneId(),
                            salesman_id: vm.SalesmanFilter.getSelectedUserId(),
                            emp_code: vm.empcodeFilter.getSelectedEmployeeId(),
                            beat_id: vm.beatFilter.getSelectedBeatId()
                        },
                        // Success
                        function (data) {
                            vm.newoutlettypegraph.data = data.result;
                            if ((data.result.length) > 20) {
                                vm.newoutlettypegraph.widget2.mainChart.options.chart.width = 3000;
                            }
                            vm.newoutlettypegraph.widget2.mainChart.data.length = 0;

                            //Assigning Data to BarChart -widget1

                            var VC = [];
                            var PC = [];
                            angular.forEach(data.result, function (chartData, index) {
                                VC[index] = {
                                    x: chartData.partner_type,
                                    y: chartData.vc
                                };
                            });
                            angular.forEach(data.result, function (chartData, index) {
                                PC[index] = {
                                    x: chartData.partner_type,
                                    y: chartData.pc
                                };
                            });


                            vm.newoutlettypegraph.widget2.mainChart.data[0] = {
                                key: "VC %",
                                values: VC
                            };
                            vm.newoutlettypegraph.widget2.mainChart.data[1] = {
                                key: "PC %",
                                values: PC
                            };

                        },
                        function (data) {
                        }
                    );
                },
                init: function () {
                    vm.newoutlettypegraph.loadData();
                }
            };

            /**/

            /*New Outlet Report Graph 3*/

            vm.newoutletinstancegraph = {
                data: [],
                // Widget 1 Pie Chart
                widget2: {
                    title: "Zero sales Instance %",
                    ranges: {
                        TM: "This Month",
                        LM: "Last Month",
                        "2M": "2 Months Ago"
                    },
                    mainChart: {
                        config: {
                            refreshDataOnly: true,
                            deepWatchData: true
                        },
                        options: {
                            chart: {
                                type: 'pieChart',
                                color: ['#f44336', '#9c27b0', '#03a9f4', '#e91e63', '#c8b550', '#cc6699', '#ffcc00', '#6699ff', '#0099cc', '#9966ff', '#00cc66', '#333300'],
                                height: 400,
                                margin: {
                                    top: 0,
                                    right: 0,
                                    bottom: 0,
                                    left: 0
                                },
                                donut: true,
                                clipEdge: true,
                                cornerRadius: 0,
                                labelType: 'value',
                                padAngle: 0.02,
                                x: function (d) {
                                    return d.label;
                                },
                                y: function (d) {
                                    return d.value;
                                },
                                tooltip: {
                                    gravity: 's',
                                    classes: 'gravity-s'
                                }
                            }
                        },
                        data: []
                    }
                },

                loadData: function (rangeIdToLoad) {
                    vm.newoutletinstancegraph.loaded = false;
                    vm.newoutletinstancegraph.widget2.mainChart.data.length = 0; // Remove all previous chart data on reload
                    msApi.request(Api.get_new_outlet_zero_sales_graph + '@get',
                        {
                            start_date: vm.start_date,
                            end_date: vm.end_date,
                            zone_id: vm.zoneFilter.getSelectedZoneId(),
                            salesman_id: vm.SalesmanFilter.getSelectedUserId(),
                            emp_code: vm.empcodeFilter.getSelectedEmployeeId(),
                            beat_id: vm.beatFilter.getSelectedBeatId()
                        },
                        // Success
                        function (data) {
                            vm.newoutletinstancegraph.data = data.result;
                            vm.newoutletinstancegraph.widget2.mainChart.data.length = 0; // Remove all previous chart data on reload
                            angular.forEach(data.result, function (outlet, index) {
                                vm.newoutletinstancegraph.widget2.mainChart.data[index] = {
                                    label: outlet.type,
                                    value: outlet.percentage
                                };
                            });
                            vm.newoutletinstancegraph.loaded = true;
                        },
                        function (data) {
                        }
                    );
                },
                init: function () {
                    vm.newoutletinstancegraph.loadData();
                }
            };
            /*Ends Here*/


            /*AG Grid View for Weekly Sales Report*/


            // noinspection JSAnnotator
            vm.weeklysalesreport = {
                data: [],
                widget11 : {
                    title: "Weekly Sales Trend",
                    mainChart: {
                        config: {
                            refreshDataOnly: true,
                            deepWatchData: true
                        },
                        options: {
                            chart: {
                                type: 'lineChart',
                                color: ["#529CD6", '#A5ADA5', '#EFB500', "#529C5A", "#29528C"],
                                height: 420,
                                forceY: [0, 0, 150],
                                showValues:true,
                                margin: {
                                    top: 32,
                                    right: 32,
                                    bottom: 32,
                                    left: 72
                                },
                                useInteractiveGuideline: true,
                                clipVoronoi: false,
                                axisLabelDistance: 50,
                                // interpolate: 'cardinal',
                                x: function (d) {
                                    if (d) {
                                        return d.x;
                                    }
                                    return 0; // Assume value zero if the respective day has no data
                                },
                                y: function (d) {
                                    if (d) {
                                        return d.y;
                                    }
                                    return 0; // Assume value zero if the respective day has no data
                                },
                                xAxis: {
                                    tickFormat: function (d) {
                                        return 'WEEK ' + d;
                                    }
                                },
                                yAxis: {
                                    axisLabelDistance: 50,
                                    tickFormat: function (d) {
                                        return d+ ' %';
                                        // return d3.format(".2f");
                                        // return d3.format('.02f')(d);
                                    }

                                },
                                interactiveLayer: {
                                    tooltip: {
                                        gravity: 's',
                                        classes: 'gravity-s'
                                    }
                                },
                                legend: {
                                    margin: {
                                        top: 8,
                                        right: 0,
                                        bottom: 32,
                                        left: 0
                                    },
                                    rightAlign: false
                                }
                            }
                        },
                        data: []
                    },

                    },
                widget12 : {
                    title: "Weekly Range Analysis",

                    mainChart: {
                        config: {
                            refreshDataOnly: true,
                            deepWatchData: true
                        },
                        options: {
                            chart: {
                                type: 'lineChart',
                                height: 420,
                                forceY: [0, 300],
                                showValues:true,
                                margin: {
                                    top: 32,
                                    right: 32,
                                    bottom: 32,
                                    left: 72
                                },
                                useInteractiveGuideline: true,
                                clipVoronoi: false,
                                interpolate: 'cardinal',
                                x: function (d) {
                                    if (d) {
                                        return d.x;
                                    }
                                    return 0; // Assume value zero if the respective day has no data
                                },
                                y: function (d) {
                                    if (d) {
                                        return d.y;
                                    }
                                    return 0; // Assume value zero if the respective day has no data
                                },
                                xAxis: {
                                    tickFormat: function (d) {
                                        return 'WEEK ' + d;
                                    }
                                },
                                yAxis: {
                                    tickFormat: function (d) {
                                        return d;

                                    }
                                },
                                interactiveLayer: {
                                    tooltip: {
                                        gravity: 's',
                                        classes: 'gravity-s'
                                    }
                                },
                                legend: {
                                    margin: {
                                        top: 8,
                                        right: 0,
                                        bottom: 32,
                                        left: 0
                                    },
                                    rightAlign: false
                                }
                            }
                        },
                        data: []
                    },
                },

                loadData: function () {
                    vm.weeklysalesreport.loaded = false;
                    vm.loadweeklysalesreportGrid = false;
                    gridcolumns = weeklysalesreportcolumns;
                    vm.weeklysalesreport.widget11.loaded = false;
                    vm.weeklysalesreport.widget11.mainChart.data.length = 0;
                    vm.weeklysalesreport.widget12.loaded = false;
                    vm.weeklysalesreport.widget12.mainChart.data.length = 0;

                    vm.searchGrid = function () {
                        vm.gridOptions.api.setQuickFilter(vm.searchaggrid);
                    };

                    msApi.request(Api.weekly_sales_report + '@get',
                        {
                            month: vm.start_date,
                            zone_id: vm.zoneFilter.getSelectedZoneId()
                        },
                        // Success
                        function (data) {

                            vm.weeklysalesreport.widget11.mainChart.data.length = 0;
                            vm.weeklysalesreport.data = data.result;
                            var WeeklySalesArray = [];
                            var rowDataNew = [];
                            var y_lenght = [];

                            var month_ach = [], coverage = [], pc_pct=[], fc_ach=[];
                            angular.forEach(data.result, function (record, index) {
                                month_ach.push({x: index+1, y: record.month_ach});
                                y_lenght.push(parseInt(record.month_ach));
                                coverage.push({x: index+1, y: record.coverage});
                                y_lenght.push(parseInt(record.coverage));
                                pc_pct.push({x: index+1, y: record.pc_ach});
                                y_lenght.push(parseInt(record.pc_ach));
                                fc_ach.push({x: index+1, y: record.focus_pct});
                                y_lenght.push(parseInt(record.focus_pct));

                                index++;

                                vm.weeklysalesreport.widget11.mainChart.options.chart.forceY = [0, 0, Math.max.apply(Math, y_lenght)];
                                vm.weeklysalesreport.widget11.mainChart.data[0] = {
                                    key: "Achievement",
                                            values: month_ach,
                                            strokeWidth: 3.5,
                                            showValues:true,
                                            color:"#0033cc"
                                        };
                                vm.weeklysalesreport.widget11.mainChart.data[1] = {
                                    key: "VC %",
                                    values: coverage,
                                    strokeWidth: 3.5,
                                    showValues:true,
                                    color:"#009999"
                                };
                                vm.weeklysalesreport.widget11.mainChart.data[2] = {
                                    key: "PC %",
                                    values: pc_pct,
                                    strokeWidth: 3.5,
                                    showValues:true,
                                    color:"#ff6600"
                                };
                                vm.weeklysalesreport.widget11.mainChart.data[3] = {
                                    key: "Focus Ach %",
                                    values: fc_ach,
                                    strokeWidth: 3.5,
                                    showValues:true,
                                    color:"#009933"

                                };
                               vm.weeklysalesreport.widget11.loaded = true;
                            });


                            vm.weeklysalesreport.widget12.mainChart.data.length = 0;

                            var WeeklySalesArray = [];
                            var rowDataNew = [];

                            var us = [], as = [], usb=[];
                            angular.forEach(data.result, function (record, index) {
                                us.push({x: index+1, y: record.unique_sku});
                                as.push({x: index+1, y: record.avg_sku});
                                usb.push({x: index+1, y: record.us_per_beat});
                                index++;
                                vm.weeklysalesreport.widget12.mainChart.data[0] = {
                                    key: "Unique SKUs",
                                    values: us,
                                    strokeWidth: 3.5,
                                    showValues:true,
                                    color:"#0033cc"
                                };

                                vm.weeklysalesreport.widget12.mainChart.data[1] = {
                                    key: "Avg SKUs",
                                    values: as,
                                    strokeWidth: 3.5,
                                    showValues:true,
                                    color:"#ff6600"
                                };

                                vm.weeklysalesreport.widget12.mainChart.data[2] = {
                                    key: "Unique SKUs/Beat",
                                    values: usb,
                                    strokeWidth: 3.5,
                                    showValues:true,
                                    color:"#009999"
                                };

                                vm.weeklysalesreport.widget12.loaded = true;
                            });

                            var i = 0;
                            for (var key in vm.weeklysalesreport.data) {
                                if (vm.weeklysalesreport.data.hasOwnProperty(key)) {
                                    WeeklySalesArray.push({
                                        'SL No': i + 1,
                                        'Week': vm.weeklysalesreport.data[key].name,
                                        'Target': vm.weeklysalesreport.data[key].month_target,
                                        'Revenue': vm.weeklysalesreport.data[key].month_value,
                                        'Achievement': vm.weeklysalesreport.data[key].month_ach,
                                        'TC': vm.weeklysalesreport.data[key].retailer_count,
                                        'VC': vm.weeklysalesreport.data[key].visited_count,
                                        'Coverage': vm.weeklysalesreport.data[key].coverage,
                                        'PC': vm.weeklysalesreport.data[key].productive_calls,
                                        'PC %': vm.weeklysalesreport.data[key].pc_ach,
                                        'Total SKU': vm.weeklysalesreport.data[key].total_sku,
                                        'Unique SKU': vm.weeklysalesreport.data[key].unique_sku,
                                        'Avg Order Value': vm.weeklysalesreport.data[key].avg_order_value,
                                        'Beat Count': vm.weeklysalesreport.data[key].beat_count,
                                        'PC / Beat': vm.weeklysalesreport.data[key].pc_per_beat,
                                        'TC / Beat': vm.weeklysalesreport.data[key].tc_per_beat,
                                        'Order / Beat': vm.weeklysalesreport.data[key].avg_order_per_beat,
                                        'Total SKU/Beat': vm.weeklysalesreport.data[key].sku_per_beat,
                                        'Unique SKU/Beat': vm.weeklysalesreport.data[key].us_per_beat,
                                        'Mss Ach': vm.weeklysalesreport.data[key].mss_achievement,
                                        'Focus Target': vm.weeklysalesreport.data[key].focus_target,
                                        'Focus Ach': vm.weeklysalesreport.data[key].focus_ach
                                    });
                                    rowDataNew.push({
                                        'name': vm.weeklysalesreport.data[key].name,
                                        'month_target': vm.weeklysalesreport.data[key].month_target,
                                        'month_value': vm.weeklysalesreport.data[key].month_value,
                                        'month_ach': vm.weeklysalesreport.data[key].month_ach,
                                        'retailer_count': vm.weeklysalesreport.data[key].retailer_count,
                                        'visited_count': vm.weeklysalesreport.data[key].visited_count,
                                        'coverage': vm.weeklysalesreport.data[key].coverage,
                                        'productive_calls': vm.weeklysalesreport.data[key].productive_calls,
                                        'pc_ach': vm.weeklysalesreport.data[key].pc_ach,
                                        'total_sku': vm.weeklysalesreport.data[key].total_sku,
                                        'unique_sku': vm.weeklysalesreport.data[key].unique_sku,
                                        'avg_order_value': vm.weeklysalesreport.data[key].avg_order_value,
                                        'beat_count': vm.weeklysalesreport.data[key].beat_count,
                                        'pc_per_beat': vm.weeklysalesreport.data[key].pc_per_beat,
                                        'tc_per_beat': vm.weeklysalesreport.data[key].tc_per_beat,
                                        'avg_order_per_beat': vm.weeklysalesreport.data[key].avg_order_per_beat,
                                        'sku_per_beat': vm.weeklysalesreport.data[key].sku_per_beat,
                                        'us_per_beat': vm.weeklysalesreport.data[key].us_per_beat,
                                        'mss_achievement': vm.weeklysalesreport.data[key].mss_achievement,
                                        'focus_target': vm.weeklysalesreport.data[key].focus_target,
                                        'focus_ach': vm.weeklysalesreport.data[key].focus_ach

                                    });
                                    i++;
                                }
                            }
                            vm.excelArray = WeeklySalesArray;
                            vm.gridOptions.rowData = rowDataNew;
                            vm.gridOptions.columnDefs = gridcolumns;
                            vm.loadweeklysalesreportGrid = true;
                            vm.weeklysalesreport.loaded = true;
                        },
                        function (data) {
                            // TODO Show a notificatoin to the user, or replace the cards with an error message.
                        }
                    );
                },
                init: function () {
                    vm.weeklysalesreport.loadData();
                }
            };
            /*AG grid View Ends Here*/


            /*AG Grid For Outlet wise sales1*/

            vm.outletwisesales = {
                data: [],

                loadData: function () {

                    vm.outletwisesales.loaded = false;
                    vm.loadoutletwisesalesGrid = false;
                    gridcolumns = outletwisesalescolumns;


                    vm.searchGrid = function () {
                        vm.gridOptions.api.setQuickFilter(vm.searchaggrid);
                    },

                    msApi.request(Api.outletwise_sales + '@get',
                        {
                            start_date: vm.start_date,
                            end_date: vm.end_date,
                            zone_id: vm.zoneFilter.getSelectedZoneId(),
                            emp_code: vm.empcodeFilter.getSelectedEmployeeId(),
                            dist_code: vm.distcodeFilter.getSelectedDistributorId(),
                            partner_type: vm.partnerTypeFilter.getSelectedPartnerTypeId()
                        },
                        // Success
                        function (data) {
                            $log.log('Received Outlet Wise Sales Data');
                            $log.log(data);
                            vm.outletwisesales.data = data.result;
                            var oSalesArray = [];
                            var rowDataNew = [];
                            var i = 0;
                            for (var key in vm.outletwisesales.data) {
                                if (vm.outletwisesales.data.hasOwnProperty(key)) {
                                    oSalesArray.push({
                                        'SL No': i + 1,
                                        'EMP Code': vm.outletwisesales.data[key].emp_code,
                                        'Salesman': vm.outletwisesales.data[key].login,
                                        'Zone': vm.outletwisesales.data[key].zone,
                                        'Dist Code': vm.outletwisesales.data[key].distributor_code,
                                        'Dist Name': vm.outletwisesales.data[key].distributor,
                                        'Outlet ID': vm.outletwisesales.data[key].partner_id,
                                        'Outlet': vm.outletwisesales.data[key].partner_name,
                                        'Type': vm.outletwisesales.data[key].partner_type,
                                        'SKU Code': vm.outletwisesales.data[key].sku_code,
                                        'SKU Name': vm.outletwisesales.data[key].sku_name,
                                        'Qty': vm.outletwisesales.data[key].product_uom_qty,
                                        'Sales': vm.outletwisesales.data[key].total_sales,
                                        'Date': vm.outletwisesales.data[key].date_order

                                    });
                                    rowDataNew.push({
                                        'emp_code': vm.outletwisesales.data[key].emp_code,
                                        'login': vm.outletwisesales.data[key].login,
                                        'zone': vm.outletwisesales.data[key].zone,
                                        'distributor_code': vm.outletwisesales.data[key].distributor_code,
                                        'distributor': vm.outletwisesales.data[key].distributor,
                                        'partner_id': vm.outletwisesales.data[key].partner_id,
                                        'partner_name': vm.outletwisesales.data[key].partner_name,
                                        'partner_type': vm.outletwisesales.data[key].partner_type,
                                        'sku_code': vm.outletwisesales.data[key].sku_code,
                                        'sku_name': vm.outletwisesales.data[key].sku_name,
                                        'product_uom_qty': vm.outletwisesales.data[key].product_uom_qty,
                                        'total_sales': vm.outletwisesales.data[key].total_sales,
                                        'date_order': vm.outletwisesales.data[key].date_order
                                    });
                                    i++;
                                }
                            }
                            vm.excelArray = oSalesArray;
                            vm.gridOptions.rowData = rowDataNew;
                            vm.gridOptions.columnDefs = gridcolumns;
                            vm.loadoutletwisesalesGrid = true;
                            vm.outletwisesales.loaded = true;
                        },
                        function (data) {
                            // TODO Show a notificatoin to the user, or replace the cards with an error message.
                        }
                    );
                },
                init: function () {
                    vm.outletwisesales.loadData();
                }
            };
            /**/



            /*AG Grid Report for SR Score Card */
            vm.sr_score_card = {
                data: [],
                widgetscorecard: {
                    title: "Rank Analysis",
                    ranges: {
                        TM: "This Month",
                        LM: "Last Month",
                        "2M": "2 Months Ago"
                    },
                    mainChart: {
                        config: {
                            refreshDataOnly: true,
                            deepWatchData: true
                        },
                        options: {
                            chart: {
                                type: 'multiBarChart',
                                color: ["#529CD6", '#A5ADA5', '#EFB500', "#529C5A", "#29528C", "#B9529C"],
                                height: 600, width: 3000,
                                rotateLabels: 35,
                                axisLabelDistance: 10,
                                forceY: [0, 200],
                                margin: {
                                    top: 64,
                                    right: 16,
                                    bottom: 64,
                                    left: 64
                                },
                                padding: {
                                    top: 10
                                },
                                clipEdge: true,
                                groupSpacing: 0.4,
                                reduceXTicks: false,
                                stacked: false,
                                duration: 250, fontSize: 3,
                                x: function (d) {
                                    return d.x;
                                },
                                y: function (d) {
                                    return d.y;
                                },
                                xAxis: {
                                    tickFormat: function (d) {
                                        return d;
                                    },
                                    fontSize: 1
                                },
                                yAxis: {
                                    tickFormat: function (d) {
                                        return d;
                                    }
                                },
                                legend: {
                                    margin: {
                                        top: 32,
                                        bottom: 32
                                    }
                                },
                                controls: {
                                    margin: {
                                        top: 32,
                                        bottom: 32
                                    }
                                },
                                tooltip: {
                                    gravity: 's',
                                    classes: 'gravity-s'
                                }
                            }
                        },
                        data: [],
                    }
                },
                loadData: function () {
                    vm.sr_score_card.loaded = false;
                    vm.loadSRScoreCardGrid = false;
                    gridcolumns = srscorecardcolumns;
                    vm.searchGrid = function () {
                        vm.gridOptions.api.setQuickFilter(vm.searchaggrid);
                    },
                    msApi.request(Api.sr_score_card + '@get',
                        {
                            start_date: vm.start_date,
                            end_date: vm.end_date,
                            zone_id: vm.zoneFilter.getSelectedZoneId(),
                            salesman_id: vm.SalesmanFilter.getSelectedUserId(),
                            emp_code: vm.empcodeFilter.getSelectedEmployeeId(),
                            achieved_weight: vm.achievedweight,
                            bpa_weight: vm.bpaweight,
                            uob_weight: vm.uobweight,
                            bc_weight: vm.bcweight,
                            mss_weight: vm.mssweight
                        },
                        // Success
                        function (data) {
                            $log.log(vm.zone);
                            $log.log('Received SR Score Card Data');
                            $log.log(data);
                            // Set new values for widget4 based on the new data
                            vm.sr_score_card.data = data.result;
                            // Array build to export As CSV
                            var SRScoreCardArray = [];  // export csv array
                            var rowDataNew = [];  // ag-grid row data
                            var i = 0;
                            for (var key in vm.sr_score_card.data) {
                                if (vm.sr_score_card.data.hasOwnProperty(key)) {
                                    //  if(i<30000){
                                    SRScoreCardArray.push({
                                        'SL No': i + 1,
                                        'Emp Code': vm.sr_score_card.data[key].emp_code,
                                        'Salesman': vm.sr_score_card.data[key].salesman,
                                        'Target': vm.sr_score_card.data[key].target,
                                        'Achieved': vm.sr_score_card.data[key].achieved,
                                        'Achieved %': vm.sr_score_card.data[key].achieved_pct,
                                        'JP Adherence %': vm.sr_score_card.data[key].jp_adherence_pct,
                                        'Unique PC %': vm.sr_score_card.data[key].unique_outlet_billed_pct,
                                        'PC %': vm.sr_score_card.data[key].bills_cut_pct,
                                        'Avg SKUs %': vm.sr_score_card.data[key].average_lines_cut,
                                        'Avg Order Val': vm.sr_score_card.data[key].average_bill_value,
                                        'MSS Achieved ': vm.sr_score_card.data[key].mss_sales,
                                        'MSS Achieved % ': vm.sr_score_card.data[key].mss_achieved_pct,
                                        'Rank': vm.sr_score_card.data[key].rank

                                    });
                                    rowDataNew.push({
                                        'emp_code': vm.sr_score_card.data[key].emp_code,
                                        'salesman': vm.sr_score_card.data[key].salesman,
                                        'target': vm.sr_score_card.data[key].target,
                                        'achieved': vm.sr_score_card.data[key].achieved,
                                        'achieved_pct': vm.sr_score_card.data[key].achieved_pct,
                                        'jp_adherence_pct': vm.sr_score_card.data[key].jp_adherence_pct,
                                        'unique_outlet_billed_pct': vm.sr_score_card.data[key].unique_outlet_billed_pct,
                                        'bills_cut_pct': vm.sr_score_card.data[key].bills_cut_pct,
                                        'average_lines_cut': vm.sr_score_card.data[key].average_lines_cut,
                                        'average_bill_value': vm.sr_score_card.data[key].average_bill_value,
                                        'mss_sales': vm.sr_score_card.data[key].mss_sales,
                                        'mss_achieved_pct': vm.sr_score_card.data[key].mss_achieved_pct,
                                        'rank': vm.sr_score_card.data[key].rank

                                    });
                                    //  }
                                    i++;
                                }
                            }
                            vm.sr_score_card.widgetscorecard.mainChart.data.length = 0;
                            //Assigning Data to BarChart -widget1
                            var achievedPC = []
                            var JPAPC = []
                            var UniqueBilledPC = []
                            var billsCutPC = []
                            var MSSAchievedPC = []

                            angular.forEach(data.result, function (chartData, index) {
                                achievedPC[index] = {
                                    x: chartData.salesman,
                                    y: chartData.achieved_pct
                                };
                            });
                            angular.forEach(data.result, function (chartData, index) {
                                JPAPC[index] = {
                                    x: chartData.salesman,
                                    y: chartData.jp_adherence_pct
                                };
                            });
                            angular.forEach(data.result, function (chartData, index) {
                                UniqueBilledPC[index] = {
                                    x: chartData.salesman,
                                    y: chartData.unique_outlet_billed_pct
                                };
                            });
                            angular.forEach(data.result, function (chartData, index) {
                                billsCutPC[index] = {
                                    x: chartData.salesman,
                                    y: chartData.bills_cut_pct
                                };
                            });
                            angular.forEach(data.result, function (chartData, index) {
                                MSSAchievedPC[index] = {
                                    x: chartData.salesman,
                                    y: chartData.mss_achieved_pct
                                };
                            });
                            vm.sr_score_card.widgetscorecard.mainChart.data[0] = {
                                key: "Achieved %",
                                values: achievedPC
                            };
                            vm.sr_score_card.widgetscorecard.mainChart.data[1] = {
                                key: "JP Adherence %",
                                values: JPAPC
                            };
                            vm.sr_score_card.widgetscorecard.mainChart.data[2] = {
                                key: "Unique PC %",
                                values: UniqueBilledPC
                            };
                            vm.sr_score_card.widgetscorecard.mainChart.data[3] = {
                                key: "PC %",
                                values: billsCutPC
                            };
                            vm.sr_score_card.widgetscorecard.mainChart.data[4] = {
                                key: "MSS Achieved %",
                                values: MSSAchievedPC
                            };
                            vm.excelArray = SRScoreCardArray;
                            vm.gridOptions.rowData = rowDataNew;
                            vm.gridOptions.columnDefs = gridcolumns;
                            vm.loadSRScoreCardGrid = true;
                            vm.sr_score_card.loaded = true;
                        },
                        // Error
                        function (data) {
                            // TODO Show a notificatoin to the user, or replace the cards with an error message.
                            //$log.log('Unable to fetch widget4: ' + data);
                        }
                    );
                },
                init: function () {
                    vm.sr_score_card.loadData();
                }
            };
            /*SR Score card Ends here*/

            /**/
            /*AG Grid Report for Coberage and Prod*/


            vm.coverageandproductvity = {
                data: [],

                loadData: function () {
                    vm.coverageandproductvity.loaded = false;
                    vm.loadCandPGrid = false;

                    vm.coverageandproductvitygraph.loadData();
                    gridcolumns = coverageandprodcolumns;

                    vm.searchGrid = function () {
                        vm.gridOptions.api.setQuickFilter(vm.searchaggrid);
                    }

                    msApi.request(Api.coverage_and_productivity + '@get',
                        {
                            start_date: vm.start_date,
                            end_date: vm.end_date,
                            zone_id: vm.zoneFilter.getSelectedZoneId(),
                            team_id: vm.teamFilter.getSelectedTeamId(),
                            salesman_id: vm.SalesmanFilter.getSelectedUserId(),
                            beat_id: vm.beatFilter.getSelectedBeatId(),
                            emp_code: vm.empcodeFilter.getSelectedEmployeeId()
                        },
                        // Success
                        function (data) {
                            $log.log(vm.zone);
                            $log.log('Received Coberage and Productivity Data');
                            $log.log(data);
                            // Set new values for widget4 based on the new data
                            vm.coverageandproductvity.data = data.result;
                            // Array build to export As CSV
                            var CandPArray = [];  // export csv array
                            var rowDataNew = [];  // ag-grid row data
                            var i = 0;
                            for (var key in vm.coverageandproductvity.data) {
                                if (vm.coverageandproductvity.data.hasOwnProperty(key)) {
                                    //  if(i<30000){
                                    CandPArray.push({
                                        'SL No': i + 1,
                                        'Emp Code': vm.coverageandproductvity.data[key].emp_code,
                                        'Salesman': vm.coverageandproductvity.data[key].login,
                                        'Total Outlets': vm.coverageandproductvity.data[key].unique_retailers,
                                        'TC': vm.coverageandproductvity.data[key].retailer_count,
                                        'VC': vm.coverageandproductvity.data[key].visited_count,
                                        'VC %': vm.coverageandproductvity.data[key].coverage,
                                        'Unique VC': vm.coverageandproductvity.data[key].unique_vc,
                                        'Unique VC %': vm.coverageandproductvity.data[key].unique_vc_pct,
                                        'PC': vm.coverageandproductvity.data[key].productive_calls,
                                        'PC %': vm.coverageandproductvity.data[key].prod_pct,
                                        'Unique PC': vm.coverageandproductvity.data[key].unique_pc,
                                        'Unique PC %': vm.coverageandproductvity.data[key].unique_pc_pct,
                                        'Unscheduled PC': vm.coverageandproductvity.data[key].unscheduled_order

                                    });
                                    rowDataNew.push({
                                        'emp_code': vm.coverageandproductvity.data[key].emp_code,
                                        'login': vm.coverageandproductvity.data[key].login,
                                        'retailer_count': vm.coverageandproductvity.data[key].retailer_count,
                                        'visited_count': vm.coverageandproductvity.data[key].visited_count,
                                        'coverage': vm.coverageandproductvity.data[key].coverage,
                                        'unique_retailers': vm.coverageandproductvity.data[key].unique_retailers,
                                        'unique_vc': vm.coverageandproductvity.data[key].unique_vc,
                                        'unique_vc_pct': vm.coverageandproductvity.data[key].unique_vc_pct,
                                        'productive_calls': vm.coverageandproductvity.data[key].productive_calls,
                                        'prod_pct': vm.coverageandproductvity.data[key].prod_pct,
                                        'unique_pc': vm.coverageandproductvity.data[key].unique_pc,
                                        'unique_pc_pct': vm.coverageandproductvity.data[key].unique_pc_pct,
                                        'unscheduled_order': vm.coverageandproductvity.data[key].unscheduled_order

                                    });
                                    //  }
                                    i++;
                                }
                            }


                            vm.excelArray = CandPArray;
                            vm.gridOptions.rowData = rowDataNew;
                            vm.gridOptions.columnDefs = gridcolumns;
                            vm.loadCandPGrid = true;
                            vm.coverageandproductvity.loaded = true;
                        },
                        // Error
                        function (data) {
                            // TODO Show a notificatoin to the user, or replace the cards with an error message.
                            //$log.log('Unable to fetch widget4: ' + data);
                        }
                    );
                },
                init: function () {
                    vm.coverageandproductvity.loadData();
                }
            };
            /*Coverage and PRod Ends here*/

            /*Graph View for Coverage and Productivity*/

            vm.coverageandproductvitygraph = {
                data: [],

                widget1: {
                    title: "Coverage And Productivity Graph",
                    ranges: {
                        TM: "This Month",
                        LM: "Last Month",
                        "2M": "2 Months Ago"
                    },
                    mainChart: {
                        config: {
                            refreshDataOnly: true,
                            deepWatchData: true
                        },
                        options: {
                            chart: {
                                type: 'multiBarChart',
                                color: ["#529CD6", '#A5ADA5', '#EFB500', "#529C5A", "#29528C"],
                                height: 600,

                                rotateLabels: 30,
                                axisLabelDistance: 10,
                                forceY: [0, 200],
                                margin: {
                                    top: 64,
                                    right: 16,
                                    bottom: 64,
                                    left: 64
                                },
                                padding: {
                                    top: 10
                                },
                                clipEdge: true,
                                groupSpacing: 0.4,
                                reduceXTicks: false,
                                duration: 250,
                                x: function (d) {
                                    return d.x;
                                },
                                y: function (d) {
                                    return d.y;
                                },
                                xAxis: {
                                    tickFormat: function (d) {
                                        return d;
                                    }, scrollbar: {
                                        enabled: true
                                    },
                                    tickLength: 0
                                },
                                yAxis: {
                                    tickFormat: function (d) {
                                        return d;
                                    }
                                },
                                legend: {
                                    margin: {
                                        top: 32,
                                        bottom: 32,
                                        left: 50
                                    },
                                    rightAlign: false
                                },
                                controls: {
                                    margin: {
                                        top: 32,
                                        bottom: 32
                                    }
                                },
                                tooltip: {
                                    gravity: 's',
                                    classes: 'gravity-s'
                                }
                            }
                        },
                        data: [],
                    }
                },
                loadData: function () {

                    vm.coverageandproductvitygraph.loaded = false;
                    vm.coverageandproductvitygraph.widget1.mainChart.data.length = 0; // Remove all previous chart data on reload
                    vm.coverageandproductvitygraph.widget1.mainChart.options.chart.width = 1200 ;

                    msApi.request(Api.coverage_and_productivity_graph + '@get',
                        {
                            start_date: vm.start_date,
                            end_date: vm.end_date,
                            zone_id: vm.zoneFilter.getSelectedZoneId(),
                            salesman_id: vm.SalesmanFilter.getSelectedUserId(),
                            beat_id: vm.beatFilter.getSelectedBeatId(),
                            emp_code: vm.empcodeFilter.getSelectedEmployeeId()
                        },
                        // Success
                        function (data) {
                            vm.coverageandproductvitygraph.data = data.result;
                            if ((data.result.length) > 20) {
                                vm.coverageandproductvitygraph.widget1.mainChart.options.chart.width = 3000;
                            }
                            vm.coverageandproductvitygraph.widget1.mainChart.data.length = 0;

                            //Assigning Data to BarChart -widget

                            var VC = []
                            var PC = []
                            var UniquePC = []
                            var UniqueVC = []
                            var UnscheduledPC = []

                            angular.forEach(data.result, function (chartData, index) {
                                VC[index] = {
                                    x: chartData.zone,
                                    y: chartData.coverage
                                };
                            });
                            angular.forEach(data.result, function (chartData, index) {
                                UniqueVC[index] = {
                                    x: chartData.zone,
                                    y: chartData.unique_vc_pct
                                };
                            });
                            angular.forEach(data.result, function (chartData, index) {
                                PC[index] = {
                                    x: chartData.zone,
                                    y: chartData.prod_pct
                                };
                            });
                            angular.forEach(data.result, function (chartData, index) {
                                UniquePC[index] = {
                                    x: chartData.zone,
                                    y: chartData.unique_pc_pct
                                };
                            });
                            angular.forEach(data.result, function (chartData, index) {
                                UnscheduledPC[index] = {
                                    x: chartData.zone,
                                    y: chartData.unscheduled_order
                                };
                            });

                            vm.coverageandproductvitygraph.widget1.mainChart.data[0] = {
                                key: "VC %",
                                values: VC
                            };

                            vm.coverageandproductvitygraph.widget1.mainChart.data[1] = {
                                key: "Unique VC %",
                                values: UniqueVC
                            };
                            vm.coverageandproductvitygraph.widget1.mainChart.data[2] = {
                                key: "PC %",
                                values: PC
                            };
                            vm.coverageandproductvitygraph.widget1.mainChart.data[3] = {
                                key: "Unique PC %",
                                values: UniquePC
                            };
                            vm.coverageandproductvitygraph.widget1.mainChart.data[4] = {
                                key: "Unscheduled Orders",
                                values: UnscheduledPC
                            };


                            vm.coverageandproductvitygraph.loaded = true;

                        },
                        function (data) {
                        }
                    );
                },
                init: function () {
                    vm.coverageandproductvitygraph.loadData();
                }
            };

            /**/

            /*AG Grid Report for MSS Sales By Outlet*/
            vm.msssalesbyoutlet = {
                data: [],
                loadData: function () {
                    vm.msssalesbyoutlet.loaded = false;
                    vm.loadMssSalesGrid = false;
                    gridcolumns = msssalesbyoutletcolumns;
                    vm.searchGrid = function () {
                        vm.gridOptions.api.setQuickFilter(vm.searchaggrid);
                    }
                    msApi.request(Api.mss_sales_by_outlet + '@get',
                        {
                            start_date: vm.start_date,
                            end_date: vm.end_date,
                            zone_id: vm.zoneFilter.getSelectedZoneId(),
                            type_id: vm.partnerTypeFilter.getSelectedPartnerTypeId(),
                            dist_id: vm.distnameFilter.getSelectedDistributorId(),
                            dist_code: vm.distcodeFilter.getSelectedDistributorId(),
                        },
                        // Success
                        function (data) {
                            $log.log(vm.zone);
                            $log.log('Received MSS Sales By outlet Data');
                            $log.log(data);
                            // Set new values for widget4 based on the new data
                            vm.msssalesbyoutlet.data = data.result;
                            // Array build to export As CSV
                            var MssSalesArray = [];  // export csv array
                            var rowDataNew = [];  // ag-grid row data
                            var i = 0;
                            for (var key in vm.msssalesbyoutlet.data) {
                                if (vm.msssalesbyoutlet.data.hasOwnProperty(key)) {
                                    //  if(i<30000){
                                    MssSalesArray.push({
                                        'SL No': i + 1,
                                        'Zone': vm.msssalesbyoutlet.data[key].zone_id,
                                        'Dist Code': vm.msssalesbyoutlet.data[key].distributor_code,
                                        'Dist Name': vm.msssalesbyoutlet.data[key].distributor_name,
                                        'Outlet ID': vm.msssalesbyoutlet.data[key].partner_id,
                                        'Outlet Name': vm.msssalesbyoutlet.data[key].partner_name,
                                        'Outlet Type': vm.msssalesbyoutlet.data[key].retailer_type,
                                        'Total Sales': vm.msssalesbyoutlet.data[key].total_sales,
                                        'MSS Sales': vm.msssalesbyoutlet.data[key].mss_sales,
                                        '% Contribution': vm.msssalesbyoutlet.data[key].mss_ach
                                    });
                                    rowDataNew.push({
                                        'zone_id': vm.msssalesbyoutlet.data[key].zone_id,
                                        'distributor_code': vm.msssalesbyoutlet.data[key].distributor_code,
                                        'distributor_name': vm.msssalesbyoutlet.data[key].distributor_name,
                                        'partner_id': vm.msssalesbyoutlet.data[key].partner_id,
                                        'partner_name': vm.msssalesbyoutlet.data[key].partner_name,
                                        'retailer_type': vm.msssalesbyoutlet.data[key].retailer_type,
                                        'total_sales': vm.msssalesbyoutlet.data[key].total_sales,
                                        'mss_sales': vm.msssalesbyoutlet.data[key].mss_sales,
                                        'mss_ach': vm.msssalesbyoutlet.data[key].mss_ach
                                    });
                                    //  }
                                    i++;
                                }
                            }


                            vm.excelArray = MssSalesArray;
                            vm.gridOptions.rowData = rowDataNew;
                            vm.gridOptions.columnDefs = gridcolumns;
                            vm.loadMssSalesGrid = true;
                            vm.msssalesbyoutlet.loaded = true;
                        },
                        // Error
                        function (data) {
                            // TODO Show a notificatoin to the user, or replace the cards with an error message.
                            //$log.log('Unable to fetch widget4: ' + data);
                        }
                    );
                },
                init: function () {
                    vm.msssalesbyoutlet.loadData();
                }
            };
            /*MSS Sales By Outlet Ends here*/


            /*SKU Dispersion */
            vm.skudispersion = {
              data: [],

              // Widget 1 Bar Chart
              widget1:{
                title: "SKU DISPERSION - Customer/Invoice Count",
                ranges: {
                  TM: "This Month",
                  LM: "Last Month",
                  "2M": "2 Months Ago"
                },
                mainChart: {
                  config: {
                    refreshDataOnly: true,
                    deepWatchData: true
                  },
                  options: {
                    chart: {
                      type: 'multiBarChart',
                      color: ['#03a9f4', '#b3e5fc'],
                      height: 420,
                      margin: {
                        top: 8,
                        right: 16,
                        bottom: 32,
                        left: 64
                      },
                      clipEdge: true,
                      groupSpacing: 0.3,
                      reduceXTicks: false,
                      stacked: true,
                      duration: 250,
                      x: function (d) {
                        return d.x;
                      },
                      y: function (d) {
                        return d.y;
                      },
                      xAxis: {
                        tickFormat: function (d) {
                          return d;
                        }
                      },
                      yAxis: {
                        tickFormat: function (d) {
                          return d;
                        }
                      },
                      legend: {
                        margin: {
                          top: 8,
                          bottom: 32
                        }
                      },
                      controls: {
                        margin: {
                          top: 8,
                          bottom: 32
                        }
                      },
                      tooltip: {
                        gravity: 's',
                        classes: 'gravity-s'
                      }
                    }
                  },
                  data: []
                }
              },

              // Widget 1 Pie Chart
              widget2:{
                title: "SKU DISPERSION - Share",
                ranges: {
                  TM: "This Month",
                  LM: "Last Month",
                  "2M": "2 Months Ago"
                },
                mainChart: {
                  config: {
                    refreshDataOnly: true,
                    deepWatchData: true
                  },
                  options: {
                    chart: {
                      type: 'pieChart',
                      color: ['#f44336', '#9c27b0', '#03a9f4', '#e91e63', '#c8b550'],
                      height: 400,
                      margin: {
                        top: 0,
                        right: 0,
                        bottom: 0,
                        left: 0
                      },
                      donut: true,
                      clipEdge: true,
                      cornerRadius: 0,
                      labelType: 'percent',
                      padAngle: 0.02,
                      x: function (d) {
                        return d.label;
                      },
                      y: function (d) {
                        return d.value;
                      },
                      tooltip: {
                        gravity: 's',
                        classes: 'gravity-s'
                      }
                    }
                  },
                  data: []
                }
              },

              loadData: function () {

                    vm.skudispersion.loaded = false;
                    vm.loadskudispersionGrid = false;

                  vm.skudispersion.widget1.mainChart.data.length = 0;
                  // Remove all previous chart data on reload
                    vm.skudispersion.widget2.mainChart.data.length = 0; // Remove all previous chart data on reload
                    gridcolumns = skudispersioncolumns;

                    msApi.request(Api.get_sku_dispersion_report + '@get',
                        {
                            start_date: vm.start_date,
                            end_date: vm.end_date,
                            zone_id: vm.zoneFilter.getSelectedZoneId(),
                            outlet_type: vm.partnerTypeFilter.getSelectedPartnerTypeId()
                        },
                        // Success
                        function (data) {
                            //  $log.log(vm.zone);
                            //$log.log('Received sku dispersion data range');
                            //$log.log(data);
                            // Set new values for widget4 based on the new data
                            vm.skudispersion.data = data.result;
                            vm.skudispersion.widget1.mainChart.data.length = 0; // Remove all previous chart data on reload

                            //Assigning Data to BarChart -widget
                            var customerCount = []
                            var invoiceCount =[]
                            //console.log(result);
                            angular.forEach(data.result, function (chartData, index) {
                                //console.log(chartData);
                                customerCount[index] = {
                                    x: chartData.sol_range,
                                    y: chartData.customer_count
                                };
                            });
                            //console.log(customerCount);

                            vm.skudispersion.widget1.mainChart.data[0] = {
                                key: "Customer Count",
                                values: customerCount
                            };

                            angular.forEach(data.result, function (chartData, index) {
                                //console.log(chartData);
                                invoiceCount[index] = {
                                    x: chartData.sol_range,
                                    y: chartData.invoice_count
                                };
                            });

                            vm.skudispersion.widget1.mainChart.data[1] = {
                                key: "Invoice Count",
                                values: invoiceCount
                            };

                            //Assigning Data to pieChart -widget2
                            vm.skudispersion.widget2.mainChart.data.length = 0; // Remove all previous chart data on reload
                            angular.forEach(data.result, function (sku, index) {
                              //  console.log("............." + data);
                                vm.skudispersion.widget2.mainChart.data[index] = {
                                    label: sku.sol_range,
                                    value: sku.percentage
                                };
                            });




                            // Array build to export As CSV
                            var skudispersionArray = [];  // export csv array
                            var rowDataNew = [];  // ag-grid row data
                            var i = 0;
                            for (var key in vm.skudispersion.data) {
                                if (vm.skudispersion.data.hasOwnProperty(key)) {
                                    //  if(i<30000){
                                    skudispersionArray.push({
                                        'SL No': i + 1,
                                        'Distinct Lines': vm.skudispersion.data[key].sol_range,
                                        'No of Customers': vm.skudispersion.data[key].customer_count,
                                        'No of Invoices': vm.skudispersion.data[key].invoice_count,
                                        '%': vm.skudispersion.data[key].percentage
                                        //console.log(vm.products[key].unit);
                                    });

                                    rowDataNew.push({
                                        'sol_range': vm.skudispersion.data[key].sol_range,
                                        'customer_count': vm.skudispersion.data[key].customer_count,
                                        'invoice_count': vm.skudispersion.data[key].invoice_count,
                                        'percentage': vm.skudispersion.data[key].percentage
                                    });
                                    //  }
                                    i++;
                                }
                            }

                            vm.excelArray = skudispersionArray;
                            vm.gridOptions.rowData = rowDataNew;
                            vm.gridOptions.columnDefs = gridcolumns;
                            vm.skudispersion.loaded = true;
                            vm.loadskudispersionGrid = true;

                        },
                        // Error
                        function (data) {
                            // TODO Show a notificatoin to the user, or replace the cards with an error message.
                            //$log.log('Unable to fetch widget4: ' + data);
                        }
                    );

                },


                init: function () {
                    vm.skudispersion.loadData();
                }
            };

            vm.revenuedispersion = {
              data: [],
              widget1:{
                title: "REVENUE DISPERSION - Customer/Invoice Count",
                ranges: {
                  TM: "This Month",
                  LM: "Last Month",
                  "2M": "2 Months Ago"
                },
                mainChart: {
                  config: {
                    refreshDataOnly: true,
                    deepWatchData: true
                  },
                  options: {
                    chart: {
                      type: 'multiBarChart',
                      color: ['#03a9f4', '#b3e5fc'],
                      height: 420,
                      margin: {
                        top: 8,
                        right: 16,
                        bottom: 32,
                        left: 64
                      },
                      clipEdge: true,
                      groupSpacing: 0.3,
                      reduceXTicks: false,
                      stacked: true,
                      duration: 250,
                      x: function (d) {
                        return d.x;
                      },
                      y: function (d) {
                        return d.y;
                      },
                      xAxis: {
                        tickFormat: function (d) {
                          return d;
                        }
                      },
                      yAxis: {
                        tickFormat: function (d) {
                          return d;
                        }
                      },
                      legend: {
                        margin: {
                          top: 8,
                          bottom: 32
                        }
                      },
                      controls: {
                        margin: {
                          top: 8,
                          bottom: 32
                        }
                      },
                      tooltip: {
                        gravity: 's',
                        classes: 'gravity-s'
                      }
                    }
                  },
                  data: [],
                }
              },

              // Widget2 for to REVENUE DISPERSION - Share pieChart
              widget2:{
                title: "REVENUE DISPERSION - Share",
                ranges: {
                  TM: "This Month",
                  LM: "Last Month",
                  "2M": "2 Months Ago"
                },
                mainChart: {
                  config: {
                    refreshDataOnly: true,
                    deepWatchData: true
                  },
                  options: {
                    chart: {
                      type: 'pieChart',
                      color: ['#f44336', '#9c27b0', '#03a9f4', '#e91e63', '#c8b550'],
                      height: 400,
                      margin: {
                        top: 0,
                        right: 0,
                        bottom: 0,
                        left: 0
                      },
                      donut: true,
                      clipEdge: true,
                      cornerRadius: 0,
                      labelType: 'percent',
                      padAngle: 0.02,
                      x: function (d) {
                        return d.label;
                      },
                      y: function (d) {
                        return d.value;
                      },
                      tooltip: {
                        gravity: 's',
                        classes: 'gravity-s'
                      }
                    }
                  },
                  data: []
                }
              },

              loadData: function () {
                vm.revenuedispersion.loaded = false;
                vm.loadrevenuedispersionGrid = false;
                //vm.partnerTypeFilter.getSelectedPartnerTypeId = false;
                vm.revenuedispersion.widget1.mainChart.data.length = 0; // Remove all previous chart data on reload
                vm.revenuedispersion.widget2.mainChart.data.length = 0; // Remove all previous chart data on reload
                gridcolumns = revenuedispersioncolumns;

                msApi.request(Api.get_revenue_dispersion_report + '@get',
                      {
                            start_date: vm.start_date,
                            end_date: vm.end_date,
                            zone_id: vm.zoneFilter.getSelectedZoneId(),
                            outlet_type: vm.partnerTypeFilter.getSelectedPartnerTypeId()
                        },
                        // Success
                        function (data) {
                            $log.log(vm.zone);
                            $log.log('Received revenue dispersion data');
                            $log.log(data);
                            // Set new values for widget4 based on the new data
                            vm.revenuedispersion.data = data.result;

                            //Assigning Data to BarChart Widget1
                            var customerCount = []
                            var invoiceCount =[]

                            angular.forEach(data.result, function (chartData, index) {
                              customerCount[index] = {
                                x: chartData.sol_range,
                                y: chartData.customer_count
                              };
                            });

                            vm.revenuedispersion.widget1.mainChart.data[0] = {
                              key: "Customer Count",
                              values: customerCount
                            };

                            angular.forEach(data.result, function (chartData, index) {
                              invoiceCount[index] = {
                                x: chartData.sol_range,
                                y: chartData.invoice_count
                              };
                            });

                            vm.revenuedispersion.widget1.mainChart.data[1] = {
                              key: "Invoice Count",
                              values: invoiceCount
                            };
                              //BarChart ends enableColResize

                              //Assigning Data to PieChart Widget2
                          vm.revenuedispersion.widget2.mainChart.data.length = 0; // Remove all previous chart data on reload

                          angular.forEach(data.result, function (sku, index) {
                            //  console.log("............." + data);
                            console.log(sku.sol_range);
                            vm.revenuedispersion.widget2.mainChart.data[index] = {
                              label: sku.sol_range,
                              value: sku.percentage
                            };
                          });

                            // Array build to export As CSV
                            var revenuedispersionArray = [];  // export csv array
                            var rowDataNew = [];  // ag-grid row data
                            var i = 0;
                            for (var key in vm.revenuedispersion.data) {
                                if (vm.revenuedispersion.data.hasOwnProperty(key)) {
                                    //  if(i<30000){
                                    revenuedispersionArray.push({
                                        'SL No': i + 1,
                                        'Revenue': vm.revenuedispersion.data[key].sol_range,
                                        'No of Customers': vm.revenuedispersion.data[key].customer_count,
                                        'No of Invoices': vm.revenuedispersion.data[key].invoice_count,
                                        '%': vm.revenuedispersion.data[key].percentage
                                        //console.log(vm.products[key].unit);
                                    });

                                    rowDataNew.push({
                                        'sol_range': vm.revenuedispersion.data[key].sol_range,
                                        'customer_count': vm.revenuedispersion.data[key].customer_count,
                                        'invoice_count': vm.revenuedispersion.data[key].invoice_count,
                                        'percentage': vm.revenuedispersion.data[key].percentage
                                    });
                                    //  }
                                    i++;
                                }
                            }

                            vm.excelArray = revenuedispersionArray;
                            vm.gridOptions.rowData = rowDataNew;
                            vm.gridOptions.columnDefs = gridcolumns;
                            vm.revenuedispersion.loaded = true;
                            vm.loadrevenuedispersionGrid = true;
                        },
                        // Error
                        function (data) {
                            // TODO Show a notificatoin to the user, or replace the cards with an error message.
                            //$log.log('Unable to fetch widget4: ' + data);
                        }
                    );

                },


                init: function () {
                    vm.revenuedispersion.loadData();
                }
            };


            vm.salesmanproductivitymeasures = {
                data: [],

                widget1: {
                    title: "Coverage Analysis",
                    ranges: {
                        TM: "This Month",
                        LM: "Last Month",
                        "2M": "2 Months Ago"
                    },
                    mainChart: {
                        config: {
                            refreshDataOnly: true,
                            deepWatchData: true
                        },
                        options: {
                            chart: {
                                type: 'multiBarChart',
                                color: ["#529CD6", '#A5ADA5', '#EFB500', "#529C5A", "#29528C"],
                                height: 600,

                                rotateLabels: 35,
                                axisLabelDistance: 10,
                                forceY: [0, 200],
                                margin: {
                                    top: 64,
                                    right: 16,
                                    bottom: 64,
                                    left: 64
                                },
                                padding: {
                                    top: 10
                                },
                                clipEdge: true,
                                groupSpacing: 0.4,
                                reduceXTicks: false,
                                stacked: false,
                                duration: 250, fontSize: 3,
                                x: function (d) {
                                    return d.x;
                                },
                                y: function (d) {
                                    return d.y;
                                },
                                xAxis: {
                                    tickFormat: function (d) {
                                        return d;
                                    },
                                    fontSize: 1
                                },
                                yAxis: {
                                    tickFormat: function (d) {
                                        return d;
                                    }
                                },
                                legend: {
                                    margin: {
                                        top: 32,
                                        bottom: 32, left: 50
                                    },
                                    rightAlign: false
                                },

                                controls: {
                                    margin: {
                                        top: 32,
                                        bottom: 32
                                    }
                                },
                                tooltip: {
                                    gravity: 's',
                                    classes: 'gravity-s'
                                }
                            }
                        },
                        data: [],
                    }
                },
                widget2: {
                    title: "Range Analysis",
                    ranges: {
                        TM: "This Month",
                        LM: "Last Month",
                        "2M": "2 Months Ago"
                    },
                    mainChart: {
                        config: {
                            refreshDataOnly: true,
                            deepWatchData: true
                        },
                        options: {
                            chart: {
                                type: 'multiBarChart',
                                color: ["#529CD6", '#A5ADA5', '#EFB500', "#529C5A", "#29528C"],
                                height: 600,
                                rotateLabels: 35,
                                axisLabelDistance: 10,
                                forceY: [0, 200],
                                margin: {
                                    top: 64,
                                    right: 16,
                                    bottom: 64,
                                    left: 64
                                },
                                padding: {
                                    top: 10
                                },
                                clipEdge: true,
                                groupSpacing: 0.4,
                                reduceXTicks: false,
                                stacked: false,
                                duration: 250, fontSize: 3,
                                x: function (d) {
                                    return d.x;
                                },
                                y: function (d) {
                                    return d.y;
                                },
                                xAxis: {
                                    tickFormat: function (d) {
                                        return d;
                                    },
                                    fontSize: 1
                                },
                                yAxis: {
                                    tickFormat: function (d) {
                                        return d;
                                    }
                                },
                                legend: {
                                    margin: {
                                        top: 32,
                                        bottom: 32,
                                        left: 50
                                    },
                                    rightAlign: false,
                                },
                                controls: {
                                    margin: {
                                        top: 32,
                                        bottom: 32
                                    }
                                },
                                tooltip: {
                                    gravity: 's',
                                    classes: 'gravity-s'
                                }
                            }
                        },
                        data: [],
                    }
                },
                loadData: function () {

                    vm.salesmanproductivitymeasures.loaded = false;
                    vm.loadsalesmanproductivitymeasuresGrid = false;
                    vm.salesmanproductivitymeasures.widget1.mainChart.data.length = 0;
                    vm.salesmanproductivitymeasures.widget2.mainChart.data.length = 0;

                    vm.salesmanproductivitymeasures.widget1.mainChart.options.chart.width = 1200;
                    vm.salesmanproductivitymeasures.widget2.mainChart.options.chart.width = 1200;
                    gridcolumns = salesmanproductivitymeasurescolumns;
                    vm.searchGrid = function () {
                        vm.gridOptions.api.setQuickFilter(vm.searchaggrid);
                    }


                    msApi.request(Api.salesman_productivity_measures + '@get',
                        {
                            start_date: vm.start_date,
                            end_date: vm.end_date,
                            zone_id: vm.zoneFilter.getSelectedZoneId(),
                            salesman_id: vm.SalesmanFilter.getSelectedUserId(),
                            emp_code: vm.empcodeFilter.getSelectedEmployeeId(),
                            beat_id: vm.beatFilter.getSelectedBeatId()
                        },
                        // Success
                        function (data) {
                            $log.log(data);
                            $log.log('Received No Data');
                            vm.salesmanproductivitymeasures.data = data.result;
                            if ((data.result.length) > 20) {
                                vm.salesmanproductivitymeasures.widget1.mainChart.options.chart.width = 8000;
                                vm.salesmanproductivitymeasures.widget2.mainChart.options.chart.width = 8000;
                            }
                            // Array build to export As CSV
                            var salesmanproductivitymeasuresArray = [];  // export csv array
                            var rowDataNew = [];  // ag-grid row data
                            var i = 0;
                            for (var key in vm.salesmanproductivitymeasures.data) {
                                if (vm.salesmanproductivitymeasures.data.hasOwnProperty(key)) {
                                    //  if(i<30000){
                                    salesmanproductivitymeasuresArray.push({
                                        'SL No': i + 1,
                                        'Emp Code': vm.salesmanproductivitymeasures.data[key].emp_code,
                                        'Salesman': vm.salesmanproductivitymeasures.data[key].login,
                                        // 'Zone': vm.salesmanproductivitymeasures.data[key].zone_id,
                                        'Total Outlets': vm.salesmanproductivitymeasures.data[key].unique_retailers,
                                        'TC': vm.salesmanproductivitymeasures.data[key].retailer_count,
                                        'VC': vm.salesmanproductivitymeasures.data[key].visited_count,
                                        'VC%': vm.salesmanproductivitymeasures.data[key].coverage,
                                        'PC': vm.salesmanproductivitymeasures.data[key].productive_calls,
                                        'PC%': vm.salesmanproductivitymeasures.data[key].prod_pct,
                                        'Revenue': vm.salesmanproductivitymeasures.data[key].revenue,
                                        'Total SKU': vm.salesmanproductivitymeasures.data[key].total_sku,
                                        'Unique SKU': vm.salesmanproductivitymeasures.data[key].unique_sku,
                                        'Unique VC': vm.salesmanproductivitymeasures.data[key].unique_vc,
                                        'Unique PC': vm.salesmanproductivitymeasures.data[key].unique_pc,
                                        'Unique VC%': vm.salesmanproductivitymeasures.data[key].unique_vc_pct,
                                        'Unique PC%': vm.salesmanproductivitymeasures.data[key].unique_pc_pct,
                                        'Avg SKU': vm.salesmanproductivitymeasures.data[key].avg_sku_per_order,
                                        'Avg Order Value': vm.salesmanproductivitymeasures.data[key].avg_revenue_per_order
                                    });

                                    rowDataNew.push({
                                        'emp_code': vm.salesmanproductivitymeasures.data[key].emp_code,
                                        'login': vm.salesmanproductivitymeasures.data[key].login,
                                        // 'zone_id': vm.salesmanproductivitymeasures.data[key].zone_id,
                                        'unique_retailers': vm.salesmanproductivitymeasures.data[key].unique_retailers,
                                        'retailer_count': vm.salesmanproductivitymeasures.data[key].retailer_count,
                                        'visited_count': vm.salesmanproductivitymeasures.data[key].visited_count,
                                        'coverage': vm.salesmanproductivitymeasures.data[key].coverage,
                                        'productive_calls': vm.salesmanproductivitymeasures.data[key].productive_calls,
                                        'prod_pct': vm.salesmanproductivitymeasures.data[key].prod_pct,
                                        'revenue': vm.salesmanproductivitymeasures.data[key].revenue,
                                        'total_sku': vm.salesmanproductivitymeasures.data[key].total_sku,
                                        'unique_sku': vm.salesmanproductivitymeasures.data[key].unique_sku,
                                        'unique_vc': vm.salesmanproductivitymeasures.data[key].unique_vc,
                                        'unique_pc': vm.salesmanproductivitymeasures.data[key].unique_pc,
                                        'unique_vc_pct': vm.salesmanproductivitymeasures.data[key].unique_vc_pct,
                                        'unique_pc_pct': vm.salesmanproductivitymeasures.data[key].unique_pc_pct,
                                        'avg_sku_per_order': vm.salesmanproductivitymeasures.data[key].avg_sku_per_order,
                                        'avg_revenue_per_order': vm.salesmanproductivitymeasures.data[key].avg_revenue_per_order
                                    });
                                    //  }
                                    i++;
                                }
                            }

                            vm.salesmanproductivitymeasures.widget1.mainChart.data.length = 0;
                            vm.salesmanproductivitymeasures.widget2.mainChart.data.length = 0;
                            //Assigning Data to BarChart -widget1
                            var VC = []
                            var PC = []
                            var UniquePC = []
                            var UniqueVC = []
                            // var AVG_SKU = []
                            // var Unique_SKU = []

                            angular.forEach(data.result, function (chartData, index) {
                                VC[index] = {
                                    x: chartData.login,
                                    y: chartData.coverage
                                };
                            });
                            angular.forEach(data.result, function (chartData, index) {
                                UniqueVC[index] = {
                                    x: chartData.login,
                                    y: chartData.unique_vc_pct
                                };
                            });
                            angular.forEach(data.result, function (chartData, index) {
                                PC[index] = {
                                    x: chartData.login,
                                    y: chartData.prod_pct
                                };
                            });
                            angular.forEach(data.result, function (chartData, index) {
                                UniquePC[index] = {
                                    x: chartData.login,
                                    y: chartData.unique_pc_pct
                                };
                            });
                            // angular.forEach(data.result, function (chartData, index) {
                            //     AVG_SKU[index] = {
                            //         x: chartData.login,
                            //         y: chartData.avg_sku_per_order
                            //     };
                            // });
                            // angular.forEach(data.result, function (chartData, index) {
                            //     Unique_SKU[index] = {
                            //         x: chartData.login,
                            //         y: chartData.unique_sku
                            //     };
                            // });

                            vm.salesmanproductivitymeasures.widget1.mainChart.data[0] = {
                                key: "VC %",
                                values: VC
                            };
                            vm.salesmanproductivitymeasures.widget1.mainChart.data[1] = {
                                key: "Unique VC %",
                                values: UniqueVC
                            };
                            vm.salesmanproductivitymeasures.widget1.mainChart.data[2] = {
                                key: "PC %",
                                values: PC
                            };
                            vm.salesmanproductivitymeasures.widget1.mainChart.data[3] = {
                                key: "Unique PC %",
                                values: UniquePC
                            };
                            // vm.salesmanproductivitymeasures.widget1.mainChart.data[4] = {
                            //     key: "AVG SKU",
                            //     values: AVG_SKU
                            // };
                            // vm.salesmanproductivitymeasures.widget1.mainChart.data[5] = {
                            //     key: "Unique SKU",
                            //     values: Unique_SKU
                            // };

                            // Assigning Data to BarChart -widget003
                            var AS = []
                            var US = []

                            angular.forEach(data.result, function (chartData, index) {
                                AS[index] = {
                                    x: chartData.login,
                                    y: chartData.avg_sku_per_order
                                };
                            });
                            angular.forEach(data.result, function (chartData, index) {
                                US[index] = {
                                    x: chartData.login,
                                    y: chartData.unique_sku
                                };
                            });

                            vm.salesmanproductivitymeasures.widget2.mainChart.data[0] = {
                                key: "AVG SKU",
                                values: AS
                            };
                            vm.salesmanproductivitymeasures.widget2.mainChart.data[1] = {
                                key: "Unique SKU",
                                values: US
                            };


                            vm.excelArray = salesmanproductivitymeasuresArray;
                            vm.gridOptions.rowData = rowDataNew;
                            vm.gridOptions.columnDefs = gridcolumns;
                            vm.loadsalesmanproductivitymeasuresGrid = true;
                            vm.salesmanproductivitymeasures.loaded = true;
                        },
                        // Error
                        function (data) {
                            // TODO Show a notificatoin to the user, or replace the cards with an error message.
                            // $log.log('Unable to fetch widget4: ' + data);
                        }
                    );

                },


                init: function () {
                    vm.salesmanproductivitymeasures.loadData();
                }
            };
            /*Graph View for No Sales Visits Zone bar analysis*/

            vm.nosalesvisitszonegraph = {
                data: [],

                widget1: {
                    title: "By Zone ",
                    ranges: {
                        TM: "This Month",
                        LM: "Last Month",
                        "2M": "2 Months Ago"
                    },
                    mainChart: {
                        config: {
                            refreshDataOnly: true,
                            deepWatchData: true
                        },
                        options: {
                            chart: {
                                type: 'multiBarChart',
                                color: ['#f44336', '#9c27b0', '#03a9f4', '#e91e63', '#c8b550', '#cc6699', '#ffcc00', '#6699ff', '#0099cc', '#9966ff', '#00cc66', '#333300', '#00DD66', '#3EE300'],
                                height: 600,
                                rotateLabels: 30,
                                axisLabelDistance: 10,
                                forceY: [0,10000],
                                showValues: true,
                                margin: {
                                    top: 64,
                                    right: 16,
                                    bottom: 64,
                                    left: 64
                                },
                                padding: {
                                    top: 10
                                },
                                clipEdge: true,
                                groupSpacing: 0.1,
                                reduceXTicks: false,
                                duration: 250,
                                x: function (d) {
                                    return d.x;
                                },
                                y: function (d) {
                                    return d.y;
                                },
                                xAxis: {
                                    tickFormat: function (d) {
                                        return d;
                                    }, scrollbar: {
                                        enabled: true
                                    },
                                    tickLength: 0
                                },
                                yAxis: {
                                    tickFormat: function (d) {
                                        return d;
                                    }
                                },
                                legend: {
                                    margin: {
                                        top: 32,
                                        bottom: 32,
                                        left: 50
                                    },
                                    rightAlign: false
                                },
                                controls: {
                                    margin: {
                                        top: 32,
                                        bottom: 32
                                    }
                                },
                                tooltip: {
                                    gravity: 's',
                                    classes: 'gravity-s'
                                }
                            }
                        },
                        data: [],
                    }
                },
                loadData: function () {

                    vm.nosalesvisitszonegraph.loaded = false;
                    vm.nosalesvisitszonegraph.widget1.mainChart.data.length = 0; // Remove all previous chart data on reload
                    vm.nosalesvisitszonegraph.widget1.mainChart.options.chart.width = 1200 ;

                    msApi.request(Api.no_sales_visits_zone_graph + '@get',
                        {
                            start_date: vm.start_date,
                            end_date: vm.end_date,
                            zone_id: vm.zoneFilter.getSelectedZoneId(),
                            salesman_id: vm.SalesmanFilter.getSelectedUserId(),
                            emp_code: vm.empcodeFilter.getSelectedEmployeeId()
                        },
                        // Success
                        function (data) {
                            vm.nosalesvisitszonegraph.data = data.result;
                            vm.nosalesvisitszonegraph.widget1.mainChart.data.length = 0;
                            // vm.nosalesvisitszonegraph.widget1.mainChart.options.chart.width = 500+150*parseInt(data.result.length);
                            vm.nosalesvisitszonegraph.widget1.mainChart.options.chart.forceX = parseInt(data.result.length);
                            // vm.nosalesvisitszonegraph.widget1.mainChart.options.chart.showValues = true;
                            vm.nosalesvisitszonegraph.widget1.mainChart.options.chart.showData = true;

                            if ((data.result.length) > 20) {
                                vm.nosalesvisitszonegraph.widget1.mainChart.options.chart.width = 10000;
                            }
                            var Grocer = []
                            var i1 = 0;
                            var BigGrocer = []
                            var i2 = 0;
                            var PujaOutlet = []
                            var i3 = 0;
                            var StarWholesale = []
                            var i4 = 0;
                            var WholesaleOthers = []
                            var i5 = 0;
                            var RangRaj = []
                            var i6 = 0;
                            var RangPuja = []
                            var i7 = 0;
                            var RangSeva = []
                            var i8 = 0;
                            var AgarbattiDealer = []
                            var i9 = 0;
                            var SelfService = []
                            var i10 = 0;
                            var ymax= 10;

                            angular.forEach(data.result, function (chartData, index) {
                                if (parseInt(chartData.outlet_count) > parseInt(ymax) ){
                                    ymax = parseInt(chartData.outlet_count)
                                }
                                if (chartData.outlet_type.toString().trim() === "Grocer"){
                                    Grocer[i1++] = {
                                        x: chartData.zone_name,
                                        y: chartData.outlet_count
                                    };
                                }else{
                                    Grocer[i1++] = {
                                        x: chartData.zone_name,
                                        y: 0
                                    };
                                }
                                if (chartData.outlet_type.toString().trim() === "Big Grocer"){
                                    BigGrocer[i2++] = {
                                        x: chartData.zone_name,
                                        y: chartData.outlet_count
                                    };
                                }else{
                                    BigGrocer[i2++] = {
                                        x: chartData.zone_name,
                                        y: 0
                                    };
                                }

                                if (chartData.outlet_type.toString().trim() === "Puja Outlet"){
                                    PujaOutlet[i3++] = {
                                        x: chartData.zone_name,
                                        y: chartData.outlet_count
                                    };
                                }else{
                                    PujaOutlet[i3++] = {
                                        x: chartData.zone_name,
                                        y: 0
                                    };
                                }
                                if (chartData.outlet_type.toString().trim() === "Star Wholesale"){
                                    StarWholesale[i4++] = {
                                        x: chartData.zone_name,
                                        y: chartData.outlet_count
                                    };
                                }else{
                                    StarWholesale[i4++]  = {
                                        x: chartData.zone_name,
                                        y: 0
                                    };
                                }
                                if (chartData.outlet_type.toString().trim() === "Wholesale others"){
                                    WholesaleOthers[i5++] = {
                                        x: chartData.zone_name,
                                        y: chartData.outlet_count
                                    };
                                }else{
                                    WholesaleOthers[i5++]= {
                                        x: chartData.zone_name,
                                        y: 0
                                    };
                                }
                                if (chartData.outlet_type.toString().trim() === "Rang Raj"){
                                    RangRaj[i6++] = {
                                        x: chartData.zone_name,
                                        y: chartData.outlet_count
                                    };
                                }else{
                                    RangRaj[i6++]= {
                                        x: chartData.zone_name,
                                        y: 0
                                    };
                                }
                                if (chartData.outlet_type.toString().trim() === "Rang Puja"){
                                    RangPuja[i7++] = {
                                        x: chartData.zone_name,
                                        y: chartData.outlet_count
                                    };
                                }else{
                                    RangPuja[i7++] = {
                                        x: chartData.zone_name,
                                        y: 0
                                    };
                                }
                                if (chartData.outlet_type.toString().trim() === "Rang Seva"){
                                    RangSeva[i8++] = {
                                        x: chartData.zone_name,
                                        y: chartData.outlet_count
                                    };
                                }else{
                                    RangSeva[i8++] = {
                                        x: chartData.zone_name,
                                        y: 0
                                    };
                                }
                                if (chartData.outlet_type.toString().trim() === "Agarbatti Dealer"){
                                    AgarbattiDealer[i9++] = {
                                        x: chartData.zone_name,
                                        y: chartData.outlet_count
                                    };
                                }else{
                                    AgarbattiDealer[i9++] = {
                                        x: chartData.zone_name,
                                        y: 0
                                    };
                                }
                                if (chartData.outlet_type.toString().trim() === "Self Service"){
                                    SelfService[i10++] = {
                                        x: chartData.zone_name,
                                        y: chartData.outlet_count
                                    };
                                }else{
                                    SelfService[i10++] = {
                                        x: chartData.zone_name,
                                        y: 0
                                    };
                                }
                            });

                            vm.nosalesvisitszonegraph.widget1.mainChart.options.chart.forceY = [0, ymax];
                            vm.nosalesvisitszonegraph.widget1.mainChart.options.chart.height = 500+(ymax)/10 ;
                            vm.nosalesvisitszonegraph.widget1.mainChart.data[0] = {
                                key: "Grocer",
                                values: Grocer
                            };
                            vm.nosalesvisitszonegraph.widget1.mainChart.data[1] = {
                                key: "Big Grocer",
                                values: BigGrocer
                            };
                            vm.nosalesvisitszonegraph.widget1.mainChart.data[2] = {
                                key: "Puja Outlet",
                                values: PujaOutlet
                            };
                            vm.nosalesvisitszonegraph.widget1.mainChart.data[3] = {
                                key: "Wholesale Others",
                                values: WholesaleOthers
                            };
                            vm.nosalesvisitszonegraph.widget1.mainChart.data[4] = {
                                key: "Star Wholesale",
                                values: StarWholesale
                            };
                            vm.nosalesvisitszonegraph.widget1.mainChart.data[5] = {
                                key: "Rang Raj",
                                values: RangRaj
                            };
                            vm.nosalesvisitszonegraph.widget1.mainChart.data[6] = {
                                key: "Rang Puja",
                                values: RangPuja
                            };
                            vm.nosalesvisitszonegraph.widget1.mainChart.data[7] = {
                                key: "Rang Seva",
                                values: RangSeva
                            };
                            vm.nosalesvisitszonegraph.widget1.mainChart.data[8] = {
                                key: "Agarbatti Dealer",
                                values: AgarbattiDealer
                            };
                            vm.nosalesvisitszonegraph.widget1.mainChart.data[9] = {
                                key: "Self Service",
                                values: SelfService
                            };
                            vm.nosalesvisitszonegraph.loaded = true;
                        },
                        function (data) {
                        }
                    );
                },
                init: function () {
                    vm.nosalesvisitszonegraph.loadData();
                }
            };
            /*No Sales Consecutive Visits By Outlet  Type Graph widget*/

            vm.nosalesvisitsoutletgraph = {
                data: [],
                // Widget 1 Pie Chart
                widget2: {
                    title: "By Outlet Type %",
                    mainChart: {
                        config: {
                            refreshDataOnly: true,
                            deepWatchData: true
                        },
                        options: {
                            chart: {
                                type: 'pieChart',
                                color: ['#f44336', '#9c27b0', '#03a9f4', '#e91e63', '#c8b550', '#cc6699', '#ffcc00', '#6699ff', '#0099cc', '#9966ff', '#00cc66', '#333300'],
                                height: 400,
                                margin: {
                                    top: 0,
                                    right: 0,
                                    bottom: 0,
                                    left: 0
                                },
                                donut: true,
                                clipEdge: true,
                                cornerRadius: 0,
                                labelType: 'value',
                                padAngle: 0.02,
                                x: function (d) {
                                    return d.label;
                                },
                                y: function (d) {
                                    return d.value;
                                },
                                tooltip: {
                                    gravity: 's',
                                    classes: 'gravity-s'
                                }
                            }
                        },
                        data: []
                    }
                },
                loadData: function () {
                    vm.nosalesvisitsoutletgraph.loaded = false;
                    vm.nosalesvisitsoutletgraph.widget2.mainChart.data.length = 0; // Remove all previous chart data on reload
                    gridcolumns1 = nosalesvisitsoutletgraphcolumns;

                    msApi.request(Api.no_sales_visits_outlet_graph + '@get',
                        {
                            start_date: vm.start_date,
                            end_date: vm.end_date,
                            zone_id: vm.zoneFilter.getSelectedZoneId(),
                            salesman_id: vm.SalesmanFilter.getSelectedUserId(),
                            emp_code: vm.empcodeFilter.getSelectedEmployeeId(),
                        },
                        // Success
                        function (data) {
                            vm.nosalesvisitsoutletgraph.data = data.result;
                            //Assigning Data to pieChart -widget2
                            vm.nosalesvisitsoutletgraph.widget2.mainChart.data.length = 0; // Remove all previous chart data on reload
                            angular.forEach(data.result, function (outlet, index) {
                                vm.nosalesvisitsoutletgraph.widget2.mainChart.data[index] = {
                                    label: outlet.outlet_type,
                                    value: outlet.outlet_count_pct
                                };
                            });
                            vm.nosalesvisitsoutletgraph.loaded = true;
                        },
                        // Error
                        function (data) {
                            // TODO Show a notificatoin to the user, or replace the cards with an error message.
                        }
                    );
                },
                init: function () {
                    vm.nosalesvisitsoutletgraph.loadData();
                }
            };
            /**/


            vm.nosalesconsecutivevisits = {
                data: [],

                loadData: function () {

                    vm.nosalesconsecutivevisits.loaded = false;
                    vm.loadnosalesconsecutivevisitsGrid = false;
                    vm.nosalesvisitsoutletgraph.loadData();
                    vm.nosalesvisitszonegraph.loadData();
                    gridcolumns = nosalesconsecutivevisitscolumns;
                    vm.searchGrid = function () {
                        vm.gridOptions.api.setQuickFilter(vm.searchaggrid);
                    }

                    msApi.request(Api.no_sales_consecutive_visits + '@get',
                        {
                            start_date: vm.start_date,
                            end_date: vm.end_date,
                            zone_id: vm.zoneFilter.getSelectedZoneId(),
                            team_id: vm.teamFilter.getSelectedTeamId(),
                            salesman_id: vm.SalesmanFilter.getSelectedUserId(),
                            emp_code: vm.empcodeFilter.getSelectedEmployeeId()
                        },
                        // Success
                        function (data) {
                            $log.log(data);
                            $log.log('Received No Data');
                            // $log.log(data);
                            // Set new values for widget4 based on the new data
                            vm.nosalesconsecutivevisits.data = data.result;

                            // Array build to export As CSV
                            var nosalesconsecutivevisitsArray = [];  // export csv array
                            var rowDataNew = [];  // ag-grid row data
                            var i = 0;
                            for (var key in vm.nosalesconsecutivevisits.data) {
                                if (vm.nosalesconsecutivevisits.data.hasOwnProperty(key)) {
                                    //  if(i<30000){
                                    nosalesconsecutivevisitsArray.push({
                                        'SL No': i + 1,
                                        'Emp Code': vm.nosalesconsecutivevisits.data[key].emp_code,
                                        'Emp Name': vm.nosalesconsecutivevisits.data[key].salesman,
                                        'Zone': vm.nosalesconsecutivevisits.data[key].zone,
                                        'Outlet ID': vm.nosalesconsecutivevisits.data[key].outlet_id,
                                        'Outlet Name': vm.nosalesconsecutivevisits.data[key].retailer_name,
                                        'Outlet Type': vm.nosalesconsecutivevisits.data[key].outlet_type,
                                        //'VC': vm.nosalesconsecutivevisits.data[key].visit_count

                                        //console.log(vm.products[key].unit);
                                    });

                                    rowDataNew.push({
                                        'emp_code': vm.nosalesconsecutivevisits.data[key].emp_code,
                                        'salesman': vm.nosalesconsecutivevisits.data[key].salesman,
                                        'zone': vm.nosalesconsecutivevisits.data[key].zone,
                                        'outlet_id': vm.nosalesconsecutivevisits.data[key].outlet_id,
                                        'retailer_name': vm.nosalesconsecutivevisits.data[key].retailer_name,
                                        'outlet_type': vm.nosalesconsecutivevisits.data[key].outlet_type,
                                        //'visit_count': vm.nosalesconsecutivevisits.data[key].visit_count
                                    });
                                    //  }
                                    i++;
                                }
                            }

                            vm.excelArray = nosalesconsecutivevisitsArray;
                            vm.gridOptions.rowData = rowDataNew;
                            vm.gridOptions.columnDefs = gridcolumns;
                            vm.loadnosalesconsecutivevisitsGrid = true;
                            vm.nosalesconsecutivevisits.loaded = true;
                        },
                        // Error
                        function (data) {
                            // TODO Show a notificatoin to the user, or replace the cards with an error message.
                            // $log.log('Unable to fetch widget4: ' + data);
                        }
                    );

                },


                init: function () {
                    vm.nosalesconsecutivevisits.loadData();
                }
            };

            vm.salesbycustomertype = {
                data: [],
                loadData: function () {
                    vm.salesbycustomertype.loaded = false;
                    vm.loadsalesbycustomertypeGrid = false;
                    vm.salesbycustomertypegraph.loadData();

                    vm.searchGrid = function () {
                        vm.gridOptions.api.setQuickFilter(vm.searchaggrid);
                    }
                    gridcolumns = salesbycustomertypecolumns;

                    msApi.request(Api.sales_by_customer_type + '@get',
                        {
                            start_date: vm.start_date,
                            end_date: vm.end_date,
                            zone_id: vm.zoneFilter.getSelectedZoneId(),
                            salesman_id: vm.SalesmanFilter.getSelectedUserId(),
                            emp_code: vm.empcodeFilter.getSelectedEmployeeId(),
                            brand_id: vm.BrandFilter.getSelectedBrandId(),
                            categ_id: vm.CategoryFilter.getSelectedCategoryId(),
                            dist_id: vm.distnameFilter.getSelectedDistributorId(),
                            dist_code: vm.distcodeFilter.getSelectedDistributorId()
                        },
                        // Success
                        function (data) {
                            $log.log(vm.beat);
                            $log.log('Received No Data');
                            // $log.log(data);
                            // Set new values for widget4 based on the new data
                            vm.salesbycustomertype.data = data.result;

                            // Array build to export As CSV
                            var salesbycustomertypeArray = [];  // export csv array
                            var rowDataNew = [];  // ag-grid row data
                            var i = 0;
                            for (var key in vm.salesbycustomertype.data) {
                                if (vm.salesbycustomertype.data.hasOwnProperty(key)) {
                                    //  if(i<30000){
                                    salesbycustomertypeArray.push({
                                        'SL No': i + 1,
                                        'Emp Code': vm.salesbycustomertype.data[key].emp_code,
                                        'Employee Name': vm.salesbycustomertype.data[key].salesman,
                                        'Zone': vm.salesbycustomertype.data[key].zone,
                                        'Dist Code': vm.salesbycustomertype.data[key].dist_code,
                                        'Dist Name': vm.salesbycustomertype.data[key].dist_name,
                                        // 'Category': vm.salesbycustomertype.data[key].categ_name,
                                        // 'Brand': vm.salesbycustomertype.data[key].brand_name,
                                        'Outlet Type': vm.salesbycustomertype.data[key].outlet_type,
                                        'Net Sales': vm.salesbycustomertype.data[key].type_sales,
                                        'Contribution %': vm.salesbycustomertype.data[key].contribution_pct
                                        //console.log(vm.products[key].unit);
                                    });

                                    rowDataNew.push({
                                        'emp_code': vm.salesbycustomertype.data[key].emp_code,
                                        'salesman': vm.salesbycustomertype.data[key].salesman,
                                        'zone': vm.salesbycustomertype.data[key].zone,
                                        'dist_code': vm.salesbycustomertype.data[key].dist_code,
                                        'dist_name': vm.salesbycustomertype.data[key].dist_name,
                                        // 'categ_name': vm.salesbycustomertype.data[key].categ_name,
                                        // 'brand_name': vm.salesbycustomertype.data[key].brand_name,
                                        'outlet_type': vm.salesbycustomertype.data[key].outlet_type,
                                        'type_sales': vm.salesbycustomertype.data[key].type_sales,
                                        'contribution_pct': vm.salesbycustomertype.data[key].contribution_pct
                                    });
                                    //  }
                                    i++;
                                }
                            }

                            vm.excelArray = salesbycustomertypeArray;
                            vm.gridOptions.rowData = rowDataNew;
                            vm.gridOptions.columnDefs = gridcolumns;
                            vm.loadsalesbycustomertypeGrid = true;
                            vm.salesbycustomertype.loaded = true;
                        },
                        // Error
                        function (data) {
                            // TODO Show a notificatoin to the user, or replace the cards with an error message.
                            // $log.log('Unable to fetch widget4: ' + data);
                        }
                    );

                },


                init: function () {
                    vm.salesbycustomertype.loadData();
                }
            };


            $scope.exportData = function (tableid) {
                var uri = 'data:application/vnd.ms-excel;base64,'
                    ,
                    template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>'
                    , base64 = function (s) {
                        return window.btoa(unescape(encodeURIComponent(s)))
                    }
                    , format = function (s, c) {
                        return s.replace(/{(\w+)}/g, function (m, p) {
                            return c[p];
                        })
                    }

                var table = document.getElementById(tableid);
                $log.log(table);
                var filters = $('.ng-table-filters').remove();
                var ctx = {worksheet: name || 'Worksheet', table: table.innerHTML};
                $('.ng-table-sort-header').after(filters);
                var url = uri + base64(format(template, ctx));
                var a = document.createElement('a');
                a.href = url;
                a.download = 'Report.xls';
                a.click();
            };


            // Methods

            //////////

            // Initialize Widget 1
            // vm.widget1.init();

            // Initialize Widget 2
            //vm.widget2.init();

            // Initialize Widget 3
            //vm.widget3.init();

            // Initialize Widget 4
            //vm.widget4.init();

            // Initialize Widget 5
            vm.widget5.init();

            // Initialize Widget 6
            vm.widget6.init();

            // Initialize Widget 7
            vm.widget7.init();

            // Initialize Widget 8
            vm.widget8.init();

            // Initialize Widget 9
            vm.widget9.init();

            // Initialize Widget 10
            // vm.widget10.init();

            // Initialize Widget 11
            // vm.widget11.init();

            // Initialize Widget 11
            // vm.widget12.init();

            // Initialize Widget 11
            // vm.widget13.init();

            // Initialize Team Filter
            vm.teamFilter.init();

            // Initialize Overview Team Filter
            vm.overviewteamFilter.init();

            // Initialize Salesman Filter
            vm.SalesmanFilter.init();

            // Initialize Overview Salesman Filter
            vm.overviewSalesmanFilter.init();

            // Initialize Partner Type Filter
            vm.partnerTypeFilter.init();

            // Initialize Zone Filter
            vm.zoneFilter.init();

            // Initialize Overview Zone Filter
            vm.overviewzoneFilter.init()

            // Initialize Beat Filter
            vm.beatFilter.init()

            // Initialize Distributor Name Filter
            vm.distnameFilter.init();

            // Initialize Distributor Code Filter
            vm.distcodeFilter.init();

            // Initialize Partner Name Filter
            vm.partnerFilter.init();

            // Initialize Emp Code Filter
            vm.empcodeFilter.init();

            // Initialize Category Filter
            vm.CategoryFilter.init();

            // Initialize Brand Filter
            vm.BrandFilter.init();

            // Initialize Date Filter
            reloadWidgets();

            function loadzerosales() {

            }
        }
        else {
            //alert("Exit");
            {
                //console.log("Logout....");
                $state.go('app.login');
            }
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.components.charts.nvd3',
            [
                // 3rd Party Dependencies
                'nvd3'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.components_charts_nvd3', {
            url  : '/components/charts/nvd3',
            views: {
                'content@app': {
                    templateUrl: 'app/main/components/charts/nvd3/nvd3.html',
                    controller : 'Nvd3Controller as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.components.charts.nvd3')
        .controller('Nvd3Controller', Nvd3Controller);

    function Nvd3Controller()
    {
        var vm = this;

        // Data
        vm.lineChart = {
            options: {
                chart   : {
                    type                   : 'lineChart',
                    height                 : 450,
                    margin                 : {
                        top   : 20,
                        right : 20,
                        bottom: 40,
                        left  : 55
                    },
                    x                      : function (d)
                    {
                        return d.x;
                    },
                    y                      : function (d)
                    {
                        return d.y;
                    },
                    useInteractiveGuideline: true,
                    xAxis                  : {
                        axisLabel: 'Time (ms)'
                    },
                    yAxis                  : {
                        axisLabel        : 'Voltage (v)',
                        tickFormat       : function (d)
                        {
                            return d3.format('.02f')(d);
                        },
                        axisLabelDistance: 30
                    }
                },
                title   : {
                    enable: true,
                    text  : 'Title for Line Chart'
                },
                subtitle: {
                    enable: true,
                    text  : 'Subtitle for simple line chart. Lorem ipsum dolor sit amet, at eam blandit sadipscing, vim adhuc sanctus disputando ex, cu usu affert alienum urbanitas.',
                    css   : {
                        'text-align': 'center',
                        'margin'    : '10px 13px 0px 7px'
                    }
                },
                caption : {
                    enable: true,
                    html  : '<b>Figure 1.</b> Lorem ipsum dolor sit amet, at eam blandit sadipscing, <span style="text-decoration: underline;">vim adhuc sanctus disputando ex</span>, cu usu affert alienum urbanitas. <i>Cum in purto erat, mea ne nominavi persecuti reformidans.</i> Docendi blandit abhorreant ea has, minim tantas alterum pro eu. <span style="color: darkred;">Exerci graeci ad vix, elit tacimates ea duo</span>. Id mel eruditi fuisset. Stet vidit patrioque in pro, eum ex veri verterem abhorreant, id unum oportere intellegam nec<sup>[1, <a href="https://github.com/krispo/angular-nvd3" target="_blank">2</a>, 3]</sup>.',
                    css   : {
                        'text-align': 'justify',
                        'margin'    : '10px 13px 0px 7px'
                    }
                }
            },
            data   : sinAndCos()
        };

        vm.stackedAreaChart = {
            options: {
                chart: {
                    type                   : 'stackedAreaChart',
                    height                 : 450,
                    margin                 : {
                        top   : 20,
                        right : 20,
                        bottom: 60,
                        left  : 40
                    },
                    x                      : function (d)
                    {
                        return d[0];
                    },
                    y                      : function (d)
                    {
                        return d[1];
                    },
                    useVoronoi             : false,
                    clipEdge               : true,
                    transitionDuration     : 500,
                    useInteractiveGuideline: true,
                    xAxis                  : {
                        showMaxMin: false,
                        tickFormat: function (d)
                        {
                            return d3.time.format('%x')(new Date(d));
                        }
                    },
                    yAxis                  : {
                        tickFormat: function (d)
                        {
                            return d3.format(',.2f')(d);
                        }
                    }
                }
            },

            data: [
                {
                    'key'   : 'North America',
                    'values': [[1025409600000, 23.041422681023], [1028088000000, 19.854291255832], [1030766400000, 21.02286281168], [1033358400000, 22.093608385173], [1036040400000, 25.108079299458], [1038632400000, 26.982389242348], [1041310800000, 19.828984957662], [1043989200000, 19.914055036294], [1046408400000, 19.436150539916], [1049086800000, 21.558650338602], [1051675200000, 24.395594061773], [1054353600000, 24.747089309384], [1056945600000, 23.491755498807], [1059624000000, 23.376634878164], [1062302400000, 24.581223154533], [1064894400000, 24.922476843538], [1067576400000, 27.357712939042], [1070168400000, 26.503020572593], [1072846800000, 26.658901244878], [1075525200000, 27.065704156445], [1078030800000, 28.735320452588], [1080709200000, 31.572277846319], [1083297600000, 30.932161503638], [1085976000000, 31.627029785554], [1088568000000, 28.728743674232], [1091246400000, 26.858365172675], [1093924800000, 27.279922830032], [1096516800000, 34.408301211324], [1099195200000, 34.794362930439], [1101790800000, 35.609978198951], [1104469200000, 33.574394968037], [1107147600000, 31.979405070598], [1109566800000, 31.19009040297], [1112245200000, 31.083933968994], [1114833600000, 29.668971113185], [1117512000000, 31.490638014379], [1120104000000, 31.818617451128], [1122782400000, 32.960314008183], [1125460800000, 31.313383196209], [1128052800000, 33.125486081852], [1130734800000, 32.791805509149], [1133326800000, 33.506038030366], [1136005200000, 26.96501697216], [1138683600000, 27.38478809681], [1141102800000, 27.371377218209], [1143781200000, 26.309915460827], [1146369600000, 26.425199957518], [1149048000000, 26.823411519396], [1151640000000, 23.850443591587], [1154318400000, 23.158355444054], [1156996800000, 22.998689393695], [1159588800000, 27.9771285113], [1162270800000, 29.073672469719], [1164862800000, 28.587640408904], [1167541200000, 22.788453687637], [1170219600000, 22.429199073597], [1172638800000, 22.324103271052], [1175313600000, 17.558388444187], [1177905600000, 16.769518096208], [1180584000000, 16.214738201301], [1183176000000, 18.729632971229], [1185854400000, 18.814523318847], [1188532800000, 19.789986451358], [1191124800000, 17.070049054933], [1193803200000, 16.121349575716], [1196398800000, 15.141659430091], [1199077200000, 17.175388025297], [1201755600000, 17.286592443522], [1204261200000, 16.323141626568], [1206936000000, 19.231263773952], [1209528000000, 18.446256391095], [1212206400000, 17.822632399764], [1214798400000, 15.53936647598], [1217476800000, 15.255131790217], [1220155200000, 15.660963922592], [1222747200000, 13.254482273698], [1225425600000, 11.920796202299], [1228021200000, 12.122809090924], [1230699600000, 15.691026271393], [1233378000000, 14.720881635107], [1235797200000, 15.387939360044], [1238472000000, 13.765436672228], [1241064000000, 14.631445864799], [1243742400000, 14.292446536221], [1246334400000, 16.170071367017], [1249012800000, 15.948135554337], [1251691200000, 16.612872685134], [1254283200000, 18.778338719091], [1256961600000, 16.756026065421], [1259557200000, 19.385804443146], [1262235600000, 22.950590240168], [1264914000000, 23.61159018141], [1267333200000, 25.708586989581], [1270008000000, 26.883915999885], [1272600000000, 25.893486687065], [1275278400000, 24.678914263176], [1277870400000, 25.937275793024], [1280548800000, 29.461381693838], [1283227200000, 27.357322961861], [1285819200000, 29.057235285673], [1288497600000, 28.549434189386], [1291093200000, 28.506352379724], [1293771600000, 29.449241421598], [1296450000000, 25.796838168807], [1298869200000, 28.740145449188], [1301544000000, 22.091744141872], [1304136000000, 25.07966254541], [1306814400000, 23.674906973064], [1309406400000, 23.418002742929], [1312084800000, 23.24364413887], [1314763200000, 31.591854066817], [1317355200000, 31.497112374114], [1320033600000, 26.67238082043], [1322629200000, 27.297080015495], [1325307600000, 20.174315530051], [1327986000000, 19.631084213898], [1330491600000, 20.366462219461], [1333166400000, 19.284784434185], [1335758400000, 19.157810257624]]
                },

                {
                    'key'   : 'Africa',
                    'values': [[1025409600000, 7.9356392949025], [1028088000000, 7.4514668527298], [1030766400000, 7.9085410566608], [1033358400000, 5.8996782364764], [1036040400000, 6.0591869346923], [1038632400000, 5.9667815800451], [1041310800000, 8.65528925664], [1043989200000, 8.7690763386254], [1046408400000, 8.6386160387453], [1049086800000, 5.9895557449743], [1051675200000, 6.3840324338159], [1054353600000, 6.5196511461441], [1056945600000, 7.0738618553114], [1059624000000, 6.5745957367133], [1062302400000, 6.4658359184444], [1064894400000, 2.7622758754954], [1067576400000, 2.9794782986241], [1070168400000, 2.8735432712019], [1072846800000, 1.6344817513645], [1075525200000, 1.5869248754883], [1078030800000, 1.7172279157246], [1080709200000, 1.9649927409867], [1083297600000, 2.0261695079196], [1085976000000, 2.0541261923929], [1088568000000, 3.9466318927569], [1091246400000, 3.7826770946089], [1093924800000, 3.9543021004028], [1096516800000, 3.8309891064711], [1099195200000, 3.6340958946166], [1101790800000, 3.5289755762525], [1104469200000, 5.702378559857], [1107147600000, 5.6539569019223], [1109566800000, 5.5449506370392], [1112245200000, 4.7579993280677], [1114833600000, 4.4816139372906], [1117512000000, 4.5965558568606], [1120104000000, 4.3747066116976], [1122782400000, 4.4588822917087], [1125460800000, 4.4460351848286], [1128052800000, 3.7989113035136], [1130734800000, 3.7743883140088], [1133326800000, 3.7727852823828], [1136005200000, 7.2968111448895], [1138683600000, 7.2800122043237], [1141102800000, 7.1187787503354], [1143781200000, 8.351887016482], [1146369600000, 8.4156698763993], [1149048000000, 8.1673298604231], [1151640000000, 5.5132447126042], [1154318400000, 6.1152537710599], [1156996800000, 6.076765091942], [1159588800000, 4.6304473798646], [1162270800000, 4.6301068469402], [1164862800000, 4.3466656309389], [1167541200000, 6.830104897003], [1170219600000, 7.241633040029], [1172638800000, 7.1432372054153], [1175313600000, 10.608942063374], [1177905600000, 10.914964549494], [1180584000000, 10.933223880565], [1183176000000, 8.3457524851265], [1185854400000, 8.1078413081882], [1188532800000, 8.2697185922474], [1191124800000, 8.4742436475968], [1193803200000, 8.4994601179319], [1196398800000, 8.7387319683243], [1199077200000, 6.8829183612895], [1201755600000, 6.984133637885], [1204261200000, 7.0860136043287], [1206936000000, 4.3961787956053], [1209528000000, 3.8699674365231], [1212206400000, 3.6928925238305], [1214798400000, 6.7571718894253], [1217476800000, 6.4367313362344], [1220155200000, 6.4048441521454], [1222747200000, 5.4643833239669], [1225425600000, 5.3150786833374], [1228021200000, 5.3011272612576], [1230699600000, 4.1203601430809], [1233378000000, 4.0881783200525], [1235797200000, 4.1928665957189], [1238472000000, 7.0249415663205], [1241064000000, 7.006530880769], [1243742400000, 6.994835633224], [1246334400000, 6.1220222336254], [1249012800000, 6.1177436137653], [1251691200000, 6.1413396231981], [1254283200000, 4.8046006145874], [1256961600000, 4.6647600660544], [1259557200000, 4.544865006255], [1262235600000, 6.0488249316539], [1264914000000, 6.3188669540206], [1267333200000, 6.5873958262306], [1270008000000, 6.2281189839578], [1272600000000, 5.8948915746059], [1275278400000, 5.5967320482214], [1277870400000, 0.99784432084837], [1280548800000, 1.0950794175359], [1283227200000, 0.94479734407491], [1285819200000, 1.222093988688], [1288497600000, 1.335093106856], [1291093200000, 1.3302565104985], [1293771600000, 1.340824670897], [1296450000000, 0], [1298869200000, 0], [1301544000000, 0], [1304136000000, 0], [1306814400000, 0], [1309406400000, 0], [1312084800000, 0], [1314763200000, 0], [1317355200000, 4.4583692315], [1320033600000, 3.6493043348059], [1322629200000, 3.8610064091761], [1325307600000, 5.5144800685202], [1327986000000, 5.1750695220791], [1330491600000, 5.6710066952691], [1333166400000, 5.5611890039181], [1335758400000, 5.5979368839939]]
                },

                {
                    'key'   : 'South America',
                    'values': [[1025409600000, 7.9149900245423], [1028088000000, 7.0899888751059], [1030766400000, 7.5996132380614], [1033358400000, 8.2741174301034], [1036040400000, 9.3564460833513], [1038632400000, 9.7066786059904], [1041310800000, 10.213363052343], [1043989200000, 10.285809585273], [1046408400000, 10.222053149228], [1049086800000, 8.6188592137975], [1051675200000, 9.3335447543566], [1054353600000, 8.9312402186628], [1056945600000, 8.1895089343658], [1059624000000, 8.260622135079], [1062302400000, 7.7700786851364], [1064894400000, 7.9907428771318], [1067576400000, 8.7769091865606], [1070168400000, 8.4855077060661], [1072846800000, 9.6277203033655], [1075525200000, 9.9685913452624], [1078030800000, 10.615085181759], [1080709200000, 9.2902488079646], [1083297600000, 8.8610439830061], [1085976000000, 9.1075344931229], [1088568000000, 9.9156737639203], [1091246400000, 9.7826003238782], [1093924800000, 10.55403610555], [1096516800000, 10.926900264097], [1099195200000, 10.903144818736], [1101790800000, 10.862890389067], [1104469200000, 10.64604998964], [1107147600000, 10.042790814087], [1109566800000, 9.7173391591038], [1112245200000, 9.6122415755443], [1114833600000, 9.4337921146562], [1117512000000, 9.814827171183], [1120104000000, 12.059260396788], [1122782400000, 12.139649903873], [1125460800000, 12.281290663822], [1128052800000, 8.8037085409056], [1130734800000, 8.6300618239176], [1133326800000, 9.1225708491432], [1136005200000, 12.988124170836], [1138683600000, 13.356778764353], [1141102800000, 13.611196863271], [1143781200000, 6.8959030061189], [1146369600000, 6.9939633271353], [1149048000000, 6.7241510257676], [1151640000000, 5.5611293669517], [1154318400000, 5.6086488714041], [1156996800000, 5.4962849907033], [1159588800000, 6.9193153169278], [1162270800000, 7.0016334389778], [1164862800000, 6.7865422443273], [1167541200000, 9.0006454225383], [1170219600000, 9.2233916171431], [1172638800000, 8.8929316009479], [1175313600000, 10.345937520404], [1177905600000, 10.075914677026], [1180584000000, 10.089006188111], [1183176000000, 10.598330295008], [1185854400000, 9.9689546533009], [1188532800000, 9.7740580198146], [1191124800000, 10.558483060626], [1193803200000, 9.9314651823603], [1196398800000, 9.3997715873769], [1199077200000, 8.4086493387262], [1201755600000, 8.9698309085926], [1204261200000, 8.2778357995396], [1206936000000, 8.8585045600123], [1209528000000, 8.7013756413322], [1212206400000, 7.7933605469443], [1214798400000, 7.0236183483064], [1217476800000, 6.9873088186829], [1220155200000, 6.8031713070097], [1222747200000, 6.6869531315723], [1225425600000, 6.138256993963], [1228021200000, 5.6434994016354], [1230699600000, 5.495220262512], [1233378000000, 4.6885326869846], [1235797200000, 4.4524349883438], [1238472000000, 5.6766520778185], [1241064000000, 5.7675774480752], [1243742400000, 5.7882863168337], [1246334400000, 7.2666010034924], [1249012800000, 7.5191821322261], [1251691200000, 7.849651451445], [1254283200000, 10.383992037985], [1256961600000, 9.0653691861818], [1259557200000, 9.6705248324159], [1262235600000, 10.856380561349], [1264914000000, 11.27452370892], [1267333200000, 11.754156529088], [1270008000000, 8.2870811422455], [1272600000000, 8.0210264360699], [1275278400000, 7.5375074474865], [1277870400000, 8.3419527338039], [1280548800000, 9.4197471818443], [1283227200000, 8.7321733185797], [1285819200000, 9.6627062648126], [1288497600000, 10.187962234548], [1291093200000, 9.8144201733476], [1293771600000, 10.275723361712], [1296450000000, 16.796066079353], [1298869200000, 17.543254984075], [1301544000000, 16.673660675083], [1304136000000, 17.963944353609], [1306814400000, 16.63774086721], [1309406400000, 15.84857094609], [1312084800000, 14.767303362181], [1314763200000, 24.778452182433], [1317355200000, 18.370353229999], [1320033600000, 15.253137429099], [1322629200000, 14.989600840649], [1325307600000, 16.052539160125], [1327986000000, 16.424390322793], [1330491600000, 17.884020741104], [1333166400000, 18.372698836036], [1335758400000, 18.315881576096]]
                },

                {
                    'key'   : 'Asia',
                    'values': [[1025409600000, 13.153938631352], [1028088000000, 12.456410521864], [1030766400000, 12.537048663919], [1033358400000, 13.947386398309], [1036040400000, 14.421680682568], [1038632400000, 14.143238262286], [1041310800000, 12.229635347478], [1043989200000, 12.508479916948], [1046408400000, 12.155368409526], [1049086800000, 13.335455563994], [1051675200000, 12.888210138167], [1054353600000, 12.842092790511], [1056945600000, 12.513816474199], [1059624000000, 12.21453674494], [1062302400000, 11.750848343935], [1064894400000, 10.526579636787], [1067576400000, 10.873596086087], [1070168400000, 11.019967131519], [1072846800000, 11.235789380602], [1075525200000, 11.859910850657], [1078030800000, 12.531031616536], [1080709200000, 11.360451067019], [1083297600000, 11.456244780202], [1085976000000, 11.436991407309], [1088568000000, 11.638595744327], [1091246400000, 11.190418301469], [1093924800000, 11.835608007589], [1096516800000, 11.540980244475], [1099195200000, 10.958762325687], [1101790800000, 10.885791159509], [1104469200000, 13.605810720109], [1107147600000, 13.128978067437], [1109566800000, 13.119012086882], [1112245200000, 13.003706129783], [1114833600000, 13.326996807689], [1117512000000, 13.547947991743], [1120104000000, 12.807959646616], [1122782400000, 12.931763821068], [1125460800000, 12.795359993008], [1128052800000, 9.6998935538319], [1130734800000, 9.3473740089131], [1133326800000, 9.36902067716], [1136005200000, 14.258619539875], [1138683600000, 14.21241095603], [1141102800000, 13.973193618249], [1143781200000, 15.218233920664], [1146369600000, 14.382109727451], [1149048000000, 13.894310878491], [1151640000000, 15.593086090031], [1154318400000, 16.244839695189], [1156996800000, 16.017088850647], [1159588800000, 14.183951830057], [1162270800000, 14.148523245696], [1164862800000, 13.424326059971], [1167541200000, 12.974450435754], [1170219600000, 13.232470418021], [1172638800000, 13.318762655574], [1175313600000, 15.961407746104], [1177905600000, 16.287714639805], [1180584000000, 16.24659058389], [1183176000000, 17.564505594808], [1185854400000, 17.872725373164], [1188532800000, 18.018998508756], [1191124800000, 15.584518016602], [1193803200000, 15.480850647182], [1196398800000, 15.699120036985], [1199077200000, 19.184281817226], [1201755600000, 19.691226605205], [1204261200000, 18.982314051293], [1206936000000, 18.707820309008], [1209528000000, 17.459630929759], [1212206400000, 16.500616076782], [1214798400000, 18.086324003978], [1217476800000, 18.929464156259], [1220155200000, 18.233728682084], [1222747200000, 16.315776297325], [1225425600000, 14.632892190251], [1228021200000, 14.667835024479], [1230699600000, 13.946993947309], [1233378000000, 14.394304684398], [1235797200000, 13.724462792967], [1238472000000, 10.930879035807], [1241064000000, 9.8339915513708], [1243742400000, 10.053858541872], [1246334400000, 11.786998438286], [1249012800000, 11.780994901769], [1251691200000, 11.305889670277], [1254283200000, 10.918452290083], [1256961600000, 9.6811395055706], [1259557200000, 10.971529744038], [1262235600000, 13.330210480209], [1264914000000, 14.592637568961], [1267333200000, 14.605329141157], [1270008000000, 13.936853794037], [1272600000000, 12.189480759072], [1275278400000, 11.676151385046], [1277870400000, 13.058852800018], [1280548800000, 13.62891543203], [1283227200000, 13.811107569918], [1285819200000, 13.786494560786], [1288497600000, 14.045162857531], [1291093200000, 13.697412447286], [1293771600000, 13.677681376221], [1296450000000, 19.96151186453], [1298869200000, 21.049198298156], [1301544000000, 22.687631094009], [1304136000000, 25.469010617433], [1306814400000, 24.88379943712], [1309406400000, 24.203843814249], [1312084800000, 22.138760964036], [1314763200000, 16.034636966228], [1317355200000, 15.394958944555], [1320033600000, 12.62564246197], [1322629200000, 12.973735699739], [1325307600000, 15.78601833615], [1327986000000, 15.227368020134], [1330491600000, 15.899752650733], [1333166400000, 15.661317319168], [1335758400000, 15.359891177281]]
                },

                {
                    'key'   : 'Europe',
                    'values': [[1025409600000, 9.3433263069351], [1028088000000, 8.4583069475546], [1030766400000, 8.0342398154196], [1033358400000, 8.1538966876572], [1036040400000, 10.743604786849], [1038632400000, 12.349366155851], [1041310800000, 10.742682503899], [1043989200000, 11.360983869935], [1046408400000, 11.441336039535], [1049086800000, 10.897508791837], [1051675200000, 11.469101547709], [1054353600000, 12.086311476742], [1056945600000, 8.0697180773504], [1059624000000, 8.2004392233445], [1062302400000, 8.4566434900643], [1064894400000, 7.9565760979059], [1067576400000, 9.3764619255827], [1070168400000, 9.0747664160538], [1072846800000, 10.508939004673], [1075525200000, 10.69936754483], [1078030800000, 10.681562399145], [1080709200000, 13.184786109406], [1083297600000, 12.668213052351], [1085976000000, 13.430509403986], [1088568000000, 12.393086349213], [1091246400000, 11.942374044842], [1093924800000, 12.062227685742], [1096516800000, 11.969974363623], [1099195200000, 12.14374574055], [1101790800000, 12.69422821995], [1104469200000, 9.1235211044692], [1107147600000, 8.758211757584], [1109566800000, 8.8072309258443], [1112245200000, 11.687595946835], [1114833600000, 11.079723082664], [1117512000000, 12.049712896076], [1120104000000, 10.725319428684], [1122782400000, 10.844849996286], [1125460800000, 10.833535488461], [1128052800000, 17.180932407865], [1130734800000, 15.894764896516], [1133326800000, 16.412751299498], [1136005200000, 12.573569093402], [1138683600000, 13.242301508051], [1141102800000, 12.863536342041], [1143781200000, 21.034044171629], [1146369600000, 21.419084618802], [1149048000000, 21.142678863692], [1151640000000, 26.56848967753], [1154318400000, 24.839144939906], [1156996800000, 25.456187462166], [1159588800000, 26.350164502825], [1162270800000, 26.478333205189], [1164862800000, 26.425979547846], [1167541200000, 28.191461582256], [1170219600000, 28.930307448808], [1172638800000, 29.521413891117], [1175313600000, 28.188285966466], [1177905600000, 27.704619625831], [1180584000000, 27.49086242483], [1183176000000, 28.770679721286], [1185854400000, 29.06048067145], [1188532800000, 28.240998844973], [1191124800000, 33.004893194128], [1193803200000, 34.075180359928], [1196398800000, 32.548560664834], [1199077200000, 30.629727432729], [1201755600000, 28.642858788159], [1204261200000, 27.973575227843], [1206936000000, 27.393351882726], [1209528000000, 28.476095288522], [1212206400000, 29.29667866426], [1214798400000, 29.222333802896], [1217476800000, 28.092966093842], [1220155200000, 28.107159262922], [1222747200000, 25.482974832099], [1225425600000, 21.208115993834], [1228021200000, 20.295043095268], [1230699600000, 15.925754618402], [1233378000000, 17.162864628346], [1235797200000, 17.084345773174], [1238472000000, 22.24600710228], [1241064000000, 24.530543998508], [1243742400000, 25.084184918241], [1246334400000, 16.606166527359], [1249012800000, 17.239620011628], [1251691200000, 17.336739127379], [1254283200000, 25.478492475754], [1256961600000, 23.017152085244], [1259557200000, 25.617745423684], [1262235600000, 24.061133998641], [1264914000000, 23.223933318646], [1267333200000, 24.425887263936], [1270008000000, 35.501471156693], [1272600000000, 33.775013878675], [1275278400000, 30.417993630285], [1277870400000, 30.023598978467], [1280548800000, 33.327519522436], [1283227200000, 31.963388450372], [1285819200000, 30.49896723209], [1288497600000, 32.403696817913], [1291093200000, 31.47736071922], [1293771600000, 31.53259666241], [1296450000000, 41.760282761548], [1298869200000, 45.605771243237], [1301544000000, 39.986557966215], [1304136000000, 43.84633051005], [1306814400000, 39.857316881858], [1309406400000, 37.675127768207], [1312084800000, 35.775077970313], [1314763200000, 48.631009702578], [1317355200000, 42.830831754505], [1320033600000, 35.611502589362], [1322629200000, 35.320136981738], [1325307600000, 31.564136901516], [1327986000000, 32.074407502433], [1330491600000, 35.053013769977], [1333166400000, 33.873085184128], [1335758400000, 32.321039427046]]
                },

                {
                    'key'   : 'Australia',
                    'values': [[1025409600000, 5.1162447683392], [1028088000000, 4.2022848306513], [1030766400000, 4.3543715758736], [1033358400000, 5.4641223667245], [1036040400000, 6.0041275884577], [1038632400000, 6.6050520064486], [1041310800000, 5.0154059912793], [1043989200000, 5.1835708554647], [1046408400000, 5.1142682006164], [1049086800000, 5.0271381717695], [1051675200000, 5.3437782653456], [1054353600000, 5.2105844515767], [1056945600000, 6.552565997799], [1059624000000, 6.9873363581831], [1062302400000, 7.010986789097], [1064894400000, 4.4254242025515], [1067576400000, 4.9613848042174], [1070168400000, 4.8854920484764], [1072846800000, 4.0441111794228], [1075525200000, 4.0219596813179], [1078030800000, 4.3065749225355], [1080709200000, 3.9148434915404], [1083297600000, 3.8659430654512], [1085976000000, 3.9572824600686], [1088568000000, 4.7372190641522], [1091246400000, 4.6871476374455], [1093924800000, 5.0398702564196], [1096516800000, 5.5221787544964], [1099195200000, 5.424646299798], [1101790800000, 5.9240223067349], [1104469200000, 5.9936860983601], [1107147600000, 5.8499523215019], [1109566800000, 6.4149040329325], [1112245200000, 6.4547895561969], [1114833600000, 5.9385382611161], [1117512000000, 6.0486751030592], [1120104000000, 5.23108613838], [1122782400000, 5.5857797121029], [1125460800000, 5.3454665096987], [1128052800000, 5.0439154120119], [1130734800000, 5.054634702913], [1133326800000, 5.3819451380848], [1136005200000, 5.2638869269803], [1138683600000, 5.5806167415681], [1141102800000, 5.4539047069985], [1143781200000, 7.6728842432362], [1146369600000, 7.719946716654], [1149048000000, 8.0144619912942], [1151640000000, 7.942223133434], [1154318400000, 8.3998279827444], [1156996800000, 8.532324572605], [1159588800000, 4.7324285199763], [1162270800000, 4.7402397487697], [1164862800000, 4.9042069355168], [1167541200000, 5.9583963430882], [1170219600000, 6.3693899239171], [1172638800000, 6.261153903813], [1175313600000, 5.3443942184584], [1177905600000, 5.4932111235361], [1180584000000, 5.5747393101109], [1183176000000, 5.3833633060013], [1185854400000, 5.5125898831832], [1188532800000, 5.8116112661327], [1191124800000, 4.3962296939996], [1193803200000, 4.6967663605521], [1196398800000, 4.7963004350914], [1199077200000, 4.1817985183351], [1201755600000, 4.3797643870182], [1204261200000, 4.6966642197965], [1206936000000, 4.3609995132565], [1209528000000, 4.4736290996496], [1212206400000, 4.3749762738128], [1214798400000, 3.3274661194507], [1217476800000, 3.0316184691337], [1220155200000, 2.5718140204728], [1222747200000, 2.7034994044603], [1225425600000, 2.2033786591364], [1228021200000, 1.9850621240805], [1230699600000, 0], [1233378000000, 0], [1235797200000, 0], [1238472000000, 0], [1241064000000, 0], [1243742400000, 0], [1246334400000, 0], [1249012800000, 0], [1251691200000, 0], [1254283200000, 0.44495950017788], [1256961600000, 0.33945469262483], [1259557200000, 0.38348269455195], [1262235600000, 0], [1264914000000, 0], [1267333200000, 0], [1270008000000, 0], [1272600000000, 0], [1275278400000, 0], [1277870400000, 0], [1280548800000, 0], [1283227200000, 0], [1285819200000, 0], [1288497600000, 0], [1291093200000, 0], [1293771600000, 0], [1296450000000, 0.52216435716176], [1298869200000, 0.59275786698454], [1301544000000, 0], [1304136000000, 0], [1306814400000, 0], [1309406400000, 0], [1312084800000, 0], [1314763200000, 0], [1317355200000, 0], [1320033600000, 0], [1322629200000, 0], [1325307600000, 0], [1327986000000, 0], [1330491600000, 0], [1333166400000, 0], [1335758400000, 0]]
                },

                {
                    'key'   : 'Antarctica',
                    'values': [[1025409600000, 1.3503144674343], [1028088000000, 1.2232741112434], [1030766400000, 1.3930470790784], [1033358400000, 1.2631275030593], [1036040400000, 1.5842699103708], [1038632400000, 1.9546996043116], [1041310800000, 0.8504048300986], [1043989200000, 0.85340686311353], [1046408400000, 0.843061357391], [1049086800000, 2.119846992476], [1051675200000, 2.5285382124858], [1054353600000, 2.5056570712835], [1056945600000, 2.5212789901005], [1059624000000, 2.6192011642534], [1062302400000, 2.5382187823805], [1064894400000, 2.3393223047168], [1067576400000, 2.491219888698], [1070168400000, 2.497555874906], [1072846800000, 1.734018115546], [1075525200000, 1.9307268299646], [1078030800000, 2.2261679836799], [1080709200000, 1.7608893704206], [1083297600000, 1.6242690616808], [1085976000000, 1.7161663801295], [1088568000000, 1.7183554537038], [1091246400000, 1.7179780759145], [1093924800000, 1.7314274801784], [1096516800000, 1.2596883356752], [1099195200000, 1.381177053009], [1101790800000, 1.4408819615814], [1104469200000, 3.4743581836444], [1107147600000, 3.3603749903192], [1109566800000, 3.5350883257893], [1112245200000, 3.0949644237828], [1114833600000, 3.0796455899995], [1117512000000, 3.3441247640644], [1120104000000, 4.0947643978168], [1122782400000, 4.4072631274052], [1125460800000, 4.4870979780825], [1128052800000, 4.8404549457934], [1130734800000, 4.8293016233697], [1133326800000, 5.2238093263952], [1136005200000, 3.382306337815], [1138683600000, 3.7056975170243], [1141102800000, 3.7561118692318], [1143781200000, 2.861913700854], [1146369600000, 2.9933744103381], [1149048000000, 2.7127537218463], [1151640000000, 3.1195497076283], [1154318400000, 3.4066964004508], [1156996800000, 3.3754571113569], [1159588800000, 2.2965579982924], [1162270800000, 2.4486818633018], [1164862800000, 2.4002308848517], [1167541200000, 1.9649579750349], [1170219600000, 1.9385263638056], [1172638800000, 1.9128975336387], [1175313600000, 2.3412869836298], [1177905600000, 2.4337870351445], [1180584000000, 2.62179703171], [1183176000000, 3.2642864957929], [1185854400000, 3.3200396223709], [1188532800000, 3.3934212707572], [1191124800000, 4.2822327088179], [1193803200000, 4.1474964228541], [1196398800000, 4.1477082879801], [1199077200000, 5.2947122916128], [1201755600000, 5.2919843508028], [1204261200000, 5.198978305031], [1206936000000, 3.5603057673513], [1209528000000, 3.3009087690692], [1212206400000, 3.1784852603792], [1214798400000, 4.5889503538868], [1217476800000, 4.401779617494], [1220155200000, 4.2208301828278], [1222747200000, 3.89396671475], [1225425600000, 3.0423832241354], [1228021200000, 3.135520611578], [1230699600000, 1.9631418164089], [1233378000000, 1.8963543874958], [1235797200000, 1.8266636017025], [1238472000000, 0.93136635895188], [1241064000000, 0.92737801918888], [1243742400000, 0.97591889805002], [1246334400000, 2.6841193805515], [1249012800000, 2.5664341140531], [1251691200000, 2.3887523699873], [1254283200000, 1.1737801663681], [1256961600000, 1.0953582317281], [1259557200000, 1.2495674976653], [1262235600000, 0.36607452464754], [1264914000000, 0.3548719047291], [1267333200000, 0.36769242398939], [1270008000000, 0], [1272600000000, 0], [1275278400000, 0], [1277870400000, 0], [1280548800000, 0], [1283227200000, 0], [1285819200000, 0.85450741275337], [1288497600000, 0.91360317921637], [1291093200000, 0.89647678692269], [1293771600000, 0.87800687192639], [1296450000000, 0], [1298869200000, 0], [1301544000000, 0.43668720882994], [1304136000000, 0.4756523602692], [1306814400000, 0.46947368328469], [1309406400000, 0.45138896152316], [1312084800000, 0.43828726648117], [1314763200000, 2.0820861395316], [1317355200000, 0.9364411075395], [1320033600000, 0.60583907839773], [1322629200000, 0.61096950747437], [1325307600000, 0], [1327986000000, 0], [1330491600000, 0], [1333166400000, 0], [1335758400000, 0]]
                }

            ]
        };

        vm.historicalBarChart = {
            options: {
                chart: {
                    type              : 'historicalBarChart',
                    height            : 450,
                    margin            : {
                        top   : 20,
                        right : 20,
                        bottom: 60,
                        left  : 50
                    },
                    x                 : function (d)
                    {
                        return d[0];
                    },
                    y                 : function (d)
                    {
                        return d[1] / 100000;
                    },
                    showValues        : true,
                    valueFormat       : function (d)
                    {
                        return d3.format(',.1f')(d);
                    },
                    transitionDuration: 500,
                    xAxis             : {
                        axisLabel   : 'X Axis',
                        tickFormat  : function (d)
                        {
                            return d3.time.format('%x')(new Date(d));
                        },
                        rotateLabels: 50,
                        showMaxMin  : false
                    },
                    yAxis             : {
                        axisLabel        : 'Y Axis',
                        axisLabelDistance: 35,
                        tickFormat       : function (d)
                        {
                            return d3.format(',.1f')(d);
                        }
                    }
                }
            },

            data: [
                {
                    'key'   : 'Quantity',
                    'bar'   : true,
                    'values': [[1159588800000, 3899486.0], [1162270800000, 3899486.0], [1164862800000, 3899486.0], [1167541200000, 3564700.0], [1170219600000, 3564700.0], [1172638800000, 3564700.0], [1175313600000, 2648493.0], [1177905600000, 2648493.0], [1180584000000, 2648493.0], [1183176000000, 2522993.0], [1185854400000, 2522993.0], [1188532800000, 2522993.0], [1191124800000, 2906501.0], [1193803200000, 2906501.0], [1196398800000, 2906501.0], [1199077200000, 2206761.0], [1201755600000, 2206761.0], [1204261200000, 2206761.0], [1206936000000, 2287726.0], [1209528000000, 2287726.0], [1212206400000, 2287726.0], [1214798400000, 2732646.0], [1217476800000, 2732646.0], [1220155200000, 2732646.0], [1222747200000, 2599196.0], [1225425600000, 2599196.0], [1228021200000, 2599196.0], [1230699600000, 1924387.0], [1233378000000, 1924387.0], [1235797200000, 1924387.0], [1238472000000, 1756311.0], [1241064000000, 1756311.0], [1243742400000, 1756311.0], [1246334400000, 1743470.0], [1249012800000, 1743470.0], [1251691200000, 1743470.0], [1254283200000, 1519010.0], [1256961600000, 1519010.0], [1259557200000, 1519010.0], [1262235600000, 1591444.0], [1264914000000, 1591444.0], [1267333200000, 1591444.0], [1270008000000, 1543784.0], [1272600000000, 1543784.0], [1275278400000, 1543784.0], [1277870400000, 1309915.0], [1280548800000, 1309915.0], [1283227200000, 1309915.0], [1285819200000, 1331875.0], [1288497600000, 1331875.0], [1291093200000, 1331875.0], [1293771600000, 1331875.0], [1296450000000, 1154695.0], [1298869200000, 1154695.0], [1301544000000, 1194025.0], [1304136000000, 1194025.0], [1306814400000, 1194025.0], [1309406400000, 1194025.0], [1312084800000, 1194025.0], [1314763200000, 1244525.0], [1317355200000, 475000.0], [1320033600000, 475000.0], [1322629200000, 475000.0], [1325307600000, 690033.0], [1327986000000, 690033.0], [1330491600000, 690033.0], [1333166400000, 514733.0], [1335758400000, 514733.0]]
                }]
        };

        vm.multiBarHorizontalChart = {
            options: {
                chart: {
                    type              : 'multiBarHorizontalChart',
                    height            : 450,
                    x                 : function (d)
                    {
                        return d.label;
                    },
                    y                 : function (d)
                    {
                        return d.value;
                    },
                    showControls      : true,
                    showValues        : true,
                    transitionDuration: 500,
                    xAxis             : {
                        showMaxMin: false
                    },
                    yAxis             : {
                        axisLabel : 'Values',
                        tickFormat: function (d)
                        {
                            return d3.format(',.2f')(d);
                        }
                    }
                }
            },
            data   : [
                {
                    'key'   : 'Series1',
                    'color' : '#d62728',
                    'values': [
                        {
                            'label': 'Group A',
                            'value': -1.8746444827653
                        },
                        {
                            'label': 'Group B',
                            'value': -8.0961543492239
                        },
                        {
                            'label': 'Group C',
                            'value': -0.57072943117674
                        },
                        {
                            'label': 'Group D',
                            'value': -2.4174010336624
                        },
                        {
                            'label': 'Group E',
                            'value': -0.72009071426284
                        },
                        {
                            'label': 'Group F',
                            'value': -0.77154485523777
                        },
                        {
                            'label': 'Group G',
                            'value': -0.90152097798131
                        },
                        {
                            'label': 'Group H',
                            'value': -0.91445417330854
                        },
                        {
                            'label': 'Group I',
                            'value': -0.055746319141851
                        }
                    ]
                },
                {
                    'key'   : 'Series2',
                    'color' : '#1f77b4',
                    'values': [
                        {
                            'label': 'Group A',
                            'value': 25.307646510375
                        },
                        {
                            'label': 'Group B',
                            'value': 16.756779544553
                        },
                        {
                            'label': 'Group C',
                            'value': 18.451534877007
                        },
                        {
                            'label': 'Group D',
                            'value': 8.6142352811805
                        },
                        {
                            'label': 'Group E',
                            'value': 7.8082472075876
                        },
                        {
                            'label': 'Group F',
                            'value': 5.259101026956
                        },
                        {
                            'label': 'Group G',
                            'value': 0.30947953487127
                        },
                        {
                            'label': 'Group H',
                            'value': 0
                        },
                        {
                            'label': 'Group I',
                            'value': 0
                        }
                    ]
                }
            ]
        };

        vm.pieChart = {
            options: {
                chart: {
                    type              : 'pieChart',
                    height            : 500,
                    x                 : function (d)
                    {
                        return d.key;
                    },
                    y                 : function (d)
                    {
                        return d.y;
                    },
                    showLabels        : true,
                    transitionDuration: 500,
                    labelThreshold    : 0.01,
                    legend            : {
                        margin: {
                            top   : 5,
                            right : 35,
                            bottom: 5,
                            left  : 0
                        }
                    }
                }
            },
            data   : [
                {
                    key: 'One',
                    y  : 5
                },
                {
                    key: 'Two',
                    y  : 2
                },
                {
                    key: 'Three',
                    y  : 9
                },
                {
                    key: 'Four',
                    y  : 7
                },
                {
                    key: 'Five',
                    y  : 4
                },
                {
                    key: 'Six',
                    y  : 3
                },
                {
                    key: 'Seven',
                    y  : 0.5
                }
            ]
        };

        vm.donutChart = {
            options: {
                chart: {
                    type      : 'pieChart',
                    height    : 450,
                    donut     : true,
                    x         : function (d)
                    {
                        return d.key;
                    },
                    y         : function (d)
                    {
                        return d.y;
                    },
                    showLabels: true,

                    pie               : {
                        startAngle: function (d)
                        {
                            return d.startAngle / 2 - Math.PI / 2;
                        },
                        endAngle  : function (d)
                        {
                            return d.endAngle / 2 - Math.PI / 2;
                        }
                    },
                    transitionDuration: 500,
                    legend            : {
                        margin: {
                            top   : 5,
                            right : 70,
                            bottom: 5,
                            left  : 0
                        }
                    }
                }
            },

            data: [
                {
                    key: 'One',
                    y  : 5
                },
                {
                    key: 'Two',
                    y  : 2
                },
                {
                    key: 'Three',
                    y  : 9
                },
                {
                    key: 'Four',
                    y  : 7
                },
                {
                    key: 'Five',
                    y  : 4
                },
                {
                    key: 'Six',
                    y  : 3
                },
                {
                    key: 'Seven',
                    y  : 0.5
                }
            ]

        };

        vm.sparklineChart = {
            options: {
                chart: {
                    type              : 'sparklinePlus',
                    height            : 450,
                    x                 : function (d, i)
                    {
                        return i;
                    },
                    xTickFormat       : function (d)
                    {
                        return d3.time.format('%x')(new Date(vm.sparklineChart.data[d].x));
                    },
                    transitionDuration: 250
                }
            },

            //$scope.data = sine();
            data: volatileChart(130.0, 0.02)
        };

        vm.bulletChart = {
            options: {
                chart: {
                    type              : 'bulletChart',
                    transitionDuration: 500
                }
            },
            data   : {
                'title'   : 'Revenue',
                'subtitle': 'US$, in thousands',
                'ranges'  : [150, 225, 300],
                'measures': [220],
                'markers' : [250]
            }
        };

        vm.scatterChart = {
            options: {
                chart: {
                    type              : 'scatterChart',
                    height            : 450,
                    color             : d3.scale.category10().range(),
                    scatter           : {
                        onlyCircles: false
                    },
                    showDistX         : true,
                    showDistY         : true,
                    tooltipContent    : function (key)
                    {
                        return '<h3>' + key + '</h3>';
                    },
                    transitionDuration: 350,
                    xAxis             : {
                        axisLabel : 'X Axis',
                        tickFormat: function (d)
                        {
                            return d3.format('.02f')(d);
                        }
                    },
                    yAxis             : {
                        axisLabel        : 'Y Axis',
                        tickFormat       : function (d)
                        {
                            return d3.format('.02f')(d);
                        },
                        axisLabelDistance: 30
                    }
                }
            },
            data   : generateData(4, 5)
        };

        // Methods


        //////////

        /*Random Data Generator */
        function sinAndCos()
        {
            var sin = [], sin2 = [],
                cos = [];

            //Data is represented as an array of {x,y} pairs.
            for ( var i = 0; i < 100; i++ )
            {
                sin.push({
                    x: i,
                    y: Math.sin(i / 10)
                });
                sin2.push({
                    x: i,
                    y: (i % 10 === 5 ? null : Math.sin(i / 10) * 0.25 + 0.5)
                });
                cos.push({
                    x: i,
                    y: 0.5 * Math.cos(i / 10 + 2) + Math.random() / 10
                });
            }

            //Line chart data should be sent as an array of series objects.
            return [
                {
                    values: sin,      //values - represents the array of {x,y} data points
                    key   : 'Sine Wave', //key  - the name of the series.
                    color : '#ff7f0e'  //color - optional: choose your own line color.
                },
                {
                    values: cos,
                    key   : 'Cosine Wave',
                    color : '#2ca02c'
                },
                {
                    values: sin2,
                    key   : 'Another sine wave',
                    color : '#7777ff',
                    area  : true      //area - set to true if you want this line to turn into a filled area chart.
                }
            ];
        }

        function volatileChart(startPrice, volatility, numPoints)
        {
            var rval = [];
            var now = +new Date();
            numPoints = numPoints || 100;
            for ( var i = 1; i < numPoints; i++ )
            {
                rval.push({
                    x: now + i * 1000 * 60 * 60 * 24,
                    y: startPrice
                });
                var rnd = Math.random();
                var changePct = 2 * volatility * rnd;
                if ( changePct > volatility )
                {
                    changePct -= (2 * volatility);
                }
                startPrice = startPrice + startPrice * changePct;
            }
            return rval;
        }

        /* Random Data Generator (took from nvd3.org) */
        function generateData(groups, points)
        {
            var data = [],
                shapes = ['circle', 'cross', 'triangle-up', 'triangle-down', 'diamond', 'square'],
                random = d3.random.normal();

            for ( var i = 0; i < groups; i++ )
            {
                data.push({
                    key   : 'Group ' + i,
                    values: []
                });

                for ( var j = 0; j < points; j++ )
                {
                    data[i].values.push(
                        {
                            x    : random(),
                            y    : random(),
                            size : Math.random(),
                            shape: shapes[j % 6]
                        });
                }
            }
            return data;
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.dashboards.server',
            [
                // 3rd Party Dependencies
                'nvd3',
                'datatables'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider)
    {
        // State
        $stateProvider.state('app.dashboards_server', {
            url      : '/dashboard-server',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/dashboards/server/dashboard-server.html',
                    controller : 'DashboardServerController as vm'
                }
            },
            resolve  : {
                DashboardData: function (msApi)
                {
                    return msApi.resolve('dashboard.server@get');
                }
            },
            bodyClass: 'dashboard-server'
        });

        // Api
        msApiProvider.register('dashboard.server', ['app/data/dashboard/server/data.json']);
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.dashboards.server')
        .controller('DashboardServerController', DashboardServerController);

    /** @ngInject */
    function DashboardServerController($scope, $interval, DashboardData)
    {
        var vm = this;

        // Data
        vm.dashboardData = DashboardData;

        // Widget 1
        vm.widget1 = {
            title: vm.dashboardData.widget1.title,
            chart: {
                options: {
                    chart: {
                        type                   : 'lineChart',
                        color                  : ['#4caf50', '#3f51b5', '#ff5722'],
                        height                 : 320,
                        margin                 : {
                            top   : 32,
                            right : 32,
                            bottom: 32,
                            left  : 48
                        },
                        useInteractiveGuideline: true,
                        clipVoronoi            : false,
                        interpolate            : 'cardinal',
                        x                      : function (d)
                        {
                            return d.x;
                        },
                        y                      : function (d)
                        {
                            return d.y;
                        },
                        xAxis                  : {
                            tickFormat: function (d)
                            {
                                return d + ' min.';
                            },
                            showMaxMin: false
                        },
                        yAxis                  : {
                            tickFormat: function (d)
                            {
                                return d + ' MB';
                            }
                        },
                        interactiveLayer       : {
                            tooltip: {
                                gravity: 's',
                                classes: 'gravity-s'
                            }
                        },
                        legend                 : {
                            margin    : {
                                top   : 8,
                                right : 0,
                                bottom: 32,
                                left  : 0
                            },
                            rightAlign: false
                        }
                    }
                },
                data   : vm.dashboardData.widget1.chart
            }
        };

        // Widget 2
        vm.widget2 = vm.dashboardData.widget2;

        // Widget 3
        vm.widget3 = vm.dashboardData.widget3;

        // Widget 4
        vm.widget4 = {
            title   : vm.dashboardData.widget4.title,
            value   : vm.dashboardData.widget4.value,
            footnote: vm.dashboardData.widget4.footnote,
            detail  : vm.dashboardData.widget4.detail,
            chart   : {
                config : {
                    refreshDataOnly: true,
                    deepWatchData  : true
                },
                options: {
                    chart: {
                        type        : 'lineChart',
                        color       : ['rgba(0, 0, 0, 0.27)'],
                        height      : 50,
                        margin      : {
                            top   : 8,
                            right : 0,
                            bottom: 0,
                            left  : 0
                        },
                        duration    : 1,
                        clipEdge    : true,
                        interpolate : 'cardinal',
                        interactive : false,
                        isArea      : true,
                        showLegend  : false,
                        showControls: false,
                        showXAxis   : false,
                        showYAxis   : false,
                        x           : function (d)
                        {
                            return d.x;
                        },
                        y           : function (d)
                        {
                            return d.y;
                        },
                        yDomain     : [0, 4]
                    }
                },
                data   : vm.dashboardData.widget4.chart
            },
            init    : function ()
            {
                // Run this function once to initialize the widget

                // Grab the x value
                var lastIndex = vm.dashboardData.widget4.chart[0].values.length - 1,
                    x = vm.dashboardData.widget4.chart[0].values[lastIndex].x;

                /**
                 * Emulate constant data flow
                 *
                 * @param min
                 * @param max
                 */
                function latencyTicker(min, max)
                {
                    // Increase the x value
                    x++;

                    var randomNumber = Math.floor(Math.random() * (max - min + 1)) + min;

                    var newValue = {
                        x: x,
                        y: randomNumber
                    };

                    vm.widget4.chart.data[0].values.shift();
                    vm.widget4.chart.data[0].values.push(newValue);

                    // Randomize the value
                    vm.widget4.value = 20 + randomNumber + 'ms';
                }

                // Set interval
                var latencyTickerInterval = $interval(function ()
                {
                    latencyTicker(1, 4);
                }, 1000);

                // Cleanup
                $scope.$on('$destroy', function ()
                {
                    $interval.cancel(latencyTickerInterval);
                });
            }
        };

        // Widget 5
        vm.widget5 = vm.dashboardData.widget5;

        // Widget 6
        vm.widget6 = {
            title: vm.dashboardData.widget6.title,
            chart: {
                config : {
                    refreshDataOnly: true,
                    deepWatchData  : true
                },
                options: {
                    chart: {
                        type                   : 'lineChart',
                        color                  : ['#03A9F4'],
                        height                 : 140,
                        margin                 : {
                            top   : 8,
                            right : 32,
                            bottom: 16,
                            left  : 48
                        },
                        duration               : 1,
                        clipEdge               : true,
                        clipVoronoi            : false,
                        interpolate            : 'cardinal',
                        isArea                 : true,
                        useInteractiveGuideline: true,
                        showLegend             : false,
                        showControls           : false,
                        x                      : function (d)
                        {
                            return d.x;
                        },
                        y                      : function (d)
                        {
                            return d.y;
                        },
                        yDomain                : [0, 100],
                        xAxis                  : {
                            tickFormat: function (d)
                            {
                                return d + ' sec.';
                            },
                            showMaxMin: false
                        },
                        yAxis                  : {
                            tickFormat: function (d)
                            {
                                return d + '%';
                            }
                        },
                        interactiveLayer       : {
                            tooltip: {
                                gravity: 's',
                                classes: 'gravity-s'
                            }
                        }
                    }
                },
                data   : vm.dashboardData.widget6.chart
            },
            init : function ()
            {
                // Run this function once to initialize the widget

                // Grab the x value
                var lastIndex = vm.dashboardData.widget6.chart[0].values.length - 1,
                    x = vm.dashboardData.widget6.chart[0].values[lastIndex].x;

                /**
                 * Emulate constant data flow
                 *
                 * @param min
                 * @param max
                 */
                function cpuTicker(min, max)
                {
                    // Increase the x value
                    x = x + 5;

                    var newValue = {
                        x: x,
                        y: Math.floor(Math.random() * (max - min + 1)) + min
                    };

                    vm.widget6.chart.data[0].values.shift();
                    vm.widget6.chart.data[0].values.push(newValue);
                }

                // Set interval
                var cpuTickerInterval = $interval(function ()
                {
                    cpuTicker(0, 100);
                }, 5000);

                // Cleanup
                $scope.$on('$destroy', function ()
                {
                    $interval.cancel(cpuTickerInterval);
                });
            }
        };

        // Widget 7
        vm.widget7 = {
            title    : vm.dashboardData.widget7.title,
            table    : vm.dashboardData.widget7.table,
            dtOptions: {
                dom       : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                pagingType: 'simple',
                pageLength: 10,
                lengthMenu: [10, 20, 50, 100],
                autoWidth : false,
                responsive: true,
                columnDefs: [
                    {
                        width  : '20%',
                        targets: [0, 1, 2, 3, 4]
                    }
                ],
                columns   : [
                    {},
                    {},
                    {
                        render: function (data, type)
                        {
                            if ( type === 'display' )
                            {
                                return data + ' KB/s';
                            }
                            else
                            {
                                return data;
                            }
                        }
                    },
                    {
                        render: function (data, type)
                        {
                            if ( type === 'display' )
                            {
                                return data + '%';
                            }
                            else
                            {
                                return data;
                            }
                        }
                    },
                    {
                        render: function (data, type)
                        {
                            if ( type === 'display' )
                            {
                                var el = angular.element(data);
                                el.html(el.text() + ' MB');

                                return el[0].outerHTML;
                            }
                            else
                            {
                                return data;
                            }
                        }
                    }
                ]
            }
        };

        // Widget 8
        vm.widget8 = vm.dashboardData.widget8;

        // Methods

        //////////

        // Init Widget 4
        vm.widget4.init();

        // Init Widget 6
        vm.widget6.init();
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.dashboards.project',
            [
                // 3rd Party Dependencies
                'nvd3',
                'datatables'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider)
    {
        // State
        $stateProvider.state('app.dashboards_project', {
            url      : '/dashboard-project',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/dashboards/project/dashboard-project.html',
                    controller : 'DashboardProjectController as vm'
                }
            },
            resolve  : {
                DashboardData: function (msApi)
                {
                    return msApi.resolve('dashboard.project@get');
                }
            },
            bodyClass: 'dashboard-project'
        });

        // Api
        msApiProvider.register('dashboard.project', ['app/data/dashboard/project/data.json']);
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.dashboards.project')
        .controller('DashboardProjectController', DashboardProjectController);

    /** @ngInject */
    function DashboardProjectController($scope, $interval, $mdSidenav, DashboardData)
    {
        var vm = this;

        // Data
        vm.dashboardData = DashboardData;
        vm.projects = vm.dashboardData.projects;

        // Widget 1
        vm.widget1 = vm.dashboardData.widget1;

        // Widget 2
        vm.widget2 = vm.dashboardData.widget2;

        // Widget 3
        vm.widget3 = vm.dashboardData.widget3;

        // Widget 4
        vm.widget4 = vm.dashboardData.widget4;

        // Widget 5
        vm.widget5 = {
            title       : vm.dashboardData.widget5.title,
            mainChart   : {
                config : {
                    refreshDataOnly: true,
                    deepWatchData  : true
                },
                options: {
                    chart: {
                        type        : 'multiBarChart',
                        color       : ['#03a9f4', '#b3e5fc'],
                        height      : 420,
                        margin      : {
                            top   : 8,
                            right : 16,
                            bottom: 32,
                            left  : 32
                        },
                        clipEdge    : true,
                        groupSpacing: 0.3,
                        reduceXTicks: false,
                        stacked     : true,
                        duration    : 250,
                        x           : function (d)
                        {
                            return d.x;
                        },
                        y           : function (d)
                        {
                            return d.y;
                        },
                        yAxis       : {
                            tickFormat: function (d)
                            {
                                return d;
                            }
                        },
                        legend      : {
                            margin: {
                                top   : 8,
                                bottom: 32
                            }
                        },
                        controls    : {
                            margin: {
                                top   : 8,
                                bottom: 32
                            }
                        },
                        tooltip     : {
                            gravity: 's',
                            classes: 'gravity-s'
                        }
                    }
                },
                data   : []
            },
            supporting  : {
                widgets: {
                    created  : {
                        data : vm.dashboardData.widget5.supporting.created,
                        chart: {
                            data: []
                        }
                    },
                    closed   : {
                        data : vm.dashboardData.widget5.supporting.closed,
                        chart: {
                            data: []
                        }
                    },
                    reOpened : {
                        data : vm.dashboardData.widget5.supporting.reOpened,
                        chart: {
                            data: []
                        }
                    },
                    wontFix  : {
                        data : vm.dashboardData.widget5.supporting.wontFix,
                        chart: {
                            data: []
                        }
                    },
                    needsTest: {
                        data : vm.dashboardData.widget5.supporting.needsTest,
                        chart: {
                            data: []
                        }
                    },
                    fixed    : {
                        data : vm.dashboardData.widget5.supporting.fixed,
                        chart: {
                            data: []
                        }
                    }
                },
                chart  : {
                    config : {
                        refreshDataOnly: true,
                        deepWatchData  : true
                    },
                    options: {
                        chart: {
                            type                   : 'lineChart',
                            color                  : ['#03A9F4'],
                            height                 : 50,
                            margin                 : {
                                top   : 8,
                                right : 0,
                                bottom: 0,
                                left  : 0
                            },
                            isArea                 : true,
                            interpolate            : 'cardinal',
                            clipEdge               : true,
                            duration               : 500,
                            showXAxis              : false,
                            showYAxis              : false,
                            showLegend             : false,
                            useInteractiveGuideline: true,
                            x                      : function (d)
                            {
                                return d.x;
                            },
                            y                      : function (d)
                            {
                                return d.y;
                            },
                            yDomain                : [0, 9],
                            xAxis                  : {
                                tickFormat: function (d)
                                {
                                    return vm.widget5.days[d];
                                }
                            },
                            interactiveLayer       : {
                                tooltip: {
                                    gravity: 'e',
                                    classes: 'gravity-e'
                                }
                            }
                        }
                    },
                    data   : []
                }
            },
            days        : ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
            ranges      : vm.dashboardData.widget5.ranges,
            currentRange: '',
            changeRange : function (range)
            {
                vm.widget5.currentRange = range;

                /**
                 * Update main chart data by iterating through the
                 * chart dataset and separately adding every single
                 * dataset by hand.
                 *
                 * You MUST NOT swap the entire data object by doing
                 * something similar to this:
                 * vm.widget.mainChart.data = chartData
                 *
                 * It would be easier but it won't work with the
                 * live updating / animated charts due to how d3
                 * works.
                 *
                 * If you don't need animated / live updating charts,
                 * you can simplify these greatly.
                 */
                angular.forEach(vm.dashboardData.widget5.mainChart, function (chartData, index)
                {
                    vm.widget5.mainChart.data[index] = {
                        key   : chartData.key,
                        values: chartData.values[range]
                    };
                });

                /**
                 * Do the same thing for the supporting widgets but they
                 * only have 1 dataset so we can do [0] without needing to
                 * iterate through in their data arrays
                 */
                angular.forEach(vm.dashboardData.widget5.supporting, function (widget, name)
                {
                    vm.widget5.supporting.widgets[name].chart.data[0] = {
                        key   : widget.chart.key,
                        values: widget.chart.values[range]
                    };
                });
            },
            init        : function ()
            {
                // Run this function once to initialize widget

                /**
                 * Update the range for the first time
                 */
                vm.widget5.changeRange('TW');
            }
        };

        // Widget 6
        vm.widget6 = {
            title       : vm.dashboardData.widget6.title,
            mainChart   : {
                config : {
                    refreshDataOnly: true,
                    deepWatchData  : true
                },
                options: {
                    chart: {
                        type        : 'pieChart',
                        color       : ['#f44336', '#9c27b0', '#03a9f4', '#e91e63'],
                        height      : 400,
                        margin      : {
                            top   : 0,
                            right : 0,
                            bottom: 0,
                            left  : 0
                        },
                        donut       : true,
                        clipEdge    : true,
                        cornerRadius: 0,
                        labelType   : 'percent',
                        padAngle    : 0.02,
                        x           : function (d)
                        {
                            return d.label;
                        },
                        y           : function (d)
                        {
                            return d.value;
                        },
                        tooltip     : {
                            gravity: 's',
                            classes: 'gravity-s'
                        }
                    }
                },
                data   : []
            },
            footerLeft  : vm.dashboardData.widget6.footerLeft,
            footerRight : vm.dashboardData.widget6.footerRight,
            ranges      : vm.dashboardData.widget6.ranges,
            currentRange: '',
            changeRange : function (range)
            {
                vm.widget6.currentRange = range;

                /**
                 * Update main chart data by iterating through the
                 * chart dataset and separately adding every single
                 * dataset by hand.
                 *
                 * You MUST NOT swap the entire data object by doing
                 * something similar to this:
                 * vm.widget.mainChart.data = chartData
                 *
                 * It would be easier but it won't work with the
                 * live updating / animated charts due to how d3
                 * works.
                 *
                 * If you don't need animated / live updating charts,
                 * you can simplify these greatly.
                 */
                angular.forEach(vm.dashboardData.widget6.mainChart, function (data, index)
                {
                    vm.widget6.mainChart.data[index] = {
                        label: data.label,
                        value: data.values[range]
                    };
                });
            },
            init        : function ()
            {
                // Run this function once to initialize widget

                /**
                 * Update the range for the first time
                 */
                vm.widget6.changeRange('TW');
            }
        };

        // Widget 7
        vm.widget7 = {
            title       : vm.dashboardData.widget7.title,
            ranges      : vm.dashboardData.widget7.ranges,
            schedule    : vm.dashboardData.widget7.schedule,
            currentRange: 'T'
        };

        // Widget 8
        vm.widget8 = {
            title    : vm.dashboardData.widget8.title,
            mainChart: {
                options: {
                    chart: {
                        type     : 'pieChart',
                        color    : ['#f44336', '#9c27b0', '#03a9f4', '#e91e63', '#ffc107'],
                        height   : 400,
                        margin   : {
                            top   : 0,
                            right : 0,
                            bottom: 0,
                            left  : 0
                        },
                        labelType: 'percent',
                        x        : function (d)
                        {
                            return d.label;
                        },
                        y        : function (d)
                        {
                            return d.value;
                        },
                        tooltip  : {
                            gravity: 's',
                            classes: 'gravity-s'
                        }
                    }
                },
                data   : vm.dashboardData.widget8.mainChart
            }
        };

        // Widget 9
        vm.widget9 = {
            title       : vm.dashboardData.widget9.title,
            weeklySpent : {
                title    : vm.dashboardData.widget9.weeklySpent.title,
                count    : vm.dashboardData.widget9.weeklySpent.count,
                chartData: []
            },
            totalSpent  : {
                title    : vm.dashboardData.widget9.totalSpent.title,
                count    : vm.dashboardData.widget9.totalSpent.count,
                chartData: []
            },
            remaining   : {
                title    : vm.dashboardData.widget9.remaining.title,
                count    : vm.dashboardData.widget9.remaining.count,
                chartData: []
            },
            totalBudget : vm.dashboardData.widget9.totalBudget,
            chart       : {
                config : {
                    refreshDataOnly: true,
                    deepWatchData  : true
                },
                options: {
                    chart: {
                        type                   : 'lineChart',
                        color                  : ['#00BCD4'],
                        height                 : 50,
                        margin                 : {
                            top   : 8,
                            right : 0,
                            bottom: 0,
                            left  : 0
                        },
                        isArea                 : true,
                        interpolate            : 'cardinal',
                        clipEdge               : true,
                        duration               : 500,
                        showXAxis              : false,
                        showYAxis              : false,
                        showLegend             : false,
                        useInteractiveGuideline: true,
                        x                      : function (d)
                        {
                            return d.x;
                        },
                        y                      : function (d)
                        {
                            return d.y;
                        },
                        yDomain                : [0, 9],
                        xAxis                  : {
                            tickFormat: function (d)
                            {
                                return vm.widget9.days[d];
                            }
                        },
                        interactiveLayer       : {
                            tooltip: {
                                gravity: 'e',
                                classes: 'gravity-e'
                            }
                        }
                    }
                }
            },
            days        : ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
            ranges      : vm.dashboardData.widget9.ranges,
            currentRange: '',
            changeRange : function (range)
            {
                vm.widget9.currentRange = range;

                /**
                 * Update mini charts. They only have 1 dataset
                 * so we can do [0] without needing to iterate
                 * through in their data arrays
                 */
                vm.widget9.weeklySpent.chartData[0] = {
                    key   : vm.dashboardData.widget9.weeklySpent.chart.label,
                    values: vm.dashboardData.widget9.weeklySpent.chart.values[range]
                };

                vm.widget9.totalSpent.chartData[0] = {
                    key   : vm.dashboardData.widget9.totalSpent.chart.label,
                    values: vm.dashboardData.widget9.totalSpent.chart.values[range]
                };

                vm.widget9.remaining.chartData[0] = {
                    key   : vm.dashboardData.widget9.remaining.chart.label,
                    values: vm.dashboardData.widget9.remaining.chart.values[range]
                };
            },
            init        : function ()
            {
                // Run this function once to initialize widget

                /**
                 * Update the range for the first time
                 */
                vm.widget9.changeRange('TW');
            }
        };

        // Widget 10
        vm.widget10 = vm.dashboardData.widget10;

        // Widget 11
        vm.widget11 = {
            title    : vm.dashboardData.widget11.title,
            table    : vm.dashboardData.widget11.table,
            dtOptions: {
                dom       : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                pagingType: 'simple',
                autoWidth : false,
                responsive: true,
                order     : [1, 'asc'],
                columnDefs: [
                    {
                        width    : '40',
                        orderable: false,
                        targets  : [0]
                    },
                    {
                        width  : '20%',
                        targets: [1, 2, 3, 4, 5]
                    }
                ]
            }
        };

        // Now widget
        vm.nowWidget = {
            now   : {
                second: '',
                minute: '',
                hour  : '',
                day   : '',
                month : '',
                year  : ''
            },
            ticker: function ()
            {
                var now = moment();
                vm.nowWidget.now = {
                    second : now.format('ss'),
                    minute : now.format('mm'),
                    hour   : now.format('HH'),
                    day    : now.format('D'),
                    weekDay: now.format('dddd'),
                    month  : now.format('MMMM'),
                    year   : now.format('YYYY')
                };
            }
        };

        // Weather widget
        vm.weatherWidget = vm.dashboardData.weatherWidget;

        // Methods
        vm.toggleSidenav = toggleSidenav;
        vm.selectProject = selectProject;

        //////////
        vm.selectedProject = vm.projects[0];

        // Initialize Widget 5
        vm.widget5.init();

        // Initialize Widget 6
        vm.widget6.init();

        // Initialize Widget 9
        vm.widget9.init();

        // Now widget ticker
        vm.nowWidget.ticker();

        var nowWidgetTicker = $interval(vm.nowWidget.ticker, 1000);

        $scope.$on('$destroy', function ()
        {
            $interval.cancel(nowWidgetTicker);
        });

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Select project
         */
        function selectProject(project)
        {
            vm.selectedProject = project;
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.dashboards.analytics',
            [
                // 3rd Party Dependencies
                'nvd3'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider)
    {
        // State
        $stateProvider.state('app.dashboards_analytics', {
            url      : '/dashboard-analytics',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/dashboards/analytics/dashboard-analytics.html',
                    controller : 'DashboardAnalyticsController as vm'
                }
            },
            resolve  : {
                DashboardData: function (msApi)
                {
                    return msApi.resolve('dashboard.analytics@get');
                }
            },
            bodyClass: 'dashboard-analytics'
        });

        // Api
        msApiProvider.register('dashboard.analytics', ['app/data/dashboard/analytics/data.json']);
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.dashboards.analytics')
        .controller('DashboardAnalyticsController', DashboardAnalyticsController);

    /** @ngInject */
    function DashboardAnalyticsController(DashboardData, uiGmapGoogleMapApi)
    {
        var vm = this;

        // Data
        vm.dashboardData = DashboardData;
        vm.colors = ['blue-bg', 'blue-grey-bg', 'orange-bg', 'pink-bg', 'purple-bg'];

        vm.widget1 = {
            title             : vm.dashboardData.widget1.title,
            onlineUsers       : vm.dashboardData.widget1.onlineUsers,
            bigChart          : {
                options: {
                    chart: {
                        type                   : 'lineWithFocusChart',
                        color                  : ['#2196F3'],
                        height                 : 400,
                        margin                 : {
                            top   : 32,
                            right : 32,
                            bottom: 64,
                            left  : 48
                        },
                        isArea                 : true,
                        useInteractiveGuideline: true,
                        duration               : 1,
                        clipEdge               : true,
                        clipVoronoi            : false,
                        interpolate            : 'cardinal',
                        showLegend             : false,
                        x                      : function (d)
                        {
                            return d.x;
                        },
                        y                      : function (d)
                        {
                            return d.y;
                        },
                        xAxis                  : {
                            showMaxMin: false,
                            tickFormat: function (d)
                            {
                                var date = new Date(new Date().setDate(new Date().getDate() + d));
                                return d3.time.format('%b %d')(date);
                            }
                        },
                        yAxis                  : {
                            showMaxMin: false
                        },
                        x2Axis                 : {
                            showMaxMin: false,
                            tickFormat: function (d)
                            {
                                var date = new Date(new Date().setDate(new Date().getDate() + d));
                                return d3.time.format('%b %d')(date);
                            }
                        },
                        y2Axis                 : {
                            showMaxMin: false
                        },
                        interactiveLayer       : {
                            tooltip: {
                                gravity: 's',
                                classes: 'gravity-s'
                            }
                        },
                        legend                 : {
                            margin    : {
                                top   : 8,
                                right : 0,
                                bottom: 32,
                                left  : 0
                            },
                            rightAlign: false
                        }
                    }
                },
                data   : vm.dashboardData.widget1.bigChart.chart
            },
            sessions          : {
                title   : vm.dashboardData.widget1.sessions.title,
                value   : vm.dashboardData.widget1.sessions.value,
                previous: vm.dashboardData.widget1.sessions.previous,
                options : {
                    chart: {
                        type                   : 'lineChart',
                        color                  : ['#03A9F4'],
                        height                 : 40,
                        margin                 : {
                            top   : 4,
                            right : 4,
                            bottom: 4,
                            left  : 4
                        },
                        isArea                 : true,
                        interpolate            : 'cardinal',
                        clipEdge               : true,
                        duration               : 500,
                        showXAxis              : false,
                        showYAxis              : false,
                        showLegend             : false,
                        useInteractiveGuideline: true,
                        x                      : function (d)
                        {
                            return d.x;
                        },
                        y                      : function (d)
                        {
                            return d.y;
                        },
                        xAxis                  : {
                            tickFormat: function (d)
                            {
                                var date = new Date(new Date().setDate(new Date().getDate() + d));
                                return d3.time.format('%A, %B %d, %Y')(date);
                            }
                        },
                        interactiveLayer       : {
                            tooltip: {
                                gravity: 's',
                                classes: 'gravity-s'
                            }
                        }
                    }
                },
                data    : vm.dashboardData.widget1.sessions.chart
            },
            pageviews         : {
                title   : vm.dashboardData.widget1.pageviews.title,
                value   : vm.dashboardData.widget1.pageviews.value,
                previous: vm.dashboardData.widget1.pageviews.previous,
                options : {
                    chart: {
                        type                   : 'lineChart',
                        color                  : ['#3F51B5'],
                        height                 : 40,
                        margin                 : {
                            top   : 4,
                            right : 4,
                            bottom: 4,
                            left  : 4
                        },
                        isArea                 : true,
                        interpolate            : 'cardinal',
                        clipEdge               : true,
                        duration               : 500,
                        showXAxis              : false,
                        showYAxis              : false,
                        showLegend             : false,
                        useInteractiveGuideline: true,
                        x                      : function (d)
                        {
                            return d.x;
                        },
                        y                      : function (d)
                        {
                            return d.y;
                        },
                        xAxis                  : {
                            tickFormat: function (d)
                            {
                                var date = new Date(new Date().setDate(new Date().getDate() + d));
                                return d3.time.format('%A, %B %d, %Y')(date);
                            }
                        },
                        interactiveLayer       : {
                            tooltip: {
                                gravity: 's',
                                classes: 'gravity-s'
                            }
                        }
                    }
                },
                data    : vm.dashboardData.widget1.pageviews.chart
            },
            pagesSessions     : {
                title   : vm.dashboardData.widget1.pagesSessions.title,
                value   : vm.dashboardData.widget1.pagesSessions.value,
                previous: vm.dashboardData.widget1.pagesSessions.previous,
                options : {
                    chart: {
                        type                   : 'lineChart',
                        color                  : ['#E91E63'],
                        height                 : 40,
                        margin                 : {
                            top   : 4,
                            right : 4,
                            bottom: 4,
                            left  : 4
                        },
                        isArea                 : true,
                        interpolate            : 'cardinal',
                        clipEdge               : true,
                        duration               : 500,
                        showXAxis              : false,
                        showYAxis              : false,
                        showLegend             : false,
                        useInteractiveGuideline: true,
                        x                      : function (d)
                        {
                            return d.x;
                        },
                        y                      : function (d)
                        {
                            return d.y;
                        },
                        xAxis                  : {
                            tickFormat: function (d)
                            {
                                var date = new Date(new Date().setDate(new Date().getDate() + d));
                                return d3.time.format('%A, %B %d, %Y')(date);
                            }
                        },
                        interactiveLayer       : {
                            tooltip: {
                                gravity: 's',
                                classes: 'gravity-s'
                            }
                        }
                    }
                },
                data    : vm.dashboardData.widget1.pagesSessions.chart
            },
            avgSessionDuration: {
                title   : vm.dashboardData.widget1.avgSessionDuration.title,
                value   : vm.dashboardData.widget1.avgSessionDuration.value,
                previous: vm.dashboardData.widget1.avgSessionDuration.previous,
                options : {
                    chart: {
                        type                   : 'lineChart',
                        color                  : ['#009688'],
                        height                 : 40,
                        margin                 : {
                            top   : 4,
                            right : 4,
                            bottom: 4,
                            left  : 4
                        },
                        isArea                 : true,
                        interpolate            : 'cardinal',
                        clipEdge               : true,
                        duration               : 500,
                        showXAxis              : false,
                        showYAxis              : false,
                        showLegend             : false,
                        useInteractiveGuideline: true,
                        x                      : function (d)
                        {
                            return d.x;
                        },
                        y                      : function (d)
                        {
                            return d.y;
                        },
                        xAxis                  : {
                            tickFormat: function (d)
                            {
                                var date = new Date(new Date().setDate(new Date().getDate() + d));
                                return d3.time.format('%A, %B %d, %Y')(date);
                            }
                        },
                        yAxis                  : {
                            tickFormat: function (d)
                            {
                                var formatTime = d3.time.format('%M:%S');
                                return formatTime(new Date('2012', '0', '1', '0', '0', d));
                            }
                        },
                        interactiveLayer       : {
                            tooltip: {
                                gravity: 's',
                                classes: 'gravity-s'
                            }
                        }
                    }
                },
                data    : vm.dashboardData.widget1.avgSessionDuration.chart
            }
        };

        // Widget 2
        vm.widget2 = {
            title: vm.dashboardData.widget2.title
        };

        // Widget 3
        vm.widget3 = {
            title       : vm.dashboardData.widget3.title,
            pages       : vm.dashboardData.widget3.pages,
            ranges      : vm.dashboardData.widget3.ranges,
            currentRange: vm.dashboardData.widget3.currentRange,
            changeRange : function (range)
            {
                vm.widget3.currentRange(range);
            }
        };

        // Widget 4
        vm.widget4 = vm.dashboardData.widget4;


        // Methods

        //////////

        // Widget 2
        uiGmapGoogleMapApi.then(function ()
        {
            vm.widget2.map = vm.dashboardData.widget2.map;
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.quick-panel', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider, msApiProvider)
    {
        // Translation
        $translatePartialLoaderProvider.addPart('app/quick-panel');

        // Api
        msApiProvider.register('quickPanel.activities', ['app/data/quick-panel/activities.json']);
        msApiProvider.register('quickPanel.contacts', ['app/data/quick-panel/contacts.json']);
        msApiProvider.register('quickPanel.events', ['app/data/quick-panel/events.json']);
        msApiProvider.register('quickPanel.notes', ['app/data/quick-panel/notes.json']);
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('ChatTabController', ChatTabController);

    /** @ngInject */
    function ChatTabController(msApi, $timeout)
    {
        var vm = this;

        // Data
        vm.chat = {};
        vm.chatActive = false;
        vm.replyMessage = '';

        msApi.request('quickPanel.contacts@get', {},
            // Success
            function (response)
            {
                vm.contacts = response.data;
            }
        );

        // Methods
        vm.toggleChat = toggleChat;
        vm.reply = reply;

        //////////

        function toggleChat(contact)
        {
            vm.chatActive = !vm.chatActive;

            if ( vm.chatActive )
            {
                vm.replyMessage = '';
                vm.chat.contact = contact;
                scrollToBottomOfChat(0);
            }
        }

        function reply()
        {
            if ( vm.replyMessage === '' )
            {
                return;
            }

            if ( !vm.chat.contact.dialog )
            {
                vm.chat.contact.dialog = [];
            }

            vm.chat.contact.dialog.push({
                who    : 'user',
                message: vm.replyMessage,
                time   : 'Just now'
            });

            vm.replyMessage = '';

            scrollToBottomOfChat(400);
        }

        function scrollToBottomOfChat(speed)
        {
            var chatDialog = angular.element('#chat-dialog');

            $timeout(function ()
            {
                chatDialog.animate({
                    scrollTop: chatDialog[0].scrollHeight
                }, speed);
            }, 0);

        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.search', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_search', {
            url      : '/pages/search',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pages/search/search.html',
                    controller : 'SearchController as vm'
                }
            },
            resolve  : {
                Classic : function (msApi)
                {
                    return msApi.resolve('search.classic@get');
                },
                Mails   : function (msApi)
                {
                    return msApi.resolve('search.mails@get');
                },
                Users   : function (msApi)
                {
                    return msApi.resolve('search.users@get');
                },
                Contacts: function (msApi)
                {
                    return msApi.resolve('search.contacts@get');
                }
            },
            bodyClass: 'search'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/search');

        // Api
        msApiProvider.register('search.classic', ['app/data/search/classic.json']);
        msApiProvider.register('search.mails', ['app/data/search/mails.json']);
        msApiProvider.register('search.users', ['app/data/search/users.json']);
        msApiProvider.register('search.contacts', ['app/data/search/contacts.json']);

        // Navigation
        msNavigationServiceProvider.saveItem('pages.search', {
            title : 'Search',
            icon  : 'icon-magnify',
            state : 'app.pages_search',
            weight: 7
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.search')
        .controller('SearchController', SearchController);

    /** @ngInject */
    function SearchController(Classic, Mails, Users, Contacts)
    {
        var vm = this;

        // Data
        vm.colors = ['blue-bg', 'blue-grey-bg', 'orange-bg', 'pink-bg', 'purple-bg'];

        vm.classic = Classic.data;
        vm.mails = Mails.data;
        vm.users = Users.data;
        vm.contacts = Contacts.data;

        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.profile',[])
        .config(config);

    /** @ngInject */
    function config($stateProvider,$cookiesProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        $stateProvider.state('app.pages_profile', {
            url      : '/pages/profile:username',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pages/profile/profile.html',
                    controller : 'ProfileController as vm'
                }
            },
            bodyClass: 'profile',
            data    : {
              access: 'all'
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/profile');

        // Api
        //msApiProvider.register('profile.timeline', ['app/data/profile/timeline.json']);
        msApiProvider.register('profile.about', ['app/data/profile/about.json']);
        //msApiProvider.register('profile.photosVideos', ['app/data/profile/photos-videos.json']);

        // Navigation
        msNavigationServiceProvider.saveItem('profile', {
            title : 'Profile',
            icon  : 'icon-account',
            state : 'app.pages_profile',
            weight: 5
        });
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.pages.profile')
        .controller('ProfileController', ProfileController);

    /** @ngInject */
    function ProfileController(api, $rootScope, msNavigationService, $cookies, $state, msToasts)
    {
	var username = $cookies.get('username');
	if(username)
	{
	var vm = this;
        vm.GeneralEdit = false;
        vm.ControlEdit = false;
        vm.ChangePasswordForm = {};
	vm.UserDetailsForm = {};
        vm.ControlForm = {};
        vm.about={};
        vm.key = "";
        $rootScope.loadingProgress = true;


	var data = {
    		username:username
	};
        api.GetUserDetails.get(data,
          function(res) {
            vm.UserDetails = res.data;
          },
          function(res){
            console.error(res.data);
          }
        );

        vm.FormUserSubmit = function(data){
	vm.PasswordEdit = false;
	//console.log(data);
          api.UpdateUser.update(data,
            function(res) {
		msToasts.showToastMsg('Account Updated Successfully');
              //$state.go('app.devices');
              //window.location.href = "/pages/profile";
		vm.UserEdit = false;
              //console.log(res);
            },
            function(res) {
              console.log(res);
            }
          );
        }

	vm.FormChangePassword = function(data){
	vm.UserEdit = false;
	var newPassword = data.newPassword;
	var confirmPassword = data.confirmPassword;
	//alert(data.oldPassword);
	//alert(vm.UserDetails.username)
	var passwordObj = data;
	passwordObj["username"] = vm.UserDetails.username;
	//console.log(passwordObj);
	if(newPassword == confirmPassword)
	{

		   api.UpdatePassword.update(data,
            function(res) {
		//console.log("Update Password...................");
		console.log(res.status);
		if(res.statuscode == "403")
		{
			msToasts.showToastMsg('Password change failed. Invalid old password');
			//ChangePasswordForm.oldPassword.reset();
			ChangePasswordForm.oldPassword.focus();
              //$state.go('app.devices');
              //window.location.href = "/pages/profile";
		//vm.PasswordEdit = false;
		}
		else
		{
			msToasts.showToastMsg('Password Updated Successfully');
			vm.PasswordEdit = false;
			ChangePasswordForm.reset();
		}

            //  console.log(res);
            },
            function(res) {
		msToasts.showToastMsg('Password change failed. Invalid old password');
		//ChangePasswordForm.oldPassword.reset();
		ChangePasswordForm.oldPassword.focus();
            //  console.log(res);
            }
          );

	}

	else
	{
		msToasts.showToastMsg('Password change failed. New Passwords do not match');
		ChangePasswordForm.newPassword.focus();
	}

        }



        //////////
	}
	else
	{
	//console.log("Logout....");
	 $state.go('app.login');
	}

    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.pages.maintenance', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_maintenance', {
            url      : '/pages/maintenance',
            views    : {
                'main@'                        : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_maintenance': {
                    templateUrl: 'app/main/pages/maintenance/maintenance.html',
                    controller : 'MaintenanceController as vm'
                }
            },
            bodyClass: 'maintenance'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/maintenance');

        // Navigation
        msNavigationServiceProvider.saveItem('pages.maintenance', {
            title : 'Maintenance',
            icon  : 'icon-oil',
            state : 'app.pages_maintenance',
            weight: 5
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.maintenance')
        .controller('MaintenanceController', MaintenanceController);

    /** @ngInject */
    function MaintenanceController()
    {
        // Data

        // Methods

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.components.maps',
            [
                // 3rd Party Dependencies
                'uiGmapgoogle-maps'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider
            .state('app.components_maps', {
                url  : '/components/maps',
                views: {
                    'content@app'                   : {
                        templateUrl: 'app/main/components/maps/maps.html',
                        controller : 'MapsController as vm'
                    },
                    'tabContent@app.components_maps': {
                        templateUrl: 'app/main/components/maps/tabs/simple.html'
                    }
                }
            })

            .state('app.components_maps.satellite', {
                url  : '/satellite',
                views: {
                    'tabContent': {
                        templateUrl: 'app/main/components/maps/tabs/satellite.html'
                    }
                }
            })

            .state('app.components_maps.terrain', {
                url  : '/terrain',
                views: {
                    'tabContent': {
                        templateUrl: 'app/main/components/maps/tabs/terrain.html'
                    }
                }
            })

            .state('app.components_maps.simple-marker', {
                url  : '/simple-marker',
                views: {
                    'tabContent': {
                        templateUrl: 'app/main/components/maps/tabs/simple-marker.html'
                    }
                }
            })

            .state('app.components_maps.custom-marker', {
                url  : '/custom-marker',
                views: {
                    'tabContent': {
                        templateUrl: 'app/main/components/maps/tabs/custom-marker.html'
                    }
                }
            })

            .state('app.components_maps.info-window', {
                url  : '/info-window',
                views: {
                    'tabContent': {
                        templateUrl: 'app/main/components/maps/tabs/info-window.html'
                    }
                }
            });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.components.maps')
        .controller('MapsController', MapsController);

    /** @ngInject */
    function MapsController($state, uiGmapGoogleMapApi)
    {
        var vm = this;

        // Data
        var currentState = $state.current.name;

        switch ( currentState )
        {
            case 'app.components_maps':
                vm.selectedNavItem = 'simpleMap';
                break;

            case 'app.components_maps.satellite':
                vm.selectedNavItem = 'satelliteMap';
                break;

            case 'app.components_maps.terrain':
                vm.selectedNavItem = 'terrainMap';
                break;

            case 'app.components_maps.simple-marker':
                vm.selectedNavItem = 'simpleMarkerMap';
                break;

            case 'app.components_maps.custom-marker':
                vm.selectedNavItem = 'customMarkerMap';
                break;

            case 'app.components_maps.info-window':
                vm.selectedNavItem = 'infoWindowMap';
                break;

            default:
                vm.selectedNavItem = 'simpleMap';
        }

        // Methods

        //////////

        uiGmapGoogleMapApi.then(function (maps)
        {
            vm.simpleMap = {
                center: {
                    latitude : -34.397,
                    longitude: 150.644
                },
                zoom  : 8
            };

            vm.satelliteMap = {
                center : {
                    latitude : -34.397,
                    longitude: 150.644
                },
                zoom   : 8,
                options: {
                    mapTypeId: maps.MapTypeId.SATELLITE
                }
            };

            vm.terrainMap = {
                center : {
                    latitude : -34.397,
                    longitude: 150.644
                },
                zoom   : 8,
                options: {
                    mapTypeId: maps.MapTypeId.TERRAIN
                }
            };

            vm.simpleMarkerMap = {
                center: {
                    latitude : -25.363882,
                    longitude: 131.044922
                },
                zoom  : 8,
                marker: {
                    id    : 0,
                    coords: {
                        latitude : -25.363882,
                        longitude: 131.044922
                    }
                }
            };

            vm.customMarkerMap = {
                center: {
                    latitude : -25.363882,
                    longitude: 131.044922
                },
                zoom  : 8,
                marker: {
                    id     : 0,
                    coords : {
                        latitude : -25.363882,
                        longitude: 131.044922
                    },
                    options: {
                        icon: {
                            anchor: new maps.Point(36, 36),
                            origin: new maps.Point(0, 0),
                            url   : '//google-developers.appspot.com/maps/documentation/javascript/examples/full/images/beachflag.png'
                        }
                    }
                }
            };

        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.components.custom-directives', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.components_custom-directives', {
                abstract: true,
                url     : '/components/custom-directives'
            })
            .state('app.components_custom-directives.ms-card', {
                url  : '/ms-card',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/components/custom-directives/pages/ms-card.html',
                        controller : 'CustomDirectivesController as vm'
                    }
                }
            })
            .state('app.components_custom-directives.ms-form-wizard', {
                url  : '/ms-form-wizard',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/components/custom-directives/pages/ms-form-wizard.html',
                        controller : 'CustomDirectivesController as vm'
                    }
                }
            })
            .state('app.components_custom-directives.ms-info-bar', {
                url  : '/ms-info-bar',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/components/custom-directives/pages/ms-info-bar.html',
                        controller : 'CustomDirectivesController as vm'
                    }
                }
            })
            .state('app.components_custom-directives.ms-masonry', {
                url  : '/ms-masonry',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/components/custom-directives/pages/ms-masonry.html',
                        controller : 'CustomDirectivesController as vm'
                    }
                }
            })
            .state('app.components_custom-directives.ms-material-color-picker', {
                url  : '/ms-material-color-picker',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/components/custom-directives/pages/ms-material-color-picker.html',
                        controller : 'CustomDirectivesController as vm'
                    }
                }
            })
            .state('app.components_custom-directives.ms-nav', {
                url  : '/ms-nav',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/components/custom-directives/pages/ms-nav.html',
                        controller : 'CustomDirectivesController as vm'
                    }
                }
            })
            .state('app.components_custom-directives.ms-navigation', {
                url  : '/ms-navigation',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/components/custom-directives/pages/ms-navigation.html',
                        controller : 'CustomDirectivesController as vm'
                    }
                }
            })
            .state('app.components_custom-directives.ms-random-class', {
                url  : '/ms-random-class',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/components/custom-directives/pages/ms-random-class.html',
                        controller : 'CustomDirectivesController as vm'
                    }
                }
            })
            .state('app.components_custom-directives.ms-responsive-table', {
                url  : '/ms-responsive-table',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/components/custom-directives/pages/ms-responsive-table.html',
                        controller : 'CustomDirectivesController as vm'
                    }
                }
            })
            .state('app.components_custom-directives.ms-scroll', {
                url  : '/ms-scroll',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/components/custom-directives/pages/ms-scroll.html',
                        controller : 'CustomDirectivesController as vm'
                    }
                }
            })
            .state('app.components_custom-directives.ms-search-bar', {
                url  : '/ms-search-bar',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/components/custom-directives/pages/ms-search-bar.html',
                        controller : 'CustomDirectivesController as vm'
                    }
                }
            })
            .state('app.components_custom-directives.ms-shortcuts', {
                url  : '/ms-shortcuts',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/components/custom-directives/pages/ms-shortcuts.html',
                        controller : 'CustomDirectivesController as vm'
                    }
                }
            })
            .state('app.components_custom-directives.ms-sidenav-helper', {
                url  : '/ms-sidenav-helper',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/components/custom-directives/pages/ms-sidenav-helper.html',
                        controller : 'CustomDirectivesController as vm'
                    }
                }
            })
            .state('app.components_custom-directives.ms-splash-screen', {
                url  : '/ms-splash-screen',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/components/custom-directives/pages/ms-splash-screen.html',
                        controller : 'CustomDirectivesController as vm'
                    }
                }
            })
            .state('app.components_custom-directives.ms-stepper', {
                url  : '/ms-stepper',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/components/custom-directives/pages/ms-stepper.html',
                        controller : 'CustomDirectivesController as vm'
                    }
                }
            })
            .state('app.components_custom-directives.ms-timeline', {
                url  : '/ms-timeline',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/components/custom-directives/pages/ms-timeline.html',
                        controller : 'CustomDirectivesController as vm'
                    }
                }
            })
            .state('app.components_custom-directives.ms-widget', {
                url  : '/ms-widget',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/components/custom-directives/pages/ms-widget.html',
                        controller : 'CustomDirectivesController as vm'
                    }
                }
            });

        // Navigation
        msNavigationServiceProvider.saveItem('components.custom-directives', {
            title : 'Custom Directives',
            icon  : 'icon-star',
            weight: 2
        });

        msNavigationServiceProvider.saveItem('components.custom-directives.ms-card', {
            title : 'ms-card',
            state : 'app.components_custom-directives.ms-card',
            weight: 1
        });

        msNavigationServiceProvider.saveItem('components.custom-directives.ms-form-wizard', {
            title : 'ms-form-wizard',
            state : 'app.components_custom-directives.ms-form-wizard',
            weight: 2
        });

        msNavigationServiceProvider.saveItem('components.custom-directives.ms-info-bar', {
            title : 'ms-info-bar',
            state : 'app.components_custom-directives.ms-info-bar',
            weight: 3
        });

        msNavigationServiceProvider.saveItem('components.custom-directives.ms-masonry', {
            title : 'ms-masonry',
            state : 'app.components_custom-directives.ms-masonry',
            weight: 4
        });

        msNavigationServiceProvider.saveItem('components.custom-directives.ms-material-color-picker', {
            title : 'ms-material-color-picker',
            state : 'app.components_custom-directives.ms-material-color-picker',
            weight: 5
        });

        msNavigationServiceProvider.saveItem('components.custom-directives.ms-nav', {
            title : 'ms-nav',
            state : 'app.components_custom-directives.ms-nav',
            weight: 6
        });

        msNavigationServiceProvider.saveItem('components.custom-directives.ms-navigation', {
            title : 'ms-navigation',
            state : 'app.components_custom-directives.ms-navigation',
            weight: 7
        });

        msNavigationServiceProvider.saveItem('components.custom-directives.ms-random-class', {
            title : 'ms-random-class',
            state : 'app.components_custom-directives.ms-random-class',
            weight: 8
        });

        msNavigationServiceProvider.saveItem('components.custom-directives.ms-responsive-table', {
            title : 'ms-responsive-table',
            state : 'app.components_custom-directives.ms-responsive-table',
            weight: 9
        });

        msNavigationServiceProvider.saveItem('components.custom-directives.ms-scroll', {
            title : 'ms-scroll',
            state : 'app.components_custom-directives.ms-scroll',
            weight: 10
        });

        msNavigationServiceProvider.saveItem('components.custom-directives.ms-search-bar', {
            title : 'ms-search-bar',
            state : 'app.components_custom-directives.ms-search-bar',
            weight: 11
        });

        msNavigationServiceProvider.saveItem('components.custom-directives.ms-shortcuts', {
            title : 'ms-shortcuts',
            state : 'app.components_custom-directives.ms-shortcuts',
            weight: 12
        });

        msNavigationServiceProvider.saveItem('components.custom-directives.ms-sidenav-helper', {
            title : 'ms-sidenav-helper',
            state : 'app.components_custom-directives.ms-sidenav-helper',
            weight: 13
        });

        msNavigationServiceProvider.saveItem('components.custom-directives.ms-splash-screen', {
            title : 'ms-splash-screen',
            state : 'app.components_custom-directives.ms-splash-screen',
            weight: 14
        });

        msNavigationServiceProvider.saveItem('components.custom-directives.ms-stepper', {
            title : 'ms-stepper',
            state : 'app.components_custom-directives.ms-stepper',
            weight: 15
        });

        msNavigationServiceProvider.saveItem('components.custom-directives.ms-timeline', {
            title : 'ms-timeline',
            state : 'app.components_custom-directives.ms-timeline',
            weight: 16
        });

        msNavigationServiceProvider.saveItem('components.custom-directives.ms-widget', {
            title : 'ms-widget',
            state : 'app.components_custom-directives.ms-widget',
            weight: 17
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.components.custom-directives')
        .controller('CustomDirectivesController', CustomDirectivesController);

    /** @ngInject */
    function CustomDirectivesController()
    {
        // Data

        // Methods

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.dashboards',
            [
              // 3rd Party Dependencies
              'nvd3',
              'datatables'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider,msNavigationServiceProvider,msApiProvider)
    {
        //State
        $stateProvider.state('app.dashboards', {
            url      : '/dashboards',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/dashboards/dashboards.html',
                    controller : 'DashboardsController as vm'
                }
            },
            resolve  : {
                DashboardData: function (msApi)
                {
                    return msApi.resolve('dashboard.project@get');
                }
            },
            bodyClass: 'dashboards'
        });

        // Navigation
        msNavigationServiceProvider.saveItem('apps', {
            title : 'APPS',
            group : true,
            weight: 1
        });

        msNavigationServiceProvider.saveItem('apps.dashboards', {
            title : 'Dashboards',
            icon  : 'icon-tile-four',
            state : 'app.dashboards',
            weight: 1
        });

      /*  msNavigationServiceProvider.saveItem('apps.dashboards.project', {
            title: 'Project',
            state: 'app.dashboards_project'
        });

        msNavigationServiceProvider.saveItem('apps.dashboards.server', {
            title: 'Server',
            state: 'app.dashboards_server'
        });

        msNavigationServiceProvider.saveItem('apps.dashboards.analytics', {
            title: 'Analytics',
            state: 'app.dashboards_analytics'
        }); */

        // Api
        msApiProvider.register('dashboard.project', ['app/data/dashboard/project/data.json']);
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.dashboards')
        .controller('DashboardsController', DashboardsController);

    /** @ngInject */
    function DashboardsController($scope, $interval, $mdSidenav, DashboardData)
    {
        var vm = this;

        // Data
        vm.dashboardData = DashboardData;
        vm.projects = vm.dashboardData.projects;

        // Widget 1
        vm.widget1 = vm.dashboardData.widget1;

        // Widget 2
        vm.widget2 = vm.dashboardData.widget2;

        // Widget 3
        vm.widget3 = vm.dashboardData.widget3;

        // Widget 4
        vm.widget4 = vm.dashboardData.widget4;

        // Widget 5
        vm.widget5 = {
            title       : vm.dashboardData.widget5.title,
            mainChart   : {
                config : {
                    refreshDataOnly: true,
                    deepWatchData  : true
                },
                options: {
                    chart: {
                        type        : 'multiBarChart',
                        color       : ['#03a9f4', '#b3e5fc'],
                        height      : 420,
                        margin      : {
                            top   : 8,
                            right : 16,
                            bottom: 32,
                            left  : 32
                        },
                        clipEdge    : true,
                        groupSpacing: 0.3,
                        reduceXTicks: false,
                        stacked     : true,
                        duration    : 250,
                        x           : function (d)
                        {
                            return d.x;
                        },
                        y           : function (d)
                        {
                            return d.y;
                        },
                        yAxis       : {
                            tickFormat: function (d)
                            {
                                return d;
                            }
                        },
                        legend      : {
                            margin: {
                                top   : 8,
                                bottom: 32
                            }
                        },
                        controls    : {
                            margin: {
                                top   : 8,
                                bottom: 32
                            }
                        },
                        tooltip     : {
                            gravity: 's',
                            classes: 'gravity-s'
                        }
                    }
                },
                data   : []
            },
            supporting  : {
                widgets: {
                    created  : {
                        data : vm.dashboardData.widget5.supporting.created,
                        chart: {
                            data: []
                        }
                    },
                    closed   : {
                        data : vm.dashboardData.widget5.supporting.closed,
                        chart: {
                            data: []
                        }
                    },
                    reOpened : {
                        data : vm.dashboardData.widget5.supporting.reOpened,
                        chart: {
                            data: []
                        }
                    },
                    wontFix  : {
                        data : vm.dashboardData.widget5.supporting.wontFix,
                        chart: {
                            data: []
                        }
                    },
                    needsTest: {
                        data : vm.dashboardData.widget5.supporting.needsTest,
                        chart: {
                            data: []
                        }
                    },
                    fixed    : {
                        data : vm.dashboardData.widget5.supporting.fixed,
                        chart: {
                            data: []
                        }
                    }
                },
                chart  : {
                    config : {
                        refreshDataOnly: true,
                        deepWatchData  : true
                    },
                    options: {
                        chart: {
                            type                   : 'lineChart',
                            color                  : ['#03A9F4'],
                            height                 : 50,
                            margin                 : {
                                top   : 8,
                                right : 0,
                                bottom: 0,
                                left  : 0
                            },
                            isArea                 : true,
                            interpolate            : 'cardinal',
                            clipEdge               : true,
                            duration               : 500,
                            showXAxis              : false,
                            showYAxis              : false,
                            showLegend             : false,
                            useInteractiveGuideline: true,
                            x                      : function (d)
                            {
                                return d.x;
                            },
                            y                      : function (d)
                            {
                                return d.y;
                            },
                            yDomain                : [0, 9],
                            xAxis                  : {
                                tickFormat: function (d)
                                {
                                    return vm.widget5.days[d];
                                }
                            },
                            interactiveLayer       : {
                                tooltip: {
                                    gravity: 'e',
                                    classes: 'gravity-e'
                                }
                            }
                        }
                    },
                    data   : []
                }
            },
            days        : ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
            ranges      : vm.dashboardData.widget5.ranges,
            currentRange: '',
            changeRange : function (range)
            {
                vm.widget5.currentRange = range;

                /**
                 * Update main chart data by iterating through the
                 * chart dataset and separately adding every single
                 * dataset by hand.
                 *
                 * You MUST NOT swap the entire data object by doing
                 * something similar to this:
                 * vm.widget.mainChart.data = chartData
                 *
                 * It would be easier but it won't work with the
                 * live updating / animated charts due to how d3
                 * works.
                 *
                 * If you don't need animated / live updating charts,
                 * you can simplify these greatly.
                 */
                angular.forEach(vm.dashboardData.widget5.mainChart, function (chartData, index)
                {
                    vm.widget5.mainChart.data[index] = {
                        key   : chartData.key,
                        values: chartData.values[range]
                    };
                });

                /**
                 * Do the same thing for the supporting widgets but they
                 * only have 1 dataset so we can do [0] without needing to
                 * iterate through in their data arrays
                 */
                angular.forEach(vm.dashboardData.widget5.supporting, function (widget, name)
                {
                    vm.widget5.supporting.widgets[name].chart.data[0] = {
                        key   : widget.chart.key,
                        values: widget.chart.values[range]
                    };
                });
            },
            init        : function ()
            {
                // Run this function once to initialize widget

                /**
                 * Update the range for the first time
                 */
                vm.widget5.changeRange('TW');
            }
        };

        // Widget 6
        vm.widget6 = {
            title       : vm.dashboardData.widget6.title,
            mainChart   : {
                config : {
                    refreshDataOnly: true,
                    deepWatchData  : true
                },
                options: {
                    chart: {
                        type        : 'pieChart',
                        color       : ['#f44336', '#9c27b0', '#03a9f4', '#e91e63'],
                        height      : 400,
                        margin      : {
                            top   : 0,
                            right : 0,
                            bottom: 0,
                            left  : 0
                        },
                        donut       : true,
                        clipEdge    : true,
                        cornerRadius: 0,
                        labelType   : 'percent',
                        padAngle    : 0.02,
                        x           : function (d)
                        {
                            return d.label;
                        },
                        y           : function (d)
                        {
                            return d.value;
                        },
                        tooltip     : {
                            gravity: 's',
                            classes: 'gravity-s'
                        }
                    }
                },
                data   : []
            },
            footerLeft  : vm.dashboardData.widget6.footerLeft,
            footerRight : vm.dashboardData.widget6.footerRight,
            ranges      : vm.dashboardData.widget6.ranges,
            currentRange: '',
            changeRange : function (range)
            {
                vm.widget6.currentRange = range;

                /**
                 * Update main chart data by iterating through the
                 * chart dataset and separately adding every single
                 * dataset by hand.
                 *
                 * You MUST NOT swap the entire data object by doing
                 * something similar to this:
                 * vm.widget.mainChart.data = chartData
                 *
                 * It would be easier but it won't work with the
                 * live updating / animated charts due to how d3
                 * works.
                 *
                 * If you don't need animated / live updating charts,
                 * you can simplify these greatly.
                 */
                angular.forEach(vm.dashboardData.widget6.mainChart, function (data, index)
                {
                    vm.widget6.mainChart.data[index] = {
                        label: data.label,
                        value: data.values[range]
                    };
                });
            },
            init        : function ()
            {
                // Run this function once to initialize widget

                /**
                 * Update the range for the first time
                 */
                vm.widget6.changeRange('TW');
            }
        };

        // Widget 7
        vm.widget7 = {
            title       : vm.dashboardData.widget7.title,
            ranges      : vm.dashboardData.widget7.ranges,
            schedule    : vm.dashboardData.widget7.schedule,
            currentRange: 'T'
        };

        // Widget 8
        vm.widget8 = {
            title    : vm.dashboardData.widget8.title,
            mainChart: {
                options: {
                    chart: {
                        type     : 'pieChart',
                        color    : ['#f44336', '#9c27b0', '#03a9f4', '#e91e63', '#ffc107'],
                        height   : 400,
                        margin   : {
                            top   : 0,
                            right : 0,
                            bottom: 0,
                            left  : 0
                        },
                        labelType: 'percent',
                        x        : function (d)
                        {
                            return d.label;
                        },
                        y        : function (d)
                        {
                            return d.value;
                        },
                        tooltip  : {
                            gravity: 's',
                            classes: 'gravity-s'
                        }
                    }
                },
                data   : vm.dashboardData.widget8.mainChart
            }
        };

        // Widget 9
        vm.widget9 = {
            title       : vm.dashboardData.widget9.title,
            weeklySpent : {
                title    : vm.dashboardData.widget9.weeklySpent.title,
                count    : vm.dashboardData.widget9.weeklySpent.count,
                chartData: []
            },
            totalSpent  : {
                title    : vm.dashboardData.widget9.totalSpent.title,
                count    : vm.dashboardData.widget9.totalSpent.count,
                chartData: []
            },
            remaining   : {
                title    : vm.dashboardData.widget9.remaining.title,
                count    : vm.dashboardData.widget9.remaining.count,
                chartData: []
            },
            totalBudget : vm.dashboardData.widget9.totalBudget,
            chart       : {
                config : {
                    refreshDataOnly: true,
                    deepWatchData  : true
                },
                options: {
                    chart: {
                        type                   : 'lineChart',
                        color                  : ['#00BCD4'],
                        height                 : 50,
                        margin                 : {
                            top   : 8,
                            right : 0,
                            bottom: 0,
                            left  : 0
                        },
                        isArea                 : true,
                        interpolate            : 'cardinal',
                        clipEdge               : true,
                        duration               : 500,
                        showXAxis              : false,
                        showYAxis              : false,
                        showLegend             : false,
                        useInteractiveGuideline: true,
                        x                      : function (d)
                        {
                            return d.x;
                        },
                        y                      : function (d)
                        {
                            return d.y;
                        },
                        yDomain                : [0, 9],
                        xAxis                  : {
                            tickFormat: function (d)
                            {
                                return vm.widget9.days[d];
                            }
                        },
                        interactiveLayer       : {
                            tooltip: {
                                gravity: 'e',
                                classes: 'gravity-e'
                            }
                        }
                    }
                }
            },
            days        : ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
            ranges      : vm.dashboardData.widget9.ranges,
            currentRange: '',
            changeRange : function (range)
            {
                vm.widget9.currentRange = range;

                /**
                 * Update mini charts. They only have 1 dataset
                 * so we can do [0] without needing to iterate
                 * through in their data arrays
                 */
                vm.widget9.weeklySpent.chartData[0] = {
                    key   : vm.dashboardData.widget9.weeklySpent.chart.label,
                    values: vm.dashboardData.widget9.weeklySpent.chart.values[range]
                };

                vm.widget9.totalSpent.chartData[0] = {
                    key   : vm.dashboardData.widget9.totalSpent.chart.label,
                    values: vm.dashboardData.widget9.totalSpent.chart.values[range]
                };

                vm.widget9.remaining.chartData[0] = {
                    key   : vm.dashboardData.widget9.remaining.chart.label,
                    values: vm.dashboardData.widget9.remaining.chart.values[range]
                };
            },
            init        : function ()
            {
                // Run this function once to initialize widget

                /**
                 * Update the range for the first time
                 */
                vm.widget9.changeRange('TW');
            }
        };

        // Widget 10
        vm.widget10 = vm.dashboardData.widget10;

        // Widget 11
        vm.widget11 = {
            title    : vm.dashboardData.widget11.title,
            table    : vm.dashboardData.widget11.table,
            dtOptions: {
                dom       : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                pagingType: 'simple',
                autoWidth : false,
                responsive: true,
                order     : [1, 'asc'],
                columnDefs: [
                    {
                        width    : '40',
                        orderable: false,
                        targets  : [0]
                    },
                    {
                        width  : '20%',
                        targets: [1, 2, 3, 4, 5]
                    }
                ]
            }
        };

        // Now widget
        vm.nowWidget = {
            now   : {
                second: '',
                minute: '',
                hour  : '',
                day   : '',
                month : '',
                year  : ''
            },
            ticker: function ()
            {
                var now = moment();
                vm.nowWidget.now = {
                    second : now.format('ss'),
                    minute : now.format('mm'),
                    hour   : now.format('HH'),
                    day    : now.format('D'),
                    weekDay: now.format('dddd'),
                    month  : now.format('MMMM'),
                    year   : now.format('YYYY')
                };
            }
        };

        // Weather widget
        vm.weatherWidget = vm.dashboardData.weatherWidget;

        // Methods
        vm.toggleSidenav = toggleSidenav;
        vm.selectProject = selectProject;

        //////////
        vm.selectedProject = vm.projects[0];

        // Initialize Widget 5
        vm.widget5.init();

        // Initialize Widget 6
        vm.widget6.init();

        // Initialize Widget 9
        vm.widget9.init();

        // Now widget ticker
        vm.nowWidget.ticker();

        var nowWidgetTicker = $interval(vm.nowWidget.ticker, 1000);

        $scope.$on('$destroy', function ()
        {
            $interval.cancel(nowWidgetTicker);
        });

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Select project
         */
        function selectProject(project)
        {
            vm.selectedProject = project;
        }
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.core',
            [
                'ngAnimate',
                'ngAria',
                'ngCookies',
                'ngMessages',
                'ngResource',
                'ngSanitize',
                'ngMaterial',
                'pascalprecht.translate',
                'ui.router'
            ]);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSplashScreen', msSplashScreenDirective);

    /** @ngInject */
    function msSplashScreenDirective($animate)
    {
        return {
            restrict: 'E',
            link    : function (scope, iElement)
            {
                var splashScreenRemoveEvent = scope.$on('msSplashScreen::remove', function ()
                {
                    $animate.leave(iElement).then(function ()
                    {
                        // De-register scope event
                        splashScreenRemoveEvent();

                        // Null-ify everything else
                        scope = iElement = null;
                    });
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsWidgetController', MsWidgetController)
        .directive('msWidget', msWidgetDirective)
        .directive('msWidgetFront', msWidgetFrontDirective)
        .directive('msWidgetBack', msWidgetBackDirective);

    /** @ngInject */
    function MsWidgetController($scope, $element)
    {
        var vm = this;

        // Data
        vm.flipped = false;

        // Methods
        vm.flip = flip;

        //////////

        /**
         * Flip the widget
         */
        function flip()
        {
            if ( !isFlippable() )
            {
                return;
            }

            // Toggle flipped status
            vm.flipped = !vm.flipped;

            // Toggle the 'flipped' class
            $element.toggleClass('flipped', vm.flipped);
        }

        /**
         * Check if widget is flippable
         *
         * @returns {boolean}
         */
        function isFlippable()
        {
            return (angular.isDefined($scope.flippable) && $scope.flippable === true);
        }
    }

    /** @ngInject */
    function msWidgetDirective()
    {
        return {
            restrict  : 'E',
            scope     : {
                flippable: '=?'
            },
            controller: 'MsWidgetController',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    //////////
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetFrontDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-front');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetBackDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-back');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsTimelineController', MsTimelineController)
        .directive('msTimeline', msTimelineDirective)
        .directive('msTimelineItem', msTimelineItemDirective);

    /** @ngInject */
    function MsTimelineController()
    {
        var vm = this;

        // Data
        vm.scrollEl = undefined;

        // Methods
        vm.setScrollEl = setScrollEl;
        vm.getScrollEl = getScrollEl;

        //////////

        /**
         * Set scroll element
         *
         * @param scrollEl
         */
        function setScrollEl(scrollEl)
        {
            vm.scrollEl = scrollEl;
        }

        /**
         * Get scroll element
         *
         * @returns {undefined|*}
         */
        function getScrollEl()
        {
            return vm.scrollEl;
        }
    }

    /** @ngInject */
    function msTimelineDirective()
    {
        return {
            scope     : {
                msTimeline: '=?',
                loadMore  : '&?msTimelineLoadMore'
            },
            controller: 'MsTimelineController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-timeline');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    // Create an element for triggering the load more action and append it
                    var loadMoreEl = angular.element('<div class="ms-timeline-loader md-accent-bg md-whiteframe-4dp"><span class="spinner animate-rotate"></span></div>');
                    iElement.append(loadMoreEl);

                    // Default config
                    var config = {
                        scrollEl: '#content'
                    };

                    // Extend the configuration
                    config = angular.extend(config, scope.msTimeline, {});
                    
                    // Grab the scrollable element and store it in the controller for general use
                    var scrollEl = angular.element(config.scrollEl);
                    MsTimelineCtrl.setScrollEl(scrollEl);

                    // Threshold
                    var threshold = 144;

                    // Register onScroll event for the first time
                    registerOnScroll();

                    /**
                     * onScroll Event
                     */
                    function onScroll()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() + threshold > loadMoreEl.position().top )
                        {
                            // Show the loader
                            loadMoreEl.addClass('show');

                            // Unregister scroll event to prevent triggering the function over and over again
                            unregisterOnScroll();

                            // Trigger load more event
                            scope.loadMore().then(
                                // Success
                                function ()
                                {
                                    // Hide the loader
                                    loadMoreEl.removeClass('show');

                                    // Register the onScroll event again
                                    registerOnScroll();
                                },

                                // Error
                                function ()
                                {
                                    // Remove the loader completely
                                    loadMoreEl.remove();
                                }
                            );
                        }
                    }

                    /**
                     * onScroll event registerer
                     */
                    function registerOnScroll()
                    {
                        scrollEl.on('scroll', onScroll);
                    }

                    /**
                     * onScroll event unregisterer
                     */
                    function unregisterOnScroll()
                    {
                        scrollEl.off('scroll', onScroll);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        unregisterOnScroll();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msTimelineItemDirective($timeout, $q)
    {
        return {
            scope  : true,
            require: '^msTimeline',
            compile: function (tElement)
            {
                tElement.addClass('ms-timeline-item').addClass('hidden');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    var threshold = 72,
                        itemLoaded = false,
                        itemInViewport = false,
                        scrollEl = MsTimelineCtrl.getScrollEl();

                    //////////

                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Check if the timeline item has ms-card
                        if ( iElement.find('ms-card') )
                        {
                            // If the ms-card template loaded...
                            scope.$on('msCard::cardTemplateLoaded', function (event, args)
                            {
                                var cardEl = angular.element(args[0]);

                                // Test the card to see if there is any image on it
                                testForImage(cardEl).then(function ()
                                {
                                    $timeout(function ()
                                    {
                                        itemLoaded = true;
                                    });
                                });
                            });
                        }
                        else
                        {
                            // Test the element to see if there is any image on it
                            testForImage(iElement).then(function ()
                            {
                                $timeout(function ()
                                {
                                    itemLoaded = true;
                                });
                            });
                        }

                        // Check if the loaded element also in the viewport
                        scrollEl.on('scroll', testForVisibility);

                        // Test for visibility for the first time without waiting for the scroll event
                        testForVisibility();
                    }

                    // Item ready watcher
                    var itemReadyWatcher = scope.$watch(
                        function ()
                        {
                            return itemLoaded && itemInViewport;
                        },
                        function (current, old)
                        {
                            if ( angular.equals(current, old) )
                            {
                                return;
                            }

                            if ( current )
                            {
                                iElement.removeClass('hidden').addClass('animate');

                                // Unbind itemReadyWatcher
                                itemReadyWatcher();
                            }
                        }, true);

                    /**
                     * Test the given element for image
                     *
                     * @param element
                     * @returns promise
                     */
                    function testForImage(element)
                    {
                        var deferred = $q.defer(),
                            imgEl = element.find('img');

                        if ( imgEl.length > 0 )
                        {
                            imgEl.on('load', function ()
                            {
                                deferred.resolve('Image is loaded');
                            });
                        }
                        else
                        {
                            deferred.resolve('No images');
                        }

                        return deferred.promise;
                    }

                    /**
                     * Test the element for visibility
                     */
                    function testForVisibility()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() > iElement.position().top + threshold )
                        {
                            $timeout(function ()
                            {
                                itemInViewport = true;
                            });

                            // Unbind the scroll event
                            scrollEl.off('scroll', testForVisibility);
                        }
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsStepperController', MsStepperController)
        .directive('msHorizontalStepper', msHorizontalStepperDirective)
        .directive('msHorizontalStepperStep', msHorizontalStepperStepDirective)
        .directive('msVerticalStepper', msVerticalStepperDirective)
        .directive('msVerticalStepperStep', msVerticalStepperStepDirective);

    /** @ngInject */
    function MsStepperController($timeout)
    {
        var vm = this;

        // Data
        vm.mainForm = undefined;

        vm.orientation = 'horizontal';
        vm.steps = [];
        vm.currentStep = undefined;
        vm.currentStepNumber = 1;

        // Methods
        vm.setOrientation = setOrientation;
        vm.registerMainForm = registerMainForm;
        vm.registerStep = registerStep;
        vm.setupSteps = setupSteps;
        vm.resetForm = resetForm;

        vm.setCurrentStep = setCurrentStep;

        vm.gotoStep = gotoStep;
        vm.gotoPreviousStep = gotoPreviousStep;
        vm.gotoNextStep = gotoNextStep;
        vm.gotoFirstStep = gotoFirstStep;
        vm.gotoLastStep = gotoLastStep;

        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.isStepCurrent = isStepCurrent;
        vm.isStepDisabled = isStepDisabled;
        vm.isStepOptional = isStepOptional;
        vm.isStepHidden = isStepHidden;
        vm.filterHiddenStep = filterHiddenStep;
        vm.isStepValid = isStepValid;
        vm.isStepNumberValid = isStepNumberValid;

        vm.isFormValid = isFormValid;

        //////////

        /**
         * Set the orientation of the stepper
         *
         * @param orientation
         */
        function setOrientation(orientation)
        {
            vm.orientation = orientation || 'horizontal';
        }

        /**
         * Register the main form
         *
         * @param form
         */
        function registerMainForm(form)
        {
            vm.mainForm = form;
        }

        /**
         * Register a step
         *
         * @param element
         * @param scope
         * @param form
         */
        function registerStep(element, scope, form)
        {
            var step = {
                element           : element,
                scope             : scope,
                form              : form,
                stepNumber        : scope.step || (vm.steps.length + 1),
                stepTitle         : scope.stepTitle,
                stepTitleTranslate: scope.stepTitleTranslate
            };

            // Push the step into steps array
            vm.steps.push(step);

            // Sort steps by stepNumber
            vm.steps.sort(function (a, b)
            {
                return a.stepNumber - b.stepNumber;
            });

            return step;
        }

        /**
         * Setup steps for the first time
         */
        function setupSteps()
        {
            vm.setCurrentStep(vm.currentStepNumber);
        }

        /**
         * Reset steps and the main form
         */
        function resetForm()
        {
            // Timeout is required here because we need to
            // let form model to reset before setting the
            // statuses
            $timeout(function ()
            {
                // Reset all the steps
                for ( var x = 0; x < vm.steps.length; x++ )
                {
                    vm.steps[x].form.$setPristine();
                    vm.steps[x].form.$setUntouched();
                }

                // Reset the main form
                vm.mainForm.$setPristine();
                vm.mainForm.$setUntouched();

                // Go to first step
                gotoFirstStep();
            });
        }

        /**
         * Set current step
         *
         * @param stepNumber
         */
        function setCurrentStep(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return;
            }

            // Update the current step number
            vm.currentStepNumber = stepNumber;

            if ( vm.orientation === 'horizontal' )
            {
                // Hide all steps
                for ( var i = 0; i < vm.steps.length; i++ )
                {
                    vm.steps[i].element.hide();
                }

                // Show the current step
                vm.steps[vm.currentStepNumber - 1].element.show();
            }
            else if ( vm.orientation === 'vertical' )
            {
                // Hide all step content
                for ( var j = 0; j < vm.steps.length; j++ )
                {
                    vm.steps[j].element.find('.ms-stepper-step-content').hide();
                }

                // Show the current step content
                vm.steps[vm.currentStepNumber - 1].element.find('.ms-stepper-step-content').show();
            }
        }

        /**
         * Go to a step
         *
         * @param stepNumber
         */
        function gotoStep(stepNumber)
        {
            // If the step we are about to go
            // is hidden, bail...
            if ( isStepHidden(stepNumber) )
            {
                return;
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the previous step
         */
        function gotoPreviousStep()
        {
            var stepNumber = vm.currentStepNumber - 1;

            // Test the previous steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s >= 1; s-- )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the next step
         */
        function gotoNextStep()
        {
            var stepNumber = vm.currentStepNumber + 1;

            // Test the following steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s <= vm.steps.length; s++ )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the first step
         */
        function gotoFirstStep()
        {
            vm.setCurrentStep(1);
        }

        /**
         * Go to the last step
         */
        function gotoLastStep()
        {
            vm.setCurrentStep(vm.steps.length);
        }

        /**
         * Check if the current step is the first step
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.currentStepNumber === 1;
        }

        /**
         * Check if the current step is the last step
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.currentStepNumber === vm.steps.length;
        }

        /**
         * Check if the given step is the current one
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepCurrent(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.currentStepNumber === stepNumber;
        }

        /**
         * Check if the given step should be disabled
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepDisabled(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            var disabled = false;

            for ( var i = 1; i < stepNumber; i++ )
            {
                if ( !isStepValid(i) )
                {
                    disabled = true;
                    break;
                }
            }

            return disabled;
        }

        /**
         * Check if the given step is optional
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepOptional(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.steps[stepNumber - 1].scope.optionalStep;
        }

        /**
         * Check if the given step is hidden
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepHidden(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return !!vm.steps[stepNumber - 1].scope.hideStep;
        }

        /**
         * Check if the given step is hidden as a filter
         *
         * @param step
         * @returns {boolean}
         */
        function filterHiddenStep(step)
        {
            return !isStepHidden(step.stepNumber);
        }

        /**
         * Check if the given step is valid
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepValid(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            // If the step is optional, always return true
            if ( isStepOptional(stepNumber) )
            {
                return true;
            }

            return vm.steps[stepNumber - 1].form.$valid;
        }

        /**
         * Check if the given step number is a valid step number
         *
         * @param stepNumber
         * @returns {boolean}
         */
        function isStepNumberValid(stepNumber)
        {
            return !(angular.isUndefined(stepNumber) || stepNumber < 1 || stepNumber > vm.steps.length);
        }

        /**
         * Check if the entire form is valid
         *
         * @returns {boolean}
         */
        function isFormValid()
        {
            return vm.mainForm.$valid;
        }
    }

    /** @ngInject */
    function msHorizontalStepperDirective()
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msHorizontalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/horizontal/horizontal.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time
                    MsStepperCtrl.setOrientation('horizontal');
                    MsStepperCtrl.registerMainForm(FormCtrl);
                    MsStepperCtrl.setupSteps();
                };
            }
        };
    }

    /** @ngInject */
    function msHorizontalStepperStepDirective()
    {
        return {
            restrict: 'E',
            require : ['form', '^msHorizontalStepper'],
            priority: 1000,
            scope   : {
                step              : '=?',
                stepTitle         : '=?',
                stepTitleTranslate: '=?',
                optionalStep      : '=?',
                hideStep          : '=?'
            },
            compile : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Hide the step by default
                    iElement.hide();
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperDirective($timeout)
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msVerticalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/vertical/vertical.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time

                    // Timeout is required in vertical stepper
                    // as we are using transclusion in steps.
                    // We have to wait for them to be transcluded
                    // and registered to the controller
                    $timeout(function ()
                    {
                        MsStepperCtrl.setOrientation('vertical');
                        MsStepperCtrl.registerMainForm(FormCtrl);
                        MsStepperCtrl.setupSteps();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperStepDirective()
    {
        return {
            restrict   : 'E',
            require    : ['form', '^msVerticalStepper'],
            priority   : 1000,
            scope      : {
                step              : '=?',
                stepTitle         : '=?',
                stepTitleTranslate: '=?',
                optionalStep      : '=?',
                hideStep          : '=?'
            },
            transclude : true,
            templateUrl: 'app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    scope.stepInfo = MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Expose the controller to the scope
                    scope.MsStepper = MsStepperCtrl;

                    // Hide the step content by default
                    iElement.find('.ms-stepper-step-content').hide();
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSidenavHelper', msSidenavHelperDirective);

    /** @ngInject */
    function msSidenavHelperDirective()
    {
        return {
            restrict: 'A',
            require : '^mdSidenav',
            link    : function (scope, iElement, iAttrs, MdSidenavCtrl)
            {
                // Watch md-sidenav open & locked open statuses
                // and add class to the ".page-layout" if only
                // the sidenav open and NOT locked open
                scope.$watch(function ()
                {
                    return MdSidenavCtrl.isOpen() && !MdSidenavCtrl.isLockedOpen();
                }, function (current)
                {
                    if ( angular.isUndefined(current) )
                    {
                        return;
                    }

                    iElement.parent().toggleClass('full-height', current);
                    angular.element('html').toggleClass('sidenav-open', current);
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsShortcutsController', MsShortcutsController)
        .directive('msShortcuts', msShortcutsDirective);

    /** @ngInject */
    function MsShortcutsController($scope, $cookies, $document, $timeout, $q, msNavigationService)
    {
        var vm = this;

        // Data
        vm.query = '';
        vm.queryOptions = {
            debounce: 300
        };
        vm.resultsLoading = false;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;
        vm.mobileBarActive = false;

        vm.results = null;
        vm.shortcuts = [];

        vm.sortableOptions = {
            ghostClass   : 'ghost',
            forceFallback: true,
            fallbackClass: 'dragging',
            onSort       : function ()
            {
                vm.saveShortcuts();
            }
        };

        // Methods
        vm.populateResults = populateResults;
        vm.loadShortcuts = loadShortcuts;
        vm.saveShortcuts = saveShortcuts;
        vm.addShortcut = addShortcut;
        vm.removeShortcut = removeShortcut;
        vm.handleResultClick = handleResultClick;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;
        vm.toggleMobileBar = toggleMobileBar;

        //////////

        init();

        function init()
        {
            // Load the shortcuts
            vm.loadShortcuts().then(
                // Success
                function (response)
                {
                    vm.shortcuts = response;

                    // Add shortcuts as results by default
                    if ( vm.shortcuts.length > 0 )
                    {
                        vm.results = response;
                    }
                }
            );

            // Watch the model changes to trigger the search
            $scope.$watch('MsShortcuts.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                // Show the loader
                vm.resultsLoading = true;

                // Populate the results
                vm.populateResults().then(
                    // Success
                    function (response)
                    {
                        vm.results = response;
                    },
                    // Error
                    function ()
                    {
                        vm.results = [];
                    }
                ).finally(
                    function ()
                    {
                        // Hide the loader
                        vm.resultsLoading = false;
                    }
                );
            });
        }

        /**
         * Populate the results
         */
        function populateResults()
        {
            var results = [],
                flatNavigation = msNavigationService.getFlatNavigation(),
                deferred = $q.defer();

            // Iterate through the navigation array and
            // make sure it doesn't have any groups or
            // none ui-sref items
            for ( var x = 0; x < flatNavigation.length; x++ )
            {
                if ( flatNavigation[x].uisref )
                {
                    results.push(flatNavigation[x]);
                }
            }

            // If there is a query, filter the results
            if ( vm.query )
            {
                results = results.filter(function (item)
                {
                    if ( angular.lowercase(item.title).search(angular.lowercase(vm.query)) > -1 )
                    {
                        return true;
                    }
                });

                // Iterate through one last time and
                // add required properties to items
                for ( var i = 0; i < results.length; i++ )
                {
                    // Add false to hasShortcut by default
                    results[i].hasShortcut = false;

                    // Test if the item is in the shortcuts list
                    for ( var y = 0; y < vm.shortcuts.length; y++ )
                    {
                        if ( vm.shortcuts[y]._id === results[i]._id )
                        {
                            results[i].hasShortcut = true;
                            break;
                        }
                    }
                }
            }
            else
            {
                // If the query is empty, that means
                // there is nothing to search for so
                // we will populate the results with
                // current shortcuts if there is any
                if ( vm.shortcuts.length > 0 )
                {
                    results = vm.shortcuts;
                }
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Fake the service delay
            $timeout(function ()
            {
                // Resolve the promise
                deferred.resolve(results);
            }, 250);

            // Return a promise
            return deferred.promise;
        }

        /**
         * Load shortcuts
         */
        function loadShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // load the shortcuts from the cookies.
            // But here you can make an API call
            // to load them from the DB.
            var shortcuts = angular.fromJson($cookies.get('FUSE.shortcuts'));

            // No cookie available. Generate one
            // for the demo purposes...
            if ( angular.isUndefined(shortcuts) )
            {
                shortcuts = [
                    {
                        'title'      : 'Sample',
                        'icon'       : 'icon-tile-four',
                        'state'      : 'app.sample',
                        'weight'     : 1,
                        'children'   : [],
                        '_id'        : 'sample',
                        '_path'      : 'apps.sample',
                        'uisref'     : 'app.sample',
                        'hasShortcut': true
                    }
                ];

                $cookies.put('FUSE.shortcuts', angular.toJson(shortcuts));
            }

            // Resolve the promise
            deferred.resolve(shortcuts);

            return deferred.promise;
        }

        /**
         * Save the shortcuts
         */
        function saveShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // keep the shortcuts in the cookies.
            // But here you can make an API call
            // to save them to the DB.
            $cookies.put('FUSE.shortcuts', angular.toJson(vm.shortcuts));

            // Fake the service delay
            $timeout(function ()
            {
                deferred.resolve({'success': true});
            }, 250);

            return deferred.promise;
        }

        /**
         * Add item as shortcut
         *
         * @param item
         */
        function addShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = true;

            // Add as a shortcut
            vm.shortcuts.push(item);

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Remove item from shortcuts
         *
         * @param item
         */
        function removeShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = false;

            // Remove the shortcut
            for ( var x = 0; x < vm.shortcuts.length; x++ )
            {
                if ( vm.shortcuts[x]._id === item._id )
                {
                    // Remove the x-th item from the array
                    vm.shortcuts.splice(x, 1);

                    // If we aren't searching for anything...
                    if ( !vm.query )
                    {
                        // If all the shortcuts have been removed,
                        // null-ify the results
                        if ( vm.shortcuts.length === 0 )
                        {
                            vm.results = null;
                        }
                        // Otherwise update the selected index
                        else
                        {
                            if ( x >= vm.shortcuts.length )
                            {
                                vm.selectedResultIndex = vm.shortcuts.length - 1;
                            }
                        }
                    }
                }
            }

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            // Add or remove the shortcut
            if ( item.hasShortcut )
            {
                vm.removeShortcut(item);
            }
            else
            {
                vm.addShortcut(item);
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $document.find('#ms-shortcut-add-menu').find('.results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }

        /**
         * Toggle mobile bar
         */
        function toggleMobileBar()
        {
            vm.mobileBarActive = !vm.mobileBarActive;
        }
    }

    /** @ngInject */
    function msShortcutsDirective()
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msShortcuts',
            controller      : 'MsShortcutsController as MsShortcuts',
            bindToController: {},
            templateUrl     : 'app/core/directives/ms-shortcuts/ms-shortcuts.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-shortcuts');

                return function postLink(scope, iElement)
                {
                    // Data

                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsSearchBarController', MsSearchBarController)
        .directive('msSearchBar', msSearchBarDirective);

    /** @ngInject */
    function MsSearchBarController($scope, $element, $timeout)
    {
        var vm = this;

        // Data
        vm.collapsed = true;
        vm.query = '';
        vm.queryOptions = {
            debounce: vm.debounce || 0
        };
        vm.resultsLoading = false;
        vm.results = null;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;

        // Methods
        vm.populateResults = populateResults;

        vm.expand = expand;
        vm.collapse = collapse;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.handleResultClick = handleResultClick;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;

        //////////

        init();

        function init()
        {
            // Watch the model changes to trigger the search
            $scope.$watch('MsSearchBar.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }
		
		if ( current.length <= 3 )
                {
                    return;
                }		
	
                if ( angular.equals(current, old) )
                {
                    return;
                }

                if ( vm.collapsed )
                {
                    return;
                }

                // Evaluate the onSearch function to access the
                // function itself
                var onSearchEvaluated = $scope.$parent.$eval(vm.onSearch, {query: current}),
                    isArray = angular.isArray(onSearchEvaluated),
                    isPromise = (onSearchEvaluated && !!onSearchEvaluated.then);

                if ( isArray )
                {
                    // Populate the results
                    vm.populateResults(onSearchEvaluated);
                }

                if ( isPromise )
                {
                    // Show the loader
                    vm.resultsLoading = true;

                    onSearchEvaluated.then(
                        // Success
                        function (response)
                        {
                            // Populate the results
                            vm.populateResults(response);
                        },
                        // Error
                        function ()
                        {
                            // Assign an empty array to show
                            // the no-results screen
                            vm.populateResults([]);
                        }
                    ).finally(function ()
                        {
                            // Hide the loader
                            vm.resultsLoading = false;
                        }
                    );
                }
            });
        }

        /**
         * Populate the results
         *
         * @param results
         */
        function populateResults(results)
        {
            // Before doing anything,
            // make sure the search bar is expanded
            if ( vm.collapsed )
            {
                return;
            }

            var isArray = angular.isArray(results),
                isNull = results === null;

            // Only accept arrays and null values
            if ( !isArray && !isNull )
            {
                return;
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Populate the results
            vm.results = results;
        }

        /**
         * Expand
         */
        function expand()
        {
            // Set collapsed status
            vm.collapsed = false;

            // Call expand on scope
            $scope.expand();

            // Callback
            if ( vm.onExpand && angular.isFunction(vm.onExpand) )
            {
                vm.onExpand();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Empty the query
            vm.query = '';

            // Empty results to hide the results view
            vm.populateResults(null);

            // Set collapsed status
            vm.collapsed = true;

            // Call collapse on scope
            $scope.collapse();

            // Callback
            if ( vm.onCollapse && angular.isFunction(vm.onCollapse) )
            {
                vm.onCollapse();
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [27, 38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Escape
                case 27:

                    // Collapse the search bar
                    vm.collapse();

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    if ( !vm.results )
                    {
                        return;
                    }

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            if ( vm.onResultClick )
            {
                vm.onResultClick({item: item});
            }

            // Collapse the search bar
            vm.collapse();
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $element.find('.ms-search-bar-results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }
    }

    /** @ngInject */
    function msSearchBarDirective($document)
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msSearchBar',
            controller      : 'MsSearchBarController as MsSearchBar',
            bindToController: {
                debounce     : '=?',
                onSearch     : '@',
                onResultClick: '&?',
                onExpand     : '&?',
                onCollapse   : '&?'
            },
            templateUrl     : 'app/core/directives/ms-search-bar/ms-search-bar.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-search-bar');

                return function postLink(scope, iElement)
                {
                    // Data
                    var inputEl,
                        bodyEl = $document.find('body');

                    // Methods
                    scope.collapse = collapse;
                    scope.expand = expand;

                    //////////

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Grab the input element
                        inputEl = iElement.find('#ms-search-bar-input');
                    }

                    /**
                     * Expand action
                     */
                    function expand()
                    {
                        // Add expanded class
                        iElement.addClass('expanded');

                        // Add helper class to the body
                        bodyEl.addClass('ms-search-bar-expanded');

                        // Focus on the input
                        inputEl.focus();
                    }

                    /**
                     * Collapse action
                     */
                    function collapse()
                    {
                        // Remove expanded class
                        iElement.removeClass('expanded');

                        // Remove helper class from the body
                        bodyEl.removeClass('ms-search-bar-expanded');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msScrollConfig', msScrollConfigProvider)
        .directive('msScroll', msScrollDirective);

    /** @ngInject */
    function msScrollConfigProvider()
    {
        // Default configuration
        var defaultConfiguration = {
            wheelSpeed            : 1,
            wheelPropagation      : false,
            swipePropagation      : true,
            minScrollbarLength    : null,
            maxScrollbarLength    : null,
            useBothWheelAxes      : false,
            useKeyboard           : true,
            suppressScrollX       : false,
            suppressScrollY       : false,
            scrollXMarginOffset   : 0,
            scrollYMarginOffset   : 0,
            stopPropagationOnClick: true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig
            };

            return service;

            //////////

            /**
             * Return the config
             */
            function getConfig()
            {
                return defaultConfiguration;
            }
        };
    }

    /** @ngInject */
    function msScrollDirective($timeout, msScrollConfig, msUtils, fuseConfig)
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                // Do not replace scrollbars if
                // 'disableCustomScrollbars' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbars') )
                {
                    return;
                }

                // Do not replace scrollbars on mobile devices
                // if 'disableCustomScrollbarsOnMobile' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbarsOnMobile') && msUtils.isMobile() )
                {
                    return;
                }

                // Add class
                tElement.addClass('ms-scroll');

                return function postLink(scope, iElement, iAttrs)
                {
                    var options = {};

                    // If options supplied, evaluate the given
                    // value. This is because we don't want to
                    // have an isolated scope but still be able
                    // to use scope variables.
                    // We don't want an isolated scope because
                    // we should be able to use this everywhere
                    // especially with other directives
                    if ( iAttrs.msScroll )
                    {
                        options = scope.$eval(iAttrs.msScroll);
                    }

                    // Extend the given config with the ones from provider
                    options = angular.extend({}, msScrollConfig.getConfig(), options);

                    // Initialize the scrollbar
                    $timeout(function ()
                    {
                        PerfectScrollbar.initialize(iElement[0], options);
                    }, 0);

                    // Update the scrollbar on element mouseenter
                    iElement.on('mouseenter', updateScrollbar);

                    // Watch scrollHeight and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollHeight');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    // Watch scrollWidth and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollWidth');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    /**
                     * Update the scrollbar
                     */
                    function updateScrollbar()
                    {
                        PerfectScrollbar.update(iElement[0]);
                    }

                    // Cleanup on destroy
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('mouseenter');
                        PerfectScrollbar.destroy(iElement[0]);
                    });
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msResponsiveTable', msResponsiveTableDirective);

    /** @ngInject */
    function msResponsiveTableDirective()
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement)
            {
                // Wrap the table
                var wrapper = angular.element('<div class="ms-responsive-table-wrapper"></div>');
                iElement.after(wrapper);
                wrapper.append(iElement);

                //////////
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msRandomClass', msRandomClassDirective);

    /** @ngInject */
    function msRandomClassDirective()
    {
        return {
            restrict: 'A',
            scope   : {
                msRandomClass: '='
            },
            link    : function (scope, iElement)
            {
                var randomClass = scope.msRandomClass[Math.floor(Math.random() * (scope.msRandomClass.length))];
                iElement.addClass(randomClass);
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msNavigationService', msNavigationServiceProvider)
        .controller('MsNavigationController', MsNavigationController)
        // Vertical
        .directive('msNavigation', msNavigationDirective)
        .controller('MsNavigationNodeController', MsNavigationNodeController)
        .directive('msNavigationNode', msNavigationNodeDirective)
        .directive('msNavigationItem', msNavigationItemDirective)
        //Horizontal
        .directive('msNavigationHorizontal', msNavigationHorizontalDirective)
        .controller('MsNavigationHorizontalNodeController', MsNavigationHorizontalNodeController)
        .directive('msNavigationHorizontalNode', msNavigationHorizontalNodeDirective)
        .directive('msNavigationHorizontalItem', msNavigationHorizontalItemDirective);

    /** @ngInject */
    function msNavigationServiceProvider()
    {
        // Inject $log service
        var $log = angular.injector(['ng']).get('$log');

        // Navigation array
        var navigation = [];

        var service = this;

        // Methods
        service.saveItem = saveItem;
        service.deleteItem = deleteItem;
        service.sortByWeight = sortByWeight;

        //////////

        /**
         * Create or update the navigation item
         *
         * @param path
         * @param item
         */
        function saveItem(path, item)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            var parts = path.split('.');

            // Generate the object id from the parts
            var id = parts[parts.length - 1];

            // Get the parent item from the parts
            var parent = _findOrCreateParent(parts);

            // Decide if we are going to update or create
            var updateItem = false;

            for ( var i = 0; i < parent.length; i++ )
            {
                if ( parent[i]._id === id )
                {
                    updateItem = parent[i];

                    break;
                }
            }

            // Update
            if ( updateItem )
            {
                angular.extend(updateItem, item);

                // Add proper ui-sref
                updateItem.uisref = _getUiSref(updateItem);
            }
            // Create
            else
            {
                // Create an empty children array in the item
                item.children = [];

                // Add the default weight if not provided or if it's not a number
                if ( angular.isUndefined(item.weight) || !angular.isNumber(item.weight) )
                {
                    item.weight = 1;
                }

                // Add the item id
                item._id = id;

                // Add the item path
                item._path = path;

                // Add proper ui-sref
                item.uisref = _getUiSref(item);

                // Push the item into the array
                parent.push(item);
            }
        }

        /**
         * Delete navigation item
         *
         * @param path
         */
        function deleteItem(path)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            // Locate the item by using given path
            var item = navigation,
                parts = path.split('.');

            for ( var p = 0; p < parts.length; p++ )
            {
                var id = parts[p];

                for ( var i = 0; i < item.length; i++ )
                {
                    if ( item[i]._id === id )
                    {
                        // If we have a matching path,
                        // we have found our object:
                        // remove it.
                        if ( item[i]._path === path )
                        {
                            item.splice(i, 1);
                            return true;
                        }

                        // Otherwise grab the children of
                        // the current item and continue
                        item = item[i].children;
                        break;
                    }
                }
            }

            return false;
        }

        /**
         * Sort the navigation items by their weights
         *
         * @param parent
         */
        function sortByWeight(parent)
        {
            // If parent not provided, sort the root items
            if ( !parent )
            {
                parent = navigation;
                parent.sort(_byWeight);
            }

            // Sort the children
            for ( var i = 0; i < parent.length; i++ )
            {
                var children = parent[i].children;

                if ( children.length > 1 )
                {
                    children.sort(_byWeight);
                }

                if ( children.length > 0 )
                {
                    sortByWeight(children);
                }
            }
        }

        /* ----------------- */
        /* Private Functions */
        /* ----------------- */

        /**
         * Find or create parent
         *
         * @param parts
         * @returns {Array|Boolean}
         * @private
         */
        function _findOrCreateParent(parts)
        {
            // Store the main navigation
            var parent = navigation;

            // If it's going to be a root item
            // return the navigation itself
            if ( parts.length === 1 )
            {
                return parent;
            }

            // Remove the last element from the parts as
            // we don't need that to figure out the parent
            parts.pop();

            // Find and return the parent
            for ( var i = 0; i < parts.length; i++ )
            {
                var _id = parts[i],
                    createParent = true;

                for ( var p = 0; p < parent.length; p++ )
                {
                    if ( parent[p]._id === _id )
                    {
                        parent = parent[p].children;
                        createParent = false;

                        break;
                    }
                }

                // If there is no parent found, create one, push
                // it into the current parent and assign it as a
                // new parent
                if ( createParent )
                {
                    var item = {
                        _id     : _id,
                        _path   : parts.join('.'),
                        title   : _id,
                        weight  : 1,
                        children: []
                    };

                    parent.push(item);
                    parent = item.children;
                }
            }

            return parent;
        }

        /**
         * Sort by weight
         *
         * @param x
         * @param y
         * @returns {number}
         * @private
         */
        function _byWeight(x, y)
        {
            return parseInt(x.weight) - parseInt(y.weight);
        }

        /**
         * Setup the ui-sref using state & state parameters
         *
         * @param item
         * @returns {string}
         * @private
         */
        function _getUiSref(item)
        {
            var uisref = '';

            if ( angular.isDefined(item.state) )
            {
                uisref = item.state;

                if ( angular.isDefined(item.stateParams) && angular.isObject(item.stateParams) )
                {
                    uisref = uisref + '(' + angular.toJson(item.stateParams) + ')';
                }
            }

            return uisref;
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */

        this.$get = function ()
        {
            var activeItem = null,
                navigationScope = null,
                folded = null,
                foldedOpen = null;

            var service = {
                saveItem          : saveItem,
                deleteItem        : deleteItem,
                sort              : sortByWeight,
                clearNavigation   : clearNavigation,
                setActiveItem     : setActiveItem,
                getActiveItem     : getActiveItem,
                getNavigation     : getNavigation,
                getFlatNavigation : getFlatNavigation,
                setNavigationScope: setNavigationScope,
                setFolded         : setFolded,
                getFolded         : getFolded,
                setFoldedOpen     : setFoldedOpen,
                getFoldedOpen     : getFoldedOpen,
                toggleFolded      : toggleFolded
            };

            return service;

            //////////

            /**
             * Clear the entire navigation
             */
            function clearNavigation()
            {
                // Clear the navigation array
                navigation = [];

                // Clear the vm.navigation from main controller
                if ( navigationScope )
                {
                    navigationScope.vm.navigation = navigation;
                }
            }

            /**
             * Set active item
             *
             * @param node
             * @param scope
             */
            function setActiveItem(node, scope)
            {
                activeItem = {
                    node : node,
                    scope: scope
                };
            }

            /**
             * Return active item
             */
            function getActiveItem()
            {
                return activeItem;
            }

            /**
             * Return navigation array
             *
             * @param root
             * @returns Array
             */
            function getNavigation(root)
            {
                if ( root )
                {
                    for ( var i = 0; i < navigation.length; i++ )
                    {
                        if ( navigation[i]._id === root )
                        {
                            return [navigation[i]];
                        }
                    }

                    return null;
                }

                return navigation;
            }

            /**
             * Return flat navigation array
             *
             * @param root
             * @returns Array
             */
            function getFlatNavigation(root)
            {
                // Get the correct navigation array
                var navigation = getNavigation(root);

                // Flatten the navigation object
                return _flattenNavigation(navigation);
            }

            /**
             * Store navigation's scope for later use
             *
             * @param scope
             */
            function setNavigationScope(scope)
            {
                navigationScope = scope;
            }

            /**
             * Set folded status
             *
             * @param status
             */
            function setFolded(status)
            {
                folded = status;
            }

            /**
             * Return folded status
             *
             * @returns {*}
             */
            function getFolded()
            {
                return folded;
            }

            /**
             * Set folded open status
             *
             * @param status
             */
            function setFoldedOpen(status)
            {
                foldedOpen = status;
            }

            /**
             * Return folded open status
             *
             * @returns {*}
             */
            function getFoldedOpen()
            {
                return foldedOpen;
            }


            /**
             * Toggle fold on stored navigation's scope
             */
            function toggleFolded()
            {
                navigationScope.toggleFolded();
            }

            /**
             * Flatten the given navigation
             *
             * @param navigation
             * @private
             */
            function _flattenNavigation(navigation)
            {
                var flatNav = [];

                for ( var x = 0; x < navigation.length; x++ )
                {
                    // Copy and clear the children of the
                    // navigation that we want to push
                    var navToPush = angular.copy(navigation[x]);
                    navToPush.children = [];

                    // Push the item
                    flatNav.push(navToPush);

                    // If there are child items in this navigation,
                    // do some nested function magic
                    if ( navigation[x].children.length > 0 )
                    {
                        flatNav = flatNav.concat(_flattenNavigation(navigation[x].children));
                    }
                }

                return flatNav;
            }
        };
    }

    /** @ngInject */
    function MsNavigationController($scope, msNavigationService)
    {
        var vm = this;

        // Data
        if ( $scope.root )
        {
            vm.navigation = msNavigationService.getNavigation($scope.root);
        }
        else
        {
            vm.navigation = msNavigationService.getNavigation();
        }

        // Methods
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Sort the navigation before doing anything else
            msNavigationService.sort();
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu()
        {
            angular.element('body').toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }
    }

    /** @ngInject */
    function msNavigationDirective($rootScope, $timeout, $mdSidenav, msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                folded: '=',
                root  : '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/vertical.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation');

                return function postLink(scope, iElement)
                {
                    var bodyEl = angular.element('body'),
                        foldExpanderEl = angular.element('<div id="ms-navigation-fold-expander"></div>'),
                        foldCollapserEl = angular.element('<div id="ms-navigation-fold-collapser"></div>'),
                        sidenav = $mdSidenav('navigation');

                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Set the folded status for the first time.
                        // First, we have to check if we have a folded
                        // status available in the service already. This
                        // will prevent navigation to act weird if we already
                        // set the fold status, remove the navigation and
                        // then re-initialize it, which happens if we
                        // change to a view without a navigation and then
                        // come back with history.back() function.

                        // If the service didn't initialize before, set
                        // the folded status from scope, otherwise we
                        // won't touch anything because the folded status
                        // already set in the service...
                        if ( msNavigationService.getFolded() === null )
                        {
                            msNavigationService.setFolded(scope.folded);
                        }

                        if ( msNavigationService.getFolded() )
                        {
                            // Collapse everything.
                            // This must be inside a $timeout because by the
                            // time we call this, the 'msNavigation::collapse'
                            // event listener is not registered yet. $timeout
                            // will ensure that it will be called after it is
                            // registered.
                            $timeout(function ()
                            {
                                $rootScope.$broadcast('msNavigation::collapse');
                            });

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                    }

                    // Sidenav locked open status watcher
                    scope.$watch(function ()
                    {
                        return sidenav.isLockedOpen();
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        var folded = msNavigationService.getFolded();

                        if ( folded )
                        {
                            if ( current )
                            {
                                // Collapse everything
                                $rootScope.$broadcast('msNavigation::collapse');
                            }
                            else
                            {
                                // Expand the active one and its parents
                                var activeItem = msNavigationService.getActiveItem();
                                if ( activeItem )
                                {
                                    activeItem.scope.$emit('msNavigation::stateMatched');
                                }
                            }
                        }
                    });

                    // Folded status watcher
                    scope.$watch('folded', function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        setFolded(current);
                    });

                    /**
                     * Set folded status
                     *
                     * @param folded
                     */
                    function setFolded(folded)
                    {
                        // Store folded status on the service for global access
                        msNavigationService.setFolded(folded);

                        if ( folded )
                        {
                            // Collapse everything
                            $rootScope.$broadcast('msNavigation::collapse');

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                        else
                        {
                            // Expand the active one and its parents
                            var activeItem = msNavigationService.getActiveItem();
                            if ( activeItem )
                            {
                                activeItem.scope.$emit('msNavigation::stateMatched');
                            }

                            // Remove body class
                            bodyEl.removeClass('ms-navigation-folded ms-navigation-folded-open');

                            // Remove fold collapser
                            removeFoldCollapser();
                        }
                    }

                    /**
                     * Set fold expander
                     */
                    function setFoldExpander()
                    {
                        iElement.parent().append(foldExpanderEl);

                        // Let everything settle for a moment
                        // before registering the event listener
                        $timeout(function ()
                        {
                            foldExpanderEl.on('mouseenter touchstart', onFoldExpanderHover);
                        });
                    }

                    /**
                     * Set fold collapser
                     */
                    function setFoldCollapser()
                    {
                        bodyEl.find('#main').append(foldCollapserEl);
                        foldCollapserEl.on('mouseenter touchstart', onFoldCollapserHover);
                    }

                    /**
                     * Remove fold collapser
                     */
                    function removeFoldCollapser()
                    {
                        foldCollapserEl.remove();
                    }

                    /**
                     * onHover event of foldExpander
                     */
                    function onFoldExpanderHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(true);

                        // Expand the active one and its parents
                        var activeItem = msNavigationService.getActiveItem();
                        if ( activeItem )
                        {
                            activeItem.scope.$emit('msNavigation::stateMatched');
                        }

                        // Add class to the body
                        bodyEl.addClass('ms-navigation-folded-open');

                        // Remove the fold opener
                        foldExpanderEl.remove();

                        // Set fold collapser
                        setFoldCollapser();
                    }

                    /**
                     * onHover event of foldCollapser
                     */
                    function onFoldCollapserHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(false);

                        // Collapse everything
                        $rootScope.$broadcast('msNavigation::collapse');

                        // Remove body class
                        bodyEl.removeClass('ms-navigation-folded-open');

                        // Remove the fold collapser
                        foldCollapserEl.remove();

                        // Set fold expander
                        setFoldExpander();
                    }

                    /**
                     * Public access for toggling folded status externally
                     */
                    scope.toggleFolded = function ()
                    {
                        var folded = msNavigationService.getFolded();

                        setFolded(!folded);
                    };

                    /**
                     * On $stateChangeStart
                     */
                    scope.$on('$stateChangeStart', function ()
                    {
                        // Close the sidenav
                        sidenav.close();
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        foldCollapserEl.off('mouseenter touchstart');
                        foldExpanderEl.off('mouseenter touchstart');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationNodeController($scope, $element, $rootScope, $animate, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.collapsed = undefined;
        vm.collapsable = undefined;
        vm.group = undefined;
        vm.animateHeightClass = 'animate-height';

        // Methods
        vm.toggleCollapsed = toggleCollapsed;
        vm.collapse = collapse;
        vm.expand = expand;
        vm.getClass = getClass;
        vm.isHidden = isHidden;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Is collapsable?
            if ( !vm.hasChildren || vm.group )
            {
                vm.collapsable = false;
            }
            else
            {
                vm.collapsable = !!(angular.isUndefined(vm.node.collapsable) || typeof vm.node.collapsable !== 'boolean' || vm.node.collapsable === true);
            }

            // Is collapsed?
            if ( !vm.collapsable )
            {
                vm.collapsed = false;
            }
            else
            {
                vm.collapsed = !!(angular.isUndefined(vm.node.collapsed) || typeof vm.node.collapsed !== 'boolean' || vm.node.collapsed === true);
            }

            // Expand all parents if we have a matching state or
            // the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Expand if the current scope is collapsable and is collapsed
                if ( vm.collapsable && vm.collapsed )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.collapsed = false;
                    });
                }
            });

            // Listen for collapse event
            $scope.$on('msNavigation::collapse', function (event, path)
            {
                if ( vm.collapsed || !vm.collapsable )
                {
                    return;
                }

                // If there is no path defined, collapse
                if ( angular.isUndefined(path) )
                {
                    vm.collapse();
                }
                // If there is a path defined, do not collapse
                // the items that are inside that path. This will
                // prevent parent items from collapsing
                else
                {
                    var givenPathParts = path.split('.'),
                        activePathParts = [];

                    var activeItem = msNavigationService.getActiveItem();
                    if ( activeItem )
                    {
                        activePathParts = activeItem.node._path.split('.');
                    }

                    // Test for given path
                    if ( givenPathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    // Test for active path
                    if ( activePathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    vm.collapse();
                }
            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Collapse everything except the one we're using
                    $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
                }

                // Expand the parents if we the current
                // state is a child of the node's state
                if ( $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Emit the stateMatched
                    $scope.$emit('msNavigation::stateMatched');
                }
            });
        }

        /**
         * Toggle collapsed
         */
        function toggleCollapsed()
        {
            if ( vm.collapsed )
            {
                vm.expand();
            }
            else
            {
                vm.collapse();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Grab the element that we are going to collapse
            var collapseEl = vm.element.children('ul');

            // Grab the height
            var height = collapseEl[0].offsetHeight;

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = true;

                // Add collapsing class to the node
                vm.element.addClass('collapsing');

                // Animate the height
                $animate.animate(collapseEl,
                    {
                        'display': 'block',
                        'height' : height + 'px'
                    },
                    {
                        'height': '0px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        collapseEl.css({
                            'display': '',
                            'height' : ''
                        });

                        // Clear collapsing class from the node
                        vm.element.removeClass('collapsing');
                    }
                );

                // Broadcast the collapse event so child items can also be collapsed
                $scope.$broadcast('msNavigation::collapse');
            });
        }

        /**
         * Expand
         */
        function expand()
        {
            // Grab the element that we are going to expand
            var expandEl = vm.element.children('ul');

            // Move the element out of the dom flow and
            // make it block so we can get its height
            expandEl.css({
                'position'  : 'absolute',
                'visibility': 'hidden',
                'display'   : 'block',
                'height'    : 'auto'
            });

            // Grab the height
            var height = expandEl[0].offsetHeight;

            // Reset the style modifications
            expandEl.css({
                'position'  : '',
                'visibility': '',
                'display'   : '',
                'height'    : ''
            });

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = false;

                // Add expanding class to the node
                vm.element.addClass('expanding');

                // Animate the height
                $animate.animate(expandEl,
                    {
                        'display': 'block',
                        'height' : '0px'
                    },
                    {
                        'height': height + 'px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        expandEl.css({
                            'height': ''
                        });

                        // Clear expanding class from the node
                        vm.element.removeClass('expanding');
                    }
                );

                // If item expanded, broadcast the collapse event from rootScope so that the other expanded items
                // can be collapsed. This is necessary for keeping only one parent expanded at any time
                $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }

        /**
         * Check if node should be hidden
         *
         * @returns {boolean}
         */
        function isHidden()
        {
            if ( angular.isDefined(vm.node.hidden) && angular.isFunction(vm.node.hidden) )
            {
                return vm.node.hidden();
            }

            return false;
        }
    }

    /** @ngInject */
    function msNavigationNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationNode'
            },
            controller      : 'MsNavigationNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationItemDirective()
    {
        return {
            restrict: 'A',
            require : '^msNavigationNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // If the item is collapsable...
                    if ( MsNavigationNodeCtrl.collapsable )
                    {
                        iElement.on('click', MsNavigationNodeCtrl.toggleCollapsed);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalDirective(msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                root: '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/horizontal.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal');

                return function postLink(scope)
                {
                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationHorizontalNodeController($scope, $element, $rootScope, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.group = undefined;

        // Methods
        vm.getClass = getClass;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Is active
            vm.isActive = false;

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Mark all parents as active if we have a matching state
            // or the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Mark as active if has children
                if ( vm.hasChildren )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
            });

            // Listen for clearActive event
            $scope.$on('msNavigation::clearActive', function ()
            {
                if ( !vm.hasChildren )
                {
                    return;
                }

                var activePathParts = [];

                var activeItem = msNavigationService.getActiveItem();
                if ( activeItem )
                {
                    activePathParts = activeItem.node._path.split('.');
                }

                // Test for active path
                if ( activePathParts.indexOf(vm.node._id) > -1 )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
                else
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = false;
                    });
                }

            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Clear all active states except the one we're using
                    $rootScope.$broadcast('msNavigation::clearActive');
                }
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }
    }

    /** @ngInject */
    function msNavigationHorizontalNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationHorizontalNode'
            },
            controller      : 'MsNavigationHorizontalNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationHorizontalNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationHorizontalNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalItemDirective($mdMedia)
    {
        return {
            restrict: 'A',
            require : '^msNavigationHorizontalNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    iElement.on('click', onClick);

                    function onClick()
                    {
                        if ( !MsNavigationHorizontalNodeCtrl.hasChildren || $mdMedia('gt-md') )
                        {
                            return;
                        }

                        iElement.toggleClass('expanded');
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msNavFoldService', msNavFoldService)
        .directive('msNavIsFolded', msNavIsFoldedDirective)
        .controller('MsNavController', MsNavController)
        .directive('msNav', msNavDirective)
        .directive('msNavTitle', msNavTitleDirective)
        .directive('msNavButton', msNavButtonDirective)
        .directive('msNavToggle', msNavToggleDirective);

    /** @ngInject */
    function msNavFoldService()
    {
        var foldable = {};

        var service = {
            setFoldable    : setFoldable,
            isNavFoldedOpen: isNavFoldedOpen,
            toggleFold     : toggleFold,
            openFolded     : openFolded,
            closeFolded    : closeFolded
        };

        return service;

        //////////

        /**
         * Set the foldable
         *
         * @param scope
         * @param element
         */
        function setFoldable(scope, element)
        {
            foldable = {
                'scope'  : scope,
                'element': element
            };
        }

        /**
         * Is folded open
         */
        function isNavFoldedOpen()
        {
            return foldable.scope.isNavFoldedOpen();
        }

        /**
         * Toggle fold
         */
        function toggleFold()
        {
            foldable.scope.toggleFold();
        }

        /**
         * Open folded navigation
         */
        function openFolded()
        {
            foldable.scope.openFolded();
        }

        /**
         * Close folded navigation
         */
        function closeFolded()
        {
            foldable.scope.closeFolded();
        }
    }

    /** @ngInject */
    function msNavIsFoldedDirective($document, $rootScope, msNavFoldService)
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement, iAttrs)
            {
                var isFolded = (iAttrs.msNavIsFolded === 'true'),
                    isFoldedOpen = false,
                    body = angular.element($document[0].body),
                    openOverlay = angular.element('<div id="ms-nav-fold-open-overlay"></div>'),
                    closeOverlay = angular.element('<div id="ms-nav-fold-close-overlay"></div>'),
                    sidenavEl = iElement.parent();

                // Initialize the service
                msNavFoldService.setFoldable(scope, iElement, isFolded);

                // Set the fold status for the first time
                if ( isFolded )
                {
                    fold();
                }
                else
                {
                    unfold();
                }

                /**
                 * Is nav folded open
                 */
                function isNavFoldedOpen()
                {
                    return isFoldedOpen;
                }

                /**
                 * Toggle fold
                 */
                function toggleFold()
                {
                    isFolded = !isFolded;

                    if ( isFolded )
                    {
                        fold();
                    }
                    else
                    {
                        unfold();
                    }
                }

                /**
                 * Fold the navigation
                 */
                function fold()
                {
                    // Add classes
                    body.addClass('ms-nav-folded');

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    // Append the openOverlay to the element
                    sidenavEl.append(openOverlay);

                    // Event listeners
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Open folded navigation
                 */
                function openFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    body.addClass('ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Remove open overlay
                    sidenavEl.find(openOverlay).remove();

                    // Append close overlay and bind its events
                    sidenavEl.parent().append(closeOverlay);
                    closeOverlay.on('mouseenter touchstart', function (event)
                    {
                        closeFolded(event);
                        isFoldedOpen = false;
                    });
                }

                /**
                 * Close folded navigation
                 */
                function closeFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    body.removeClass('ms-nav-folded-open');

                    // Remove close overlay
                    sidenavEl.parent().find(closeOverlay).remove();

                    // Append open overlay and bind its events
                    sidenavEl.append(openOverlay);
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Unfold the navigation
                 */
                function unfold()
                {
                    body.removeClass('ms-nav-folded ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    iElement.off('mouseenter mouseleave');
                }

                // Expose functions to the scope
                scope.toggleFold = toggleFold;
                scope.openFolded = openFolded;
                scope.closeFolded = closeFolded;
                scope.isNavFoldedOpen = isNavFoldedOpen;

                // Cleanup
                scope.$on('$destroy', function ()
                {
                    openOverlay.off('mouseenter touchstart');
                    closeOverlay.off('mouseenter touchstart');
                    iElement.off('mouseenter mouseleave');
                });
            }
        };
    }


    /** @ngInject */
    function MsNavController()
    {
        var vm = this,
            disabled = false,
            toggleItems = [],
            lockedItems = [];

        // Data

        // Methods
        vm.isDisabled = isDisabled;
        vm.enable = enable;
        vm.disable = disable;
        vm.setToggleItem = setToggleItem;
        vm.getLockedItems = getLockedItems;
        vm.setLockedItem = setLockedItem;
        vm.clearLockedItems = clearLockedItems;

        //////////

        /**
         * Is navigation disabled
         *
         * @returns {boolean}
         */
        function isDisabled()
        {
            return disabled;
        }

        /**
         * Disable the navigation
         */
        function disable()
        {
            disabled = true;
        }

        /**
         * Enable the navigation
         */
        function enable()
        {
            disabled = false;
        }

        /**
         * Set toggle item
         *
         * @param element
         * @param scope
         */
        function setToggleItem(element, scope)
        {
            toggleItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Get locked items
         *
         * @returns {Array}
         */
        function getLockedItems()
        {
            return lockedItems;
        }

        /**
         * Set locked item
         *
         * @param element
         * @param scope
         */
        function setLockedItem(element, scope)
        {
            lockedItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Clear locked items list
         */
        function clearLockedItems()
        {
            lockedItems = [];
        }
    }

    /** @ngInject */
    function msNavDirective($rootScope, $mdComponentRegistry, msNavFoldService)
    {
        return {
            restrict  : 'E',
            scope     : {},
            controller: 'MsNavController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-nav');

                return function postLink(scope)
                {
                    // Update toggle status according to the ui-router current state
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Update toggles on state changes
                    var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
                    {
                        $rootScope.$broadcast('msNav::expandMatchingToggles');

                        // Close navigation sidenav on stateChangeSuccess
                        $mdComponentRegistry.when('navigation').then(function (navigation)
                        {
                            navigation.close();

                            if ( msNavFoldService.isNavFoldedOpen() )
                            {
                                msNavFoldService.closeFolded();
                            }
                        });
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        stateChangeSuccessEvent();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavTitleDirective()
    {
        return {
            restrict: 'A',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-title');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavButtonDirective()
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-button');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavToggleDirective($rootScope, $q, $animate, $state)
    {
        return {
            restrict: 'A',
            require : '^msNav',
            scope   : true,
            compile : function (tElement, tAttrs)
            {
                tElement.addClass('ms-nav-toggle');

                // Add collapsed attr
                if ( angular.isUndefined(tAttrs.collapsed) )
                {
                    tAttrs.collapsed = true;
                }

                tElement.attr('collapsed', tAttrs.collapsed);

                return function postLink(scope, iElement, iAttrs, MsNavCtrl)
                {
                    var classes = {
                        expanded         : 'expanded',
                        expandAnimation  : 'expand-animation',
                        collapseAnimation: 'collapse-animation'
                    };

                    // Store all related states
                    var links = iElement.find('a');
                    var states = [];
                    var regExp = /\(.*\)/g;

                    angular.forEach(links, function (link)
                    {
                        var state = angular.element(link).attr('ui-sref');

                        if ( angular.isUndefined(state) )
                        {
                            return;
                        }

                        // Remove any parameter definition from the state name before storing it
                        state = state.replace(regExp, '');

                        states.push(state);
                    });

                    // Store toggle-able element and its scope in the main nav controller
                    MsNavCtrl.setToggleItem(iElement, scope);

                    // Click handler
                    iElement.children('.ms-nav-button').on('click', toggle);

                    // Toggle function
                    function toggle()
                    {
                        // If navigation is disabled, do nothing...
                        if ( MsNavCtrl.isDisabled() )
                        {
                            return;
                        }

                        // Disable the entire navigation to prevent spamming
                        MsNavCtrl.disable();

                        if ( isCollapsed() )
                        {
                            // Clear the locked items list
                            MsNavCtrl.clearLockedItems();

                            // Emit pushToLockedList event
                            scope.$emit('msNav::pushToLockedList');

                            // Collapse everything but locked items
                            $rootScope.$broadcast('msNav::collapse');

                            // Expand and then...
                            expand().then(function ()
                            {
                                // Enable the entire navigation after animations completed
                                MsNavCtrl.enable();
                            });
                        }
                        else
                        {
                            // Collapse with all children
                            scope.$broadcast('msNav::forceCollapse');
                        }
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.children('.ms-nav-button').off('click');
                    });

                    /*---------------------*/
                    /* Scope Events        */
                    /*---------------------*/

                    /**
                     * Collapse everything but locked items
                     */
                    scope.$on('msNav::collapse', function ()
                    {
                        // Only collapse toggles that are not locked
                        var lockedItems = MsNavCtrl.getLockedItems();
                        var locked = false;

                        angular.forEach(lockedItems, function (lockedItem)
                        {
                            if ( angular.equals(lockedItem.scope, scope) )
                            {
                                locked = true;
                            }
                        });

                        if ( locked )
                        {
                            return;
                        }

                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Collapse everything
                     */
                    scope.$on('msNav::forceCollapse', function ()
                    {
                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Expand toggles that match with the current states
                     */
                    scope.$on('msNav::expandMatchingToggles', function ()
                    {
                        var currentState = $state.current.name;
                        var shouldExpand = false;

                        angular.forEach(states, function (state)
                        {
                            if ( currentState === state )
                            {
                                shouldExpand = true;
                            }
                        });

                        if ( shouldExpand )
                        {
                            expand();
                        }
                        else
                        {
                            collapse();
                        }
                    });

                    /**
                     * Add toggle to the locked list
                     */
                    scope.$on('msNav::pushToLockedList', function ()
                    {
                        // Set expanded item on main nav controller
                        MsNavCtrl.setLockedItem(iElement, scope);
                    });

                    /*---------------------*/
                    /* Internal functions  */
                    /*---------------------*/

                    /**
                     * Is element collapsed
                     *
                     * @returns {bool}
                     */
                    function isCollapsed()
                    {
                        return iElement.attr('collapsed') === 'true';
                    }

                    /**
                     * Is element expanded
                     *
                     * @returns {bool}
                     */
                    function isExpanded()
                    {
                        return !isCollapsed();
                    }

                    /**
                     * Expand the toggle
                     *
                     * @returns $promise
                     */
                    function expand()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already expanded, do nothing..
                        if ( isExpanded() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', false);

                        // Grab the element to expand
                        var elementToExpand = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Move the element out of the dom flow and
                        // make it block so we can get its height
                        elementToExpand.css({
                            'position'  : 'absolute',
                            'visibility': 'hidden',
                            'display'   : 'block',
                            'height'    : 'auto'
                        });

                        // Grab the height
                        var height = elementToExpand[0].offsetHeight;

                        // Reset the style modifications
                        elementToExpand.css({
                            'position'  : '',
                            'visibility': '',
                            'display'   : '',
                            'height'    : ''
                        });

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToExpand,
                                {
                                    'display': 'block',
                                    'height' : '0px'
                                },
                                {
                                    'height': height + 'px'
                                },
                                classes.expandAnimation
                            ).then(
                                function ()
                                {
                                    // Add expanded class
                                    elementToExpand.addClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToExpand.css({'height': ''});

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }

                    /**
                     * Collapse the toggle
                     *
                     * @returns $promise
                     */
                    function collapse()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already collapsed, do nothing..
                        if ( isCollapsed() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', true);

                        // Grab the element to collapse
                        var elementToCollapse = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Grab the height
                        var height = elementToCollapse[0].offsetHeight;

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToCollapse,
                                {
                                    'height': height + 'px'
                                },
                                {
                                    'height': '0px'
                                },
                                classes.collapseAnimation
                            ).then(
                                function ()
                                {
                                    // Remove expanded class
                                    elementToCollapse.removeClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToCollapse.css({
                                        'display': '',
                                        'height' : ''
                                    });

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMaterialColorPickerController', msMaterialColorPickerController)
        .directive('msMaterialColorPicker', msMaterialColorPicker);

    /** @ngInject */
    function msMaterialColorPickerController($scope, $mdColorPalette, $mdMenu, fuseGenerator)
    {
        var vm = this;
        vm.palettes = $mdColorPalette; // Material Color Palette
        vm.selectedPalette = false;
        vm.selectedHues = false;
        $scope.$selectedColor = {};

        // Methods
        vm.activateHueSelection = activateHueSelection;
        vm.selectColor = selectColor;
        vm.removeColor = removeColor;

        /**
         * Initialize / Watch model changes
         */
        $scope.$watch('ngModel', setSelectedColor);

        /**
         * Activate Hue Selection
         * @param palette
         * @param hues
         */
        function activateHueSelection(palette, hues)
        {
            vm.selectedPalette = palette;
            vm.selectedHues = hues;
        }

        /**
         * Select Color
         * @type {selectColor}
         */
        function selectColor(palette, hue)
        {
            // Update Selected Color
            updateSelectedColor(palette, hue);

            // Update Model Value
            updateModel();

            // Hide The picker
            $mdMenu.hide();
        }

        function removeColor()
        {
            vm.selectedColor = {
                palette: '',
                hue    : '',
                class  : ''
            };

            activateHueSelection(false, false);

            updateModel();
        }

        /**
         * Set SelectedColor by model type
         */
        function setSelectedColor()
        {
            if ( !vm.modelCtrl.$viewValue || vm.modelCtrl.$viewValue === '' )
            {
                removeColor();
                return;
            }

            var palette, hue;

            // If ModelType Class
            if ( vm.msModelType === 'class' )
            {
                var color = vm.modelCtrl.$viewValue.split('-');
                if ( color.length >= 5 )
                {
                    palette = color[1] + '-' + color[2];
                    hue = color[3];
                }
                else
                {
                    palette = color[1];
                    hue = color[2];
                }
            }

            // If ModelType Object
            else if ( vm.msModelType === 'obj' )
            {
                palette = vm.modelCtrl.$viewValue.palette;
                hue = vm.modelCtrl.$viewValue.hue || 500;
            }

            // Update Selected Color
            updateSelectedColor(palette, hue);
        }

        /**
         * Update Selected Color
         * @param palette
         * @param hue
         */
        function updateSelectedColor(palette, hue)
        {
            vm.selectedColor = {
                palette     : palette,
                hue         : hue,
                class       : 'md-' + palette + '-' + hue + '-bg',
                bgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].value),
                fgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].contrast)
            };

            // If Model object not Equals the selectedColor update it
            // it can be happen when the model only have pallete and hue values
            if ( vm.msModelType === 'obj' && !angular.equals(vm.selectedColor, vm.modelCtrl.$viewValue) )
            {
                // Update Model Value
                updateModel();
            }

            activateHueSelection(palette, vm.palettes[palette]);

            $scope.$selectedColor = vm.selectedColor;
        }

        /**
         * Update Model Value by model type
         */
        function updateModel()
        {
            if ( vm.msModelType === 'class' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor.class);
            }
            else if ( vm.msModelType === 'obj' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor);
            }
        }
    }

    /** @ngInject */
    function msMaterialColorPicker()
    {
        return {
            require    : ['msMaterialColorPicker', 'ngModel'],
            restrict   : 'E',
            scope      : {
                ngModel    : '=',
                msModelType: '@?'
            },
            controller : 'msMaterialColorPickerController as vm',
            transclude : true,
            templateUrl: 'app/core/directives/ms-material-color-picker/ms-material-color-picker.html',
            link       : function (scope, element, attrs, controllers, transclude)
            {
                var ctrl = controllers[0];

                /**
                 *  Pass model controller to directive controller
                 */
                ctrl.modelCtrl = controllers[1];

                /**
                 * ModelType: 'obj', 'class'(default)
                 * @type {string|string}
                 */
                ctrl.msModelType = scope.msModelType || 'class';

                transclude(scope, function (clone)
                {
                    clone = clone.filter(function (i, el)
                    {
                        return ( el.nodeType === 1 ) ? true : false;
                    });

                    if ( clone.length )
                    {
                        element.find('ms-color-picker-button').replaceWith(clone);
                    }
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMasonryController', msMasonryController)
        .directive('msMasonry', msMasonry)
        .directive('msMasonryItem', msMasonryItem);

    /** @ngInject */
    function msMasonryController($scope, $window, $mdMedia, $timeout)
    {
        var vm = this,
            defaultOpts = {
                columnCount     : 5,
                respectItemOrder: false,
                reLayoutDebounce: 400,
                responsive      : {
                    md: 3,
                    sm: 2,
                    xs: 1
                }
            },
            reLayoutTimeout = true;

        vm.options = null;
        vm.container = [];
        vm.containerPos = '';
        vm.columnWidth = '';
        vm.items = [];

        // Methods
        vm.reLayout = reLayout;
        vm.initialize = initialize;
        vm.waitImagesLoaded = waitImagesLoaded;

        function initialize()
        {
            vm.options = !vm.options ? defaultOpts : angular.extend(defaultOpts, vm.options);


            watchContainerResize();
        }

        $scope.$on('msMasonry:relayout', function ()
        {
            reLayout();
        });

        function waitImagesLoaded(element, callback)
        {
            if ( typeof imagesLoaded !== 'undefined' )
            {
                var imgLoad = $window.imagesLoaded(element);

                imgLoad.on('done', function ()
                {
                    callback();
                });
            }
            else
            {
                callback();
            }
        }

        function watchContainerResize()
        {
            $scope.$watch(
                function ()
                {
                    return vm.container.width();
                },
                function (newValue, oldValue)
                {
                    if ( newValue !== oldValue )
                    {
                        reLayout();
                    }
                }
            );
        }

        function reLayout()
        {
            // Debounce for relayout
            if ( reLayoutTimeout )
            {
                $timeout.cancel(reLayoutTimeout);
            }

            reLayoutTimeout = $timeout(function ()
            {
                start();

                $scope.$broadcast('msMasonry:relayoutFinished');

            }, vm.options.reLayoutDebounce);

            // Start relayout
            function start()
            {
                vm.containerPos = vm.container[0].getBoundingClientRect();

                updateColumnOptions();

                $scope.$broadcast('msMasonry:relayoutStarted');

                vm.items = vm.container.find('ms-masonry-item');

                //initialize lastRowBottomArr
                var referenceArr = Array.apply(null, new Array(vm.columnCount)).map(function ()
                {
                    return 0;
                });

                // set item positions
                for ( var i = 0; i < vm.items.length; i++ )
                {
                    var item = vm.items[i],
                        xPos, yPos, column, refTop;

                    item = angular.element(item);

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:startReLayout');
                    }

                    item.css({'width': vm.columnWidth});

                    if ( vm.options.respectItemOrder )
                    {
                        column = i % vm.columnCount;
                        refTop = referenceArr[column];
                    }
                    else
                    {
                        refTop = Math.min.apply(Math, referenceArr);
                        column = referenceArr.indexOf(refTop);
                    }

                    referenceArr[column] = refTop + item[0].getBoundingClientRect().height;

                    xPos = Math.round(column * vm.columnWidth);
                    yPos = refTop;

                    item.css({'transform': 'translate3d(' + xPos + 'px,' + yPos + 'px,0px)'});
                    item.addClass('placed');

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:finishReLayout');
                    }
                }
            }
        }

        function updateColumnOptions()
        {
            vm.columnCount = vm.options.columnCount;

            if ( $mdMedia('gt-md') )
            {
                vm.columnCount = vm.options.columnCount;
            }
            else if ( $mdMedia('md') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.md ? vm.options.responsive.md : vm.columnCount);
            }
            else if ( $mdMedia('sm') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.sm ? vm.options.responsive.sm : vm.columnCount);
            }
            else
            {
                vm.columnCount = vm.options.responsive.xs;
            }

            vm.columnWidth = vm.containerPos.width / vm.columnCount;

        }
    }

    /** @ngInject */
    function msMasonry($timeout)
    {
        return {
            restrict  : 'AEC',
            controller: 'msMasonryController',
            compile   : compile
        };
        function compile(element, attributes)
        {
            return {
                pre : function preLink(scope, iElement, iAttrs, controller)
                {
                    controller.options = angular.fromJson(attributes.options || '{}');
                    controller.container = element;
                },
                post: function postLink(scope, iElement, iAttrs, controller)
                {
                    $timeout(function ()
                    {
                        controller.initialize();
                    });
                }
            };
        }
    }

    /** @ngInject */
    function msMasonryItem()
    {
        return {
            restrict: 'AEC',
            require : '^msMasonry',
            priority: 1,
            link    : link
        };

        function link(scope, element, attributes, controller)
        {
            controller.waitImagesLoaded(element, function ()
            {
                controller.reLayout();

            });

            scope.$on('msMasonryItem:finishReLayout', function ()
            {
                scope.$watch(function ()
                {
                    return element.height();
                }, function (newVal, oldVal)
                {
                    if ( newVal !== oldVal )
                    {
                        controller.reLayout();
                    }
                });
            });

            element.on('$destroy', function ()
            {
                controller.reLayout();
            });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msInfoBar', msInfoBarDirective);

    /** @ngInject */
    function msInfoBarDirective($document)
    {
        return {
            restrict   : 'E',
            scope      : {},
            transclude : true,
            templateUrl: 'app/core/directives/ms-info-bar/ms-info-bar.html',
            link       : function (scope, iElement)
            {
                var body = $document.find('body'),
                    bodyClass = 'ms-info-bar-active';

                // Add body class
                body.addClass(bodyClass);

                /**
                 * Remove the info bar
                 */
                function removeInfoBar()
                {
                    body.removeClass(bodyClass);
                    iElement.remove();
                    scope.$destroy();
                }

                // Expose functions
                scope.removeInfoBar = removeInfoBar;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsFormWizardController', MsFormWizardController)
        .directive('msFormWizard', msFormWizardDirective)
        .directive('msFormWizardForm', msFormWizardFormDirective);

    /** @ngInject */
    function MsFormWizardController()
    {
        var vm = this;

        // Data
        vm.forms = [];
        vm.selectedIndex = 0;

        // Methods
        vm.registerForm = registerForm;

        vm.previousStep = previousStep;
        vm.nextStep = nextStep;
        vm.firstStep = firstStep;
        vm.lastStep = lastStep;

        vm.totalSteps = totalSteps;
        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.currentStepInvalid = currentStepInvalid;
        vm.previousStepInvalid = previousStepInvalid;
        vm.formsIncomplete = formsIncomplete;
        vm.resetForm = resetForm;

        //////////

        /**
         * Register form
         *
         * @param form
         */
        function registerForm(form)
        {
            vm.forms.push(form);
        }

        /**
         * Go to previous step
         */
        function previousStep()
        {
            if ( isFirstStep() )
            {
                return;
            }

            vm.selectedIndex--;
        }

        /**
         * Go to next step
         */
        function nextStep()
        {
            if ( isLastStep() )
            {
                return;
            }

            vm.selectedIndex++;
        }

        /**
         * Go to first step
         */
        function firstStep()
        {
            vm.selectedIndex = 0;
        }

        /**
         * Go to last step
         */
        function lastStep()
        {
            vm.selectedIndex = totalSteps() - 1;
        }

        /**
         * Return total steps
         *
         * @returns {int}
         */
        function totalSteps()
        {
            return vm.forms.length;
        }

        /**
         * Is first step?
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.selectedIndex === 0;
        }

        /**
         * Is last step?
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.selectedIndex === totalSteps() - 1;
        }

        /**
         * Is current step invalid?
         *
         * @returns {boolean}
         */
        function currentStepInvalid()
        {
            return angular.isDefined(vm.forms[vm.selectedIndex]) && vm.forms[vm.selectedIndex].$invalid;
        }

        /**
         * Is previous step invalid?
         *
         * @returns {boolean}
         */
        function previousStepInvalid()
        {
            return vm.selectedIndex > 0 && angular.isDefined(vm.forms[vm.selectedIndex - 1]) && vm.forms[vm.selectedIndex - 1].$invalid;
        }

        /**
         * Check if there is any incomplete forms
         *
         * @returns {boolean}
         */
        function formsIncomplete()
        {
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                if ( vm.forms[x].$invalid )
                {
                    return true;
                }
            }

            return false;
        }

        /**
         * Reset form
         */
        function resetForm()
        {
            // Go back to the first step
            vm.selectedIndex = 0;

            // Make sure all the forms are back in the $pristine & $untouched status
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                vm.forms[x].$setPristine();
                vm.forms[x].$setUntouched();
            }
        }
    }

    /** @ngInject */
    function msFormWizardDirective()
    {
        return {
            restrict  : 'E',
            scope     : true,
            controller: 'MsFormWizardController as msWizard',
            compile   : function (tElement)
            {
                tElement.addClass('ms-form-wizard');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msFormWizardFormDirective()
    {
        return {
            restrict: 'A',
            require : ['form', '^msFormWizard'],
            compile : function (tElement)
            {
                tElement.addClass('ms-form-wizard-form');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var formCtrl = ctrls[0],
                        MsFormWizardCtrl = ctrls[1];

                    MsFormWizardCtrl.registerForm(formCtrl);
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msCard', msCardDirective);

    /** @ngInject */
    function msCardDirective()
    {
        return {
            restrict: 'E',
            scope   : {
                templatePath: '=template',
                card        : '=ngModel',
                vm          : '=viewModel'
            },
            template: '<div class="ms-card-content-wrapper" ng-include="templatePath" onload="cardTemplateLoaded()"></div>',
            compile : function (tElement)
            {
                // Add class
                tElement.addClass('ms-card');

                return function postLink(scope, iElement)
                {
                    // Methods
                    scope.cardTemplateLoaded = cardTemplateLoaded;

                    //////////

                    /**
                     * Emit cardTemplateLoaded event
                     */
                    function cardTemplateLoaded()
                    {
                        scope.$emit('msCard::cardTemplateLoaded', iElement);
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msDatepickerFixConfig', msDatepickerFixConfigProvider)
        .directive('msDatepickerFix', msDatepickerFix);

    /** @ngInject */
    function msDatepickerFixConfigProvider()
    {
        var service = this;

        // Default configuration
        var defaultConfig = {
            // To view
            formatter: function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return val === '' ? val : new Date(val);
            },
            // To model
            parser   : function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return moment(val).add(moment(val).utcOffset(), 'm').toDate();
            }
        };

        // Methods
        service.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfig = angular.extend({}, defaultConfig, configuration);
        }

        /**
         * Service
         */
        service.$get = function ()
        {
            return defaultConfig;
        };
    }

    /** @ngInject */
    function msDatepickerFix(msDatepickerFixConfig)
    {
        return {
            require : 'ngModel',
            priority: 1,
            link    : function (scope, elem, attrs, ngModel)
            {
                ngModel.$formatters.push(msDatepickerFixConfig.formatter); // to view
                ngModel.$parsers.push(msDatepickerFixConfig.parser); // to model
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.overview', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.overview', {
            url      : '/overview',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/overview/overview.html',
                    controller : 'OverviewController as vm'
                }
            },
            bodyClass: 'login'
        });
        // Navigation
      /*  msNavigationServiceProvider.saveItem('appmanage', {
            title : 'App Management',
            group : true,
            weight: 3
        }); */

        msNavigationServiceProvider.saveItem('overview', {
            title : 'Overview',
            icon  : 'icon-document',
            state : 'app.overview',
            weight: 1
        });
    }

})();

(function () {
    'use strict';

    angular
        .module('app.overview')
        .controller('OverviewController', OverviewController);
    /** @ngInject */

    function OverviewController($scope, api, msToasts, $state, $cookies, share) {
        var stateData = new Array();


        //var stateData = new Array();
        var username = $cookies.get('username');
        if (username) {
            var vm = this;
            vm.apps = {};

            function dateRange(month, year) {
                var date = new Date(), y = date.getFullYear(), m = date.getMonth();
                if (month == m && year == y) {
                    var lastDay = new Date(y, m + 1, 0);
                }
                else {
                    var lastDay = new Date(year, Number(month) + 1, 0);
                }
                var firstDay = new Date(year, month, 1);
                var start_date = new Date(firstDay.getTime() - (firstDay.getTimezoneOffset() * 60000)).toISOString().slice(0, 10);
                var end_date = new Date(lastDay.getTime() - (lastDay.getTimezoneOffset() * 60000)).toISOString().slice(0, 10);
                var monthNames = ["January", "February", "March", "April", "May", "June", "July",
                    "August", "September", "October", "November", "December"];
                var today = new Date();
                var dd = today.getDate();
                var mm = monthNames[today.getMonth()]; //January is 0!
                var yyyy = today.getFullYear();
                var data = {
                    "start_date": start_date,
                    "end_date": end_date
                };
                //console.log(data);
                return data;
            }

            $scope.exportData = function () {
                var uri = 'data:application/vnd.ms-excel;base64,'
                    ,
                    template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>'
                    , base64 = function (s) {
                        return window.btoa(unescape(encodeURIComponent(s)))
                    }
                    , format = function (s, c) {
                        return s.replace(/{(\w+)}/g, function (m, p) {
                            return c[p];
                        })
                    }

                var table = document.getElementById("exportable");
                var filters = $('.ng-table-filters').remove();
                var ctx = {worksheet: name || 'Worksheet', table: table.innerHTML};
                $('.ng-table-sort-header').after(filters);
                var url = uri + base64(format(template, ctx));
                var a = document.createElement('a');
                a.href = url;
                a.download = 'Overview.xls';
                a.click();
            };

            // Initial Loading Data with current Month and Year
            var date = new Date();
            var m = date.getMonth();
            var y = date.getFullYear();
            var yearJson = {};
            yearJson[y] = y;
            yearJson[y - 1] = y - 1;
            //  yearJson[y-2]=y-2;
            //yearJson[y-3]=y-3;
            //var yearJson = {x:"This Year",2016:"2016", 2015:"2015",2014:"2014"};
            var data = dateRange(m, y);
            //  console.log(data);
            //vm.stateData.loaded = false;
            reloadWidgets(data);
            //vm.stateData.loaded = true;

            vm.DateFilter = {
                months: {
                    0: "January", 1: "February", 2: "March", 3: "April", 4: "May", 5: "June",
                    6: "July", 7: "August", 8: "September", 9: "October", 10: "November", 11: "December"
                },
                currentRange: m,

                loadData: function (rangeIdToLoad) {
                    vm.DateFilter.currentRange = rangeIdToLoad;
                    //console.log("mon......"+vm.DateFilter.currentRange);
                    //  console.log("End Result......."+dateRange(rangeIdToLoad,vm.yearFilter.currentRange));
                    var data = dateRange(rangeIdToLoad, vm.yearFilter.currentRange);
                    //  console.log(data);
                    //vm.stateData.loaded = false;
                    reloadWidgets(data);
                    //vm.stateData.loaded = true;
                }
            };


            vm.yearFilter = {
                years: yearJson,
                // TO GET Current Year's Details
                currentRange: y,
            };


            function reloadWidgets(data) {
                stateData.length = 0;

                api.GetSummarry_nrror.action(data,
                    function (res) {
                        res['result']['summary']['serverstatus'] = "LIVE";
                        res['result']['summary']['state'] = "nrror";
                        // var stateResult= {"nrrka":res.result.summary};

                        stateData.splice(0, 0, res.result.summary);
                        //stateData.push(res.result.summary);
                        // console.log("..........."+JSON.stringify(stateData[0]['nrrka']['serverstatus']));

                    },
                    function (res) {
                        // console.log(res.data);
                    }
                );

                api.GetSummarry_nrrne.action(data,
                    function (res) {
                        res['result']['summary']['serverstatus'] = "LIVE";
                        res['result']['summary']['state'] = "nrrne";
                        // var stateResult= {"nrrka":res.result.summary};

                        stateData.splice(0, 0, res.result.summary);
                        //stateData.push(res.result.summary);
                        // console.log("..........."+JSON.stringify(stateData[0]['nrrka']['serverstatus']));

                    },
                    function (res) {
                        // console.log(res.data);
                    }
                );


                api.GetSummarry_nrrka.action(data,
                    function (res) {
                        res['result']['summary']['serverstatus'] = "LIVE";
                        res['result']['summary']['state'] = "nrrka";
                        // var stateResult= {"nrrka":res.result.summary};

                        stateData.splice(0, 0, res.result.summary);
                        //stateData.push(res.result.summary);
                        // console.log("..........."+JSON.stringify(stateData[0]['nrrka']['serverstatus']));

                    },
                    function (res) {
                        // console.log(res.data);
                    }
                );


                api.GetSummarry_nrrtn.action(data,

                    function (res) {
                        res['result']['summary']['serverstatus'] = "LIVE";
                        res['result']['summary']['state'] = "nrrtn";
                        // var stateResult= {"nrrtn":res.result.summary};
                        // stateData.splice(1,0,stateResult);
                        //stateData.push(stateResult);
                        stateData.push(res.result.summary);
                        // console.log(res.result.summary);
                        //console.log(data);
                    },
                    function (res) {
                        res['result']['summary']['serverstatus'] = "OFFLINE";
                        res['result']['summary']['state'] = "nrrtn";
                        // console.log(res.data);
                    }
                );

                api.GetSummarry_nrrap.action(data,
                    function (res) {
                        res['result']['summary']['serverstatus'] = "LIVE";
                        res['result']['summary']['state'] = "nrrap";
                        //    var stateResult= {"nrrap":res.result.summary};
                        //stateData.splice(2,0,stateResult);
                        stateData.push(res.result.summary);
                        //stateData.push(stateResult);
                        // console.log(stateData);

                    },
                    function (res) {
                        // console.log(res.data);
                    }
                );

                api.GetSummarry_nrrmh.action(data,
                    function (res) {
                        res['result']['summary']['serverstatus'] = "LIVE";
                        res['result']['summary']['state'] = "nrrmh";
                        //  var stateResult= {"nrrmh":res.result.summary};
                        //  stateData.splice(3,0,stateResult);
                        stateData.push(res.result.summary);
                        //stateData.push(stateResult);
                        // console.log(stateData);

                    },
                    function (res) {
                        // console.log(res.data);
                    }
                );
                //
                api.GetSummarry_nrrmb.action(data,
                    function (res) {
                        res['result']['summary']['serverstatus'] = "LIVE";
                        res['result']['summary']['state'] = "nrrmb";
                        stateData.push(res.result.summary);

                        //  var stateResult= {"nrrmb":res.result.summary};
                        //stateData.splice(4,0,stateResult);
                        //stateData.push(stateResult);
                        // console.log(stateData);

                    },
                    function (res) {
                        // console.log(res.data);
                    }
                );

                api.GetSummarry_nrrgj.action(data,
                    function (res) {
                        res['result']['summary']['serverstatus'] = "LIVE";
                        res['result']['summary']['state'] = "nrrgj";
                        //var stateResult= {"nrrgj":res.result.summary};
                        //  stateData.splice(5,0,stateResult);
                        stateData.push(res.result.summary);

                        //  stateData.push(stateResult);
                        // console.log(stateData);

                    },
                    function (res) {
                        // console.log(res.data);
                    }
                );

                api.GetSummarry_nrrwb.action(data,
                    function (res) {
                        res['result']['summary']['serverstatus'] = "LIVE";
                        res['result']['summary']['state'] = "nrrwb";
                        stateData.push(res.result.summary);
                        //var stateResult= {"nrrkol":res.result.summary};
                        //stateData.splice(6,0,stateResult);
                        //stateData.push(stateResult);
                        // console.log(stateData);

                    },
                    function (res) {
                        // console.log(res.data);
                    }
                );

                api.GetSummarry_nrrdl.action(data,
                    function (res) {
                        res['result']['summary']['serverstatus'] = "LIVE";
                        res['result']['summary']['state'] = "nrrdl";
                        //  var stateResult= {"nrrdl":res.result.summary};
                        //stateData.splice(7,0,stateResult);
                        stateData.push(res.result.summary);
                        //stateData.push(stateResult);
                        // console.log(stateData);
                        //    stateData.push(res.result.summary);

                    },
                    function (res) {
                        // console.log(res.data);
                    }
                );

                api.GetSummarry_nrrkl.action(data,
                    function (res) {
                        res['result']['summary']['serverstatus'] = "LIVE";
                        res['result']['summary']['state'] = "nrrkl";
                        //  var stateResult= {"nrrkl":res.result.summary};
                        //  stateData.splice(8,0,stateResult);
                        stateData.push(res.result.summary);
                        //stateData.push(stateResult);
                        // console.log(stateData);

                    },
                    function (res) {
                        // console.log(res.data);
                    }
                );

                api.GetSummarry_nrrbr.action(data,
                    function (res) {
                        res['result']['summary']['serverstatus'] = "LIVE";
                        res['result']['summary']['state'] = "nrrbr";

                        stateData.push(res.result.summary);
                        //stateData.splice(10,0,stateResult);
                        //stateData.push(stateResult);
                        // console.log(stateData);

                    },
                    function (res) {
                        // console.log(res.data);

                    }
                );

                api.GetSummarry_nrrup.action(data,
                    function (res) {
                        res['result']['summary']['serverstatus'] = "LIVE";
                        res['result']['summary']['state'] = "nrrup";
                        // var stateResult= {"nrrup":res.result.summary};
                        stateData.push(res.result.summary);
                        //stateData.splice(9,0,stateResult);
                        //stateData.push(stateResult);
                        // console.log(stateData);

                    },
                    function (res) {
                        // console.log(res.data);
                    }
                );

                api.GetSummarry_nrrrj.action(data,
                    function (res) {
                        res['result']['summary']['serverstatus'] = "LIVE";
                        res['result']['summary']['state'] = "nrrrj";
                        // var stateResult= {"nrrup":res.result.summary};
                        stateData.push(res.result.summary);
                        //stateData.splice(9,0,stateResult);
                        //stateData.push(stateResult);
                        // console.log(stateData);

                    },
                    function (res) {
                        // console.log(res.data);
                    }
                );

                api.GetSummarry_nrrpb.action(data,
                    function (res) {
                        res['result']['summary']['serverstatus'] = "LIVE";
                        res['result']['summary']['state'] = "nrrpb";
                        // var stateResult= {"nrrup":res.result.summary};
                        stateData.push(res.result.summary);
                        //stateData.splice(9,0,stateResult);
                        //stateData.push(stateResult);
                        // console.log(stateData);

                    },
                    function (res) {
                        // console.log(res.data);
                    }
                );

                api.GetSummarry_nrrmp.action(data,
                    function (res) {
                        res['result']['summary']['serverstatus'] = "LIVE";
                        res['result']['summary']['state'] = "nrrmp";
                        // var stateResult= {"nrrup":res.result.summary};
                        stateData.push(res.result.summary);
                        //stateData.splice(9,0,stateResult);
                        //stateData.push(stateResult);
                        // console.log(stateData);

                    },
                    function (res) {
                        // console.log(res.data);
                    }
                );


                //  angular.forEach(stateList,function(stateId){
                //           //console.log(stateId['key']);
                //         //  var apiString = 'api.GetSummarry_'+ stateId['key'] +'.action';
                //


                // });
                //var vm.stateData.loaded = false;
                setTimeout(function () {
                    JSON.stringify(stateData)
                }, 1000);
                //    var vm.stateData1 = JSON.stringify(stateData);
                vm.stateData = stateData;
                vm.stateData.loaded = false;
                vm.stateData.date = data;
                vm.stateData.loaded = true;
                //vm.stateData.sample = true;

                vm.StateDetails = function (ev, emp) {
                    var goState = 'app.dashboard.dashboard-' + emp;
                    $state.go(goState, {data: emp})
                }

            }
        }


        else {
            //console.log("Logout....");
            $state.go('app.login');
        }

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.login', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.login', {
            url      : '/login',
            views    : {
                'main@'                       : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.login': {
                    templateUrl: 'app/main/login/login.html',
                    controller : 'LoginController as vm'
                }
            },
            bodyClass: 'login'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/login');

        // Navigation

        /*msNavigationServiceProvider.saveItem('pages.auth.login', {
            title : 'Login',
            state : 'app.pages_auth_login',
            weight: 1
        });*/
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.login')
        .controller('LoginController', LoginController);

    /** @ngInject */
    function LoginController(api, msToasts, $state, $cookies)
    {
	var username = $cookies.get('username');
	//console.log(username);
	if(username)
	{
	//window.location.href = "/devices";
	$state.go('app.devices');
	}
        else
	{
		var vm = this;
        // Data
        $cookies.remove('Username');
        $cookies.remove('Role');
        $cookies.remove('token');
        // Methods
        vm.FirstForm = function(){
          api.login.save(vm.form,
            function(res){
		if(res.statuscode == '200')
		{
			$cookies.put('token',res.data.token);
			$cookies.put('username',res.data.username);
            		msToasts.showToastMsg('Logged In Successfully');
			//$state.go('app.devices');
              		window.location.href = "/overview";
		}
		else
		{
			msToasts.showToastMsg('Wrong Credentials. Please Try again.');
              		console.error(res);
		}

            },
            function(res) {
		 msToasts.showToastMsg('Wrong Credentials. Please Try again.');
              console.error(res);
            }
          );
        }

	// Register

	vm.Register = function(){
	var userjson = {
      	"firstName": "nrr",
      	"emailId": "santosh@appslab.in",
      	"username": "admin",
      	"password": "nrr@admin"
    	}

	 api.registerUser.register(userjson,
            function(res) {
		if(res.statuscode == '200')
		{
			msToasts.showToastMsg('Account Created Successfully');
		}
		else
		{
			msToasts.showToastMsg('Could not create account');
		}
              //$state.go('app.devices');
              //window.location.href = "/pages/profile";
		//vm.UserEdit = false;
             // console.log(res);
            },
            function(res) {
             // console.log(res);
            }
          );

        }
        //////////
	}


    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.devices', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.devices', {
            url      : '/devices',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/devices/devices.html',
                    controller : 'DevicesController as vm'
                }
            },
            bodyClass: 'login'
        });

        // Navigation
       /* msNavigationServiceProvider.saveItem('devices', {
            title : 'Devices',
            group : false,
            weight: 1
        });*/

        msNavigationServiceProvider.saveItem('devices', {
            title : 'Devices',
            icon  : 'icon-cellphone-android',
            state : 'app.devices',
            weight: 3
        });
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.devices')
        .controller('DevicesController', DevicesController);

    /** @ngInject */
    function DevicesController($scope,api, msToasts, $state, share,$cookies)
    {

	var username = $cookies.get('username');
	if(username)
	{
		var vm = this;
    var gridcolumns;
        	vm.devices = [];
       	 // Data
        vm.dtOptions = {
          dom       : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
          pagingType: 'simple',
          autoWidth : false,
          responsive: true,
          order     : [0,'desc'],
          columnDefs: [
              {
                 // width  : '40%',
                  targets: '_all'
              },
              {
                  orderable : true,
                //  type   : 'date-euro',
                  targets: [4]
              }
          ]
      };

      var devicecolumns = [
                      {headerName: "Emp Id", field: "employeeid", sort: 'dsc',width: 150, suppressSizeToFit: true},
                      {headerName: "Mobile Number", field: "mobilenumber",width: 150, minWidth: 50, maxWidth: 100},
                      {headerName: "IMEI", field: "deviceid",width: 160},
                      {headerName: "Created Date", field: "created",width: 150},
                      //{headerName: "Model", field: "modelid",width: 110},
                      {headerName: "App Version", field: "app_version_code",width: 150},
                      {headerName: "Version Name", field: "app_version_name",width: 150},
                      {headerName: "Status", field: "devicestatus",width: 120,valueParser: numberParser,
                      cellClassRules: {
                        'rag-green-outer': function(params) { return params.value === 'ACTIVE'},
                        'rag-amber-outer': function(params) { return params.value === 'LOST'},
                      },
                    },
                  ];



	vm.deviceList = false;
        // Methods
        var rowDataNew = [];
        vm.gridOptions = {
                columnDefs: gridcolumns,
                rowData: [],
                enableColResize: true,
                pagination: true,
                enableSorting: true,
                //enableColResize: true,
                //cellClicked:cellClicked,
                rowSelection: 'single',
                onRowSelected : DeviceDetails,
            };

            vm.searchGrid = function(){
                vm.gridOptions.api.setQuickFilter(vm.searchaggrid);
            }

            function numberParser(params) {
              var newValue = params.newValue;
              var valueAsNumber;
              if (newValue === null || newValue === undefined || newValue === '') {
                valueAsNumber = null;
              } else {
                valueAsNumber = parseFloat(params.newValue);
              }
              return valueAsNumber;
            }

            //function to redirect Device Details Page
            function DeviceDetails(ev) {
              console.log(ev.node.data);
              $state.go('app.device_details',{data : ev.node.data})
            }

            api.getdevices.get(
              function(res){
                //Uncomment this code when json format is changed
                //if(res.statuscode == '200'){
                //console.log(res.data);
                if(res.statuscode == '200')
                {
                  var dv = res.data;
                  dv.forEach(function(i) {
                    //console.log(i);
                    var ldate = new Date(i.created);
                    var year = ldate.getFullYear();
                    var month = ldate.getMonth()+1;
                    var dt = ldate.getDate();
                    var hr = ldate.getHours();
                    var min = ldate.getMinutes();
                    var sec = ldate.getSeconds();

                    if (dt < 10) {
                      dt = '0' + dt;
                    }
                    if (month < 10) {
                      month = '0' + month;
                    }
                    if (hr < 10) {
                      hr = '0' + hr;
                    }
                    if (min < 10) {
                      min = '0' + min;
                    }
                    if (sec < 10) {
                      sec = '0' + sec;
                    }

                    i.created = year+'-' + month + '-'+dt+' '+hr+':'+min+':'+sec;
                  });

              }
              vm.devices.data = res.data;
            //  var rowDataNew = [];  // ag-grid row data
              var i = 0;
              vm.devices.loaded = true;
              var j = 0;
              var data_array=[];
                // ag-grid row data
              gridcolumns = devicecolumns;
              for (var key in vm.devices.data) {
                if (vm.devices.data.hasOwnProperty(key)) {
                  rowDataNew.push({
                    'employeeid': vm.devices.data[key].employeeid,
                    'mobilenumber': vm.devices.data[key].mobilenumber,
                    'deviceid': vm.devices.data[key].deviceid,
                    'created': vm.devices.data[key].created,
                    //'modelid': vm.devices.data[key].modelid,
                    'app_version_code': vm.devices.data[key].app_version_code,
                    'app_version_name': vm.devices.data[key].app_version_name,
                    'devicestatus': vm.devices.data[key].devicestatus
                  });
                  i++ ;
                }
              }
              vm.gridOptions.rowData = rowDataNew;
              vm.gridOptions.columnDefs = gridcolumns;
              share.addDevice(res.data);
              vm.deviceList = true;
            },
            function(err) {
              console.log(err);
            }
          );

          vm.Approve = function(ev,emp){
          $state.go('app.device_manage',{data : emp})
        }

	//  vm.DeviceDetails = function(ev,emp){
  //         alert("jjjjj");
  //         $state.go('app.device_details',{data : emp})
  //       }
	}
	else
	{
	//console.log("Logout....");
	 $state.go('app.login');
	}

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.devicemanage', [
          // 3rd Party Dependencies
                'uiGmapgoogle-maps'
        ])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.device_manage', {
            url      : '/devicemanage',
            params   : {
              data: null
            },
            views    : {
                'content@app': {
                    templateUrl: 'app/main/devicemanagement/devicemanagement.html',
                    controller : 'DevicesmanageController as vm'
                }
            },
            bodyClass: 'login'
        });

        // Navigation

       // msNavigationServiceProvider.saveItem('devices.devicemanage', {
      //      title : 'Device Management',
      //      state : 'app.device_manage',
       //     weight: 2
       // });
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.devicemanage')
        .controller('DevicesmanageController', DevicesmanageController);

    /** @ngInject */
    function DevicesmanageController(api, msToasts, $state,$location, uiGmapGoogleMapApi)
    {

	var username = $cookies.get('username');
	if(username)
	{
		var vm = this;
        // Data
        vm.requestForm ={};
        vm.deviceData = $state.params.data;

        if($state.params.data != null){
          vm.requestForm.deviceid = vm.deviceData.deviceid;
        }
        else {
          msToasts.showToastMsg("Please Select Device from Devices Page");
        }

        //////////
        uiGmapGoogleMapApi.then(function (maps)
        {
            vm.simpleMarkerMap = {
                center: {
                    latitude : -25.363882,
                    longitude: 131.044922
                },
                zoom  : 8,
                marker: {
                    id    : 0,
                    coords: {
                        latitude : -25.363882,
                        longitude: 131.044922
                    }
                }
            };
        });

        vm.notification = function(){
          vm.requestForm;
          var notification = {};
          notification.fcm_token = vm.deviceData.fcm_token;
          notification.notifyText = vm.requestForm.message;
          notification.fcmtype = 'FCM';
          console.log(notification);
          var socket = io('http://35.154.46.104:8087', {'forceNew': true});
          socket.on('connect', function(){
          socket.emit('push_notification', notification);
            console.log("Notification.......notify");
            msToasts.showToastMsg("Notification Sent Successfully");
          });
          socket.on('disconnect', function(){
            console.log("Disconnected");
          });

        }

        vm.DeviceLost = function(){
          
        }
	}

	else
	{
	//console.log("Logout....");
	 $state.go('app.login');
	}
        
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.createapp', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.create_app', {
            url      : '/createapp',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/createapp/createapp.html',
                    controller : 'CreateappController as vm'
                }
            },
            bodyClass: 'login'
        });

        // Navigation
        /*msNavigationServiceProvider.saveItem('createapp', {
            title : 'App Management',
            group : true,
            weight: 3
        });

        msNavigationServiceProvider.saveItem('createapp.d', {
            title : 'Apps',
            icon  : 'icon-cellphone-android',
            state : 'app.create_app',
            weight: 1
        });*/
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.createapp')
        .controller('CreateappController', CreateappController);

    /** @ngInject */
    function CreateappController(api, $rootScope, msNavigationService, $cookies, $state, msToasts)
    {

	var username = $cookies.get('username');
	if(username)
	{
		$rootScope.opts = [
    {  status: 'Allowed' },
    {  status: 'Blocked' }
  ];
	
        var vm = this;
        vm.GeneralEdit = false;
        vm.ControlEdit = false;
        vm.CreateAppForm = {};
	
        vm.ControlForm = {};
        vm.about={};
        vm.key = "";
        $rootScope.loadingProgress = true;

	vm.createapp = function(data){
	vm.PasswordEdit = false;
	console.log(data);
          api.createapp.create(data,
            function(res) {
		msToasts.showToastMsg('App Added Successfully');
              //$state.go('app.devices');
              window.location.href = "/appmanage";
		//vm.UserEdit = false;
              console.log(res);
            },
            function(res) {
              console.log(res);
            }
          ); 
        }
        
        // Data

        // Methods


        //////////
	}

	else
	{
	//console.log("Logout....");
	 $state.go('app.login');
	}
        
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.devicedetails', [
          // 3rd Party Dependencies
                'uiGmapgoogle-maps',
                'nvd3',
                'datatables'
        ])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider, msApiProvider)
    {
        // State
        $stateProvider.state('app.device_details', {
            url      : '/devicedetails',
            params   : {
              data: null
            },
            views    : {
                'content@app': {
                    templateUrl: 'app/main/devicedetails/devicedetails.html',
                    controller : 'DevicedetailsController as vm'
                }
            },
            resolve  : {
                ActionData: function (msApi)
                {
                    return msApi.resolve('actions.data@get');
                }
            },
            bodyClass: 'login'
        });

         msApiProvider.register('actions.data', ['app/data/actions/actions.json']);

        // Navigation

       // msNavigationServiceProvider.saveItem('devices.devicemanage', {
      //      title : 'Device Management',
      //      state : 'app.device_manage',
       //     weight: 2
       // });
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.devicedetails')
        .controller('DevicedetailsController', DevicedetailsController);

    /** @ngInject */
    function DevicedetailsController(api, msToasts, $state,$location,$cookies,$mdDialog, uiGmapGoogleMapApi,ActionData)
    {
	var username = $cookies.get('username');
	if(username)
	{
		var vm = this;
        // Data

        vm.requestForm = {};
	vm.lostdeviceform = {};
	vm.showdevicelost = false;
	vm.shownotify = true;
        vm.deviceData = $state.params.data;

        vm.actions = ActionData.data;
        //console.log(vm.deviceData);
        //vm.currAction = vm.actions[0];

        if($state.params.data != null){
        	vm.requestForm.deviceid = vm.deviceData.deviceid;
		vm.lostdeviceform.deviceid = vm.deviceData.deviceid;
	  	var data = {
    			deviceid:vm.deviceData.deviceid
		};
        }
        else {
          	msToasts.showToastMsg("Please Select Device from Devices Page");
		$state.go('app.devices');
        }

  vm.missingloc = false;
	var devicelat;
	var devicelong;
	//devicelat = 12.92559913225269;
	//devicelong = 77.61634826660156;
        api.GetDeviceLocation.get(data,
        function(res) {
          //  console.log(res);
          if(res.statuscode != '200')
          {
                vm.missingloc = true;
                vm.missinglocstring = 'Location Unknown';
          }
            devicelat = res.data.latitude;
	          devicelong = res.data.longitude;

            var ldate = new Date(res.data.updatedon);
            var year = ldate.getFullYear();
            var month = ldate.getMonth()+1;
            var dt = ldate.getDate();
            var hr = ldate.getHours();
            var min = ldate.getMinutes();
            var sec = ldate.getSeconds();

            if (dt < 10) {
              dt = '0' + dt;
            }
            if (month < 10) {
              month = '0' + month;
            }
            if (hr < 10) {
              hr = '0' + hr;
            }
            if (min < 10) {
              min = '0' + min;
            }
            if (sec < 10) {
              sec = '0' + sec;
            }

            vm.lastlocupdate = year+'-' + month + '-'+dt+' '+hr+':'+min+':'+sec;
          //  console.log(year+'-' + month + '-'+dt+' '+hr+':'+min+':'+sec);
            //console.log(vm.lastlocupdate);
		        //devicelat = 12.92559913225269;
		       // devicelong = 77.61634826660156;
        	uiGmapGoogleMapApi.then(function (maps)
        	{
            	vm.simpleMarkerMap = {
                center: {
                  latitude : devicelat,
                  longitude: devicelong
                },
                zoom  : 17,
                marker: {
                    id    : 0,
                    coords: {
                       latitude : devicelat,
                    longitude: devicelong
                    }
                }
            };
        });
          },
          function(res){
            console.error(res.data);
          }
        );

        vm.notification = function(requestForm){
        	vm.requestForm;
		        var notification = {};
          	notification.fcm_token = vm.deviceData.fcm_token;
          	notification.notifyText = vm.requestForm.message;
	  	      notification.fcmtype = vm.currAction;
		        api.PushNotification.notify(notification,
          	function(res) {
			      if(res.statuscode == "200")
			      {
				          msToasts.showToastMsg('Notification sent successfully');
				          vm.requestForm.message = "";
				          requestForm.$setPristine();
				          requestForm.$setUntouched();
			      }
			      else
			      {
				         msToasts.showToastMsg('Could not send notification');
				         vm.requestForm.message = "";
				         requestForm.$setPristine();
			           requestForm.$setUntouched();
			      }

          	},
          	function(res){
            		console.error(res.data);
          	}
        );
        }



	vm.showConfirm = function(ev) {
    // Appending dialog to document.body to cover sidenav in docs app
	if(vm.currAction != 'lost')
		{
			vm.shownotify = true;
			vm.showdevicelost = false;

		}
	if(vm.currAction != 'notify'){
    	var confirm = $mdDialog.prompt()
          .title('Are you sure you want to perform this action ?')
         //.textContent('All of the banks have agreed to forgive you your debts.')
          .ariaLabel('Action')
          .targetEvent(ev)
         // .input('password')
         // .clickOutsideToClose(true)
          //  .message('required')
          //  .htmlContent('pass')
          .placeholder('Please Enter Super Admin Password')
          .parent(angular.element(document.body))
          .ok('Yes I am sure')
          .cancel('Cancel');
    	$mdDialog.show(confirm).then(function(result) {
	     	// confirm
	// Enable message form if action is device lost
    var superAdminPassword = '123456';
      if(result!=undefined && result == superAdminPassword)
          {
              //alert("Super Admin");

		var data = {
    			deviceid:vm.deviceData.deviceid,
			fcm_token:vm.deviceData.fcm_token,
			fcmtype:vm.currAction
		};
		var msg = {
				"screenlock":"Screen Locked Successfully",
				"wipedata":"Data Wiped Out Successfully",
				"lost":"Device Locked Successfully"
			};
		//console.log(msg.screenlock);
		api.DeviceAction.action(data,
          	function(res) {
			//console.log(res);
			if(vm.currAction == 'screenlock'){var act = "Screen Locked Successfully";}
			else if(vm.currAction == 'wipedata'){var act = "Data Wiped Out Successfully";}
			else if(vm.currAction == 'lost'){var act = "Device Locked Successfully";}

			if(res.statuscode == "200")
			{
				msToasts.showToastMsg(act);
				if(vm.currAction == 'lost')
				{
					vm.shownotify = false;
					vm.showdevicelost = true;

				}
			}
			else
			{
				msToasts.showToastMsg('Could not perform action');
			}

          	},
          	function(res){
            		console.error(res.data);
          	}
        )
      }

        else
    {

      var confirm = $mdDialog.alert()
          .title('Wrong Password, Please try again')
         //.textContent('All of the banks have agreed to forgive you your debts.')
          .ariaLabel('Action')
          .targetEvent(ev)
          .clickOutsideToClose(true)
          //.placeholder('Please Enter Super Admin Password')
          .parent(angular.element(document.body))
          .ok('Ok')
          //.cancel('Cancel');
          $mdDialog.show(confirm).then(function() {
          });
    }


    }, function() {
     // $scope.status = 'You decided to keep your debt.';
    });
}



  };


vm.sendlostmessage = function()
{
	var data = {
			"deviceid" : vm.lostdeviceform.deviceid,
			"contactiflost" : vm.lostdeviceform.mobile
		}

	api.LostSendMessage.sendlost(data,
          	function(res) {
			if(res.statuscode == "200")
			{
				msToasts.showToastMsg('Lost Message sent successfully');
				vm.requestForm.message = "";
			}
			else
			{
				msToasts.showToastMsg('Could not send message');
			}

          	},
          	function(res){
            		console.error(res.data);
          	}
        );
}

var pieChartData = {
        title: "Time Spent",
        mainChart: [
            {
                label: "WhatsApp",
                value: 12
            },
            {
                label: "Youtube",
                value: 10
            },
            {
                label: "Facebook",
                value: 28
            },
            {
                label: "Sales Diary",
                value: 25
            },
            {
                label: "Calls",
                value: 15
            }
        ]
    }

  vm.widget8 = {
            title    : "yet to decide",
            mainChart: {
                options: {
                    chart: {
                        type     : 'pieChart',
                        color    : ['#f44336', '#9c27b0', '#03a9f4', '#e91e63', '#ffc107'],
                        height   : 400,
                        margin   : {
                            top   : 0,
                            right : 0,
                            bottom: 0,
                            left  : 0
                        },
                        labelType: 'percent',
                        x        : function (d)
                        {
                            return d.label;
                        },
                        y        : function (d)
                        {
                            return d.value;
                        },
                        tooltip  : {
                            gravity: 's',
                            labelType: 'percent',
                            classes: 'gravity-s'
                        }
                    }
                },
                data   : pieChartData.mainChart
            }
        };
	}

	else
	{
	//console.log("Logout....");
	 $state.go('app.login');
	}

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.appmanage', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.appmanage', {
            url      : '/appmanage',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/appmanage/appmanage.html',
                    controller : 'AppmanageController as vm'
                }
            },
            bodyClass: 'login'
        });

        // Navigation
      /*  msNavigationServiceProvider.saveItem('appmanage', {
            title : 'App Management',
            group : true,
            weight: 3
        }); */

        msNavigationServiceProvider.saveItem('appmanage', {
            title : 'Apps',
            icon  : 'icon-package-variant-closed',
            state : 'app.appmanage',
            weight: 4
        });
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.appmanage')
        .controller('AppmanageController', AppmanageController);

    /** @ngInject */
    function AppmanageController($scope,api, msToasts, $state,$cookies, share)
    {
	var username = $cookies.get('username');
	if(username)
	{
		var vm = this;
        vm.apps = {};
        // Data
        vm.dtOptions = {
          dom       : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
          pagingType: 'simple',
          autoWidth : false,
          responsive: true,
          order     : [0,'desc'],
          columnDefs: [
              {
                 // width  : '40%',
                  targets: '_all'
              },
              {
                  orderable : true,
                 // type   : 'date-euro',
                  targets: [4]
              }
          ]
      };

      $scope.exportData= function(){
      var uri = 'data:application/vnd.ms-excel;base64,'
        , template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>'
        , base64 = function(s) { return window.btoa(unescape(encodeURIComponent(s))) }
        , format = function(s, c) { return s.replace(/{(\w+)}/g, function(m, p) { return c[p]; }) }

        var table = document.getElementById("exportable");
        var filters = $('.ng-table-filters').remove();
        var ctx = {worksheet: name || 'Worksheet', table: table.innerHTML};
        $('.ng-table-sort-header').after(filters) ;
        var url = uri + base64(format(template, ctx));
        var a = document.createElement('a');
        a.href = url;
      //  a.download = 'Overview_'+mm+'_'+dd+'_'+yyyy+'.xls';
        a.download = 'Overview.xls';
        a.click();
      };
        // Methods

	api.getallapps.get(
          function(res){
            if(res.statuscode == '200')
            {
              var dv = res.data;
              dv.forEach(function(i) {
                  //console.log(i);
                  var ldate = new Date(i.appCreatedAt);
                  var year = ldate.getFullYear();
                  var month = ldate.getMonth()+1;
                  var dt = ldate.getDate();
                  var hr = ldate.getHours();
                  var min = ldate.getMinutes();
                  var sec = ldate.getSeconds();

                  if (dt < 10) {
                    dt = '0' + dt;
                  }
                  if (month < 10) {
                    month = '0' + month;
                  }
                  if (hr < 10) {
                    hr = '0' + hr;
                  }
                  if (min < 10) {
                    min = '0' + min;
                  }
                  if (sec < 10) {
                    sec = '0' + sec;
                  }

                  i.appCreatedAt = year+'-' + month + '-'+dt+' '+hr+':'+min+':'+sec;
                });

            }
            vm.allapps = res.data;
            share.addDevice(res.data);
          },
          function(res) {
            console.log(res.data);
          }
        );

        vm.Approve = function(ev,emp){
         // $state.go('app.device_manage',{data : emp})
        }


        //////////
	}

	else
	{
	//console.log("Logout....");
	 $state.go('app.login');
	}

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsThemeOptionsController', MsThemeOptionsController)
        .directive('msThemeOptions', msThemeOptions);

    /** @ngInject */
    function MsThemeOptionsController($cookies, fuseTheming)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;

        vm.layoutModes = [
            {
                label: 'Boxed',
                value: 'boxed'
            },
            {
                label: 'Wide',
                value: 'wide'
            }
        ];
        vm.layoutStyles = [
            {
                label : 'Vertical Navigation',
                value : 'verticalNavigation',
                figure: '/assets/images/theme-options/vertical-nav.jpg'
            },
            {
                label : 'Vertical Navigation with Fullwidth Toolbar',
                value : 'verticalNavigationFullwidthToolbar',
                figure: '/assets/images/theme-options/vertical-nav-with-full-toolbar.jpg'
            },
            {
                label : 'Vertical Navigation with Fullwidth Toolbar 2',
                value : 'verticalNavigationFullwidthToolbar2',
                figure: '/assets/images/theme-options/vertical-nav-with-full-toolbar-2.jpg'
            },
            {
                label : 'Horizontal Navigation',
                value : 'horizontalNavigation',
                figure: '/assets/images/theme-options/horizontal-nav.jpg'
            },
            {
                label : 'Content with Toolbar',
                value : 'contentWithToolbar',
                figure: '/assets/images/theme-options/content-with-toolbar.jpg'
            },
            {
                label : 'Content Only',
                value : 'contentOnly',
                figure: '/assets/images/theme-options/content-only.jpg'
            },
        ];

        vm.layoutMode = 'wide';
        vm.layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

        // Methods
        vm.setActiveTheme = setActiveTheme;
        vm.getActiveTheme = getActiveTheme;
        vm.updateLayoutMode = updateLayoutMode;
        vm.updateLayoutStyle = updateLayoutStyle;

        //////////

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            fuseTheming.setActiveTheme(themeName);
        }

        /**
         * Get active theme
         *
         * @returns {service.themes.active|{name, theme}}
         */
        function getActiveTheme()
        {
            return fuseTheming.themes.active;
        }

        /**
         * Update layout mode
         */
        function updateLayoutMode()
        {
            var bodyEl = angular.element('body');

            // Update class on body element
            bodyEl.toggleClass('boxed', (vm.layoutMode === 'boxed'));
        }

        /**
         * Update layout style
         */
        function updateLayoutStyle()
        {
            // Update the cookie
            $cookies.put('layoutStyle', vm.layoutStyle);

            // Reload the page to apply the changes
            location.reload();
        }
    }

    /** @ngInject */
    function msThemeOptions($mdSidenav)
    {
        return {
            restrict   : 'E',
            scope      : {},
            controller : 'MsThemeOptionsController as vm',
            templateUrl: 'app/core/theme-options/theme-options.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-theme-options');

                return function postLink(scope)
                {
                    /**
                     * Toggle options sidenav
                     */
                    function toggleOptionsSidenav()
                    {
                        // Toggle the fuse theme options panel
                        $mdSidenav('fuse-theme-options').toggle();
                    }

                    // Expose the toggle function
                    scope.toggleOptionsSidenav = toggleOptionsSidenav;
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .service('fuseTheming', fuseThemingService);

    /** @ngInject */
    function fuseThemingService($cookies, $log, $mdTheming)
    {
        var service = {
            getRegisteredPalettes: getRegisteredPalettes,
            getRegisteredThemes  : getRegisteredThemes,
            setActiveTheme       : setActiveTheme,
            setThemesList        : setThemesList,
            themes               : {
                list  : {},
                active: {
                    'name' : '',
                    'theme': {}
                }
            }
        };

        return service;

        //////////

        /**
         * Get registered palettes
         *
         * @returns {*}
         */
        function getRegisteredPalettes()
        {
            return $mdTheming.PALETTES;
        }

        /**
         * Get registered themes
         *
         * @returns {*}
         */
        function getRegisteredThemes()
        {
            return $mdTheming.THEMES;
        }

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            // If theme does not exist, fallback to the default theme
            if ( angular.isUndefined(service.themes.list[themeName]) )
            {
                // If there is no theme called "default"...
                if ( angular.isUndefined(service.themes.list.default) )
                {
                    $log.error('You must have at least one theme named "default"');
                    return;
                }

                $log.warn('The theme "' + themeName + '" does not exist! Falling back to the "default" theme.');

                // Otherwise set theme to default theme
                service.themes.active.name = 'default';
                service.themes.active.theme = service.themes.list.default;
                $cookies.put('selectedTheme', service.themes.active.name);

                return;
            }

            service.themes.active.name = themeName;
            service.themes.active.theme = service.themes.list[themeName];
            $cookies.put('selectedTheme', themeName);
        }

        /**
         * Set available themes list
         *
         * @param themeList
         */
        function setThemesList(themeList)
        {
            service.themes.list = themeList;
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($mdThemingProvider, fusePalettes, fuseThemes)
    {
        // Inject Cookies Service
        var $cookies;
        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Check if custom theme exist in cookies
        var customTheme = $cookies.getObject('customTheme');
        if ( customTheme )
        {
            fuseThemes['custom'] = customTheme;
        }

        $mdThemingProvider.alwaysWatchTheme(true);

        // Define custom palettes
        angular.forEach(fusePalettes, function (palette)
        {
            $mdThemingProvider.definePalette(palette.name, palette.options);
        });

        // Register custom themes
        angular.forEach(fuseThemes, function (theme, themeName)
        {
            $mdThemingProvider.theme(themeName)
                .primaryPalette(theme.primary.name, theme.primary.hues)
                .accentPalette(theme.accent.name, theme.accent.hues)
                .warnPalette(theme.warn.name, theme.warn.hues)
                .backgroundPalette(theme.background.name, theme.background.hues);
        });
    }

})();
(function ()
{
    'use strict';

    var fuseThemes = {
        default  : {
            primary   : {
                name: 'fuse-paleblue',
                hues: {
                    'default': '700',
                    'hue-1'  : '500',
                    'hue-2'  : '600',
                    'hue-3'  : '400'
                }
            },
            accent    : {
                name: 'light-blue',
                hues: {
                    'default': '600',
                    'hue-1'  : '400',
                    'hue-2'  : '700',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'red'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        },
        'pinkTheme': {
            primary   : {
                name: 'blue-grey',
                hues: {
                    'default': '800',
                    'hue-1'  : '600',
                    'hue-2'  : '400',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'pink',
                hues: {
                    'default': '400',
                    'hue-1'  : '300',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'blue'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        },
        'tealTheme': {
            primary   : {
                name: 'fuse-blue',
                hues: {
                    'default': '900',
                    'hue-1'  : '600',
                    'hue-2'  : '500',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'teal',
                hues: {
                    'default': '500',
                    'hue-1'  : '400',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'deep-orange'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        }
    };

    angular
        .module('app.core')
        .constant('fuseThemes', fuseThemes);
})();
(function () {
    'use strict';

    var fusePalettes = [
        {
            name: 'fuse-blue',
            options: {
                '50': '#ebf1fa',
                '100': '#c2d4ef',
                '200': '#9ab8e5',
                '300': '#78a0dc',
                '400': '#5688d3',
                '500': '#3470ca',
                '600': '#2e62b1',
                '700': '#275498',
                '800': '#21467e',
                '900': '#1a3865',
                'A100': '#c2d4ef',
                'A200': '#9ab8e5',
                'A400': '#5688d3',
                'A700': '#275498',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        },
        {
            name: 'fuse-paleblue',
            options: {
                '50': '#ececee',
                '100': '#c5c6cb',
                '200': '#9ea1a9',
                '300': '#7d818c',
                '400': '#5c616f',
                '500': '#3c4252',
                '600': '#353a48',
                '700': '#2d323e',
                '800': '#262933',
                '900': '#1e2129',
                'A100': '#c5c6cb',
                'A200': '#9ea1a9',
                'A400': '#5c616f',
                'A700': '#2d323e',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        }
    ];

    angular
        .module('app.core')
        .constant('fusePalettes', fusePalettes);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('fuseGenerator', fuseGeneratorService);

    /** @ngInject */
    function fuseGeneratorService($cookies, $log, fuseTheming)
    {
        // Storage for simplified themes object
        var themes = {};

        var service = {
            generate: generate,
            rgba    : rgba
        };

        return service;

        //////////

        /**
         * Generate less variables for each theme from theme's
         * palette by using material color naming conventions
         */
        function generate()
        {
            // Get registered themes and palettes and copy
            // them so we don't modify the original objects
            var registeredThemes = angular.copy(fuseTheming.getRegisteredThemes());
            var registeredPalettes = angular.copy(fuseTheming.getRegisteredPalettes());

            // First, create a simplified object that stores
            // all registered themes and their colors

            // Iterate through registered themes
            angular.forEach(registeredThemes, function (registeredTheme)
            {
                themes[registeredTheme.name] = {};

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(registeredTheme.colors, function (colorType, colorTypeName)
                {
                    themes[registeredTheme.name][colorTypeName] = {
                        'name'  : colorType.name,
                        'levels': {
                            'default': {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues.default].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 4)
                            },
                            'hue1'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 4)
                            },
                            'hue2'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 4)
                            },
                            'hue3'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 4)
                            }
                        }
                    };
                });
            });

            // Process themes one more time and then store them in the service for external use
            processAndStoreThemes(themes);

            // Iterate through simplified themes
            // object and create style variables
            var styleVars = {};

            // Iterate through registered themes
            angular.forEach(themes, function (theme, themeName)
            {
                styleVars = {};
                styleVars['@themeName'] = themeName;

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorTypes, colorTypeName)
                {
                    // Iterate through color levels (default, hue1, hue2 & hue3)
                    angular.forEach(colorTypes.levels, function (colors, colorLevelName)
                    {
                        // Iterate through color name (color, contrast1, contrast2, contrast3 & contrast4)
                        angular.forEach(colors, function (color, colorName)
                        {
                            styleVars['@' + colorTypeName + ucfirst(colorLevelName) + ucfirst(colorName)] = color;
                        });
                    });
                });

                // Render styles
                render(styleVars);
            });
        }

        // ---------------------------
        //  INTERNAL HELPER FUNCTIONS
        // ---------------------------

        /**
         * Process and store themes for global use
         *
         * @param _themes
         */
        function processAndStoreThemes(_themes)
        {
            // Here we will go through every registered theme one more time
            // and try to simplify their objects as much as possible for
            // easier access to their properties.
            var themes = angular.copy(_themes);

            // Iterate through themes
            angular.forEach(themes, function (theme)
            {
                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorType, colorTypeName)
                {
                    theme[colorTypeName] = colorType.levels;
                    theme[colorTypeName].color = colorType.levels.default.color;
                    theme[colorTypeName].contrast1 = colorType.levels.default.contrast1;
                    theme[colorTypeName].contrast2 = colorType.levels.default.contrast2;
                    theme[colorTypeName].contrast3 = colorType.levels.default.contrast3;
                    theme[colorTypeName].contrast4 = colorType.levels.default.contrast4;
                    delete theme[colorTypeName].default;
                });
            });

            // Store themes and set selected theme for the first time
            fuseTheming.setThemesList(themes);

            // Remember selected theme.
            var selectedTheme = $cookies.get('selectedTheme');

            if ( selectedTheme )
            {
                fuseTheming.setActiveTheme(selectedTheme);
            }
            else
            {
                fuseTheming.setActiveTheme('default');
            }
        }


        /**
         * Render css files
         *
         * @param styleVars
         */
        function render(styleVars)
        {
            var cssTemplate = '/* Content hack because they wont fix */\n/* https://github.com/angular/material/pull/8067 */\n[md-theme="@themeName"] md-content.md-hue-1,\nmd-content.md-@themeName-theme.md-hue-1 {\n    color: @backgroundHue1Contrast1;\n    background-color: @backgroundHue1Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-2,\nmd-content.md-@themeName-theme.md-hue-2 {\n    color: @backgroundHue2Contrast1;\n    background-color: @backgroundHue2Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-3,\n md-content.md-@themeName-theme.md-hue-3 {\n    color: @backgroundHue3Contrast1;\n    background-color: @backgroundHue3Color;\n}\n\n/* Text Colors */\n[md-theme="@themeName"] a {\n    color: @accentDefaultColor;\n}\n\n[md-theme="@themeName"] .secondary-text,\n[md-theme="@themeName"] .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .hint-text,\n[md-theme="@themeName"] .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .fade-text,\n[md-theme="@themeName"] .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Primary */\n[md-theme="@themeName"] .md-primary-bg {\n    background-color: @primaryDefaultColor;\n    color: @primaryDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg .secondary-text,\n[md-theme="@themeName"] .md-primary-bg .icon {\n    color: @primaryDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg .hint-text,\n[md-theme="@themeName"] .md-primary-bg .disabled-text {\n    color: @primaryDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg .fade-text,\n[md-theme="@themeName"] .md-primary-bg .divider {\n    color: @primaryDefaultContrast4;\n}\n\n/* Primary, Hue-1 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 {\n    background-color: @primaryHue1Color;\n    color: @primaryHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .icon {\n    color: @primaryHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .disabled-text {\n    color: @primaryHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .divider {\n    color: @primaryHue1Contrast4;\n}\n\n/* Primary, Hue-2 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 {\n    background-color: @primaryHue2Color;\n    color: @primaryHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .icon {\n    color: @primaryHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .disabled-text {\n    color: @primaryHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .divider {\n    color: @primaryHue2Contrast4;\n}\n\n/* Primary, Hue-3 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 {\n    background-color: @primaryHue3Color;\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .icon {\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .disabled-text {\n    color: @primaryHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .divider {\n    color: @primaryHue3Contrast4;\n}\n\n/* Primary foreground */\n[md-theme="@themeName"] .md-primary-fg {\n    color: @primaryDefaultColor !important;\n}\n\n/* Primary foreground, Hue-1 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-1 {\n    color: @primaryHue1Color !important;\n}\n\n/* Primary foreground, Hue-2 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-2 {\n    color: @primaryHue2Color !important;\n}\n\n/* Primary foreground, Hue-3 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-3 {\n    color: @primaryHue3Color !important;\n}\n\n/* Accent */\n[md-theme="@themeName"] .md-accent-bg {\n    background-color: @accentDefaultColor;\n    color: @accentDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg .secondary-text,\n[md-theme="@themeName"] .md-accent-bg .icon {\n    color: @accentDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg .hint-text,\n[md-theme="@themeName"] .md-accent-bg .disabled-text {\n    color: @accentDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg .fade-text,\n[md-theme="@themeName"] .md-accent-bg .divider {\n    color: @accentDefaultContrast4;\n}\n\n/* Accent, Hue-1 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 {\n    background-color: @accentHue1Color;\n    color: @accentHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .icon {\n    color: @accentHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .disabled-text {\n    color: @accentHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .divider {\n    color: @accentHue1Contrast4;\n}\n\n/* Accent, Hue-2 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 {\n    background-color: @accentHue2Color;\n    color: @accentHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .icon {\n    color: @accentHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .disabled-text {\n    color: @accentHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .divider {\n    color: @accentHue2Contrast4;\n}\n\n/* Accent, Hue-3 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 {\n    background-color: @accentHue3Color;\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .icon {\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .disabled-text {\n    color: @accentHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .divider {\n    color: @accentHue3Contrast4;\n}\n\n/* Accent foreground */\n[md-theme="@themeName"] .md-accent-fg {\n    color: @accentDefaultColor !important;\n}\n\n/* Accent foreground, Hue-1 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-1 {\n    color: @accentHue1Color !important;\n}\n\n/* Accent foreground, Hue-2 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-2 {\n    color: @accentHue2Color !important;\n}\n\n/* Accent foreground, Hue-3 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-3 {\n    color: @accentHue3Color !important;\n}\n\n/* Warn */\n[md-theme="@themeName"] .md-warn-bg {\n    background-color: @warnDefaultColor;\n    color: @warnDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg .secondary-text,\n[md-theme="@themeName"] .md-warn-bg .icon {\n    color: @warnDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg .hint-text,\n[md-theme="@themeName"] .md-warn-bg .disabled-text {\n    color: @warnDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg .fade-text,\n[md-theme="@themeName"] .md-warn-bg .divider {\n    color: @warnDefaultContrast4;\n}\n\n/* Warn, Hue-1 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 {\n    background-color: @warnHue1Color;\n    color: @warnHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .icon {\n    color: @warnHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .disabled-text {\n    color: @warnHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .divider {\n    color: @warnHue1Contrast4;\n}\n\n/* Warn, Hue-2 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 {\n    background-color: @warnHue2Color;\n    color: @warnHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .icon {\n    color: @warnHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .disabled-text {\n    color: @warnHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .divider {\n    color: @warnHue2Contrast4;\n}\n\n/* Warn, Hue-3 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 {\n    background-color: @warnHue3Color;\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .icon {\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .disabled-text {\n    color: @warnHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .divider {\n    color: @warnHue3Contrast4;\n}\n\n/* Warn foreground */\n[md-theme="@themeName"] .md-warn-fg {\n    color: @warnDefaultColor !important;\n}\n\n/* Warn foreground, Hue-1 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-1 {\n    color: @warnHue1Color !important;\n}\n\n/* Warn foreground, Hue-2 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-2 {\n    color: @warnHue2Color !important;\n}\n\n/* Warn foreground, Hue-3 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-3 {\n    color: @warnHue3Color !important;\n}\n\n/* Background */\n[md-theme="@themeName"] .md-background-bg {\n    background-color: @backgroundDefaultColor;\n    color: @backgroundDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg .secondary-text,\n[md-theme="@themeName"] .md-background-bg .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg .hint-text,\n[md-theme="@themeName"] .md-background-bg .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg .fade-text,\n[md-theme="@themeName"] .md-background-bg .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Background, Hue-1 */\n[md-theme="@themeName"] .md-background-bg.md-hue-1 {\n    background-color: @backgroundHue1Color;\n    color: @backgroundHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .icon {\n    color: @backgroundHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .disabled-text {\n    color: @backgroundHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .divider {\n    color: @backgroundHue1Contrast4;\n}\n\n/* Background, Hue-2 */\n[md-theme="@themeName"] .md-background-bg.md-hue-2 {\n    background-color: @backgroundHue2Color;\n    color: @backgroundHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .icon {\n    color: @backgroundHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .disabled-text {\n    color: @backgroundHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .divider {\n    color: @backgroundHue2Contrast4;\n}\n\n/* Background, Hue-3 */\n[md-theme="@themeName"] .md-background-bg.md-hue-3 {\n    background-color: @backgroundHue3Color;\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .icon {\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .disabled-text {\n    color: @backgroundHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .divider {\n    color: @backgroundHue3Contrast4;\n}\n\n/* Background foreground */\n[md-theme="@themeName"] .md-background-fg {\n    color: @backgroundDefaultColor !important;\n}\n\n/* Background foreground, Hue-1 */\n[md-theme="@themeName"] .md-background-fg.md-hue-1 {\n    color: @backgroundHue1Color !important;\n}\n\n/* Background foreground, Hue-2 */\n[md-theme="@themeName"] .md-background-fg.md-hue-2 {\n    color: @backgroundHue2Color !important;\n}\n\n/* Background foreground, Hue-3 */\n[md-theme="@themeName"] .md-background-fg.md-hue-3 {\n    color: @backgroundHue3Color !important;\n}';

            var regex = new RegExp(Object.keys(styleVars).join('|'), 'gi');
            var css = cssTemplate.replace(regex, function (matched)
            {
                return styleVars[matched];
            });

            var headEl = angular.element('head');
            var styleEl = angular.element('<style type="text/css"></style>');
            styleEl.html(css);
            headEl.append(styleEl);
        }

        /**
         * Convert color array to rgb/rgba
         * Also apply contrasts if needed
         *
         * @param color
         * @param _contrastLevel
         * @returns {string}
         */
        function rgba(color, _contrastLevel)
        {
            var contrastLevel = _contrastLevel || false;

            // Convert 255,255,255,0.XX to 255,255,255
            // According to Google's Material design specs, white primary
            // text must have opacity of 1 and we will fix that here
            // because Angular Material doesn't care about that spec
            if ( color.length === 4 && color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color.splice(3, 4);
            }

            // If contrast level provided, apply it to the current color
            if ( contrastLevel )
            {
                color = applyContrast(color, contrastLevel);
            }

            // Convert color array to color string (rgb/rgba)
            if ( color.length === 3 )
            {
                return 'rgb(' + color.join(',') + ')';
            }
            else if ( color.length === 4 )
            {
                return 'rgba(' + color.join(',') + ')';
            }
            else
            {
                $log.error('Invalid number of arguments supplied in the color array: ' + color.length + '\n' + 'The array must have 3 or 4 colors.');
            }
        }

        /**
         * Apply given contrast level to the given color
         *
         * @param color
         * @param contrastLevel
         */
        function applyContrast(color, contrastLevel)
        {
            var contrastLevels = {
                'white': {
                    '1': '1',
                    '2': '0.7',
                    '3': '0.3',
                    '4': '0.12'
                },
                'black': {
                    '1': '0.87',
                    '2': '0.54',
                    '3': '0.26',
                    '4': '0.12'
                }
            };

            // If white
            if ( color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color[3] = contrastLevels.white[contrastLevel];
            }
            // If black
            else if ( color[0] === 0 && color[1] === 0 && color[2] === 0 )
            {
                color[3] = contrastLevels.black[contrastLevel];
            }

            return color;
        }

        /**
         * Uppercase first
         */
        function ucfirst(string)
        {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msUtils', msUtils);

    /** @ngInject */
    function msUtils($window)
    {
        // Private variables
        var mobileDetect = new MobileDetect($window.navigator.userAgent),
            browserInfo = null;

        var service = {
            exists       : exists,
            detectBrowser: detectBrowser,
            guidGenerator: guidGenerator,
            isMobile     : isMobile,
            toggleInArray: toggleInArray
        };

        return service;

        //////////

        /**
         * Check if item exists in a list
         *
         * @param item
         * @param list
         * @returns {boolean}
         */
        function exists(item, list)
        {
            return list.indexOf(item) > -1;
        }

        /**
         * Returns browser information
         * from user agent data
         *
         * Found at http://www.quirksmode.org/js/detect.html
         * but modified and updated to fit for our needs
         */
        function detectBrowser()
        {
            // If we already tested, do not test again
            if ( browserInfo )
            {
                return browserInfo;
            }

            var browserData = [
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Edge',
                    versionSearch: 'Edge',
                    identity     : 'Edge'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Chrome',
                    identity : 'Chrome'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'OmniWeb',
                    versionSearch: 'OmniWeb/',
                    identity     : 'OmniWeb'
                },
                {
                    string       : $window.navigator.vendor,
                    subString    : 'Apple',
                    versionSearch: 'Version',
                    identity     : 'Safari'
                },
                {
                    prop    : $window.opera,
                    identity: 'Opera'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'iCab',
                    identity : 'iCab'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'KDE',
                    identity : 'Konqueror'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Firefox',
                    identity : 'Firefox'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'Camino',
                    identity : 'Camino'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Netscape',
                    identity : 'Netscape'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'MSIE',
                    identity     : 'Explorer',
                    versionSearch: 'MSIE'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Trident/7',
                    identity     : 'Explorer',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Gecko',
                    identity     : 'Mozilla',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Mozilla',
                    identity     : 'Netscape',
                    versionSearch: 'Mozilla'
                }
            ];

            var osData = [
                {
                    string   : $window.navigator.platform,
                    subString: 'Win',
                    identity : 'Windows'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Mac',
                    identity : 'Mac'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Linux',
                    identity : 'Linux'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPhone',
                    identity : 'iPhone'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPod',
                    identity : 'iPod'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPad',
                    identity : 'iPad'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Android',
                    identity : 'Android'
                }
            ];

            var versionSearchString = '';

            function searchString(data)
            {
                for ( var i = 0; i < data.length; i++ )
                {
                    var dataString = data[i].string;
                    var dataProp = data[i].prop;

                    versionSearchString = data[i].versionSearch || data[i].identity;

                    if ( dataString )
                    {
                        if ( dataString.indexOf(data[i].subString) !== -1 )
                        {
                            return data[i].identity;

                        }
                    }
                    else if ( dataProp )
                    {
                        return data[i].identity;
                    }
                }
            }

            function searchVersion(dataString)
            {
                var index = dataString.indexOf(versionSearchString);

                if ( index === -1 )
                {
                    return;
                }

                return parseInt(dataString.substring(index + versionSearchString.length + 1));
            }

            var browser = searchString(browserData) || 'unknown-browser';
            var version = searchVersion($window.navigator.userAgent) || searchVersion($window.navigator.appVersion) || 'unknown-version';
            var os = searchString(osData) || 'unknown-os';

            // Prepare and store the object
            browser = browser.toLowerCase();
            version = browser + '-' + version;
            os = os.toLowerCase();

            browserInfo = {
                browser: browser,
                version: version,
                os     : os
            };

            return browserInfo;
        }

        /**
         * Generates a globally unique id
         *
         * @returns {*}
         */
        function guidGenerator()
        {
            var S4 = function ()
            {
                return (((1 + Math.random()) * 0x10000) || 0).toString(16).substring(1);
            };
            return (S4() + S4() + S4() + S4() + S4() + S4());
        }

        /**
         * Return if current device is a
         * mobile device or not
         */
        function isMobile()
        {
            return mobileDetect.mobile();
        }

        /**
         * Toggle in array (push or splice)
         *
         * @param item
         * @param array
         */
        function toggleInArray(item, array)
        {
            if ( array.indexOf(item) === -1 )
            {
                array.push(item);
            }
            else
            {
                array.splice(array.indexOf(item), 1);
            }
        }
    }
}());
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msToasts', msToasts);

    /** @ngInject */
    function msToasts($mdToast)
    {
        
	var service = {
        message: '',
        showToastMsg: showToastMsg
    };


    return service;

/****************************************** Toast Code Start ******************************/

   function showToastMsg( Message ) {

     var msgval = Message;

    $mdToast.show(
      $mdToast.simple()
        .textContent(msgval)
	.position('top right')
        .hideDelay(6000)
    );
  };


/****************************************** Toast Code End ******************************/

}
 
   
}());

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msApi', msApiProvider);

    /** @ngInject **/
    function msApiProvider()
    {
        /* ----------------- */
        /* Provider          */
        /* ----------------- */
        var provider = this;

        // Inject the $log service
        var $log = angular.injector(['ng']).get('$log');

        // Data
        var baseUrl = '';
        var api = [];

        // Methods
        provider.setBaseUrl = setBaseUrl;
        provider.getBaseUrl = getBaseUrl;
        provider.getApiObject = getApiObject;
        provider.register = register;

        //////////

        /**
         * Set base url for API endpoints
         *
         * @param url {string}
         */
        function setBaseUrl(url)
        {
            baseUrl = url;
        }

        /**
         * Return the base url
         *
         * @returns {string}
         */
        function getBaseUrl()
        {
            return baseUrl;
        }

        /**
         * Return the api object
         *
         * @returns {object}
         */
        function getApiObject()
        {
            return api;
        }

        /**
         * Register API endpoint
         *
         * @param key
         * @param resource
         */
        function register(key, resource)
        {
            if ( !angular.isString(key) )
            {
                $log.error('"path" must be a string (eg. `dashboard.project`)');
                return;
            }

            if ( !angular.isArray(resource) )
            {
                $log.error('"resource" must be an array and it must follow $resource definition');
                return;
            }

            // Store the API object
            api[key] = {
                url          : baseUrl + (resource[0] || ''),
                paramDefaults: resource[1] || [],
                actions      : resource[2] || [],
                options      : resource[3] || {}
            };
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */
        this.$get = function ($log, $q, $resource, $rootScope)
        {
            // Data

            // Methods
            var service = {
                setBaseUrl: setBaseUrl,
                getBaseUrl: getBaseUrl,
                register  : register,
                resolve   : resolve,
                request   : request
            };

            return service;

            //////////

            /**
             * Resolve an API endpoint
             *
             * @param action {string}
             * @param parameters {object}
             * @returns {promise|boolean}
             */
            function resolve(action, parameters)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::resolveStart');
                
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // Success
                        function (response)
                        {
                            deferred.resolve(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveSuccess');
                        },

                        // Error
                        function (response)
                        {
                            deferred.reject(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveError');
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }

            /**
             * Make a request to an API endpoint
             *
             * @param action {string}
             * @param [parameters] {object}
             * @param [success] {function}
             * @param [error] {function}
             *
             * @returns {promise|boolean}
             */
            function request(action, parameters, success, error)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::requestStart');
                
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // SUCCESS
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestSuccess');
                            
                            // Resolve the promise
                            deferred.resolve(response);

                            // Call the success function if there is one
                            if ( angular.isDefined(success) && angular.isFunction(success) )
                            {
                                success(response);
                            }
                        },

                        // ERROR
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestError');
                            
                            // Reject the promise
                            deferred.reject(response);

                            // Call the error function if there is one
                            if ( angular.isDefined(error) && angular.isFunction(error) )
                            {
                                error(response);
                            }
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('apiResolver', apiResolverService);

    /** @ngInject */
    function apiResolverService($q, $log, api)
    {
        var service = {
            resolve: resolve
        };

        return service;

        //////////
        /**
         * Resolve api
         * @param action
         * @param parameters
         */
        function resolve(action, parameters)
        {
            var actionParts = action.split('@'),
                resource = actionParts[0],
                method = actionParts[1],
                params = parameters || {};

            if ( !resource || !method )
            {
                $log.error('apiResolver.resolve requires correct action parameter (ResourceName@methodName)');
                return false;
            }

            // Create a new deferred object
            var deferred = $q.defer();

            // Get the correct api object from api service
            var apiObject = getApiObject(resource);

            if ( !apiObject )
            {
                $log.error('Resource "' + resource + '" is not defined in the api service!');
                deferred.reject('Resource "' + resource + '" is not defined in the api service!');
            }
            else
            {
                apiObject[method](params,

                    // Success
                    function (response)
                    {
                        deferred.resolve(response);
                    },

                    // Error
                    function (response)
                    {
                        deferred.reject(response);
                    }
                );
            }

            // Return the promise
            return deferred.promise;
        }

        /**
         * Get correct api object
         *
         * @param resource
         * @returns {*}
         */
        function getApiObject(resource)
        {
            // Split the resource in case if we have a dot notated object
            var resourceParts = resource.split('.'),
                apiObject = api;

            // Loop through the resource parts and go all the way through
            // the api object and return the correct one
            for ( var l = 0; l < resourceParts.length; l++ )
            {
                if ( angular.isUndefined(apiObject[resourceParts[l]]) )
                {
                    $log.error('Resource part "' + resourceParts[l] + '" is not defined!');
                    apiObject = false;
                    break;
                }

                apiObject = apiObject[resourceParts[l]];
            }

            if ( !apiObject )
            {
                return false;
            }

            return apiObject;
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByTags', filterByTags)
        .filter('filterSingleByTags', filterSingleByTags);

    /** @ngInject */
    function filterByTags()
    {
        return function (items, tags)
        {
            if ( items.length === 0 || tags.length === 0 )
            {
                return items;
            }

            var filtered = [];

            items.forEach(function (item)
            {
                var match = tags.every(function (tag)
                {
                    var tagExists = false;

                    item.tags.forEach(function (itemTag)
                    {
                        if ( itemTag.name === tag.name )
                        {
                            tagExists = true;
                            return;
                        }
                    });

                    return tagExists;
                });

                if ( match )
                {
                    filtered.push(item);
                }
            });

            return filtered;
        };
    }

    /** @ngInject */
    function filterSingleByTags()
    {
        return function (itemTags, tags)
        {
            if ( itemTags.length === 0 || tags.length === 0 )
            {
                return;
            }

            if ( itemTags.length < tags.length )
            {
                return [];
            }

            var filtered = [];

            var match = tags.every(function (tag)
            {
                var tagExists = false;

                itemTags.forEach(function (itemTag)
                {
                    if ( itemTag.name === tag.name )
                    {
                        tagExists = true;
                        return;
                    }
                });

                return tagExists;
            });

            if ( match )
            {
                filtered.push(itemTags);
            }

            return filtered;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByPropIds', filterByPropIds);

    /** @ngInject */
    function filterByPropIds()
    {
        return function (items, parameter, ids)
        {
            if ( items.length === 0 || !ids || ids.length === 0 )
            {
                return items;
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item[parameter].indexOf(id) > -1 )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByIds', filterByIds);

    /** @ngInject */
    function filterByIds()
    {
        return function (items, ids)
        {

            if ( items.length === 0 || !ids )
            {
                return items;
            }

            if ( ids.length === 0 )
            {
                return [];
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item.id === id )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('toTrusted', toTrustedFilter)
        .filter('htmlToPlaintext', htmlToPlainTextFilter)
        .filter('nospace', nospaceFilter)
        .filter('humanizeDoc', humanizeDocFilter);

    /** @ngInject */
    function toTrustedFilter($sce)
    {
        return function (value)
        {
            return $sce.trustAsHtml(value);
        };
    }

    /** @ngInject */
    function htmlToPlainTextFilter()
    {
        return function (text)
        {
            return String(text).replace(/<[^>]+>/gm, '');
        };
    }

    /** @ngInject */
    function nospaceFilter()
    {
        return function (value)
        {
            return (!value) ? '' : value.replace(/ /g, '');
        };
    }

    /** @ngInject */
    function humanizeDocFilter()
    {
        return function (doc)
        {
            if ( !doc )
            {
                return;
            }
            if ( doc.type === 'directive' )
            {
                return doc.name.replace(/([A-Z])/g, function ($1)
                {
                    return '-' + $1.toLowerCase();
                });
            }
            return doc.label || doc.name;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('altDate', altDate);

    /** @ngInject */
    function altDate()
    {
        return function (value)
        {
            var diff = Date.now() - new Date(value);

            /**
             * If in a hour
             * e.g. "2 minutes ago"
             */
            if ( diff < (60 * 60 * 1000) )
            {
                return moment(value).fromNow();
            }
            /*
             * If in the day
             * e.g. "11:23"
             */
            else if ( diff < (60 * 60 * 24 * 1000) )
            {
                return moment(value).format('HH:mm');
            }
            /*
             * If in week
             * e.g "Tuesday"
             */
            else if ( diff < (60 * 60 * 24 * 7 * 1000) )
            {
                return moment(value).format('dddd');
            }
            /*
             * If more than a week
             * e.g. 03/29/2016
             */
            else
            {
                return moment(value).calendar();
            }

        };
    }

})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('hljs', hljsDirective);

    /** @ngInject */
    function hljsDirective($timeout, $q, $interpolate) {
        return {
            restrict: 'E',
            compile : function (element, attr) {
                var code;
                //No attribute? code is the content
                if (!attr.code) {
                    code = element.html();
                    element.empty();
                }

                return function (scope, element, attr) {

                    if (attr.code) {
                        // Attribute? code is the evaluation
                        code = scope.$eval(attr.code);
                    }
                    var shouldInterpolate = scope.$eval(attr.shouldInterpolate);

                    $q.when(code).then(function (code) {
                        if (code) {
                            if (shouldInterpolate) {
                                code = $interpolate(code)(scope);
                            }
                            var contentParent = angular.element(
                                '<pre><code class="highlight" ng-non-bindable></code></pre>'
                            );
                            element.append(contentParent);
                            // Defer highlighting 1-frame to prevent GA interference...
                            $timeout(function () {
                                render(code, contentParent);
                            }, 34, false);
                        }
                    });

                    function render(contents, parent) {

                        var codeElement = parent.find('code');
                        var lines = contents.split('\n');

                        // Remove empty lines
                        lines = lines.filter(function (line) {
                            return line.trim().length;
                        });

                        // Make it so each line starts at 0 whitespace
                        var firstLineWhitespace = lines[0].match(/^\s*/)[0];
                        var startingWhitespaceRegex = new RegExp('^' + firstLineWhitespace);
                        lines = lines.map(function (line) {
                            return line
                                .replace(startingWhitespaceRegex, '')
                                .replace(/\s+$/, '');
                        });

                        var highlightedCode = hljs.highlight(attr.language || attr.lang, lines.join('\n'), true);
                        highlightedCode.value = highlightedCode.value
                            .replace(/=<span class="hljs-value">""<\/span>/gi, '')
                            .replace('<head>', '')
                            .replace('<head/>', '');
                        codeElement.append(highlightedCode.value).addClass('highlight');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('fuseConfig', fuseConfigProvider);

    /** @ngInject */
    function fuseConfigProvider()
    {
        // Default configuration
        var fuseConfiguration = {
            'disableCustomScrollbars'        : false,
            'disableMdInkRippleOnMobile'     : true,
            'disableCustomScrollbarsOnMobile': true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            fuseConfiguration = angular.extend({}, fuseConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig,
                setConfig: setConfig
            };

            return service;

            //////////

            /**
             * Returns a config value
             */
            function getConfig(configName)
            {
                if ( angular.isUndefined(fuseConfiguration[configName]) )
                {
                    return false;
                }

                return fuseConfiguration[configName];
            }

            /**
             * Creates or updates config object
             *
             * @param configName
             * @param configValue
             */
            function setConfig(configName, configValue)
            {
                fuseConfiguration[configName] = configValue;
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.navigation', [])
        .config(config);

    /** @ngInject */
    function config()
    {
        
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.navigation')
        .controller('NavigationController', NavigationController);

    /** @ngInject */
    function NavigationController($scope)
    {
        var vm = this;

        // Data
        vm.bodyEl = angular.element('body');
        vm.folded = false;
        vm.msScrollOptions = {
            suppressScrollX: true
        };

        // Methods
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;

        //////////

        /**
         * Toggle folded status
         */
        function toggleMsNavigationFolded()
        {
            vm.folded = !vm.folded;
        }

        // Close the mobile menu on $stateChangeSuccess
        $scope.$on('$stateChangeSuccess', function ()
        {
            vm.bodyEl.removeClass('ms-navigation-horizontal-mobile-menu-active');
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.toolbar', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider)
    {
        $translatePartialLoaderProvider.addPart('app/toolbar');
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.toolbar')
        .controller('ToolbarController', ToolbarController);

    /** @ngInject */
    function ToolbarController($rootScope, $q, share, $state, $timeout, $mdSidenav, $cookies, $translate, $mdToast, msNavigationService,api)
    {
        var vm = this;

        // Data
        $rootScope.global = {
            search: ''
        };

        vm.bodyEl = angular.element('body');
        vm.userStatusOptions = [
            {
                'title': 'Online',
                'icon' : 'icon-checkbox-marked-circle',
                'color': '#4CAF50'
            },
            {
                'title': 'Away',
                'icon' : 'icon-clock',
                'color': '#FFC107'
            },
            {
                'title': 'Do not Disturb',
                'icon' : 'icon-minus-circle',
                'color': '#F44336'
            },
            {
                'title': 'Invisible',
                'icon' : 'icon-checkbox-blank-circle-outline',
                'color': '#BDBDBD'
            },
            {
                'title': 'Offline',
                'icon' : 'icon-checkbox-blank-circle-outline',
                'color': '#616161'
            }
        ];
        vm.languages = {
            en: {
                'title'      : 'English',
                'translation': 'TOOLBAR.ENGLISH',
                'code'       : 'en',
                'flag'       : 'us'
            },
            es: {
                'title'      : 'Spanish',
                'translation': 'TOOLBAR.SPANISH',
                'code'       : 'es',
                'flag'       : 'es'
            },
            tr: {
                'title'      : 'Turkish',
                'translation': 'TOOLBAR.TURKISH',
                'code'       : 'tr',
                'flag'       : 'tr'
            }
        };

        // Methods
        vm.toggleSidenav = toggleSidenav;
        vm.logout = logout;
        vm.changeLanguage = changeLanguage;
        vm.setUserStatus = setUserStatus;
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;
        vm.search = search;
        vm.searchResultClick = searchResultClick;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Select the first status as a default
            vm.userStatus = vm.userStatusOptions[0];

            // Get the selected language directly from angular-translate module setting
            vm.selectedLanguage = vm.languages[$translate.preferredLanguage()];
        }


        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Sets User Status
         * @param status
         */
        function setUserStatus(status)
        {
            vm.userStatus = status;
        }
	
	vm.username = $cookies.get('username');

	/*api.GetUserDetails.get(
          function(res){
           // console.log(res);
            vm.users = res;
          },
          function(res) {
            console.log(res);
          }
        );*/

        vm.Approve = function(ev,emp){
          $state.go('app.device_details',{data : emp})
        }


        /**
         * Logout Function
         */
        function logout()
        {
            // Do logout here..
            $cookies.remove('username');
            $cookies.remove('Role');
            $cookies.remove('token');
            $cookies.remove('IPEK');
            $cookies.remove('uid');
            $state.go('app.login');
        }

        /**
         * Change Language
         */
        function changeLanguage(lang)
        {
            vm.selectedLanguage = lang;

            /**
             * Show temporary message if user selects a language other than English
             *
             * angular-translate module will try to load language specific json files
             * as soon as you change the language. And because we don't have them, there
             * will be a lot of errors in the page potentially breaking couple functions
             * of the template.
             *
             * To prevent that from happening, we added a simple "return;" statement at the
             * end of this if block. If you have all the translation files, remove this if
             * block and the translations should work without any problems.
             */
            if ( lang.code !== 'en' )
            {
                var message = 'Fuse supports translations through angular-translate module, but currently we do not have any translations other than English language. If you want to help us, send us a message through ThemeForest profile page.';

                $mdToast.show({
                    template : '<md-toast id="language-message" layout="column" layout-align="center start"><div class="md-toast-content">' + message + '</div></md-toast>',
                    hideDelay: 7000,
                    position : 'top right',
                    parent   : '#content'
                });

                return;
            }

            // Change the language
            $translate.use(lang.code);
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu()
        {
            vm.bodyEl.toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }

        /**
         * Toggle msNavigation folded
         */
        function toggleMsNavigationFolded()
        {
            msNavigationService.toggleFolded();
        }

        /**
         * Search action
         *
         * @param query
         * @returns {Promise}
         */
        function search(query)
        {
            var navigation = [],
                flatNavigation = msNavigationService.getFlatNavigation(),
                deferred = $q.defer();
                //console.log(share.getDevice());

            // Iterate through the navigation array and
            // make sure it doesn't have any groups or
            // none ui-sref items
           /* for ( var x = 0; x < flatNavigation.length; x++ )
            {
                if ( flatNavigation[x].uisref )
                {
                    navigation.push(flatNavigation[x]);
                }
            }*/

            if(share.getDevice() != null){
              //navigation.push(share.getDevice()[0]);
		navigation = share.getDevice();
            }
            //console.log(navigation);

            // If there is a query, filter the navigation;
            // otherwise we will return the entire navigation
            // list. Not exactly a good thing to do but it's
            // for demo purposes.
            if ( query )
            {
                navigation = navigation.filter(function (item)
                {
                    if ( angular.lowercase(item.title).search(angular.lowercase(query)) > -1 )
                    {
                        return true;
                    }
                });
            }

            // Fake service delay
            $timeout(function ()
            {
                deferred.resolve(navigation);
            }, 1000);

            return deferred.promise;
        }

        /**
         * Search result click action
         *
         * @param item
         */
        function searchResultClick(item)
        {
            // If item has a link
            if ( item.uisref )
            {
                // If there are state params,
                // use them...
                if ( item.stateParams )
                {
                    $state.go(item.state, item.stateParams);
                }
                else
                {
                    $state.go(item.state);
                }
            }
            else if (item.deviceid){
              $state.go('app.device_details',{data : item})
            }
        }
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('QuickPanelController', QuickPanelController);

    /** @ngInject */
    function QuickPanelController(msApi)
    {
        var vm = this;

        // Data
        vm.date = new Date();
        vm.settings = {
            notify: true,
            cloud : false,
            retro : true
        };

        msApi.request('quickPanel.activities@get', {},
            // Success
            function (response)
            {
                vm.activities = response.data;
            }
        );

        msApi.request('quickPanel.events@get', {},
            // Success
            function (response)
            {
                vm.events = response.data;
            }
        );

        msApi.request('quickPanel.notes@get', {},
            // Success
            function (response)
            {
                vm.notes = response.data;
            }
        );

        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';
	agGrid.initialiseAgGridWithAngular1(angular);
    /**
     * Main module of the Fuse
     */
    angular
        .module('fuse', [

            // Common 3rd Party Dependencies
            'uiGmapgoogle-maps',
		'agGrid',
          //  'textAngular',
           // 'xeditable',

            // Core
            'app.core',

            // Navigation
            'app.navigation',

            // Toolbar
            'app.toolbar',

            // Quick Panel
           // 'app.quick-panel',

            // Apps
		//'app.dashboards',
            'app.login',

            'app.devices',

           // 'app.devicemanage',

            'app.pages',

            'app.appmanage',

            'app.createapp',

            'app.overview',
	    
	    'app.devicedetails',
	
	    'app.dashboard',

	   // 'app.register'
        ]);
})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .controller('MainController', MainController);

    /** @ngInject */
    function MainController($scope, $rootScope)
    {
        // Data

        //////////

        // Remove the splash screen
        $scope.$on('$viewContentAnimationEnded', function (event)
        {
            if ( event.targetScope.$id === $scope.$id )
            {
                $rootScope.$broadcast('msSplashScreen::remove');
            }
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .run(runBlock);

    /** @ngInject */
    function runBlock(msUtils, fuseGenerator, fuseConfig)
    {
        /**
         * Generate extra classes based on registered themes so we
         * can use same colors with non-angular-material elements
         */
        fuseGenerator.generate();

        /**
         * Disable md-ink-ripple effects on mobile
         * if 'disableMdInkRippleOnMobile' config enabled
         */
        if ( fuseConfig.getConfig('disableMdInkRippleOnMobile') && msUtils.isMobile() )
        {
            var bodyEl = angular.element('body');
            bodyEl.attr('md-no-ink', true);
        }

        /**
         * Put isMobile() to the html as a class
         */
        if ( msUtils.isMobile() )
        {
            angular.element('html').addClass('is-mobile');
        }

        /**
         * Put browser information to the html as a class
         */
        var browserInfo = msUtils.detectBrowser();
        if ( browserInfo )
        {
            var htmlClass = browserInfo.browser + ' ' + browserInfo.version + ' ' + browserInfo.os;
            angular.element('html').addClass(htmlClass);
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($ariaProvider, $logProvider, msScrollConfigProvider, fuseConfigProvider)
    {
        // Enable debug logging
        $logProvider.debugEnabled(true);

        /*eslint-disable */

        // ng-aria configuration
        $ariaProvider.config({
            tabindex: false
        });

        // Fuse theme configurations
        fuseConfigProvider.config({
            'disableCustomScrollbars'        : false,
            'disableCustomScrollbarsOnMobile': true,
            'disableMdInkRippleOnMobile'     : true
        });

        // msScroll configuration
        msScrollConfigProvider.config({
            wheelPropagation: true
        });

        /*eslint-enable */
    }
})();
(function ()
{
    'use strict';

    angular
        .module('fuse')
        .service('share', share);

    /** @ngInject */
    function share()
    {
      var product = [], addDevice, getDevice;
      var JSONToCSVConvertor ;

       addDevice = function(obj) {
         angular.forEach(obj, function(val) {
            val.title = val.mobilenumber;
		          product.push(val);
             if(val.employeeid != null){
               val.title = val.employeeid;
                product.push(val);
             }
          });

       };
       getDevice = function(){
          return product;
       };

       JSONToCSVConvertor = function (JSONData, ReportTitle, ShowLabel) {
            //If JSONData is not an object then JSON.parse will parse the JSON string in an Object
            var arrData = typeof JSONData != 'object' ? JSON.parse(JSONData) : JSONData;
            var CSV = '';

            //Set Report title in first row or line
            CSV += ReportTitle + '\r\n\n';

            //This condition will generate the Label/Header
            if (ShowLabel) {
                var row = "";
                //This loop will extract the label from 1st index of on array
                for (var index in arrData[0]) {
                    //Now convert each value to string and comma-seprated
                    row += index + ',';
                }

                row = row.slice(0, -1);
                //append Label row with line break
                CSV += row + '\r\n';
            }

            //1st loop is to extract each row
            for (var i = 0; i < arrData.length; i++) {
                var row = "";
                //2nd loop will extract each column and convert it in string comma-seprated
                for (var index in arrData[i]) {
                    row += '"' + arrData[i][index] + '",';
                }

                row.slice(0, row.length - 1);
                //add a line break after each row
                CSV += row + '\r\n';
            }

            if (CSV == '') {
                alert("Invalid data");
                return;
            }

            //Generate a file name
            var fileName = "";
            //this will remove the blank-spaces from the title and replace it with an underscore
            fileName += ReportTitle.replace(/ /g,"_");

            //Initialize file format you want csv or xls
            //var uri = 'data:text/csv;charset=utf-8,' + escape(CSV);

            // Now the little tricky part.
            // you can use either>> window.open(uri);
            // but this will not work in some browsers
            // or you will not get the correct file extension

            //this trick will generate a temp <a /> tag

             var csvData = new Blob([CSV], { type: 'text/csv' });
             var uri = URL.createObjectURL(csvData);
            // a.href =  csvUrl;
            var link = document.createElement("a");
            link.href = uri;

            //set the visibility hidden so it will not effect on your web-layout
            link.style = "visibility:hidden";
           link.download = fileName + ".csv";

            //this part will append the anchor tag and remove it after automatic click
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }

       return {
          addDevice: addDevice,
          getDevice: getDevice,
          JSONToCSVConvertor: JSONToCSVConvertor
       };
    }

})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .run(runBlock);

    /** @ngInject */
    function runBlock($rootScope, $timeout, $state)
    {
        // Activate loading indicator
        var stateChangeStartEvent = $rootScope.$on('$stateChangeStart', function ()
        {
            $rootScope.loadingProgress = true;
        });

        // De-activate loading indicator
        var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
        {
            $timeout(function ()
            {
                $rootScope.loadingProgress = false;
            });
        });

        // Store state in the root scope for easy access
        $rootScope.state = $state;

        // Cleanup
        $rootScope.$on('$destroy', function ()
        {
            stateChangeStartEvent();
            stateChangeSuccessEvent();
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('fuse')
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider, $locationProvider)
    {
        $locationProvider.html5Mode(true);

        $urlRouterProvider.otherwise('/login');

        /**
         * Layout Style Switcher
         *
         * This code is here for demonstration purposes.
         * If you don't need to switch between the layout
         * styles like in the demo, you can set one manually by
         * typing the template urls into the `State definitions`
         * area and remove this code
         */
        // Inject $cookies
        var $cookies;

        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Get active layout
        var layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

        var layouts = {
            verticalNavigation  : {
                main      : 'app/core/layouts/vertical-navigation.html',
                toolbar   : 'app/toolbar/layouts/vertical-navigation/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
            },
            verticalNavigationFullwidthToolbar  : {
                main      : 'app/core/layouts/vertical-navigation-fullwidth-toolbar.html',
                toolbar   : 'app/toolbar/layouts/vertical-navigation-fullwidth-toolbar/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
            },
            verticalNavigationFullwidthToolbar2  : {
                main      : 'app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html',
                toolbar   : 'app/toolbar/layouts/vertical-navigation-fullwidth-toolbar-2/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html'
            },
            horizontalNavigation: {
                main      : 'app/core/layouts/horizontal-navigation.html',
                toolbar   : 'app/toolbar/layouts/horizontal-navigation/toolbar.html',
                navigation: 'app/navigation/layouts/horizontal-navigation/navigation.html'
            },
            contentOnly         : {
                main      : 'app/core/layouts/content-only.html',
                toolbar   : '',
                navigation: ''
            },
            contentWithToolbar  : {
                main      : 'app/core/layouts/content-with-toolbar.html',
                toolbar   : 'app/toolbar/layouts/content-with-toolbar/toolbar.html',
                navigation: ''
            }
        };
        // END - Layout Style Switcher

        // State definitions
        $stateProvider
            .state('app', {
                abstract: true,
                views   : {
                    'main@'         : {
                        templateUrl: layouts[layoutStyle].main,
                        controller : 'MainController as vm'
                    },
                    'toolbar@app'   : {
                        templateUrl: layouts[layoutStyle].toolbar,
                        controller : 'ToolbarController as vm'
                    },
                    'navigation@app': {
                        templateUrl: layouts[layoutStyle].navigation,
                        controller : 'NavigationController as vm'
                    }
                }
            });
    }

})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .controller('IndexController', IndexController);

    /** @ngInject */
    function IndexController(fuseTheming)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('fuse');
})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .config(config);

    /** @ngInject */
    function config(uiGmapGoogleMapApiProvider, $translateProvider, $provide)
    {
        // Put your common app configurations here

        // uiGmapgoogle-maps configuration
        uiGmapGoogleMapApiProvider.configure({
            //key: 'AIzaSyBawTB5iTMCvdI0LGxhDVlRS_FdO1acGBI',
		key: 'AIzaSyB_IFYrxGz_pMK41ijkyitfzTRwAWz4CVQ',
            v        : '3.exp',
            libraries: 'weather,geometry,visualization'
        });

        // angular-translate configuration
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: '{part}/i18n/{lang}.json'
        });
        $translateProvider.preferredLanguage('en');
        $translateProvider.useSanitizeValueStrategy('sanitize');
    }

})();

(function () {
    'use strict';

    angular
        .module('fuse')
        .factory('api', apiService);

    /** @ngInject */
    function apiService($resource, $cookies) {
        var api = {};
        var token = $cookies.get('token');

        // Base Url
        api.baseUrl = 'app/data/';
        //	old
        // api.Url = 'http://192.168.10.130:3003/mdmserver/api/v1/';
        // api.socketUrl = 'http://192.168.10.130:3003';

        //	production
        api.Url = 'https://mdm.salesdiary.in:3001/mdmserver/api/v1/';
        api.socketUrl = 'https://mdm.salesdiary.in:3001';

        // local
        // api.Url = 'http://localhost:3000/mdmserver/api/v1/';
        // api.socketUrl = 'http://localhost:3000';
        //api.Url = 'http://192.168.10.117:3001/mdmserver/api/v1/';
        //api.socketUrl = 'http://192.168.10.117:3001';
        var corsAuthHeader = {'Authorization': "Bearer " + token, 'Access-Control-Allow-Origin':true}
        var contentHeader = {'Content-Type': 'application/json', 'Access-Control-Allow-Origin':true}

        api.login = $resource(api.Url + 'login');

        api.GetUserDetails = $resource(api.Url + 'getcurrentuser', null,
            {'get': {method: 'GET', headers: corsAuthHeader}});

        api.UpdateUser = $resource(api.Url + 'updateUser', null,
            {'update': {method: 'POST', headers: corsAuthHeader}});

        api.UpdatePassword = $resource(api.Url + 'updatePassword', null,
            {'update': {method: 'POST', headers: corsAuthHeader}});

        api.getdevices = $resource(api.Url + 'getalldevices', null,
            {'get': {method: 'GET', headers: corsAuthHeader}});

        api.searcdevices = $resource(api.Url + 'searchdevice', null,
            {'get': {method: 'POST', headers: corsAuthHeader}});

        api.getallapps = $resource(api.Url + 'getallapps', null,
            {'get': {method: 'GET', headers: corsAuthHeader}});

        api.createapp = $resource(api.Url + 'createapp', null,
            {'create': {method: 'POST', headers: corsAuthHeader}});

        api.registerUser = $resource(api.Url + 'registerUser', null,
            {'register': {method: 'POST', headers: corsAuthHeader}});

        api.GetDeviceLocation = $resource(api.Url + 'getdevicelocation', null,
            {'get': {method: 'GET', headers: corsAuthHeader}});

        api.PushNotification = $resource(api.Url + 'push_notification', null,
            {'notify': {method: 'POST', headers: corsAuthHeader}})

        api.LostSendMessage = $resource(api.Url + 'sendmessageiflost', null,
            {'sendlost': {method: 'POST', headers: corsAuthHeader}})

        api.DeviceAction = $resource(api.Url + 'device_action', null,
            {'action': {method: 'POST', headers: corsAuthHeader}})
        //return api;


        // APIs for Overview


        api.nrror = 'https://nrrka.salesdiary.in:4001/api/res_companies/';

        api.GetSummarry_nrror = $resource(api.nrror + 'get_summary', null,
            {'action': {method: 'POST', headers: contentHeader}})


        api.nrrne = 'https://nrrne.salesdiary.in:4002/api/res_companies/';

        api.GetSummarry_nrrne = $resource(api.nrrne + 'get_summary', null,
            {'action': {method: 'POST', headers: contentHeader}})


        api.nrrka = 'https://nrrka.salesdiary.in:4004/api/res_companies/';

        api.GetSummarry_nrrka = $resource(api.nrrka + 'get_summary', null,
            {'action': {method: 'POST', headers: contentHeader}})


        api.nrrkl = 'https://nrrkl.salesdiary.in:4005/api/res_companies/';

        api.GetSummarry_nrrkl = $resource(api.nrrkl + 'get_summary', null,
            {'action': {method: 'POST', headers: contentHeader}})


        api.nrrtn = 'https://nrrtn.salesdiary.in:4006/api/res_companies/';

        api.GetSummarry_nrrtn = $resource(api.nrrtn + 'get_summary', null,
            {'action': {method: 'POST', headers: contentHeader}})


        api.nrrap = 'https://nrrap.salesdiary.in:4007/api/res_companies/';

        api.GetSummarry_nrrap = $resource(api.nrrap + 'get_summary', null,
            {'action': {method: 'POST', headers: contentHeader}})


        api.nrrmb = 'https://nrrmb.salesdiary.in:4008/api/res_companies/';

        api.GetSummarry_nrrmb = $resource(api.nrrmb + 'get_summary', null,
            {'action': {method: 'POST', headers: contentHeader}})


        api.nrrmh = 'https://nrrmh.salesdiary.in:4009/api/res_companies/';

        api.GetSummarry_nrrmh = $resource(api.nrrmh + 'get_summary', null,
            {'action': {method: 'POST', headers: contentHeader}})

        api.nrrgj = 'https://nrrgj.salesdiary.in:4010/api/res_companies/';

        api.GetSummarry_nrrgj = $resource(api.nrrgj + 'get_summary', null,
            {'action': {method: 'POST', headers: contentHeader}})


        api.nrrwb = 'https://nrrwb.salesdiary.in:4011/api/res_companies/';

        api.GetSummarry_nrrwb = $resource(api.nrrwb + 'get_summary', null,
            {'action': {method: 'POST', headers: contentHeader}})


        api.nrrdl = 'https://nrrdl.salesdiary.in:4012/api/res_companies/';

        api.GetSummarry_nrrdl = $resource(api.nrrdl + 'get_summary', null,
            {'action': {method: 'POST', headers: contentHeader}})


        api.nrrbr = 'https://nrrbr.salesdiary.in:4013/api/res_companies/';

        api.GetSummarry_nrrbr = $resource(api.nrrbr + 'get_summary', null,
            {'action': {method: 'POST', headers: contentHeader}})

        api.nrrup = 'https://nrrup.salesdiary.in:4014/api/res_companies/';

        api.GetSummarry_nrrup = $resource(api.nrrup + 'get_summary', null,
            {'action': {method: 'POST', headers: contentHeader}})

        api.nrrrj = 'https://nrrrj.salesdiary.in:4016/api/res_companies/';

        api.GetSummarry_nrrrj = $resource(api.nrrrj + 'get_summary', null,
            {'action': {method: 'POST', headers: contentHeader}})

        api.nrrpb = 'https://nrrpb.salesdiary.in:4017/api/res_companies/';

        api.GetSummarry_nrrpb = $resource(api.nrrpb + 'get_summary', null,
            {'action': {method: 'POST', headers: contentHeader}})


        api.nrrmp = 'https://nrrmp.salesdiary.in:4018/api/res_companies/';

        api.GetSummarry_nrrmp = $resource(api.nrrmp + 'get_summary', null,
            {'action': {method: 'POST', headers: contentHeader}})


        return api;
    }


})();

(function ()
{
    'use strict';

    angular
        .module('app.pages', [
            /*'app.pages.auth.login',
            'app.pages.auth.login-v2',
            'app.pages.auth.register',*/
            /*'app.pages.auth.register-v2',
            'app.pages.auth.forgot-password',
            'app.pages.auth.reset-password',
            'app.pages.auth.lock',
            'app.pages.coming-soon',
            'app.pages.error-404',
            'app.pages.error-500',
            'app.pages.invoice',
            'app.pages.maintenance',*/
            'app.pages.profile'
            /*'app.pages.search',
            'app.pages.timeline'*/
        ])
        .config(config);

    /** @ngInject */
    function config(msNavigationServiceProvider)
    {
        // Navigation
       /* msNavigationServiceProvider.saveItem('pages', {
            title : 'PAGES',
            group : true,
            weight: 2
        });*/
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.components', [
            'app.components.cards',
            'app.components.charts.c3',
            'app.components.charts.chart-js',
            'app.components.charts.chartist',
            'app.components.charts.nvd3',
            'app.components.custom-directives',
            'app.components.maps',
            'app.components.price-tables',
            'app.components.tables.simple-table',
            'app.components.tables.datatable',
            'app.components.widgets',
            'app.components.material-docs'
        ])
        .config(config);

    /** @ngInject */
    function config(msNavigationServiceProvider)
    {
        // Navigation
        msNavigationServiceProvider.saveItem('components', {
            title : 'COMPONENTS',
            group : true,
            weight: 4
        });

        msNavigationServiceProvider.saveItem('components.cards', {
            title : 'Cards',
            icon  : 'icon-content-copy',
            state : 'app.components_cards',
            weight: 3
        });

        msNavigationServiceProvider.saveItem('components.charts', {
            title : 'Charts',
            icon  : 'icon-poll',
            weight: 4
        });

        msNavigationServiceProvider.saveItem('components.charts.c3', {
            title: 'C3',
            state: 'app.components_charts_c3'
        });

        msNavigationServiceProvider.saveItem('components.charts.chart-js', {
            title: 'Chart.js',
            state: 'app.components_charts_chart-js'
        });

        msNavigationServiceProvider.saveItem('components.charts.chartist', {
            title: 'Chartist',
            state: 'app.components_charts_chartist'
        });

        msNavigationServiceProvider.saveItem('components.charts.nvd3', {
            title: 'nvD3',
            state: 'app.components_charts_nvd3'
        });

        msNavigationServiceProvider.saveItem('components.maps', {
            title: 'Maps',
            icon : 'icon-map-marker',
            state: 'app.components_maps',
            weight: 5
        });

        msNavigationServiceProvider.saveItem('components.price-tables', {
            title: 'Price Tables',
            icon : 'icon-view-carousel',
            state: 'app.components_price-tables',
            weight: 6
        });

        msNavigationServiceProvider.saveItem('components.tables', {
            title: 'Tables',
            icon : 'icon-table-large',
            weight: 7
        });

        msNavigationServiceProvider.saveItem('components.tables.simple-table', {
            title: 'Simple Table',
            state: 'app.components_tables_simple-table',
            weight: 8
        });

        msNavigationServiceProvider.saveItem('components.tables.datatable', {
            title: 'Datatable',
            state: 'app.components_tables_datatable',
            weight: 9
        });

        msNavigationServiceProvider.saveItem('components.widgets', {
            title: 'Widgets',
            icon : 'icon-apps',
            state: 'app.components_widgets',
            weight: 10
        });
    }
})();
angular.module("fuse").run(["$templateCache", function($templateCache) {$templateCache.put("app/quick-panel/quick-panel.html","<md-content><md-tabs md-no-pagination md-swipe-content md-stretch-tabs=\"always\"><md-tab><md-tab-label><span \ntranslate=\"QUICKPANEL.TODAY\">TODAY</span></md-tab-label><md-tab-body><md-content class=\"today-tab scrollable\" \nms-scroll ng-include=\"\'app/quick-panel/tabs/today/today-tab.html\'\"></md-content></md-tab-body></md-tab><md-tab>\n<md-tab-label><span translate=\"QUICKPANEL.CHAT\">CHAT</span></md-tab-label><md-tab-body><md-content \nclass=\"chat-tab scrollable\" ms-scroll ng-include=\"\'app/quick-panel/tabs/chat/chat-tab.html\'\" \nng-controller=\"ChatTabController as vm\"></md-content></md-tab-body></md-tab><md-tab><md-tab-label><span \ntranslate=\"QUICKPANEL.ACTIVITY\">ACTIVITY</span></md-tab-label><md-tab-body><md-content class=\"activity-tab scrollable\" \nms-scroll ng-include=\"\'app/quick-panel/tabs/activity/activity-tab.html\'\"></md-content></md-tab-body></md-tab></md-tabs>\n</md-content>");
$templateCache.put("app/core/layouts/content-only.html","<div id=\"layout-content-only\" class=\"template-layout\" layout=\"column\" flex><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content></div>");
$templateCache.put("app/core/layouts/content-with-toolbar.html","<div id=\"layout-content-with-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content><md-sidenav id=\"quick-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n</div>");
$templateCache.put("app/core/layouts/horizontal-navigation.html","<div id=\"layout-horizontal-navigation\" class=\"template-layout\" layout=\"column\" flex><div \nid=\"toolbar-navigation-container\" class=\"md-whiteframe-1dp\" layout=\"column\" layout-align=\"space-between start\">\n<md-toolbar id=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"horizontal-navigation\" ui-view=\"navigation\" layout=\"row\" layout-align=\"start end\" flex></div></div><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar-2\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation.html","<div id=\"layout-vertical-navigation\" class=\"template-layout\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" \nclass=\"md-primary-bg\" md-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll \nui-view=\"navigation\"></md-sidenav><div id=\"content-container\" flex layout=\"column\"><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ms-scroll ui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n</div>");
$templateCache.put("app/core/theme-options/theme-options.html","<div class=\"ms-theme-options-button md-primary-bg\" ng-click=\"toggleOptionsSidenav()\"><md-icon md-font-icon=\"icon-cog\" \nclass=\"white-text\"></md-icon></div><md-sidenav md-component-id=\"fuse-theme-options\" class=\"md-sidenav-right\"><div \nclass=\"ms-theme-options-list\" layout=\"column\"><div class=\"theme-option layout-options\"><div class=\"option-title\">\nLayout Style:</div><md-radio-group layout=\"row\" layout-align=\"start start\" layout-wrap ng-model=\"vm.layoutStyle\" \nng-change=\"vm.updateLayoutStyle()\"><md-radio-button ng-repeat=\"layoutStyle in vm.layoutStyles\" \nng-value=\"layoutStyle.value\"><div layout=\"column\" layout-align=\"center center\"><img ng-src=\"{{layoutStyle.figure}}\"> \n<span class=\"text-center font-size-12 mt-8\">{{layoutStyle.label}}</span></div></md-radio-button></md-radio-group></div>\n<md-divider></md-divider><div class=\"theme-option\"><div class=\"option-title\">Layout Mode:</div><md-radio-group \nlayout=\"row\" layout-align=\"start center\" ng-model=\"vm.layoutMode\" ng-change=\"vm.updateLayoutMode()\"><md-radio-button \nng-repeat=\"layoutMode in vm.layoutModes\" ng-value=\"layoutMode.value\">{{layoutMode.label}}</md-radio-button>\n</md-radio-group></div><md-divider></md-divider><div class=\"theme-option color-palettes\"><div class=\"option-title\">\nColor Palette:</div><div layout=\"row\" layout-align=\"start start\" layout-wrap><md-button \nng-repeat=\"(themeName, theme) in vm.themes.list\" class=\"md-raised theme-button\" layout=\"row\" \nlayout-align=\"center center\" aria-label=\"{{themeName}}\" ng-click=\"vm.setActiveTheme(themeName)\" \nng-style=\"{\'background-color\': theme.primary.color,\'border-color\': theme.accent.color,\'color\': theme.primary.contrast1}\" \nng-class=\"{active: vm.getActiveTheme().name === themeName}\"><md-icon ng-style=\"{\'color\': theme.primary.contrast1}\" \nmd-font-icon=\"icon-palette\" class=\"icon s32\"></md-icon></md-button></div></div></div></md-sidenav>");
$templateCache.put("app/main/appmanage/appmanage.html","<div id=\"transactions\" class=\"page-layout simple tabbed\"><div class=\"content p-24\" flex=\"\"><md-content \nclass=\"white-bg md-whiteframe-4dp\"><div class=\"p-24 mb-8 border-bottom\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h2\" flex>Apps</div><md-button class=\"md-raised md-accent\" \nui-sref=\"app.create_app\">New App</md-button><div class=\"text-boxed red-bg white-fg m-0\">{{vm.allapps.length}} apps\n</div></div><table id=\"exportable\" class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead>\n<tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">#</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">App Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Package Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Created Date</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Status</span></div></th></tr></thead>\n<tbody><tr class=\"approw\" ng-repeat=\"app in vm.allapps track by $index\"><td>{{ $index+1 }}</td><td>{{app.appName}}</td>\n<td>{{app.packageName}}</td><td>{{app.appCreatedAt}}</td><td><span \nng-class=\"{\'status md-warn-bg\': app.appStatus === \'blocked\', \'status md-green-800-bg\': app.appStatus === \'allowed\'}\">\n{{ app.appStatus }}</span></td></tr></tbody></table></md-content></div></div>");
$templateCache.put("app/main/createapp/createapp.html","<div id=\"reset1-password\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"reset1-password-form-wrapper\" \nlayout=\"column\" layout-align=\"center center\"><div id=\"reset1-password-form\" class=\"md-whiteframe-8dp\"><div \nclass=\"title\">Add New APP</div><form name=\"requestForm\" novalidate ng-cloak ng-submit=\"vm.createapp(vm.appDetails)\">\n<md-input-container class=\"md-block\"><label>App Name</label><input type=\"text\" name=\"appname\" \nng-model=\"vm.appDetails.appName\" required><div ng-messages=\"requestForm.appname.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span>App Name field is required</span></div></div></md-input-container>\n<md-input-container class=\"md-block\"><label>Package Name</label><input type=\"text\" name=\"packagename\" \nng-model=\"vm.appDetails.packageName\" required><div ng-messages=\"requestForm.packagename.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span>Package Name field is required</span></div></div>\n</md-input-container><md-input-container><label>App Status</label><select type=\"text\" id=\"status\" \nng-model=\"vm.appDetails.appStatus\" required><option value=\"allowed\" selected=\"selected\">Allow</option><option \nvalue=\"blocked\">Block</option></select><div ng-messages=\"requestForm.status.$error\" role=\"alert\" multiple=\"multiple\">\n<div ng-message=\"required\"><span>App Status field is required</span></div></div></md-input-container><md-button \ntype=\"submit\" class=\"md-raised md-accent submit-button\" aria-label=\"Request\" \nng-disabled=\"requestForm.$invalid || requestForm.$pristine\">Submit</md-button></form></div></div></div>");
$templateCache.put("app/main/devicedetails/devicedetails.html","<div id=\"simple-table\" class=\"page-layout simple tabbed\"><div class=\"content p-12\"><div \nclass=\"widget-group layout-wrap ng-scope layout-row flex-100\" layout=\"row\" flex=\"100\" layout-wrap=\"\"><ms-widget \nlayout=\"column\" flex=\"100\" flex-gt-sm=\"50\" class=\"ms-widget ng-isolate-scope layout-column flex-gt-sm-50 flex-100\">\n<ms-widget-front class=\"white-bg ms-widget-front ng-scope\"><div class=\"h3 p-16 ng-scope\"><div class=\"h3 ng-binding\">\nProfile</div></div><md-divider class=\"ng-scope md-default-theme\"></md-divider><div \nclass=\"ph-32 margin-left-24 pv-24 ng-scope layout-align-space-between-center layout-row\" layout=\"row\" \nlayout-align=\"space-between center\"><div flex><img class=\"profile-image avatar huge\" \nsrc=\"assets/images/avatars/profile.jpg\"></div><div flex><div layout=\"column\"><div layout=\"row\" layout><div flex>\n<md-tooltip md-direction=\"left\">Employee Id</md-tooltip><md-button class=\"edit-button md-icon-button\" \naria-label=\"Order details\" translate translate-attr-aria-label=\"EC.ORDER_DETAILS\"><md-icon \nmd-font-icon=\"icon-clipboard-account\" class=\"s16\"></md-icon></md-button><span ng-bind=\"vm.deviceData.employeeid\" \nclass=\"secondary-text\"></span></div></div><div layout=\"row\" layout><div flex><md-tooltip md-direction=\"left\">\nMobile Number</md-tooltip><md-button class=\"edit-button md-icon-button\" aria-label=\"Order details\" translate \ntranslate-attr-aria-label=\"EC.ORDER_DETAILS\"><md-icon md-font-icon=\"icon-cellphone-iphone\" class=\"s16\"></md-icon>\n</md-button><span ng-bind=\"vm.deviceData.mobilenumber\" class=\"secondary-text\"></span></div></div><div layout=\"row\" \nlayout><div flex><md-tooltip md-direction=\"left\">User Name</md-tooltip><md-button class=\"edit-button md-icon-button\" \naria-label=\"Order details\" translate translate-attr-aria-label=\"EC.ORDER_DETAILS\"><md-icon \nmd-font-icon=\"icon-account-outline\" class=\"s16\"></md-icon></md-button><span ng-bind=\"vm.deviceData.username\" \nclass=\"secondary-text\"></span></div></div></div></div></div><div \nclass=\"ph-32 margin-left-24 pv-24 ng-scope layout-align-space-between-center layout-row\" layout=\"row\" \nlayout-align=\"space-between center\"><div flex><div class=\"h4 ng-binding\">Device Id</div></div><div flex><span \nng-bind=\"vm.deviceData.deviceid\" class=\"secondary-text\"></span></div></div><div \nclass=\"ph-32 margin-left-24 pv-24 ng-scope layout-align-space-between-center layout-row\" layout=\"row\" \nlayout-align=\"space-between center\"><div flex><div class=\"h4 ng-binding\">Model</div></div><div flex><span \nng-bind=\"vm.deviceData.modelid\" class=\"secondary-text\"></span></div></div><div \nclass=\"ph-32 margin-left-24 pv-24 ng-scope layout-align-space-between-center layout-row\" layout=\"row\" \nlayout-align=\"space-between center\"><div flex><div class=\"h4 ng-binding\">Status</div></div><div flex><span \nng-class=\"{\'dstatus md-warn-bg\': vm.deviceData.devicestatus === \'LOST\', \'dstatus md-deep-orange-bg\': vm.deviceData.devicestatus === \'WIPEDATA\', \'dstatus md-purple-300-bg\': vm.deviceData.devicestatus === \'SCREENLOCK\', \'dstatus md-green-800-bg\': vm.deviceData.devicestatus === \'ACTIVE\'}\">\n{{ vm.deviceData.devicestatus }}</span></div></div></ms-widget-front></ms-widget><ms-widget layout=\"column\" flex=\"100\" \nflex-gt-sm=\"50\" class=\"ms-widget ng-isolate-scope layout-column flex-gt-sm-50 flex-100\"><ms-widget-front \nclass=\"white-bg ms-widget-front ng-scope\"><div class=\"ph-16 border-bottom\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\">Actions</div><div class=\"pv-16\"><md-select class=\"simplified\" \nng-model=\"vm.currAction\" aria-label=\"Change range\" ng-change=\"vm.showConfirm($event)\"><md-option \nng-repeat=\"(index,action) in vm.actions\" value=\"{{action.id}}\" ng-selected=\"index == 0\">{{action.title}}</md-option>\n</md-select></div></div><md-divider></md-divider><div \nclass=\"ph-16 border-bottom ng-scope layout-align-space-between-center layout-row\" layout=\"row\" \nlayout-align=\"space-between center\"><div id=\"reset1-password\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div \nid=\"reset1-password-form-wrapper\" layout=\"column\" layout-align=\"center center\"><div id=\"reset1-password-form\" \nclass=\"md-whiteframe-8dp\"><form name=\"requestForm\" ng-show=\"vm.shownotify\" ng-cloak \nng-submit=\"vm.notification(requestForm)\"><md-input-container class=\"md-block\"><label>IMEI Number</label><input \ntype=\"text\" name=\"amount\" ng-disabled=\"true\" ng-model=\"vm.requestForm.deviceid\"></md-input-container>\n<md-input-container class=\"md-block\"><label>Message</label><textarea name=\"message\" ng-model=\"vm.requestForm.message\" \nng-disabled=\"vm.currAction!=\'notify\'\" md-maxlength=\"150\" rows=\"3\" required md-select-on-focus></textarea><div \nng-messages=\"requestForm.message.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nYou must supply a message.</span></div><div ng-message=\"md-maxlength\"><span>\nMessage can\'t be longer than 150 characters.</span></div></div></md-input-container><md-button type=\"submit\" \nclass=\"md-raised md-accent submit-button\" ng-disabled=\"requestForm.$invalid || requestForm.$pristine\" \naria-label=\"Request\">Send</md-button></form><form name=\"lostdeviceform\" ng-show=\"vm.showdevicelost\" novalidate \nng-cloak ng-submit=\"lostdeviceform.$valid && vm.sendlostmessage()\"><md-input-container class=\"md-block\"><div \nclass=\"p-16 ng-scope layout-align-space-between-center layout-row\" layout=\"row\" layout-align=\"space-between center\">\n</div></md-input-container><md-input-container class=\"md-block\"><label>IMEI Number</label><input type=\"text\" \nname=\"imeinumber\" ng-disabled=\"true\" ng-model=\"vm.lostdeviceform.deviceid\"></md-input-container><md-input-container \nclass=\"md-block\"><label>Mobile Number</label><input name=\"mobile\" placeholder=\"10 digit mobile number\" required \nminlength=\"10\" maxlength=\"100\" ng-pattern=\"/^[0-9]{10,10}$/\" ng-model=\"vm.lostdeviceform.mobile\"><div \nng-messages=\"lostdeviceform.mobile.$error\" role=\"alert\"><div \nng-message-exp=\"[\'required\', \'minlength\', \'maxlength\', \'pattern\']\">Enter 10 digit mobile number</div></div>\n</md-input-container><md-button type=\"submit\" class=\"md-raised md-accent submit-button\" aria-label=\"Request\">\nSend Message</md-button></form></div></div></div></div></ms-widget-front></ms-widget></div><div \nclass=\"widget-group layout-wrap ng-scope layout-row flex-100 ph-15 pv-10\" layout=\"row\" flex=\"100\" layout-wrap=\"\">\n<ms-widget ng-if=\"vm.missingloc==false\" layout=\"column\" flex=\"100\" flex-gt-sm=\"100\" \nclass=\"ms-widget ng-isolate-scope layout-column flex-gt-sm-100 flex-100\"><div class=\"h3 p-16 layout-row md-white-bg\" \nlayout=\"row\" layout-align=\"space-between center\"><div flex class=\"h3 ng-binding\">Location</div><div><span \nclass=\"status md-blue-bg\">Last location update: <b>{{vm.lastlocupdate}}</b></span></div></div><ms-widget-front \nclass=\"white-bg ms-widget-front ng-scope\"><md-divider></md-divider><div \nclass=\"ph-16 border-bottom ng-scope layout-align-space-between-center layout-row\" layout=\"row\" \nlayout-align=\"space-between center\"><ui-gmap-google-map center=\"vm.simpleMarkerMap.center\" \nzoom=\"vm.simpleMarkerMap.zoom\"><ui-gmap-marker coords=\"vm.simpleMarkerMap.marker.coords\" \nidkey=\"vm.simpleMarkerMap.marker.id\"></ui-gmap-marker></ui-gmap-google-map></div></ms-widget-front></ms-widget>\n<ms-widget ng-if=\"vm.missingloc==true\" layout=\"column\" flex=\"100\" flex-gt-sm=\"100\" \nclass=\"ms-widget ng-isolate-scope layout-column flex-gt-sm-100 flex-100\"><md-whiteframe class=\"md-whiteframe-2dp\" \nflex-sm=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"100\" layout layout-align=\"center center\"><h2>{{vm.missinglocstring}}</h2>\n</md-whiteframe></ms-widget></div></div></div>");
$templateCache.put("app/main/devicedetails/try.html","<ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" \nclass=\"ms-widget ng-isolate-scope layout-column flex-gt-sm-50 flex-100\"><ms-widget-front \nclass=\"white-bg ms-widget-front ng-scope\"><div \nclass=\"ph-16 border-bottom ng-scope layout-align-space-between-center layout-row\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3 ng-binding\">Profile</div><div class=\"pv-16\"><md-select \nclass=\"simplified ng-pristine ng-untouched ng-valid md-default-theme ng-empty\" ng-model=\"vm.widget6.currentRange\" \naria-label=\"Change range: This Week\" tabindex=\"0\" aria-disabled=\"false\" role=\"listbox\" aria-expanded=\"false\" \naria-multiselectable=\"false\" id=\"select_15\" aria-owns=\"select_container_16\" aria-invalid=\"false\"><md-select-value \nclass=\"md-select-value\" id=\"select_value_label_14\"><span><div class=\"md-text ng-binding\">User Details</div></span><span\n class=\"md-select-icon\" aria-hidden=\"true\"></span></md-select-value><div class=\"md-select-menu-container\" \naria-hidden=\"true\" id=\"select_container_16\"><md-select-menu class=\"_md md-default-theme\"><md-content \nclass=\"_md md-default-theme\"><md-option value=\"TW\" tabindex=\"0\" class=\"ng-scope md-ink-ripple\" aria-selected=\"true\" \nrole=\"option\" id=\"select_option_26\" selected=\"selected\"><div class=\"md-text ng-binding\">User Details</div></md-option>\n<md-option value=\"LW\" tabindex=\"0\" class=\"ng-scope md-ink-ripple\" role=\"option\" aria-selected=\"false\" \nid=\"select_option_27\"><div class=\"md-text ng-binding\">Device Details</div></md-option><md-option value=\"2W\" \ntabindex=\"0\" class=\"ng-scope md-ink-ripple\" role=\"option\" aria-selected=\"false\" id=\"select_option_28\"><div \nclass=\"md-text ng-binding\">Policies</div></md-option></md-content></md-select-menu></div></md-select></div></div><div \nclass=\"p-16 ng-scope\"></div><div class=\"p-16 ng-scope layout-align-space-between-center layout-row\" layout=\"row\" \nlayout-align=\"space-between center\"><div><div class=\"h3 ng-binding\">Group Meeting</div><div><span \nclass=\"secondary-text ng-binding\">In 32 minutes</span> <span ng-if=\"event.location\" class=\"ng-binding ng-scope\">\n, Room 1B</span></div></div><button class=\"md-icon-button md-button md-default-theme md-ink-ripple\" type=\"button\" \naria-label=\"More information\"><md-icon md-font-icon=\"icon-dots-vertical\" \nclass=\"ng-scope md-default-theme md-font material-icons icon-dots-vertical\" aria-hidden=\"true\"></md-icon></button>\n</div><div class=\"p-16 ng-scope layout-align-space-between-center layout-row\" layout=\"row\" \nlayout-align=\"space-between center\"><div><div class=\"h3 ng-binding\">Group Meeting</div><div><span \nclass=\"secondary-text ng-binding\">In 32 minutes</span> <span ng-if=\"event.location\" class=\"ng-binding ng-scope\">\n, Room 1B</span></div></div><button class=\"md-icon-button md-button md-default-theme md-ink-ripple\" type=\"button\" \naria-label=\"More information\"><md-icon md-font-icon=\"icon-dots-vertical\" \nclass=\"ng-scope md-default-theme md-font material-icons icon-dots-vertical\" aria-hidden=\"true\"></md-icon></button>\n</div><div class=\"pv-8 mh-16 border-top layout-wrap ng-scope layout-align-start-center layout-row\" layout=\"row\" \nlayout-align=\"start center\" layout-wrap=\"\"><div \nclass=\"pv-8 border-right layout-align-center-center layout-column flex-gt-xs-50 flex-100\" layout=\"column\" \nlayout-align=\"center center\" flex=\"100\" flex-gt-xs=\"50\"><span class=\"font-size-32 ng-binding\">294</span> <span \nclass=\"h4 ng-binding\">Today Sales</span></div><div \nclass=\"pv-8 layout-align-center-center layout-column flex-gt-xs-50 flex-100\" layout=\"column\" \nlayout-align=\"center center\" flex=\"100\" flex-gt-xs=\"50\"><span class=\"font-size-32 ng-binding\">987</span> <span \nclass=\"h4 ng-binding\">This Week Sales</span></div></div></ms-widget-front></ms-widget><ms-widget layout=\"column\" \nflex=\"100\" flex-gt-sm=\"50\" class=\"ms-widget ng-isolate-scope layout-column flex-gt-sm-50 flex-100\"><ms-widget-front \nclass=\"white-bg ms-widget-front ng-scope\"><div \nclass=\"ph-16 border-bottom ng-scope layout-align-space-between-center layout-row\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3 ng-binding\">Actions</div><div class=\"pv-16\"><md-select \nclass=\"simplified ng-pristine ng-untouched ng-valid md-default-theme ng-empty\" ng-model=\"vm.widget7.currentRange\" \naria-label=\"Change range: \n                                                Today\n                                            \" \ntabindex=\"0\" aria-disabled=\"false\" role=\"listbox\" aria-expanded=\"false\" aria-multiselectable=\"false\" id=\"select_18\" \naria-owns=\"select_container_19\" aria-invalid=\"false\"><md-select-value class=\"md-select-value\" \nid=\"select_value_label_17\"><span><div class=\"md-text ng-binding\">Notify</div></span><span class=\"md-select-icon\" \naria-hidden=\"true\"></span></md-select-value><div class=\"md-select-menu-container\" aria-hidden=\"true\" \nid=\"select_container_19\"><md-select-menu class=\"_md md-default-theme\"><md-content class=\"_md md-default-theme\">\n<md-option value=\"T\" tabindex=\"0\" class=\"ng-scope md-ink-ripple\" aria-selected=\"true\" role=\"option\" \nid=\"select_option_29\" selected=\"selected\"><div class=\"md-text ng-binding\">Notify</div></md-option><md-option \nvalue=\"TM\" tabindex=\"0\" class=\"ng-scope md-ink-ripple\" role=\"option\" aria-selected=\"false\" id=\"select_option_30\"><div \nclass=\"md-text ng-binding\">Device Lost</div></md-option><md-option value=\"TM\" tabindex=\"0\" \nclass=\"ng-scope md-ink-ripple\" role=\"option\" aria-selected=\"false\" id=\"select_option_30\"><div \nclass=\"md-text ng-binding\">Device Lock</div></md-option><md-option value=\"TM\" tabindex=\"0\" \nclass=\"ng-scope md-ink-ripple\" role=\"option\" aria-selected=\"false\" id=\"select_option_30\"><div \nclass=\"md-text ng-binding\">Data Wipe Out</div></md-option></md-content></md-select-menu></div></md-select></div></div>\n<div class=\"p-16 ng-scope layout-align-space-between-center layout-row\" layout=\"row\" \nlayout-align=\"space-between center\"><div><div class=\"h3 ng-binding\">Group Meeting</div><div><span \nclass=\"secondary-text ng-binding\">In 32 minutes</span> <span ng-if=\"event.location\" class=\"ng-binding ng-scope\">\n, Room 1B</span></div></div><button class=\"md-icon-button md-button md-default-theme md-ink-ripple\" type=\"button\" \naria-label=\"More information\"><md-icon md-font-icon=\"icon-dots-vertical\" \nclass=\"ng-scope md-default-theme md-font material-icons icon-dots-vertical\" aria-hidden=\"true\"></md-icon></button>\n</div><div class=\"p-16 ng-scope layout-align-space-between-center layout-row\" layout=\"row\" \nlayout-align=\"space-between center\"><div><div class=\"h3 ng-binding\">Coffee Break</div><div><span \nclass=\"secondary-text ng-binding\">10:30 AM</span></div></div><button \nclass=\"md-icon-button md-button md-default-theme md-ink-ripple\" type=\"button\" aria-label=\"More information\"><md-icon \nmd-font-icon=\"icon-dots-vertical\" class=\"ng-scope md-default-theme md-font material-icons icon-dots-vertical\" \naria-hidden=\"true\"></md-icon></button></div><div class=\"p-16 ng-scope layout-align-space-between-center layout-row\" \nlayout=\"row\" layout-align=\"space-between center\"><div><div class=\"h3 ng-binding\">Public Beta Release</div><div><span \nclass=\"secondary-text ng-binding\">11:00 AM</span></div></div><button \nclass=\"md-icon-button md-button md-default-theme md-ink-ripple\" type=\"button\" aria-label=\"More information\"><md-icon \nmd-font-icon=\"icon-dots-vertical\" class=\"ng-scope md-default-theme md-font material-icons icon-dots-vertical\" \naria-hidden=\"true\"></md-icon></button></div><div class=\"p-16 ng-scope layout-align-space-between-center layout-row\" \nlayout=\"row\" layout-align=\"space-between center\"><div><div class=\"h3 ng-binding\">Lunch</div><div><span \nclass=\"secondary-text ng-binding\">12:10 PM</span></div></div><button \nclass=\"md-icon-button md-button md-default-theme md-ink-ripple\" type=\"button\" aria-label=\"More information\"><md-icon \nmd-font-icon=\"icon-dots-vertical\" class=\"ng-scope md-default-theme md-font material-icons icon-dots-vertical\" \naria-hidden=\"true\"></md-icon></button></div><div class=\"p-16 ng-scope layout-align-space-between-center layout-row\" \nlayout=\"row\" layout-align=\"space-between center\"><div><div class=\"h3 ng-binding\">Dinner with David</div><div><span \nclass=\"secondary-text ng-binding\">17:30 PM</span></div></div><button \nclass=\"md-icon-button md-button md-default-theme md-ink-ripple\" type=\"button\" aria-label=\"More information\"><md-icon \nmd-font-icon=\"icon-dots-vertical\" class=\"ng-scope md-default-theme md-font material-icons icon-dots-vertical\" \naria-hidden=\"true\"></md-icon></button></div><div class=\"p-16 ng-scope layout-align-space-between-center layout-row\" \nlayout=\"row\" layout-align=\"space-between center\"><div><div class=\"h3 ng-binding\">Jane\'s Birthday Party</div><div><span \nclass=\"secondary-text ng-binding\">19:30 PM</span></div></div><button \nclass=\"md-icon-button md-button md-default-theme md-ink-ripple\" type=\"button\" aria-label=\"More information\"><md-icon \nmd-font-icon=\"icon-dots-vertical\" class=\"ng-scope md-default-theme md-font material-icons icon-dots-vertical\" \naria-hidden=\"true\"></md-icon></button></div><div class=\"p-16 ng-scope layout-align-space-between-center layout-row\" \nlayout=\"row\" layout-align=\"space-between center\"><div><div class=\"h3 ng-binding\">Overseer\'s Retirement Party</div><div>\n<span class=\"secondary-text ng-binding\">21:30 PM</span></div></div><button \nclass=\"md-icon-button md-button md-default-theme md-ink-ripple\" type=\"button\" aria-label=\"More information\"><md-icon \nmd-font-icon=\"icon-dots-vertical\" class=\"ng-scope md-default-theme md-font material-icons icon-dots-vertical\" \naria-hidden=\"true\"></md-icon></button></div></ms-widget-front></ms-widget>");
$templateCache.put("app/main/devicemanagement/devicemanagement.html","<div id=\"simple-table\" class=\"page-layout simple tabbed\"><div class=\"content\"><md-tabs md-dynamic-height \nmd-center-tabs=\"true\"><md-tab><md-tab-label><span>Push Notification</span></md-tab-label><md-tab-body><md-content \nclass=\"white-bg md-whiteframe-4dp\" ng-include=\"\'app/main/devicemanagement/tabs/fcm/fcm.html\'\"></md-content>\n</md-tab-body></md-tab><md-tab><md-tab-label><span>Locate Device</span></md-tab-label><md-tab-body><md-content \nclass=\"white-bg md-whiteframe-4dp\" ng-include=\"\'app/main/devicemanagement/tabs/loc/loc.html\'\"></md-content>\n</md-tab-body></md-tab><md-tab><md-tab-label><span>Device Lost</span></md-tab-label><md-tab-body><md-content \nclass=\"white-bg md-whiteframe-4dp\" ng-include=\"\'app/main/devicemanagement/tabs/lost/lost.html\'\"></md-content>\n</md-tab-body></md-tab><md-tab><md-tab-label><span>Data Clean</span></md-tab-label><md-tab-body><md-content \nclass=\"white-bg md-whiteframe-4dp\" ng-include=\"\'app/main/devicemanagement/tabs/clean/clean.html\'\"></md-content>\n</md-tab-body></md-tab><md-tab><md-tab-label><span>Screen Lock</span></md-tab-label><md-tab-body><md-content \nclass=\"white-bg md-whiteframe-4dp\" ng-include=\"\'app/main/devicemanagement/tabs/lock/lock.html\'\"></md-content>\n</md-tab-body></md-tab></md-tabs></div></div>");
$templateCache.put("app/main/login/login.html","<div id=\"login\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"login-form-wrapper\" layout=\"column\" \nlayout-align=\"center center\"><div id=\"login-form\" class=\"md-whiteframe-8dp\"><div class=\"logo md-accent-bg\"><span><img \nsrc=\"assets/images/logos/nrgroup.png\"></span></div><div class=\"title\" translate=\"LOGIN.TITLE\">Log in to your account\n</div><form name=\"loginForm\" ng-hide=\"vm.loginSubmit\" ng-submit=\"vm.FirstForm()\" novalidate><md-input-container \nclass=\"md-block\" md-no-float><input type=\"text\" name=\"username\" ng-model=\"vm.form.username\" placeholder=\"Username\" \nrequired><div ng-messages=\"loginForm.username.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\">\n<span>Username field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" \nmd-no-float><input type=\"password\" name=\"pasword\" ng-model=\"vm.form.password\" placeholder=\"Password\" required><div \nng-messages=\"loginForm.password.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nPassword field is required</span></div></div></md-input-container><md-button type=\"submit\" \nclass=\"md-raised md-accent submit-button\" aria-label=\"LOG IN\" ng-disabled=\"loginForm.$invalid || loginForm.$pristine\">\nLog In</md-button></form></div></div></div>");
$templateCache.put("app/main/devices/devices.html","<div id=\"transactions\" class=\"page-layout simple tabbed\"><div class=\"content p-24\" flex=\"\"><md-content \nclass=\"white-bg md-whiteframe-4dp\"><div class=\"p-24 mb-8 border-bottom\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h2\" flex>Devices<div ng-show=\"!vm.deviceList\"><div class=\"5\" \nlayout=\"column\" layout-sm=\"column\" layout-align=\"center center\">Loading...<md-progress-circular \nmd-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular></div></div></div><ms-widget layout=\"column\" \nflex=\"100\" flex-gt-sm=\"25\"><ms-widget-front class=\"white-bg\"><input type=\"text\" ng-model=\"vm.searchaggrid\" \nng-change=\"vm.searchGrid()\" placeholder=\"Type to Search\" style=\"padding: 3%\"></ms-widget-front></ms-widget><div \nclass=\"text-boxed red-bg white-fg m-0\">{{vm.devices.data.length}} Devices</div></div><div class=\"clusterize\"><table>\n<thead><tr></tr></thead></table><div ng-if=\"vm.deviceList\" ag-grid=\"vm.gridOptions\" class=\"ag-theme-material\" \nstyle=\"height: 600px\"></div></div></md-content></div></div>");
$templateCache.put("app/main/overview/overview.html","<div id=\"transactions\" class=\"page-layout simple tabbed\"><div class=\"content p-24\" flex=\"\"><md-content \nclass=\"white-bg md-whiteframe-4dp\"><div class=\"p-24 mb-8 border-bottom\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h2\" flex>OVERVIEW</div><ms-widget layout=\"column\" flex=\"100\" \nflex-gt-sm=\"25\"><ms-widget-front class=\"white-bg\"><div class=\"ph-8 pv-16 h-40\" layout=\"row\" \nlayout-align=\"space-between center\"><md-select class=\"simplified font-size-16\" ng-model=\"vm.DateFilter.currentRange\" \nng-change=\"vm.DateFilter.loadData(vm.DateFilter.currentRange)\" aria-label=\"Change range\"><md-option \nng-repeat=\"(key, range) in vm.DateFilter.months\" value=\"{{key}}\">{{range}}</md-option></md-select></div>\n</ms-widget-front></ms-widget><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"25\"><ms-widget-front class=\"white-bg\">\n<div class=\"ph-8 pv-16 h-40\" layout=\"row\" layout-align=\"space-between center\"><md-select \nclass=\"simplified font-size-16\" ng-model=\"vm.yearFilter.currentRange\" \nng-change=\"vm.DateFilter.loadData(vm.DateFilter.currentRange)\" aria-label=\"Change range\"><md-option \nng-repeat=\"(key, range) in vm.yearFilter.years\" value=\"{{key}}\">{{range}}</md-option></md-select></div>\n</ms-widget-front></ms-widget><button class=\"btn btn-link\" ng-click=\"exportData(\'#exportable\')\"><span \nclass=\"icon-export\" style=\"color: #2ee00d\" flex></span> Export to Excel</button></div><div id=\"exportable1\"><table \nid=\"exportable\" class=\"dataTable cell-border hover\"><thead><tr><th style=\"background-color: #ddd\" \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">#</span></div></th><th \nstyle=\"background-color: #ddd\" class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Status\n</span></div></th><th style=\"background-color: #ddd\" class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Instance</span></div></th><th style=\"background-color: #ddd\" class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Retailers</span></div></th><th style=\"background-color: #ddd\" \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Routes</span></div></th><th \nstyle=\"background-color: #FFD965\" class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Target\n</span></div></th><th style=\"background-color: #FFD965\" class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Revenue</span></div></th><th style=\"background-color: #FFD965\" class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Achievement</span></div></th><th style=\"background-color: #BDD6EE\" \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">TC</span></div></th><th \nstyle=\"background-color: #BDD6EE\" class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">VC</span>\n</div></th><th style=\"background-color: #BDD6EE\" class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">VC %</span></div></th><th style=\"background-color: #BDD6EE\" class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">PC</span></div></th><th style=\"background-color: #BDD6EE\" \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">PC %</span></div></th><th \nstyle=\"background-color: #C5E0B3\" class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Total SKU\n</span></div></th><th style=\"background-color: #C5E0B3\" class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Unique SKU</span></div></th><th style=\"background-color: #C5E0B3\" class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Avg SKU/Bill</span></div></th><th style=\"background-color: #C5E0B3\" \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Avg Order/Bill</span></div></th><th \nstyle=\"background-color: #F7CAAC\" class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\nPlanned Routes</span></div></th><th style=\"background-color: #F7CAAC\" class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\">Unique SKU/Route</span></div></th><th style=\"background-color: #F7CAAC\" \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">PC/Route</span></div></th><th \nstyle=\"background-color: #F7CAAC\" class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">VC/Route\n</span></div></th><th style=\"background-color: #F7CAAC\" class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Avg Revenue/Route</span></div></th><th style=\"background-color: #F7CAAC\" class=\"secondary-text\">\n<div class=\"table-header\"><span class=\"column-title\">Total SKU/Route</span></div></th><th \nstyle=\"background-color: #ACB9CA\" class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">MSS Ach\n</span></div></th><th style=\"background-color: #ACB9CA\" class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Focus Target</span></div></th><th style=\"background-color: #ACB9CA\" class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Focus Ach</span></div></th></tr></thead><tbody><ms-widget \nlayout=\"column\" flex=\"100\" flex-gt-sm=\"25\"><ms-widget-front class=\"white-bg\" ng-show=\"!vm.stateData.loaded\"><div \nclass=\"h-240\" layout=\"row\" layout-sm=\"column\" layout-align=\"center center\"><md-progress-circular \nmd-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular></div></ms-widget-front></ms-widget><tr \nstyle=\"background-color: #ddd\" class=\"devicerow\" ng-repeat=\"stateData in vm.stateData track by $index\"><th>\n{{ $index+1 }}</th><th style=\"background-color: #ddd\"><span style=\"color: #2ee00d\">{{ stateData.serverstatus }}</span>\n</th><th ng-click=\"vm.StateDetails($event,stateData.state)\" style=\"background-color: #ddd\"><span><a>\n{{stateData.state | uppercase}}</a></span></th><th style=\"background-color: #ddd\"><span>\n{{ stateData.total_retailer | number : fractionSize }}</span></th><th style=\"background-color: #ddd\"><span>\n{{ stateData.total_beat | number : fractionSize }}</span></th><th style=\"background-color: #FFD965\">\n{{stateData.schedule_target | number }}</th><th style=\"background-color: #FFD965\">\n{{stateData.revenue | number : fractionSize }}</th><th style=\"background-color: #FFD965\">\n{{(stateData.revenue/stateData.schedule_target)*100| number : 2}}%</th><th style=\"background-color: #BDD6EE\">\n{{stateData.planned_visit | number : fractionSize }}</th><th style=\"background-color: #BDD6EE\">\n{{stateData.visited_count | number : fractionSize}}</th><th style=\"background-color: #BDD6EE\">\n{{((stateData.visited_count/stateData.planned_visit)*100)| number : 2}}%</th><th style=\"background-color: #BDD6EE\">\n{{stateData.productive_calls | number : fractionSize}}</th><th style=\"background-color: #BDD6EE\">\n{{(stateData.productive_calls/stateData.visited_count)*100| number : 2}}%</th><th style=\"background-color: #C5E0B3\">\n{{stateData.total_sku | number : fractionSize}}</th><th style=\"background-color: #C5E0B3\">\n{{stateData.unique_sku| number : fractionSize}}</th><th style=\"background-color: #C5E0B3\">\n{{stateData.avg_sku| number : fractionSize}}</th><th style=\"background-color: #C5E0B3\">\n{{stateData.avg_order| number : fractionSize}}</th><th style=\"background-color: #F7CAAC\">\n{{stateData.planned_beat| number : fractionSize}}</th><th style=\"background-color: #F7CAAC\">\n{{stateData.unique_sku_beat| number : fractionSize}}</th><th style=\"background-color: #F7CAAC\">\n{{stateData.prod_call_beat| number : fractionSize}}</th><th style=\"background-color: #F7CAAC\">\n{{stateData.visited_count_beat| number : fractionSize}}</th><th style=\"background-color: #F7CAAC\">\n{{stateData.revenue_beat| number : fractionSize}}</th><th style=\"background-color: #F7CAAC\">\n{{stateData.total_sku_beat| number : fractionSize}}</th><th style=\"background-color: #ACB9CA\">\n{{stateData.mss_achievement| number : fractionSize}}</th><th style=\"background-color: #ACB9CA\">\n{{stateData.focus_target| number : fractionSize}}</th><th style=\"background-color: #ACB9CA\">\n{{stateData.focus_achievement| number : fractionSize}}</th></tr></tbody></table></div></md-content></div></div>");
$templateCache.put("app/core/directives/ms-info-bar/ms-info-bar.html","<div id=\"ms-info-bar\" layout=\"row\" layout-align=\"start center\" flex><div id=\"ms-info-bar-message\" ng-transclude flex>\n</div><md-button id=\"ms-info-bar-close\" class=\"md-icon-button\" aria-label=\"Close\" ng-click=\"removeInfoBar()\"><md-icon \nmd-font-icon=\"icon-close s24\"></md-icon></md-button></div>");
$templateCache.put("app/core/directives/ms-material-color-picker/ms-material-color-picker.html","<md-menu md-position-mode=\"target-right target\"><div ng-click=\"$mdOpenMenu($event)\"><ms-color-picker-button><md-button \naria-label=\"Row Color\" md-menu-origin ng-click=\"$mdOpenMenu($event)\" ng-class=\"vm.selectedColor.class\"><span \nng-show=\"vm.selectedColor.palette\">{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span \nng-show=\"!vm.selectedColor.palette\">Select Color</span></md-button></ms-color-picker-button></div><md-menu-content \nclass=\"ms-material-color-picker-menu-content\" layout-column><header \nng-class=\"vm.selectedColor.class || \'md-accent-bg\'\" class=\"md-whiteframe-4dp\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button md-prevent-menu-close ng-click=\"vm.activateHueSelection(false,false)\" \nclass=\"md-icon-button\" ng-class=\"{\'hidden\':!vm.selectedPalette}\" aria-label=\"Palette\"><md-icon \nmd-font-icon=\"icon-arrow-left\" class=\"s20\"></md-icon></md-button><span ng-if=\"vm.selectedColor.palette\">\n{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span ng-if=\"!vm.selectedColor.palette\">Select Color\n</span><md-button class=\"remove-color-button md-icon-button\" ng-click=\"vm.removeColor()\" aria-label=\"Remove Color\">\n<md-icon md-font-icon=\"icon-delete\" class=\"s20\"></md-icon></md-button></header><div class=\"colors\" ms-scroll><div \nng-show=\"!vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" ng-class=\"\'md-\'+palette+\'-500-bg\'\" \nng-repeat=\"(palette, hues) in vm.palettes\" ng-click=\"vm.activateHueSelection(palette,hues)\" layout=\"row\" \nlayout-align=\"start end\" md-prevent-menu-close md-ink-ripple><span class=\"label\">{{palette}}</span></div></div><div \nng-show=\"vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" \nng-class=\"\'md-\'+vm.selectedPalette+\'-\'+hue+\'-bg\'\" ng-repeat=\"(hue, values) in vm.selectedHues\" \nng-click=\"vm.selectColor(vm.selectedPalette,hue)\" layout=\"row\" layout-align=\"start end\" md-ink-ripple><span \nclass=\"label\">{{hue}} </span><i ng-if=\"vm.selectedPalette == vm.selectedColor.palette && hue == vm.selectedColor.hue\" \nclass=\"s16 icon-check\"></i></div></div></div></md-menu-content></md-menu>");
$templateCache.put("app/core/directives/ms-search-bar/ms-search-bar.html","<div flex layout=\"row\" layout-align=\"start center\"><label for=\"ms-search-bar-input\"><md-button \nclass=\"ms-search-bar-expander md-icon-button\" aria-label=\"Expand Search Bar\" ng-click=\"MsSearchBar.expand()\" \nng-if=\"!MsSearchBar.resultsLoading || MsSearchBar.collapsed\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\">\n</md-icon></md-button><div class=\"ms-search-bar-loader\" layout=\"row\" layout-align=\"center center\" \nng-if=\"MsSearchBar.resultsLoading && !MsSearchBar.collapsed\"><md-progress-circular class=\"md-accent\" md-diameter=\"32\" \nmd-mode=\"indeterminate\"></md-progress-circular></div></label><input id=\"ms-search-bar-input\" type=\"text\" \nplaceholder=\"Enter Mobile number / Emp Id\" flex ng-model=\"MsSearchBar.query\" \nng-model-options=\"MsSearchBar.queryOptions\" ng-blur=\"MsSearchBar.collapse()\" \nng-keydown=\"MsSearchBar.handleKeydown($event)\"><md-button class=\"ms-search-bar-collapser md-icon-button\" \nng-click=\"MsSearchBar.collapse()\" aria-label=\"Collapse Search Bar\"><md-icon md-font-icon=\"icon-close\" class=\"icon s24\">\n</md-icon></md-button><div class=\"ms-search-bar-results\" ng-if=\"MsSearchBar.results\" ms-scroll><div class=\"no-results\" \nng-if=\"MsSearchBar.results.length === 0\">No Results!</div><div class=\"result\" \nng-repeat=\"result in MsSearchBar.results track by $index\" ng-click=\"MsSearchBar.handleResultClick(result)\" \nng-mouseenter=\"MsSearchBar.handleMouseenter($index)\" ng-mousedown=\"MsSearchBar.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsSearchBar.selectedResultIndex}\" md-ink-ripple><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"icon-container\" layout=\"row\" layout-align=\"center center\"><i \nng-if=\"result.icon\" class=\"icon {{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div>\n<div><div class=\"title\">{{result.title}}</div><div class=\"description\" ng-if=\"result.description\">\n{{result.description}}</div></div></div></div></div></div>");
$templateCache.put("app/core/directives/ms-shortcuts/ms-shortcuts.html","<div class=\"shortcuts-container\" layout=\"row\" layout-align=\"space-between center\" flex \nng-class=\"{\'mobile-bar-active\': MsShortcuts.mobileBarActive}\"><div class=\"flex-noshrink\" layout=\"row\" \nlayout-align=\"start center\" flex><div class=\"shortcuts hide show-gt-xs\" layout=\"row\" layout-align=\"start center\" \nms-scroll ng-if=\"MsShortcuts.shortcuts.length > 0\" ng-sortable=\"MsShortcuts.sortableOptions\"><div \nng-repeat=\"shortcut in MsShortcuts.shortcuts\" layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-icon-button shortcut\" aria-label=\"{{shortcut.title}}\" ui-sref=\"{{shortcut.uisref}}\"><md-icon \nng-if=\"shortcut.icon\" md-font-icon=\"{{shortcut.icon}}\" class=\"icon s24\"></md-icon><div ng-if=\"!shortcut.icon\" \nclass=\"first-letter\">{{shortcut.title.charAt(0)}}</div><md-tooltip md-direction=\"bottom\">{{shortcut.title}}\n</md-tooltip></md-button></div></div><md-menu md-offset=\"8 56\" class=\"shortcut-menu hide show-gt-xs\"><md-button \nclass=\"md-icon-button add-shortcut-button\" aria-label=\"Add shortcut\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-menu-origin md-font-icon=\"icon-star\" class=\"icon amber-600-fg s24\"></md-icon><md-tooltip md-direction=\"bottom\">\nClick to add/remove shortcut</md-tooltip></md-button><md-menu-content><div id=\"ms-shortcut-add-menu\"><div \nclass=\"shortcut-search\" layout=\"row\" layout-align=\"start center\"><div class=\"search-icon\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"!MsShortcuts.resultsLoading\"><md-icon md-menu-align-target \nmd-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon></div><div class=\"shortcut-loader\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"MsShortcuts.resultsLoading\"><md-progress-circular class=\"md-accent\" \nmd-diameter=\"20\" md-mode=\"indeterminate\"></md-progress-circular></div><input type=\"text\" placeholder=\"Search\" flex \nng-model=\"MsShortcuts.query\" ng-model-options=\"MsShortcuts.queryOptions\" \nng-keydown=\"MsShortcuts.handleKeydown($event)\"></div><div class=\"results\" ng-if=\"MsShortcuts.results\" ms-scroll><div \nclass=\"no-results\" ng-if=\"MsShortcuts.results.length === 0\">No Results!</div><div class=\"result\" \nng-repeat=\"result in MsShortcuts.results\" ng-click=\"MsShortcuts.handleResultClick(result)\" \nng-mouseenter=\"MsShortcuts.handleMouseenter($index)\" ng-mousedown=\"MsShortcuts.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsShortcuts.selectedResultIndex}\" md-prevent-menu-close=\"md-prevent-menu-close\" \nmd-ink-ripple><div layout=\"row\" layout-align=\"start space-between\"><div layout=\"row\" layout-align=\"start center\" flex>\n<div class=\"icon icon-container\" layout=\"row\" layout-align=\"center center\"><i ng-if=\"result.icon\" \nclass=\"{{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div><div><div class=\"title\">\n{{result.title}}</div></div></div><md-icon md-font-icon=\"icon-pin\" class=\"icon s18\" \nng-class=\"{\'fade-text\': !result.hasShortcut}\"></md-icon></div></div></div></div></md-menu-content></md-menu></div>\n<md-button class=\"md-icon-button toggle-mobile-menu hide-gt-xs\" aria-label=\"Add shortcut\" \nng-click=\"MsShortcuts.toggleMobileBar()\"><md-icon md-menu-origin md-font-icon=\"icon-star\" \nclass=\"icon amber-600-fg s24\" ng-hide=\"MsShortcuts.mobileBarActive\"></md-icon><md-icon md-menu-origin \nmd-font-icon=\"icon-close\" class=\"icon s24\" ng-hide=\"!MsShortcuts.mobileBarActive\"></md-icon></md-button></div>");
$templateCache.put("app/main/apps/dashboards/dashboards.html","<div id=\"dashboard-project\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"center\" flex ms-scroll>\n<div class=\"content\"><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"row\" flex=\"100\">\n<ms-widget-front class=\"white-bg\"><div class=\"ph-16 pv-8 border-bottom\" layout=\"row\" \nlayout-align=\"space-between center\" layout-wrap><div class=\"pv-8 h3\">{{vm.widget5.title}}</div><div class=\"pv-8\" \nlayout=\"row\" layout-align=\"start center\" layout-align-sm=\"end\" flex-sm=\"100\"><md-button class=\"ph-16\" \nng-repeat=\"(key, range) in vm.widget5.ranges\" ng-click=\"vm.widget5.changeRange(key)\" \nng-disabled=\"vm.widget5.currentRange == key\">{{range}}</md-button></div></div><div layout=\"row\" \nlayout-align=\"start center\" layout-wrap><div class=\"p-16\" layout=\"row\" flex=\"100\" flex-gt-sm=\"50\"><nvd3 \nclass=\"h-420 remove-x-lines\" config=\"vm.widget5.mainChart.config\" options=\"vm.widget5.mainChart.options\" \ndata=\"vm.widget5.mainChart.data\"></nvd3></div><div class=\"p-16\" layout=\"row\" flex=\"100\" flex-gt-sm=\"50\" layout-wrap>\n<div class=\"p-16\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" layout-align=\"center\" \nng-repeat=\"(name, widget) in vm.widget5.supporting.widgets\"><div class=\"h4 secondary-text\">{{widget.data.label}}</div>\n<div class=\"md-display-1\">{{widget.data.count[vm.widget5.currentRange]}}</div><nvd3 class=\"h-50\" \nconfig=\"vm.widget5.supporting.chart.config\" options=\"vm.widget5.supporting.chart.options\" data=\"widget.chart.data\">\n</nvd3></div></div></div></ms-widget-front></ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" \nlayout-wrap><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"50\"><ms-widget-front class=\"white-bg\"><div \nclass=\"h3 p-16\">{{vm.widget8.title}}</div><md-divider></md-divider><div class=\"p-16\"><nvd3 class=\"h-400\" \noptions=\"vm.widget8.mainChart.options\" data=\"vm.widget8.mainChart.data\"></nvd3></div></ms-widget-front></ms-widget>\n<ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"50\"><ms-widget-front class=\"white-bg\"><div \nclass=\"ph-16 border-bottom\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">{{vm.widget9.title}}</div>\n<div class=\"pv-16\"><md-select class=\"simplified\" ng-model=\"vm.widget9.currentRange\" \nng-change=\"vm.widget9.changeRange(vm.widget9.currentRange)\" aria-label=\"Change range\"><md-option \nng-repeat=\"(key, range) in vm.widget6.ranges\" value=\"{{key}}\">{{range}}</md-option></md-select></div></div><div \nclass=\"p-16\" layout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"space-between center\"><div \nclass=\"p-8\"><div class=\"h4 secondary-text\">{{vm.widget9.weeklySpent.title}}</div><div \nclass=\"pt-8 md-display-1 font-weight-300\"><span class=\"secondary-text\">&#8377</span><span>\n{{vm.widget9.weeklySpent.count[vm.widget9.currentRange]}}</span></div></div><div class=\"p-8\" flex><nvd3 class=\"h-50\" \nconfig=\"vm.widget9.chart.config\" options=\"vm.widget9.chart.options\" data=\"vm.widget9.weeklySpent.chartData\"></nvd3>\n</div></div><div class=\"p-16\" layout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" \nlayout-align-gt-xs=\"space-between center\"><div class=\"p-8\"><div class=\"h4 secondary-text\">\n{{vm.widget9.totalSpent.title}}</div><div class=\"pt-8 md-display-1 font-weight-300\"><span class=\"secondary-text\">&#8377\n</span><span>{{vm.widget9.totalSpent.count[vm.widget9.currentRange]}}</span></div></div><div class=\"p-8\" flex><nvd3 \nclass=\"h-50\" config=\"vm.widget9.chart.config\" options=\"vm.widget9.chart.options\" \ndata=\"vm.widget9.totalSpent.chartData\"></nvd3></div></div><div class=\"p-16\" layout=\"column\" layout-align=\"center\" \nlayout-gt-xs=\"row\" layout-align-gt-xs=\"space-between center\"><div class=\"p-8\"><div class=\"h4 secondary-text\">\n{{vm.widget9.remaining.title}}</div><div class=\"pt-8 md-display-1 font-weight-300\"><span class=\"secondary-text\">&#8377\n</span><span>{{vm.widget9.remaining.count[vm.widget9.currentRange]}}</span></div></div><div class=\"p-8\" flex><nvd3 \nclass=\"h-50\" config=\"vm.widget9.chart.config\" options=\"vm.widget9.chart.options\" data=\"vm.widget9.remaining.chartData\">\n</nvd3></div></div><div class=\"pv-24 mh-24 border-top\"><div class=\"h4 secondary-text\">{{vm.widget9.totalBudget.title}}\n</div><div class=\"pt-8 md-display-1 font-weight-300\"><span class=\"secondary-text\">&#8377</span><span>\n{{vm.widget9.totalBudget.count}}</span></div></div></ms-widget-front></ms-widget></div></div></div><md-sidenav \nclass=\"sidenav md-sidenav-right\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll \nms-sidenav-helper><div class=\"widget-group\"><ms-widget flippable=\"false\" class=\"sidenav-widget\"><ms-widget-front><div \nclass=\"pl-16 pr-8 pv-16\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">\n{{vm.nowWidget.now.weekDay}}, {{vm.nowWidget.now.hour}}:{{vm.nowWidget.now.minute}}:{{vm.nowWidget.now.second}}</div>\n<md-menu><md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" md-menu-origin md-menu-align-target \naria-label=\"Options\"><md-icon md-font-icon=\"icon-dots-vertical\" class=\"icon\"></md-icon></md-button><md-menu-content \nwidth=\"3\"><md-menu-item><md-button ng-click=\"vm.nowWidget.dummyFunction()\"><md-icon md-font-icon=\"icon-refresh\" \nclass=\"icon\"></md-icon>Refresh</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.nowWidget.dummyFunction()\"><md-icon md-font-icon=\"icon-cog\" class=\"icon\"></md-icon>Settings</md-button>\n</md-menu-item></md-menu-content></md-menu></div><div class=\"p-16 pb-24\" layout=\"column\" layout-align=\"center center\">\n<div class=\"h1 secondary-text\"><span>{{vm.nowWidget.now.month}}</span></div><div \nclass=\"font-size-72 line-height-88 secondary-text font-weight-400\">{{vm.nowWidget.now.day}}</div><div \nclass=\"h1 secondary-text\"><span>{{vm.nowWidget.now.year}}</span></div></div><md-divider></md-divider></ms-widget-front>\n</ms-widget><ms-widget flippable=\"false\" class=\"sidenav-widget\"><ms-widget-front><div class=\"pl-16 pr-8 pv-16\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"h4\"><md-icon md-font-icon=\"icon-map-marker\" \nclass=\"icon mr-8\"></md-icon>{{vm.weatherWidget.locations[vm.weatherWidget.currentLocation].name}}</div><md-menu>\n<md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" md-menu-origin md-menu-align-target aria-label=\"Options\">\n<md-icon md-font-icon=\"icon-dots-vertical\" class=\"icon\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item>\n<md-button ng-click=\"vm.nowWidget.dummyFunction()\"><md-icon md-font-icon=\"icon-refresh\" class=\"icon\"></md-icon>Refresh\n</md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.nowWidget.dummyFunction()\"><md-icon \nmd-font-icon=\"icon-cog\" class=\"icon\"></md-icon>Settings</md-button></md-menu-item></md-menu-content></md-menu></div>\n<div class=\"p-16 pb-32\" layout=\"column\" layout-align=\"center center\"><div layout=\"row\" layout-align=\"center center\">\n<md-icon md-font-icon=\"{{vm.weatherWidget.locations[vm.weatherWidget.currentLocation].icon}}\" class=\"icon s40 mr-16\">\n</md-icon><span class=\"md-display-2 font-weight-300 secondary-text\">\n{{vm.weatherWidget.locations[vm.weatherWidget.currentLocation].temp[vm.weatherWidget.tempUnit]}} </span><span \nclass=\"font-size-48 font-weight-300 hint-text text-super ml-8\">&deg;</span> <span \nclass=\"md-display-2 font-weight-300 hint-text\">{{vm.weatherWidget.tempUnit}}</span></div></div><div \nclass=\"grey-300-bg p-16\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-weather-windy\" class=\"icon mr-8 s20\"></md-icon><span>\n{{vm.weatherWidget.locations[vm.weatherWidget.currentLocation].windSpeed[vm.weatherWidget.speedUnit]}} </span><span \nclass=\"secondary-text ml-5\">{{vm.weatherWidget.speedUnit}}</span></div><div layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-compass-outline\" class=\"icon mr-8 s20\"></md-icon><span>\n{{vm.weatherWidget.locations[vm.weatherWidget.currentLocation].windDirection}}</span></div><div layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-umbrella\" class=\"icon mr-8 s20\"></md-icon><span>\n{{vm.weatherWidget.locations[vm.weatherWidget.currentLocation].rainProbability}}</span></div></div><div class=\"pv-16\">\n<div class=\"pv-16 ph-24\" layout=\"row\" layout-align=\"space-between center\" \nng-repeat=\"day in vm.weatherWidget.locations[vm.weatherWidget.currentLocation].next3Days\"><span class=\"h4\">{{day.name}}\n</span><div layout=\"row\" layout-align=\"start center\"><md-icon class=\"mr-16\" md-font-icon=\"{{day.icon}}\" class=\"icon\">\n</md-icon><span class=\"h2\">{{day.temp[vm.weatherWidget.tempUnit]}}</span> <span \nclass=\"h2 font-weight-300 secondary-text text-super\">&deg;</span> <span class=\"h2 font-weight-300 secondary-text\">\n{{vm.weatherWidget.tempUnit}}</span></div></div></div><md-divider></md-divider></ms-widget-front></ms-widget></div>\n</md-sidenav></div>");
$templateCache.put("app/main/components/maps/maps.html","<div id=\"maps\" class=\"page-layout simple tabbed doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">COMPONENTS</span></div><div \nclass=\"title\">Maps</div></div><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-raised reference-button\" href=\"http://angular-ui.github.io/angular-google-maps/\" target=\"_blank\"><md-icon \nmd-font-icon=\"icon-link\"></md-icon><span>Reference</span></md-button></div></div><div class=\"content\"><md-nav-bar \nmd-selected-nav-item=\"vm.selectedNavItem\" nav-bar-aria-label=\"Maps\"><md-nav-item md-nav-sref=\"app.components_maps\" \nname=\"simpleMap\">Simple Map</md-nav-item><md-nav-item md-nav-sref=\"app.components_maps.satellite\" name=\"satelliteMap\">\nSatellite Map</md-nav-item><md-nav-item md-nav-sref=\"app.components_maps.terrain\" name=\"terrainMap\">Terrain Map\n</md-nav-item><md-nav-item md-nav-sref=\"app.components_maps.simple-marker\" name=\"simpleMarkerMap\">Simple Marker\n</md-nav-item><md-nav-item md-nav-sref=\"app.components_maps.custom-marker\" name=\"customMarkerMap\">Custom Marker\n</md-nav-item><md-nav-item md-nav-sref=\"app.components_maps.info-window\" name=\"infoWindowMap\">Info Window</md-nav-item>\n</md-nav-bar><md-content ui-view=\"tabContent\" flex class=\"card md-whiteframe-4dp\"></md-content></div></div>");
$templateCache.put("app/main/pages/maintenance/maintenance.html","<div id=\"maintenance\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"maintenance-form-wrapper\" \nlayout=\"column\" layout-align=\"center center\"><div id=\"maintenance-form\" class=\"md-whiteframe-8dp\"><div \nclass=\"logo md-accent-bg\"><span>F</span></div><div class=\"title\" translate=\"MAINTENANCE.TITLE\">\nClosed for scheduled maintenance!</div><div class=\"subtitle\" translate=\"MAINTENANCE.SUBTITLE\">\nWe\'re sorry for the inconvenience.<br>Please check back later.</div></div></div></div>");
$templateCache.put("app/main/pages/profile/profile.html","<div id=\"simple-table\" class=\"page-layout simple tabbed\"><div class=\"content p-12\"><div \nclass=\"widget-group layout-wrap ng-scope layout-row flex-100\" layout=\"row\" flex=\"100\" layout-wrap=\"\"><ms-widget \nlayout=\"column\" flex=\"100\" flex-gt-sm=\"50\" class=\"ms-widget ng-isolate-scope layout-column flex-gt-sm-50 flex-100\">\n<ms-widget-front class=\"white-bg ms-widget-front ng-scope\"><div \nclass=\"ph-16 border-bottom ng-scope layout-align-space-between-center layout-row\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3 ng-binding\">Account Information</div><div class=\"pv-16\"><md-button \nflex=\"90\" flex-gt-md=\"90\" flex-gt-sm=\"90\" id=\"approveBtn\" class=\"md-fab my-fab\" ng-click=\"vm.UserEdit = true\" \nng-disabled=\"vm.UserEdit\" aria-label=\"Edit\"><md-icon md-font-icon=\"icon-pencil\" class=\"icon\"></md-icon></md-button>\n</div></div><form name=\"UserDetailsForm\" ng-submit=\"vm.FormUserSubmit(vm.UserDetails)\" novalidate><div \nclass=\"p-16 ng-scope layout-align-space-between-center layout-row\" layout=\"row\" layout-align=\"space-between center\">\n<input type=\"hidden\" name=\"username\" ng-model=\"vm.UserDetails.username\" ng-disabled=\"!vm.UserEdit\" \naria-label=\"General Form\" required><div class=\"info-line\"><div class=\"title\">First Name</div><div class=\"info\">\n<md-input-container class=\"md-block no-float\"><input type=\"text\" name=\"firstName\" ng-model=\"vm.UserDetails.firstName\" \nng-disabled=\"!vm.UserEdit\" aria-label=\"General Form\" required><div ng-messages=\"UserDetailsForm.firstName.$error\" \nrole=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>First Name field is required</span></div><div \nng-message=\"pattern\"><span>First Name must be a valid</span></div></div></md-input-container></div></div></div><div \nclass=\"p-16 ng-scope layout-align-space-between-center layout-row\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"info-line\"><div class=\"title\">Email ID</div><div class=\"info\"><md-input-container \nclass=\"md-block no-float\"><input type=\"text\" name=\"emailid\" ng-model=\"vm.UserDetails.emailId\" \nng-disabled=\"!vm.UserEdit\" aria-label=\"General Form\" required><div ng-messages=\"UserDetailsForm.emailid.$error\" \nrole=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>Email field is required</span></div><div \nng-message=\"pattern\"><span>Email must be a valid</span></div></div></md-input-container></div></div></div><div \nclass=\"p-16 ng-scope layout-align-space-between-center layout-row\" layout=\"row\" layout-align=\"space-between center\">\n<md-button type=\"submit\" class=\"md-raised md-accent submit-button\" aria-label=\"Update\" \nng-disabled=\"UserDetailsForm.$invalid || UserDetailsForm.$pristine\" ng-show=\"vm.UserEdit\">Update User</md-button></div>\n</form></ms-widget-front></ms-widget><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" \nclass=\"ms-widget ng-isolate-scope layout-column flex-gt-sm-50 flex-100\"><ms-widget-front \nclass=\"white-bg ms-widget-front ng-scope\"><div \nclass=\"ph-16 border-bottom ng-scope layout-align-space-between-center layout-row\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3 ng-binding\">Change Password</div><div class=\"pv-16\"><md-button \nflex=\"90\" flex-gt-md=\"90\" flex-gt-sm=\"90\" id=\"approveBtn\" class=\"md-fab my-fab\" ng-click=\"vm.PasswordEdit = true\" \nng-disabled=\"vm.PasswordEdit\" aria-label=\"Edit\"><md-icon md-font-icon=\"icon-pencil\" class=\"icon\"></md-icon></md-button>\n</div></div><form name=\"ChangePasswordForm\" ng-submit=\"vm.FormChangePassword(vm.ChangePassword)\" novalidate><div \nclass=\"p-16 ng-scope layout-align-space-between-center layout-row\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"info-line\"><div class=\"title\">Old Password</div><div class=\"info\"><md-input-container \nclass=\"md-block no-float\"><input type=\"password\" name=\"oldPassword\" ng-model=\"vm.ChangePassword.oldPassword\" \nng-disabled=\"!vm.PasswordEdit\" aria-label=\"General Form\" required><div \nng-messages=\"ChangePasswordForm.oldPassword.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nOld Password field is required</span></div><div ng-message=\"pattern\"><span>Old Password must be a valid</span></div>\n</div></md-input-container></div></div></div><div class=\"p-16 ng-scope layout-align-space-between-center layout-row\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"info-line\"><div class=\"title\">New Password</div><div \nclass=\"info\"><md-input-container class=\"md-block no-float\"><input type=\"password\" name=\"newPassword\" \nng-model=\"vm.ChangePassword.newPassword\" ng-disabled=\"!vm.PasswordEdit\" aria-label=\"General Form\" required><div \nng-messages=\"ChangePasswordForm.newPassword.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nNew Password field is required</span></div><div ng-message=\"pattern\"><span>New Password must be a valid</span></div>\n</div></md-input-container></div></div></div><div class=\"p-16 ng-scope layout-align-space-between-center layout-row\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"info-line\"><div class=\"title\">Retype New Password</div>\n<div class=\"info\"><md-input-container class=\"md-block no-float\"><input type=\"password\" name=\"confirmPassword\" \nng-model=\"vm.ChangePassword.confirmPassword\" ng-disabled=\"!vm.PasswordEdit\" aria-label=\"General Form\" required><div \nng-messages=\"ChangePasswordForm.confirmPassword.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\">\n<span>Retype New Password is required</span></div><div ng-message=\"pattern\"><span>Retype New Password must be a valid\n</span></div></div></md-input-container></div></div></div><div \nclass=\"p-16 ng-scope layout-align-space-between-center layout-row\" layout=\"row\" layout-align=\"space-between center\">\n<md-button type=\"submit\" class=\"md-raised md-accent submit-button\" aria-label=\"Update\" \nng-disabled=\"ChangePasswordForm.$invalid || ChangePasswordForm.$pristine\" ng-show=\"vm.PasswordEdit\">Update Password\n</md-button></div></form></ms-widget-front></ms-widget></div></div></div>");
$templateCache.put("app/main/pages/search/search.html","<div id=\"search\" class=\"page-layout simple tabbed\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"search\" flex layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"icon search-icon\"></md-icon><input class=\"search-input\" ng-model=\"vm.search\" \ntype=\"text\" placeholder=\"Search..\" translate translate-attr-placeholder=\"SEARCH.SEARCH\" flex></div><md-menu \nclass=\"search-settings\" md-position-mode=\"target-right target\"><md-button class=\"md-icon-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"Search settings\" translate translate-attr-aria-label=\"SEARCH.SEARCH_SETTINGS\">\n<md-icon md-menu-origin md-menu-align-target md-font-icon=\"icon-cog\" class=\"icon s16\"></md-icon></md-button>\n<md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"vm.dummyFunction()\"><md-icon md-font-icon=\"icon-cog\">\n</md-icon><span translate=\"SEARCH.SETTINGS_1\">Settings 1</span></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.dummyFunction()\"><md-icon md-font-icon=\"icon-cog\"></md-icon><span translate=\"SEARCH.SETTINGS_2\">Settings 2\n</span></md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"content\" flex><md-tabs \nmd-dynamic-height><md-tab label=\"Classic\"><md-content class=\"classic-tab\" \nng-include=\"\'app/main/pages/search/tabs/classic/classic.html\'\"></md-content></md-tab><md-tab label=\"Emails\"><md-content\n class=\"emails-tab\" ng-include=\"\'app/main/pages/search/tabs/emails/emails.html\'\"></md-content></md-tab><md-tab \nlabel=\"Users\"><md-content class=\"users-tab\" ng-include=\"\'app/main/pages/search/tabs/users/users.html\'\"></md-content>\n</md-tab><md-tab label=\"Contacts\"><md-content class=\"contacts-tab\" \nng-include=\"\'app/main/pages/search/tabs/contacts/contacts.html\'\"></md-content></md-tab></md-tabs></div></div>");
$templateCache.put("app/navigation/layouts/horizontal-navigation/navigation.html","<div layout=\"row\" layout-align=\"start center\"><ms-navigation-horizontal></ms-navigation-horizontal></div>");
$templateCache.put("app/navigation/layouts/vertical-navigation/navigation.html","<md-toolbar class=\"navigation-header md-whiteframe-1dp\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-image\"><img \nsrc=\"assets/images/logos/nrgroup.png\"></span><span class=\"logo-text\">NRRS</span></div><md-icon class=\"fold-toggle s18\" \nmd-font-icon=\"icon-backburger\" hide show-gt-sm ng-click=\"vm.toggleMsNavigationFolded()\"></md-icon></md-toolbar>\n<ms-navigation class=\"scrollable\" folded=\"vm.folded\" ms-scroll=\"vm.msScrollOptions\"></ms-navigation>");
$templateCache.put("app/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html","<ms-navigation class=\"scrollable\" folded=\"vm.folded\" ms-scroll=\"vm.msScrollOptions\"></ms-navigation>");
$templateCache.put("app/toolbar/layouts/content-with-toolbar/toolbar.html","<div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE</span></div>\n<div class=\"toolbar-separator\"></div><ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div></div><div \nlayout=\"row\" layout-align=\"start center\"><md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular><div class=\"toolbar-separator\"></div>\n<md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" \nsrc=\"assets/images/avatars/profile.jpg\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\"></md-icon></div><span class=\"username\" hide-sm>\nJohn Doe</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-sm></md-icon></div></md-button>\n<md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" ui-sref=\"app.pages_profile\"><md-icon \nmd-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile</md-button></md-menu-item><md-menu-item \nclass=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" class=\"icon\"></md-icon><md-button>Inbox\n</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu id=\"user-status-menu\"><md-button \nng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">{{vm.userStatus.title}}</md-button>\n<md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" ng-class=\"{\'selected\': status === vm.userStatus}\" \nng-repeat=\"status in vm.userStatusOptions\"><md-icon md-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-bar><div class=\"toolbar-separator\"></div><ms-search-bar \non-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div \nclass=\"toolbar-separator\"></div><md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\">\n<md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target>\n<div layout=\"row\" layout-align=\"center center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">{{vm.selectedLanguage.code}}</span>\n</div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\"><md-menu-item \nng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" aria-label=\"{{lang.title}}\" \ntranslate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" layout-align=\"start center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span translate=\"{{lang.translation}}\">{{lang.title}}</span></span>\n</md-button></md-menu-item></md-menu-content></md-menu><div class=\"toolbar-separator\"></div><md-button \nid=\"quick-panel-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'quick-panel\')\" \naria-label=\"Toggle quick panel\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon \nmd-font-icon=\"icon-format-list-bulleted\" class=\"icon\"></md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/horizontal-navigation/toolbar.html","<div class=\"top-row\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\">\n<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE</span></div>\n</div><div layout=\"row\" layout-align=\"start center\"><md-progress-circular id=\"toolbar-progress\" \nng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular>\n<ms-shortcuts></ms-shortcuts><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\">\n</md-icon></div><span class=\"username\" hide-sm>John Doe</span><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile\n</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" \nclass=\"icon\"></md-icon><md-button>Inbox</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu \nid=\"user-status-menu\"><md-button ng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">\n{{vm.userStatus.title}}</md-button><md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" \nng-class=\"{\'selected\': status === vm.userStatus}\" ng-repeat=\"status in vm.userStatusOptions\"><md-icon \nmd-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><ms-search-bar on-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\">\n</ms-search-bar><md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\"><md-button \nclass=\"language-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target><div \nlayout=\"row\" layout-align=\"center center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">{{vm.selectedLanguage.code}}</span>\n</div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\"><md-menu-item \nng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" aria-label=\"{{lang.title}}\" \ntranslate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" layout-align=\"start center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span translate=\"{{lang.translation}}\">{{lang.title}}</span></span>\n</md-button></md-menu-item></md-menu-content></md-menu><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><md-button \nid=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"toolbar-separator\"></div></div><div \nlayout=\"row\" layout-align=\"start center\"><md-progress-circular id=\"toolbar-progress\" \nng-disabled=\"!$root.loadingProgress\" class=\"md-accent\" md-diameter=\"32\"></md-progress-circular><md-menu-bar \nid=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"User settings\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" \nsrc=\"assets/images/avatars/profile.jpg\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\"></md-icon></div><span class=\"username\" hide \nshow-gt-sm>{{ vm.username }}</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-xs></md-icon></div>\n</md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" ui-sref=\"app.pages_profile\"><md-icon \nmd-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile</md-button></md-menu-item><md-menu-item \nclass=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout\n</md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar><div class=\"toolbar-separator\"></div>\n<ms-search-bar on-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\">\n</ms-search-bar><div class=\"toolbar-separator\"></div></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation-fullwidth-toolbar/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><md-button \nid=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><ms-search-bar on-search=\"vm.search(query)\" \non-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div class=\"toolbar-separator\"></div>\n<ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div></div><div layout=\"row\" layout-align=\"start center\">\n<md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"32\"></md-progress-circular><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\">\n</md-icon></div><span class=\"username\" hide-sm>John Doe</span><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile\n</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" \nclass=\"icon\"></md-icon><md-button>Inbox</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu \nid=\"user-status-menu\"><md-button ng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">\n{{vm.userStatus.title}}</md-button><md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" \nng-class=\"{\'selected\': status === vm.userStatus}\" ng-repeat=\"status in vm.userStatusOptions\"><md-icon \nmd-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><div class=\"toolbar-separator\"></div><md-menu id=\"language-menu\" md-offset=\"0 72\" \nmd-position-mode=\"target-right target\"><md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" layout-align=\"center center\"><img \nclass=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">\n{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n<div class=\"toolbar-separator\"></div><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation-fullwidth-toolbar-2/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE</span></div>\n<div class=\"toolbar-separator\"></div><md-button id=\"navigation-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm aria-label=\"Toggle navigation\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><md-button class=\"md-icon-button navigation-fold-toggle\" hide show-gt-sm \naria-label=\"Toggle navigation fold\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION_FOLD\" \nng-click=\"vm.toggleMsNavigationFolded()\"><md-icon class=\"s18\" md-font-icon=\"icon-backburger\"></md-icon></md-button>\n<ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div></div><div layout=\"row\" layout-align=\"start center\">\n<md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"32\"></md-progress-circular><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\">\n</md-icon></div><span class=\"username\" hide-sm>John Doe</span><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile\n</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" \nclass=\"icon\"></md-icon><md-button>Inbox</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu \nid=\"user-status-menu\"><md-button ng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">\n{{vm.userStatus.title}}</md-button><md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" \nng-class=\"{\'selected\': status === vm.userStatus}\" ng-repeat=\"status in vm.userStatusOptions\"><md-icon \nmd-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><div class=\"toolbar-separator\"></div><ms-search-bar on-search=\"vm.search(query)\" \non-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div class=\"toolbar-separator\"></div>\n<md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\"><md-button class=\"language-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" \nlayout-align=\"center center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span \nclass=\"iso\">{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n<div class=\"toolbar-separator\"></div><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/quick-panel/tabs/activity/activity-tab.html","<md-list class=\"friends\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.FRIENDS\">Friends</span>\n</md-subheader><md-list-item class=\"friend md-3-line\" ng-repeat=\"friend in vm.activities.friends\"><img \nng-src=\"{{friend.avatar}}\" class=\"md-avatar\" alt=\"{{friend.name}}\"><div class=\"status {{friend.status}}\"></div><div \nng-if=\"contact.unread\" class=\"md-accent-bg unread-message-count\">{{contact.unread}}</div><div \nclass=\"md-list-item-text\"><h3 class=\"message\">{{friend.message}}</h3><p class=\"time\">{{friend.time}}</p></div>\n</md-list-item></md-list><md-divider></md-divider><md-list class=\"servers\"><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"QUICKPANEL.APP_SERVERS\">Application Servers</span></md-subheader><md-list-item class=\"server md-3-line\" \nng-repeat=\"server in vm.activities.servers\"><md-icon md-font-icon=\"icon-checkbox-blank-circle\" class=\"s16 status\" \nng-class=\"server.status\"></md-icon><div class=\"md-list-item-text\"><h3>{{server.location}}</h3><p>{{server.detail}}</p>\n</div></md-list-item></md-list><md-divider></md-divider><md-list class=\"stats\"><md-subheader class=\"md-no-sticky\"><span\n translate=\"QUICKPANEL.USER_STATS\">User Stats</span></md-subheader><md-list-item class=\"stat md-2-line\" \nng-repeat=\"stat in vm.activities.stats\"><div class=\"md-list-item-text\"><span>\n{{stat.title}} ({{stat.current}} / {{stat.total}})</span><md-progress-linear ng-class=\"stat.status\" \nmd-mode=\"determinate\" value=\"{{stat.percent}}\"></md-progress-linear></div></md-list-item></md-list>");
$templateCache.put("app/quick-panel/tabs/chat/chat-tab.html","<div class=\"main animate-slide-left\" ng-hide=\"vm.chatActive\"><md-list class=\"recent\"><md-subheader \nclass=\"md-no-sticky\"><span translate=\"QUICKPANEL.RECENT\">Recent</span></md-subheader><md-list-item \nclass=\"contact md-3-line\" ng-repeat=\"contact in vm.contacts.recent\" ng-click=\"vm.toggleChat(contact)\"><img \nng-src=\"{{contact.avatar}}\" class=\"md-avatar\" alt=\"{{contact.name}}\"><div class=\"status {{contact.status}}\"></div><div \nng-if=\"contact.unread\" class=\"md-accent-bg unread-message-count\">{{contact.unread}}</div><div \nclass=\"md-list-item-text\"><h3>{{contact.name}}</h3><p class=\"last-message\">{{contact.lastMessage}}</p></div>\n</md-list-item></md-list><md-divider></md-divider><md-list class=\"all\"><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"QUICKPANEL.START_NEW_CHAT\">Start New Chat</span></md-subheader><md-list-item class=\"contact\" \nng-repeat=\"contact in vm.contacts.all\" ng-click=\"vm.toggleChat(contact)\"><img ng-src=\"{{contact.avatar}}\" \nclass=\"md-avatar\" alt=\"{{contact.name}}\"><div class=\"status {{contact.status}}\"></div><div class=\"md-list-item-text\">\n<h3>{{contact.name}}</h3></div></md-list-item></md-list><md-divider></md-divider></div><div \nclass=\"chat animate-slide-right\" ng-show=\"vm.chatActive\" layout=\"column\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button\" ng-click=\"vm.toggleChat()\" aria-label=\"Back\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.BACK\"><md-icon md-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button><h4>\n<span>{{vm.chat.contact.name}}</span></h4></div><div layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"md-icon-button\" aria-label=\"Call\" translate translate-attr-aria-label=\"QUICKPANEL.CALL\"><md-icon \nmd-font-icon=\"icon-phone\"></md-icon></md-button><md-button class=\"md-icon-button\" aria-label=\"More\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button></div>\n</div></md-toolbar><md-content flex layout-paddings ms-scroll id=\"chat-dialog\"><div layout=\"row\" \nng-repeat=\"dialog in vm.chat.contact.dialog\" class=\"md-padding message-row\" ng-class=\"dialog.who\"><img \nng-if=\"dialog.who ===\'contact\'\" ng-src=\"{{vm.chat.contact.avatar}}\" class=\"avatar\" alt=\"{{vm.chat.contact.name}}\"> <img\n ng-if=\"dialog.who ===\'user\'\" class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><div class=\"bubble\" flex><div \nclass=\"message\">{{dialog.message}}</div><div class=\"time secondary-text\">{{dialog.time}}</div></div></div></md-content>\n<form ng-submit=\"vm.reply()\" layout=\"row\" class=\"reply\" layout-align=\"start center\"><textarea \nng-keyup=\"$event.keyCode == 13 ? vm.reply() : null\" flex ng-model=\"vm.replyMessage\" \nplaceholder=\"Type and hit enter to send message\" translate translate-attr-placeholder=\"QUICKPANEL.REPLY_PLACEHOLDER\">\n</textarea><md-button class=\"md-fab md-mini\" type=\"submit\" aria-label=\"Send message\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.SEND_MESSAGE\"><md-icon md-font-icon=\"icon-send\"></md-icon></md-button></form>\n</div>");
$templateCache.put("app/quick-panel/tabs/today/today-tab.html","<md-list class=\"date\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.TODAY\">Today</span></md-subheader>\n<md-list-item class=\"md-display-1 md-2-line\"><div class=\"secondary-text\"><div>{{vm.date | date:\'EEEE\'}}</div><div \nlayout=\"row\" layout-align=\"start start\"><span>{{vm.date | date:\'d\'}}</span> <span class=\"md-subhead\">th</span> <span>\n{{vm.date | date:\'MMMM\'}}</span></div></div></md-list-item></md-list><md-divider></md-divider><md-list><md-subheader \nclass=\"md-no-sticky\"><span translate=\"QUICKPANEL.EVENTS\">Events</span></md-subheader><md-list-item class=\"md-2-line\" \nng-repeat=\"event in vm.events\" ng-click=\"dummyFunction()\"><div class=\"md-list-item-text\"><h3>{{event.title}}</h3><p>\n{{event.detail}}</p></div></md-list-item></md-list><md-divider></md-divider><md-list><md-subheader \nclass=\"md-no-sticky\"><span translate=\"QUICKPANEL.NOTES\">Notes</span></md-subheader><md-list-item class=\"md-2-line\" \nng-repeat=\"note in vm.notes\" ng-click=\"dummyFunction()\"><div class=\"md-list-item-text\"><h3>{{note.title}}</h3><p>\n{{note.detail}}</p></div></md-list-item></md-list><md-divider></md-divider><md-list><md-subheader class=\"md-no-sticky\">\n<span translate=\"QUICKPANEL.QUICK_SETTINGS\">Quick Settings</span></md-subheader><md-list-item><h3 \ntranslate=\"QUICKPANEL.NOTIFICATIONS\">Notifications</h3><md-switch class=\"md-secondary\" ng-model=\"vm.settings.notify\" \naria-label=\"Notifications\" translate translate-attr-aria-label=\"QUICKPANEL.NOTIFICATIONS\"></md-switch></md-list-item>\n<md-list-item><h3 translate=\"QUICKPANEL.CLOUD_SYNC\">Cloud Sync</h3><md-switch class=\"md-secondary\" \nng-model=\"vm.settings.cloud\" aria-label=\"Cloud Sync\" translate translate-attr-aria-label=\"QUICKPANEL.CLOUD_SYNC\">\n</md-switch></md-list-item><md-list-item><h3 translate=\"QUICKPANEL.RETRO_THRUSTERS\">Retro Thrusters</h3><md-switch \nclass=\"md-secondary md-warn\" ng-model=\"vm.settings.retro\" aria-label=\"Retro Thrusters\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.RETRO_THRUSTERS\"></md-switch></md-list-item></md-list>");
$templateCache.put("app/core/directives/ms-navigation/templates/horizontal.html","<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><ul \nclass=\"horizontal\"><li ng-repeat=\"node in vm.navigation\" ms-navigation-horizontal-node=\"node\" \nng-class=\"{\'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-horizontal-nested.html\'\"></li></ul><script \ntype=\"text/ng-template\" id=\"navigation-horizontal-nested.html\">\n<div ms-navigation-horizontal-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n\n        <div class=\"ms-navigation-horizontal-button\" ng-if=\"!node.uisref && node.title\"\n             ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\">\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\n        </div>\n\n        <a class=\"ms-navigation-horizontal-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\n           ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\"\n           ng-if=\"node.uisref && node.title\">\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\n        </a>\n\n    </div>\n\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n        <li ng-repeat=\"node in node.children\" ms-navigation-horizontal-node=\"node\"\n            ng-class=\"{\'has-children\': vm.hasChildren}\"\n            ng-include=\"\'navigation-horizontal-nested.html\'\"></li>\n    </ul>\n</script>");
$templateCache.put("app/core/directives/ms-navigation/templates/vertical.html","<ul><li ng-repeat=\"node in vm.navigation\" ms-navigation-node=\"node\" \nng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-nested.html\'\"></li></ul>\n<script type=\"text/ng-template\" id=\"navigation-nested.html\">\n<div ms-navigation-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n\n        <div class=\"ms-navigation-button\" ng-if=\"!node.uisref && node.title\">\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n        </div>\n\n        <a class=\"ms-navigation-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\n           ng-if=\"node.uisref && node.title\">\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n        </a>\n\n    </div>\n\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n        <li ng-repeat=\"node in node.children\" ms-navigation-node=\"node\"\n            ng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\"\n            ng-include=\"\'navigation-nested.html\'\"></li>\n    </ul>\n</script>");
$templateCache.put("app/main/apps/dashboards/analytics/dashboard-analytics.html","<div id=\"dashboard-analytics\"><div id=\"widgets\"><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap>\n<ms-widget flippable=\"false\" layout=\"row\" flex=\"100\"><ms-widget-front class=\"white-bg\"><div class=\"p-24 border-bottom\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">{{vm.widget1.title}}</div><div \nclass=\"text-boxed green-600-bg white-fg\">{{vm.widget1.onlineUsers}} online users</div></div><div \nclass=\"pb-32 border-bottom\"><nvd3 class=\"h-400 remove-x-lines remove-opacity\" options=\"vm.widget1.bigChart.options\" \ndata=\"vm.widget1.bigChart.data\"></nvd3></div><div layout=\"row\" layout-align=\"start center\" layout-wrap><div \nclass=\"p-24 grey-50-bg\" layout=\"row\" layout-align=\"start center\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><div \nlayout=\"column\" flex><div class=\"h3 secondary-text pb-8\">{{vm.widget1.sessions.title}}</div><div \nclass=\"font-size-32 line-height-32 pb-16\">{{vm.widget1.sessions.value}}</div><div><nvd3 class=\"h-40\" \noptions=\"vm.widget1.sessions.options\" data=\"vm.widget1.sessions.data\"></nvd3></div></div></div><div \nclass=\"p-24 grey-50-bg\" layout=\"row\" layout-align=\"start center\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><div \nlayout=\"column\" flex><div class=\"h3 secondary-text pb-8\">{{vm.widget1.pageviews.title}}</div><div \nclass=\"font-size-32 line-height-32 pb-16\">{{vm.widget1.pageviews.value}}</div><div><nvd3 class=\"h-40\" \noptions=\"vm.widget1.pageviews.options\" data=\"vm.widget1.pageviews.data\"></nvd3></div></div></div><div \nclass=\"p-24 grey-50-bg\" layout=\"row\" layout-align=\"start center\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><div \nlayout=\"column\" flex><div class=\"h3 secondary-text pb-8\">{{vm.widget1.pagesSessions.title}}</div><div \nclass=\"font-size-32 line-height-32 pb-16\">{{vm.widget1.pagesSessions.value}}</div><div><nvd3 class=\"h-40\" \noptions=\"vm.widget1.pagesSessions.options\" data=\"vm.widget1.pagesSessions.data\"></nvd3></div></div></div><div \nclass=\"p-24 grey-50-bg\" layout=\"row\" layout-align=\"start center\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><div \nlayout=\"column\" flex><div class=\"h3 secondary-text pb-8\">{{vm.widget1.avgSessionDuration.title}}</div><div \nclass=\"font-size-32 line-height-32 pb-16\">{{vm.widget1.avgSessionDuration.value}}</div><div><nvd3 class=\"h-40\" \noptions=\"vm.widget1.avgSessionDuration.options\" data=\"vm.widget1.avgSessionDuration.data\"></nvd3></div></div></div>\n</div></ms-widget-front></ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget \nflippable=\"false\" layout=\"column\" flex=\"100\" flex-gt-md=\"65\"><ms-widget-front class=\"white-bg\"><div class=\"p-16\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">{{vm.widget2.title}}</div><md-menu><md-button \naria-label=\"more\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\">\n</md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"refreshWidget()\" \naria-label=\"Refresh widget\">Refresh</md-button></md-menu-item></md-menu-content></md-menu></div><div>\n<ui-gmap-google-map center=\"vm.widget2.map.center\" zoom=\"vm.widget2.map.zoom\" options=\"vm.widget2.map.options\">\n<ui-gmap-markers models=\"vm.widget2.map.markers\" coords=\"\'coords\'\"><ui-gmap-windows show=\"show\"><div ng-non-bindable>\n{{sessions}}</div></ui-gmap-windows></ui-gmap-markers></ui-gmap-google-map></div></ms-widget-front></ms-widget>\n<ms-widget flippable=\"false\" layout=\"column\" flex=\"100\" flex-gt-md=\"35\"><ms-widget-front class=\"white-bg\"><div \nclass=\"ph-16 border-bottom\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">{{vm.widget3.title}}</div>\n<div class=\"pv-16\"><md-select class=\"simplified\" ng-model=\"vm.widget3.currentRange\" aria-label=\"Change range\">\n<md-option ng-repeat=\"(key, range) in vm.widget3.ranges\" value=\"{{key}}\">{{range}}</md-option></md-select></div></div>\n<div class=\"ph-16 pv-20 border-bottom\" ng-repeat=\"page in vm.widget3.pages[vm.widget3.currentRange]\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"column\" flex><span class=\"h4 pb-10\">{{page.path}}</span>\n<md-progress-linear class=\"md-accent\" md-mode=\"determinate\" value=\"{{page.value}}\"></md-progress-linear></div><div \nclass=\"pl-32 h3 font-weight-500 secondary-text\">{{page.value}}%</div></div></ms-widget-front></ms-widget></div><div \nclass=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget flippable=\"false\" layout=\"row\" flex=\"100\">\n<ms-widget-front class=\"white-bg\"><div class=\"ph-16 pt-16 pb-8 md-accent-bg\"><div class=\"h3\">{{vm.widget4.title}}</div>\n</div><md-tabs class=\"md-accent no-radius\" md-dynamic-height><md-tab label=\"{{tab.label}}\" \nng-repeat=\"tab in vm.widget4.tabs\"><div layout=\"row\" layout-align=\"start center\" layout-wrap><div flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"25\" ng-repeat=\"group in tab.groups\"><div class=\"h2 m-16 pb-16 border-bottom\">\n{{group.title}}</div><div class=\"p-16 pb-32\" ng-repeat=\"data in group.data\"><div class=\"pb-8\" layout=\"row\" \nlayout-align=\"space-between start\"><span class=\"h3\">{{data.title}}</span> <span \nclass=\"h3 secondary-text font-weight-500\">{{data.value}}%</span></div><md-progress-linear \nclass=\"{{data.progressColor}}\" md-mode=\"determinate\" value=\"{{data.value}}\"></md-progress-linear></div></div></div>\n</md-tab></md-tabs></ms-widget-front></ms-widget></div></div></div>");
$templateCache.put("app/main/apps/dashboards/project/dashboard-project.html","<div id=\"dashboard-project\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"center\" flex ms-scroll>\n<div class=\"header md-accent-bg\" layout=\"column\" layout-align=\"space-between\"><div layout=\"row\" \nlayout-align=\"space-between\"><div><span class=\"md-display-1 font-weight-300\">Welcome back, John!</span></div><div \nclass=\"toolbar\"><md-button class=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" hide-gt-md \naria-label=\"Toggle sidenav\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button></div></div><div \nlayout=\"row\"><div class=\"selected-project\">{{vm.selectedProject.name}}</div><md-menu id=\"projects-menu\" \nmd-offset=\"0 48\"><md-button class=\"md-icon-button project-selector\" ng-click=\"$mdOpenMenu()\" \naria-label=\"Select project\" md-menu-origin md-menu-align-target><md-icon md-font-icon=\"icon-dots-horizontal\"></md-icon>\n</md-button><md-menu-content width=\"3\" class=\"md-background-bg\"><md-menu-item ng-repeat=\"project in vm.projects\">\n<md-button ng-click=\"vm.selectProject(project)\" aria-label=\"{{project.name}}\"><span \nng-class=\"{\'secondary-text\': vm.selectedProject == project}\">{{project.name}}</span></md-button></md-menu-item>\n</md-menu-content></md-menu></div></div><div class=\"content\"><md-tabs md-dynamic-height><md-tab label=\"Home\"><div \nclass=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div class=\"ph-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"><md-select class=\"simplified font-size-16\" ng-model=\"vm.widget1.currentRange\" \naria-label=\"Change range\"><md-option ng-repeat=\"(key, range) in vm.widget1.ranges\" value=\"{{key}}\">{{range}}\n</md-option></md-select><md-menu><md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nng-click=\"flipWidget()\" aria-label=\"Flip widget\">Details</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh</md-button></md-menu-item></md-menu-content></md-menu>\n</div><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div \nclass=\"light-blue-fg font-size-72 line-height-72\">{{vm.widget1.data.count[vm.widget1.currentRange]}}</div><div \nclass=\"h3 secondary-text font-weight-500\">{{vm.widget1.data.label}}</div></div><div class=\"p-16 grey-50-bg border-top\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"h4 secondary-text text-truncate\">{{vm.widget1.data.extra.label}}:\n</span> <span class=\"h4 ml-8\">{{vm.widget1.data.extra.count[vm.widget1.currentRange]}}</span></div></ms-widget-front>\n<ms-widget-back class=\"p-16 white-bg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" \nng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button>\n</div><div>{{vm.widget1.detail}}</div></ms-widget-back></ms-widget><ms-widget flippable=\"true\" layout=\"column\" \nflex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div class=\"pl-16 pr-8 pv-16 h-55\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">{{vm.widget2.title}}</div><md-menu><md-button \nclass=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon>\n</md-button><md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">\nDetails</md-button></md-menu-item><md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">\nRefresh</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"pt-8 pb-32\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"red-fg font-size-72 line-height-72\">{{vm.widget2.data.count}}</div><div \nclass=\"h3 secondary-text font-weight-500\">{{vm.widget2.data.label}}</div></div><div class=\"p-16 grey-50-bg border-top\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"h4 secondary-text text-truncate\">{{vm.widget2.data.extra.label}}:\n</span> <span class=\"h4 ml-8\">{{vm.widget2.data.extra.count}}</span></div></ms-widget-front><ms-widget-back \nclass=\"p-16 white-bg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" \naria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><div>\n{{vm.widget2.detail}}</div></ms-widget-back></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div class=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\">{{vm.widget3.title}}</div><md-menu><md-button \nclass=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon>\n</md-button><md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">\nDetails</md-button></md-menu-item><md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">\nRefresh</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"pt-8 pb-32\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"orange-fg font-size-72 line-height-72\">{{vm.widget3.data.count}}</div><div \nclass=\"h3 secondary-text font-weight-500\">{{vm.widget3.data.label}}</div></div><div class=\"p-16 grey-50-bg border-top\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"h4 secondary-text text-truncate\">{{vm.widget3.data.extra.label}}:\n</span> <span class=\"h4 ml-8\">{{vm.widget3.data.extra.count}}</span></div></ms-widget-front><ms-widget-back \nclass=\"p-16 white-bg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" \naria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><div>\n{{vm.widget3.detail}}</div></ms-widget-back></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div class=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\">{{vm.widget4.title}}</div><md-menu><md-button \nclass=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon>\n</md-button><md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">\nDetails</md-button></md-menu-item><md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">\nRefresh</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"pt-8 pb-32\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"blue-grey-fg font-size-72 line-height-72\">{{vm.widget4.data.count}}</div><div \nclass=\"h3 secondary-text font-weight-500\">{{vm.widget4.data.label}}</div></div><div class=\"p-16 grey-50-bg border-top\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"h4 secondary-text text-truncate\">{{vm.widget4.data.extra.label}}:\n</span> <span class=\"h4 ml-8\">{{vm.widget4.data.extra.count}}</span></div></ms-widget-front><ms-widget-back \nclass=\"p-16 white-bg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" \naria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><div>\n{{vm.widget4.detail}}</div></ms-widget-back></ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" \nlayout-wrap><ms-widget layout=\"row\" flex=\"100\"><ms-widget-front class=\"white-bg\"><div class=\"ph-16 pv-8 border-bottom\" \nlayout=\"row\" layout-align=\"space-between center\" layout-wrap><div class=\"pv-8 h3\">{{vm.widget5.title}}</div><div \nclass=\"pv-8\" layout=\"row\" layout-align=\"start center\" layout-align-sm=\"end\" flex-sm=\"100\"><md-button class=\"ph-16\" \nng-repeat=\"(key, range) in vm.widget5.ranges\" ng-click=\"vm.widget5.changeRange(key)\" \nng-disabled=\"vm.widget5.currentRange == key\">{{range}}</md-button></div></div><div layout=\"row\" \nlayout-align=\"start center\" layout-wrap><div class=\"p-16\" layout=\"row\" flex=\"100\" flex-gt-sm=\"50\"><nvd3 \nclass=\"h-420 remove-x-lines\" config=\"vm.widget5.mainChart.config\" options=\"vm.widget5.mainChart.options\" \ndata=\"vm.widget5.mainChart.data\"></nvd3></div><div class=\"p-16\" layout=\"row\" flex=\"100\" flex-gt-sm=\"50\" layout-wrap>\n<div class=\"p-16\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" layout-align=\"center\" \nng-repeat=\"(name, widget) in vm.widget5.supporting.widgets\"><div class=\"h4 secondary-text\">{{widget.data.label}}</div>\n<div class=\"md-display-1\">{{widget.data.count[vm.widget5.currentRange]}}</div><nvd3 class=\"h-50\" \nconfig=\"vm.widget5.supporting.chart.config\" options=\"vm.widget5.supporting.chart.options\" data=\"widget.chart.data\">\n</nvd3></div></div></div></ms-widget-front></ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" \nlayout-wrap><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"50\"><ms-widget-front class=\"white-bg\"><div \nclass=\"ph-16 border-bottom\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">{{vm.widget6.title}}</div>\n<div class=\"pv-16\"><md-select class=\"simplified\" ng-model=\"vm.widget6.currentRange\" \nng-change=\"vm.widget6.changeRange(vm.widget6.currentRange)\" aria-label=\"Change range\"><md-option \nng-repeat=\"(key, range) in vm.widget6.ranges\" value=\"{{key}}\">{{range}}</md-option></md-select></div></div><div \nclass=\"p-16\"><nvd3 class=\"h-400\" config=\"vm.widget6.mainChart.config\" options=\"vm.widget6.mainChart.options\" \ndata=\"vm.widget6.mainChart.data\"></nvd3></div><div class=\"pv-8 mh-16 border-top\" layout=\"row\" \nlayout-align=\"start center\" layout-wrap><div class=\"pv-8 border-right\" layout=\"column\" layout-align=\"center center\" \nflex=\"100\" flex-gt-xs=\"50\"><span class=\"font-size-32\">{{vm.widget6.footerLeft.count[vm.widget6.currentRange]}}</span> \n<span class=\"h4\">{{vm.widget6.footerLeft.title}}</span></div><div class=\"pv-8\" layout=\"column\" \nlayout-align=\"center center\" flex=\"100\" flex-gt-xs=\"50\"><span class=\"font-size-32\">\n{{vm.widget6.footerRight.count[vm.widget6.currentRange]}}</span> <span class=\"h4\">{{vm.widget6.footerRight.title}}\n</span></div></div></ms-widget-front></ms-widget><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"50\"><ms-widget-front\n class=\"white-bg\"><div class=\"ph-16 border-bottom\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">\n{{vm.widget7.title}}</div><div class=\"pv-16\"><md-select class=\"simplified\" ng-model=\"vm.widget7.currentRange\" \naria-label=\"Change range\"><md-option ng-repeat=\"(key, range) in vm.widget7.ranges\" value=\"{{key}}\">{{range}}\n</md-option></md-select></div></div><div class=\"p-16\" layout=\"row\" layout-align=\"space-between center\" \nng-repeat=\"event in vm.widget7.schedule[vm.widget7.currentRange]\"><div><div class=\"h3\">{{event.title}}</div><div><span \nclass=\"secondary-text\">{{event.time}}</span> <span ng-if=\"event.location\">, {{event.location}}</span></div></div>\n<md-button class=\"md-icon-button\" aria-label=\"More information\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon>\n</md-button></div></ms-widget-front></ms-widget></div></md-tab><md-tab label=\"Budget Summary\"><div \nclass=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"50\">\n<ms-widget-front class=\"white-bg\"><div class=\"h3 p-16\">{{vm.widget8.title}}</div><md-divider></md-divider><div \nclass=\"p-16\"><nvd3 class=\"h-400\" options=\"vm.widget8.mainChart.options\" data=\"vm.widget8.mainChart.data\"></nvd3></div>\n</ms-widget-front></ms-widget><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"50\"><ms-widget-front class=\"white-bg\">\n<div class=\"ph-16 border-bottom\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">{{vm.widget9.title}}\n</div><div class=\"pv-16\"><md-select class=\"simplified\" ng-model=\"vm.widget9.currentRange\" \nng-change=\"vm.widget9.changeRange(vm.widget9.currentRange)\" aria-label=\"Change range\"><md-option \nng-repeat=\"(key, range) in vm.widget6.ranges\" value=\"{{key}}\">{{range}}</md-option></md-select></div></div><div \nclass=\"p-16\" layout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"space-between center\"><div \nclass=\"p-8\"><div class=\"h4 secondary-text\">{{vm.widget9.weeklySpent.title}}</div><div \nclass=\"pt-8 md-display-1 font-weight-300\"><span class=\"secondary-text\">$</span><span>\n{{vm.widget9.weeklySpent.count[vm.widget9.currentRange]}}</span></div></div><div class=\"p-8\" flex><nvd3 class=\"h-50\" \nconfig=\"vm.widget9.chart.config\" options=\"vm.widget9.chart.options\" data=\"vm.widget9.weeklySpent.chartData\"></nvd3>\n</div></div><div class=\"p-16\" layout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" \nlayout-align-gt-xs=\"space-between center\"><div class=\"p-8\"><div class=\"h4 secondary-text\">\n{{vm.widget9.totalSpent.title}}</div><div class=\"pt-8 md-display-1 font-weight-300\"><span class=\"secondary-text\">$\n</span><span>{{vm.widget9.totalSpent.count[vm.widget9.currentRange]}}</span></div></div><div class=\"p-8\" flex><nvd3 \nclass=\"h-50\" config=\"vm.widget9.chart.config\" options=\"vm.widget9.chart.options\" \ndata=\"vm.widget9.totalSpent.chartData\"></nvd3></div></div><div class=\"p-16\" layout=\"column\" layout-align=\"center\" \nlayout-gt-xs=\"row\" layout-align-gt-xs=\"space-between center\"><div class=\"p-8\"><div class=\"h4 secondary-text\">\n{{vm.widget9.remaining.title}}</div><div class=\"pt-8 md-display-1 font-weight-300\"><span class=\"secondary-text\">$\n</span><span>{{vm.widget9.remaining.count[vm.widget9.currentRange]}}</span></div></div><div class=\"p-8\" flex><nvd3 \nclass=\"h-50\" config=\"vm.widget9.chart.config\" options=\"vm.widget9.chart.options\" data=\"vm.widget9.remaining.chartData\">\n</nvd3></div></div><div class=\"pv-24 mh-24 border-top\"><div class=\"h4 secondary-text\">{{vm.widget9.totalBudget.title}}\n</div><div class=\"pt-8 md-display-1 font-weight-300\"><span class=\"secondary-text\">$</span><span>\n{{vm.widget9.totalBudget.count}}</span></div></div></ms-widget-front></ms-widget></div><div class=\"widget-group\" \nlayout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"row\" flex=\"100\"><ms-widget-front class=\"white-bg\"><div \nclass=\"simple-table-container\" ms-responsive-table><div class=\"table-title\">{{vm.widget10.title}}</div><table \nclass=\"simple\"><thead><tr><th ng-repeat=\"column in vm.widget10.table.columns\">{{column.title}}</th></tr></thead><tbody>\n<tr ng-repeat=\"row in vm.widget10.table.rows\"><td ng-repeat=\"cell in row\"><span class=\"{{cell.classes}}\">\n{{cell.value}} </span><i ng-if=\"cell.icon\" class=\"icon {{cell.icon}}\"></i></td></tr></tbody></table></div>\n</ms-widget-front></ms-widget></div></md-tab><md-tab label=\"Team Members\"><div class=\"widget-group\" layout=\"row\" \nflex=\"100\" layout-wrap><ms-widget layout=\"row\" flex=\"100\"><ms-widget-front class=\"white-bg\"><div \nclass=\"p-24 mb-8 border-bottom\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h2\">{{vm.widget11.title}}\n</div><div class=\"text-boxed red-bg white-fg m-0\">{{vm.widget11.table.rows.length}} members</div></div><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.widget11.dtOptions\"><thead><tr><th \nclass=\"secondary-text\" ng-repeat=\"column in ::vm.widget11.table.columns\"><div class=\"table-header\"><span \nclass=\"column-title\">{{column.title}}</span></div></th></tr></thead><tbody><tr \nng-repeat=\"row in ::vm.widget11.table.rows\"><td ng-repeat=\"cell in row\"><img class=\"avatar\" ng-if=\"$index === 0\" \nng-src=\"assets/images/avatars/{{cell}}\"> <span ng-if=\"$index != 0\">{{cell}}</span></td></tr></tbody></table>\n</ms-widget-front></ms-widget></div></md-tab></md-tabs></div></div><md-sidenav class=\"sidenav md-sidenav-right\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div class=\"widget-group\">\n<ms-widget flippable=\"false\" class=\"sidenav-widget\"><ms-widget-front><div class=\"pl-16 pr-8 pv-16\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\">\n{{vm.nowWidget.now.weekDay}}, {{vm.nowWidget.now.hour}}:{{vm.nowWidget.now.minute}}:{{vm.nowWidget.now.second}}</div>\n<md-menu><md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" md-menu-origin md-menu-align-target \naria-label=\"Options\"><md-icon md-font-icon=\"icon-dots-vertical\" class=\"icon\"></md-icon></md-button><md-menu-content \nwidth=\"3\"><md-menu-item><md-button ng-click=\"vm.nowWidget.dummyFunction()\"><md-icon md-font-icon=\"icon-refresh\" \nclass=\"icon\"></md-icon>Refresh</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.nowWidget.dummyFunction()\"><md-icon md-font-icon=\"icon-cog\" class=\"icon\"></md-icon>Settings</md-button>\n</md-menu-item></md-menu-content></md-menu></div><div class=\"p-16 pb-24\" layout=\"column\" layout-align=\"center center\">\n<div class=\"h1 secondary-text\"><span>{{vm.nowWidget.now.month}}</span></div><div \nclass=\"font-size-72 line-height-88 secondary-text font-weight-400\">{{vm.nowWidget.now.day}}</div><div \nclass=\"h1 secondary-text\"><span>{{vm.nowWidget.now.year}}</span></div></div><md-divider></md-divider></ms-widget-front>\n</ms-widget><ms-widget flippable=\"false\" class=\"sidenav-widget\"><ms-widget-front><div class=\"pl-16 pr-8 pv-16\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"h4\"><md-icon md-font-icon=\"icon-map-marker\" \nclass=\"icon mr-8\"></md-icon>{{vm.weatherWidget.locations[vm.weatherWidget.currentLocation].name}}</div><md-menu>\n<md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" md-menu-origin md-menu-align-target aria-label=\"Options\">\n<md-icon md-font-icon=\"icon-dots-vertical\" class=\"icon\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item>\n<md-button ng-click=\"vm.nowWidget.dummyFunction()\"><md-icon md-font-icon=\"icon-refresh\" class=\"icon\"></md-icon>Refresh\n</md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.nowWidget.dummyFunction()\"><md-icon \nmd-font-icon=\"icon-cog\" class=\"icon\"></md-icon>Settings</md-button></md-menu-item></md-menu-content></md-menu></div>\n<div class=\"p-16 pb-32\" layout=\"column\" layout-align=\"center center\"><div layout=\"row\" layout-align=\"center center\">\n<md-icon md-font-icon=\"{{vm.weatherWidget.locations[vm.weatherWidget.currentLocation].icon}}\" class=\"icon s40 mr-16\">\n</md-icon><span class=\"md-display-2 font-weight-300 secondary-text\">\n{{vm.weatherWidget.locations[vm.weatherWidget.currentLocation].temp[vm.weatherWidget.tempUnit]}} </span><span \nclass=\"font-size-48 font-weight-300 hint-text text-super ml-8\">&deg;</span> <span \nclass=\"md-display-2 font-weight-300 hint-text\">{{vm.weatherWidget.tempUnit}}</span></div></div><div \nclass=\"grey-300-bg p-16\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-weather-windy\" class=\"icon mr-8 s20\"></md-icon><span>\n{{vm.weatherWidget.locations[vm.weatherWidget.currentLocation].windSpeed[vm.weatherWidget.speedUnit]}} </span><span \nclass=\"secondary-text ml-5\">{{vm.weatherWidget.speedUnit}}</span></div><div layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-compass-outline\" class=\"icon mr-8 s20\"></md-icon><span>\n{{vm.weatherWidget.locations[vm.weatherWidget.currentLocation].windDirection}}</span></div><div layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-umbrella\" class=\"icon mr-8 s20\"></md-icon><span>\n{{vm.weatherWidget.locations[vm.weatherWidget.currentLocation].rainProbability}}</span></div></div><div class=\"pv-16\">\n<div class=\"pv-16 ph-24\" layout=\"row\" layout-align=\"space-between center\" \nng-repeat=\"day in vm.weatherWidget.locations[vm.weatherWidget.currentLocation].next3Days\"><span class=\"h4\">{{day.name}}\n</span><div layout=\"row\" layout-align=\"start center\"><md-icon class=\"mr-16\" md-font-icon=\"{{day.icon}}\" class=\"icon\">\n</md-icon><span class=\"h2\">{{day.temp[vm.weatherWidget.tempUnit]}}</span> <span \nclass=\"h2 font-weight-300 secondary-text text-super\">&deg;</span> <span class=\"h2 font-weight-300 secondary-text\">\n{{vm.weatherWidget.tempUnit}}</span></div></div></div><md-divider></md-divider></ms-widget-front></ms-widget></div>\n</md-sidenav></div>");
$templateCache.put("app/main/apps/dashboards/server/dashboard-server.html","<div id=\"dashboard-server\"><div id=\"widgets\"><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget \nflippable=\"false\" layout=\"row\" flex=\"100\"><ms-widget-front class=\"p-16 white-bg\"><div class=\"pb-16\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\">{{vm.widget1.title}}</div><md-menu><md-button aria-label=\"more\" \nclass=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh\n</md-button></md-menu-item></md-menu-content></md-menu></div><div><nvd3 class=\"h-320\" class=\"remove-x-lines\" \noptions=\"vm.widget1.chart.options\" data=\"vm.widget1.chart.data\"></nvd3></div></ms-widget-front></ms-widget></div><div \nclass=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"p-16 pink-400-bg white-fg\"><div class=\"pb-24\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-icon class=\"m-0 mr-8\" \nmd-font-icon=\"icon-harddisk\"></md-icon><div class=\"h3\">{{vm.widget2.title}}</div></div><md-menu><md-button \naria-label=\"more\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\">\n</md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"flipWidget()\" \naria-label=\"Flip widget\">Details</md-button></md-menu-item><md-menu-item><md-button ng-click=\"refreshWidget()\" \naria-label=\"Refresh widget\">Refresh</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"pb-24\" \nlayout=\"row\" layout-align=\"start center\"><div class=\"h2\">{{vm.widget2.value.used}}</div><div \nclass=\"h2 secondary-text pl-8\">/ {{vm.widget2.value.total}}</div></div><md-progress-linear md-mode=\"determinate\" \nvalue=\"{{vm.widget2.value.percentage}}\"></md-progress-linear></ms-widget-front><ms-widget-back \nclass=\"p-16 pr-32 pink-400-bg white-fg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" \nng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button>\n</div><div>{{vm.widget2.detail}}</div></ms-widget-back></ms-widget><ms-widget flippable=\"true\" layout=\"column\" \nflex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"p-16 blue-bg white-fg\"><div class=\"pb-24\" \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-icon \nclass=\"m-0 mr-8\" md-font-icon=\"icon-server-network\"></md-icon><div class=\"h3\">{{vm.widget3.title}}</div></div><md-menu>\n<md-button aria-label=\"more\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button \nng-click=\"flipWidget()\" aria-label=\"Flip widget\">Details</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh</md-button></md-menu-item></md-menu-content></md-menu>\n</div><div class=\"pb-24\" layout=\"row\" layout-align=\"start end\"><div class=\"h2\">{{vm.widget3.value.used}}</div><div \nclass=\"h2 pl-8 secondary-text\">/ {{vm.widget3.value.total}}</div></div><md-progress-linear md-mode=\"determinate\" \nvalue=\"{{vm.widget3.value.percentage}}\"></md-progress-linear></ms-widget-front><ms-widget-back \nclass=\"p-16 pr-32 blue-bg white-fg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" \nng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button>\n</div><div>{{vm.widget3.detail}}</div></ms-widget-back></ms-widget><ms-widget flippable=\"true\" layout=\"column\" \nflex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"p-16 teal-400-bg white-fg\"><div class=\"pb-24\" \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-icon \nclass=\"m-0 mr-8\" md-font-icon=\"icon-clock-fast\"></md-icon><div class=\"h3\">{{vm.widget4.title}}</div></div><md-menu>\n<md-button aria-label=\"more\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button \nng-click=\"flipWidget()\" aria-label=\"Flip widget\">Details</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh</md-button></md-menu-item></md-menu-content></md-menu>\n</div><div class=\"pb-8 h1\">{{vm.widget4.value}}</div><div class=\"chart-fill-16\"><nvd3 \nclass=\"h-50 remove-opacity remove-line-stroke\" config=\"vm.widget4.chart.config\" options=\"vm.widget4.chart.options\" \ndata=\"vm.widget4.chart.data\"></nvd3></div></ms-widget-front><ms-widget-back class=\"p-16 pr-32 teal-400-bg white-fg\">\n<div class=\"flip-to-front\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon \nmd-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><div>{{vm.widget4.detail}}</div></ms-widget-back>\n</ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front \nclass=\"p-16 indigo-400-bg white-fg\"><div class=\"pb-24\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-icon class=\"m-0 mr-8\" md-font-icon=\"icon-scale\"></md-icon><div class=\"h3\">\n{{vm.widget5.title}}</div></div><md-menu><md-button aria-label=\"more\" class=\"md-icon-button\" \nng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content \nwidth=\"2\"><md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">Details</md-button></md-menu-item>\n<md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh</md-button></md-menu-item>\n</md-menu-content></md-menu></div><div layout=\"column\" layout-align=\"space-between\" flex><div class=\"h1 pb-8\" \nlayout=\"row\" layout-align=\"start center\"><span>{{vm.widget5.value}}</span><md-icon md-font-icon=\"icon-trending-down\" \nclass=\"ml-16\"></md-icon></div><div class=\"secondary-text\">{{vm.widget5.footnote}}</div></div></ms-widget-front>\n<ms-widget-back class=\"p-16 pr-32 indigo-400-bg white-fg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" \nng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button>\n</div><div>{{vm.widget5.detail}}</div></ms-widget-back></ms-widget></div><div class=\"widget-group\" layout=\"row\" \nflex=\"100\" layout-wrap><ms-widget flippable=\"false\" layout=\"row\" flex=\"100\"><ms-widget-front class=\"p-16 white-bg\"><div\n class=\"pb-24\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">{{vm.widget6.title}}</div><md-menu>\n<md-button aria-label=\"more\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button \nng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh</md-button></md-menu-item></md-menu-content></md-menu>\n</div><div><nvd3 class=\"h-140 remove-x-lines remove-opacity\" config=\"vm.widget6.chart.config\" \noptions=\"vm.widget6.chart.options\" data=\"vm.widget6.chart.data\"></nvd3></div></ms-widget-front></ms-widget></div><div \nclass=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget flippable=\"false\" layout=\"row\" flex=\"100\" \nflex-gt-md=\"60\"><ms-widget-front class=\"white-bg\"><div class=\"ph-16 pv-24 border-bottom\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><span class=\"h3\">{{vm.widget7.title}}\n</span> <span class=\"ml-16 text-boxed pink-bg white-fg\">{{vm.widget7.table.rows.length}} processes</span></div>\n<md-menu><md-button aria-label=\"more\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button \nng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh</md-button></md-menu-item></md-menu-content></md-menu>\n</div><table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.widget7.dtOptions\"><thead><tr><th \nclass=\"secondary-text\" ng-repeat=\"column in ::vm.widget7.table.columns\"><div class=\"table-header\"><span \nclass=\"column-title\">{{column.title}}</span></div></th></tr></thead><tbody><tr \nng-repeat=\"row in ::vm.widget7.table.rows\"><td ng-repeat=\"cell in row\"><span class=\"{{cell.classes}}\">{{cell.value}}\n</span></td></tr></tbody></table></ms-widget-front></ms-widget><ms-widget flippable=\"false\" layout=\"row\" flex=\"100\" \nflex-gt-md=\"40\"><ms-widget-front class=\"white-bg\"><div class=\"ph-16 pv-24 border-bottom\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><span class=\"h3\">{{vm.widget8.title}}\n</span> <span class=\"ml-16 text-boxed blue-bg white-fg\">Showing last {{vm.widget8.activities.length}} activity</span>\n</div><md-menu><md-button aria-label=\"more\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button \nng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh</md-button></md-menu-item></md-menu-content></md-menu>\n</div><div class=\"ph-16 pv-15 border-bottom\" layout=\"row\" layout-align=\"start center\" \nng-repeat=\"activity in vm.widget8.activities\"><div><i class=\"icon pr-16 mr-16 border-right\" \nng-class=\"{\'icon-arrow-down red-fg\':activity.type === \'Input\', \'icon-arrow-up green-fg\':activity.type === \'Output\'}\">\n</i></div><div class=\"h4 text-bold\" flex>{{activity.process}}</div><div class=\"h4 font-weight-500 secondary-text\">\n{{activity.value}}</div></div></ms-widget-front></ms-widget></div></div></div>");
$templateCache.put("app/main/components/charts/nvd3/nvd3.html","<div id=\"nvd3\" class=\"page-layout simple fullwidth doc-page chart-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">COMPONENTS</span><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">CHARTS</span></div><div \nclass=\"title\">nvD3</div></div><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-raised reference-button\" href=\"http://krispo.github.io/angular-nvd3/#/\" target=\"_blank\"><md-icon \nmd-font-icon=\"icon-link\"></md-icon><span>Reference</span></md-button></div></div><div class=\"content\"><div \nclass=\"md-title\">Line Chart</div><div class=\"card md-whiteframe-4dp\"><nvd3 options=\"vm.lineChart.options\" \ndata=\"vm.lineChart.data\" class=\"with-3d-shadow with-transitions\"></nvd3></div><div class=\"md-title\">Stacked Area Chart\n</div><div class=\"card md-whiteframe-4dp\"><nvd3 options=\"vm.stackedAreaChart.options\" data=\"vm.stackedAreaChart.data\">\n</nvd3></div><div class=\"md-title\">Sparkline Chart</div><div class=\"card md-whiteframe-4dp\"><nvd3 \noptions=\"vm.sparklineChart.options\" data=\"vm.sparklineChart.data\"></nvd3></div><div class=\"md-title\">\nHistorical Bar Chart</div><div class=\"card md-whiteframe-4dp\"><nvd3 options=\"vm.historicalBarChart.options\" \ndata=\"vm.historicalBarChart.data\"></nvd3></div><div class=\"md-title\">Multi Bar Horizontal Chart</div><div \nclass=\"card md-whiteframe-4dp\"><nvd3 options=\"vm.multiBarHorizontalChart.options\" \ndata=\"vm.multiBarHorizontalChart.data\"></nvd3></div><div class=\"md-title\">Pie Chart</div><div \nclass=\"card md-whiteframe-4dp\"><nvd3 options=\"vm.pieChart.options\" data=\"vm.pieChart.data\"></nvd3></div><div \nclass=\"md-title\">Donut Chart</div><div class=\"card md-whiteframe-4dp\"><nvd3 options=\"vm.donutChart.options\" \ndata=\"vm.donutChart.data\"></nvd3></div><div class=\"md-title\">Bullet Chart</div><div class=\"card md-whiteframe-4dp\">\n<nvd3 options=\"vm.bulletChart.options\" data=\"vm.bulletChart.data\"></nvd3></div><div class=\"md-title\">Scatter Chart\n</div><div class=\"card md-whiteframe-4dp\"><nvd3 options=\"vm.scatterChart.options\" data=\"vm.scatterChart.data\"></nvd3>\n</div></div></div>");
$templateCache.put("app/main/components/custom-directives/pages/ms-card.html","<div class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">COMPONENTS</span></div><div \nclass=\"title\">ms-card</div></div></div><div class=\"content\" layout=\"column\"><div class=\"card md-whiteframe-4dp\" \nlayout=\"column\"><p>\n                <hljs language=\"html\" class=\"source-code\">\n                    <ms-card template=\"PATH_TO_TEMPLATE\" ng-model=\"CARD_MODEL_DATA\"></ms-card>\n                </hljs>\n                </p><span class=\"h2 pt-16\">Description:</span><p><b>ms-card</b>\n directive can be used for creating cards that follow Google\'s Material Design specifications. Currently it has 10 different pre-defined templates but you can always create your own templates and use them with the directive.\n</p><div class=\"simple-table-container md-whiteframe-1dp mv-16\"><table class=\"simple\"><thead><tr><th>Attribute</th><th>\nDescription</th></tr></thead><tbody><tr><td>template</td><td>\nThis attribute must be present in order to ms-card directive to work. It works similar to ng-include directive. You can either provide the path of the html template file or the variable that holds the path of the html template file.\n</td></tr><tr><td>ng-model</td><td>\nDirective uses ng-model to hold the card data. Data passed with using ng-model will be available in the template files within variable named card.\n</td></tr></tbody></table></div><span class=\"h2 pt-16\">Example:</span>\n            <hljs language=\"html\" class=\"source-code\">\n                <ms-card template=\"\'app/card-templates/my-custom-template.html\'\" ng-model=\"vm.cardModel\"></ms-card>\n            </hljs>\n            <p>Above directive will use \n<span class=\"text-boxed\">my-custom-template.html</span> file as a template. And you will be able to access to the <span\n class=\"text-boxed\">vm.cardModel</span> object through card variable inside the template.</p><p>\nConsider the following object:\n                <hljs language=\"js\" class=\"source-code\">\n                    vm.cardModel = {\n                        title      : \'My Card\',\n                        description: \'My card description\'\n                    }\n                </hljs>\n                </p><p>It will be available in the template file as:\n\n                <hljs language=\"js\" class=\"source-code\">\n                    card = {\n                        title      : \'My Card\',\n                        description: \'My card description\'\n                    }\n                </hljs>\n                </p><p>So you will be able to access the title by doing\n                <hljs language=\"js\" class=\"source-code\">\n                    {{card.title}}\n                </hljs>\n                 inside the template file.\n</p></div></div></div>");
$templateCache.put("app/main/components/custom-directives/pages/ms-form-wizard.html","<div class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"column\" \nlayout-align=\"center start\"><div class=\"breadcrumb\"><span class=\"parent\">Custom Directives</span></div><div \nclass=\"title\">ms-form-wizard</div></div><div class=\"content\" layout=\"column\"><div class=\"card md-whiteframe-4dp\" \nlayout=\"column\"><span class=\"h2 pt-16\">Description:</span><p>\nms-form-wizard directive is a helper directive that will help you to create form wizards. Combined with <b>md-tabs</b>\n and <b>form</b> elements, you will be able to create as much as steps you want.</p><span class=\"h2 pt-16\">Example:\n</span>\n            <hljs language=\"html\" class=\"source-code\">\n\n                <ms-form-wizard flex>\n                    <md-tabs md-dynamic-height md-selected=\"msWizard.selectedIndex\" md-center-tabs=\"true\">\n                        <md-tab>\n                            <md-tab-label>\n                            <span class=\"ms-form-wizard-step-label\">\n                                <span class=\"ms-form-wizard-step-number md-accent-bg\"\n                                      ng-if=\"wizardStep1.$invalid\">1</span>\n                                <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$valid\">\n                                    <i class=\"icon-check s16\"></i>\n                                </span>\n                                <span class=\"ms-form-wizard-step-text\">Personal Information</span>\n                            </span>\n                            </md-tab-label>\n\n                            <md-tab-body>\n                                <form name=\"wizardStep1\" class=\"md-inline-form\" ms-form-wizard-form novalidate>\n                                    <div layout=\"column\" layout-gt-xs=\"row\" flex>\n                                        <md-input-container flex=\"100\" flex-gt-xs=\"50\">\n                                            <input type=\"text\" name=\"firstname\" ng-model=\"vm.formWizard.firstname\"\n                                                   placeholder=\"Firstname\"\n                                                   required>\n                                            <div ng-messages=\"wizardStep1.firstname.$error\"\n                                                 ng-show=\"wizardStep1.firstname.$touched\"\n                                                 role=\"alert\">\n                                                <div ng-message=\"required\">\n                                                    <span>Firstname field is required.</span>\n                                                </div>\n                                            </div>\n                                        </md-input-container>\n                                    </div>\n                                </form>\n                            </md-tab-body>\n                        </md-tab>\n\n                        <md-tab ng-disabled=\"wizardStep1.$invalid\">\n                            <md-tab-label>\n                            <span class=\"ms-form-wizard-step-label\">\n                                <span class=\"ms-form-wizard-step-number md-accent-bg\"\n                                      ng-if=\"wizardStep2.$invalid\">2</span>\n                                <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep2.$valid\">\n                                    <i class=\"icon-check s16\"></i>\n                                </span>\n                                <span class=\"ms-form-wizard-step-text\">Address</span>\n                            </span>\n                            </md-tab-label>\n\n                            <md-tab-body>\n                                <form name=\"wizardStep2\" ms-form-wizard-form novalidate>\n                                    <md-input-container class=\"md-block\">\n                                        <label>Address</label>\n                                    <textarea ng-model=\"vm.formWizard.address\" columns=\"1\" md-maxlength=\"150\"\n                                              rows=\"5\" required></textarea>\n                                        <div ng-messages=\"wizardStep2.address.$error\"\n                                             ng-show=\"wizardStep2.address.$touched\"\n                                             role=\"alert\" multiple>\n                                            <div ng-message=\"required\"><span>Address field is required.</span></div>\n                                            <div ng-message=\"md-maxlength\">\n                                                <span>Address can\'t be longer than 150 characters.</span>\n                                            </div>\n                                        </div>\n                                    </md-input-container>\n                                </form>\n                            </md-tab-body>\n                        </md-tab>\n\n                        <md-tab ng-disabled=\"wizardStep1.$invalid || wizardStep2.$invalid\">\n                            <md-tab-label>\n                            <span class=\"ms-form-wizard-step-label\">\n                                <span class=\"ms-form-wizard-step-number md-accent-bg\"\n                                      ng-if=\"wizardStep3.$invalid\">3</span>\n                                <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep3.$valid\">\n                                    <i class=\"icon-check s16\"></i>\n                                </span>\n                                <span class=\"ms-form-wizard-step-text\">Payment Method</span>\n                            </span>\n                            </md-tab-label>\n                            <md-tab-body>\n                                <form name=\"wizardStep3\" ms-form-wizard-form novalidate>\n                                    <md-input-container class=\"md-block\">\n                                        <input type=\"text\" name=\"cardholder\" ng-model=\"vm.formWizard.cardholder\"\n                                               placeholder=\"Card Holder\"\n                                               required>\n                                        <div ng-messages=\"wizardStep3.cardholder.$error\"\n                                             ng-show=\"wizardStep3.cardholder.$dirty\"\n                                             role=\"alert\">\n                                            <div ng-message=\"required\">\n                                                <span>Card holder field is required.</span>\n                                            </div>\n                                        </div>\n                                    </md-input-container>\n                                </form>\n                            </md-tab-body>\n                        </md-tab>\n                    </md-tabs>\n\n                    <div class=\"navigation\" flex layout=\"row\" layout-align=\"center center\">\n                        <md-button class=\"md-raised md-accent\" ng-click=\"msWizard.previousStep()\"\n                                   ng-disabled=\"msWizard.isFirstStep()\">\n                            Previous\n                        </md-button>\n                        <div class=\"steps\">\n                        <span ng-repeat=\"form in msWizard.forms\"\n                              ng-class=\"{\'selected md-accent-bg\':msWizard.selectedIndex === $index}\"></span>\n                        </div>\n                        <md-button class=\"md-raised md-accent\" ng-click=\"msWizard.nextStep()\"\n                                   ng-hide=\"msWizard.isLastStep()\"\n                                   ng-disabled=\"msWizard.currentStepInvalid()\">\n                            Next\n                        </md-button>\n                        <md-button class=\"md-raised md-warn\" ng-click=\"vm.sendForm(); msWizard.resetForm();\" ng-show=\"msWizard.isLastStep()\"\n                                   ng-disabled=\"msWizard.formsIncomplete()\">\n                            Send\n                        </md-button>\n                    </div>\n\n                </ms-form-wizard>\n\n            </hljs>\n            <p>For more detailed usage, we recommend you to check <b>Forms</b>\n page from our demo application.</p></div></div></div>");
$templateCache.put("app/main/components/custom-directives/pages/ms-info-bar.html","<div class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"column\" \nlayout-align=\"center start\"><div class=\"breadcrumb\"><span class=\"parent\">Custom Directives</span></div><div \nclass=\"title\">ms-info-bar</div></div><div class=\"content\" layout=\"column\"><div class=\"card md-whiteframe-4dp\" \nlayout=\"column\">\n            <hljs language=\"html\" class=\"source-code\">\n                <ms-info-bar>\n                    <div layout=\"row\" layout-align=\"start center\">\n                        <div class=\"white-fg\" flex hide-xs>\n                            We use cookies to ensure that we give you the best experience on our website. If you\n                            continue without changing your settings, we\'ll assume that you are happy to receive all\n                            cookies from this website.\n                        </div>\n                        <md-button class=\" md-raised\" layout=\"row\" layout-align=\"center center\" target=\"_blank\"\n                                   href=\"#\">\n                            <md-icon md-font-icon=\"icon-cart\" class=\"mr-5 s18\"></md-icon>\n                            <span>Accept</span></md-button>\n                    </div>\n                </ms-info-bar>\n            </hljs>\n             <span class=\"h2 pt-16\">Description:</span><p><b>ms-info-bar</b>\n is a helper directive that you can use to show information about your app. On close, its scope will be automatically destroyed.\n</p></div></div></div>");
$templateCache.put("app/main/components/custom-directives/pages/ms-masonry.html","<div class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"column\" \nlayout-align=\"center start\"><div class=\"breadcrumb\"><span class=\"parent\">Custom Directives</span></div><div \nclass=\"title\">ms-masonry</div></div><div class=\"content\" layout=\"column\"><div class=\"card md-whiteframe-4dp\" \nlayout=\"column\"><span class=\"h2 pt-16\">Description:</span><p><b>ms-masonry</b>\n is a directive that you can use to create Masonry layouts. You can use following options to configure the directive:\n</p>\n            <hljs language=\"js\" class=\"source-code\">\n                vm.masonryOptions = {\n                    columnCount     : 5,\n                    respectItemOrder: false,\n                    reLayoutDebounce: 400,\n                    responsive      : {\n                        md: 3,\n                        sm: 2,\n                        xs: 1\n                    }\n                }\n            </hljs>\n             <span class=\"h2 pt-16\">Options:</span><div \nclass=\"simple-table-container md-whiteframe-1dp mv-16\"><table class=\"simple\"><thead><tr><th>Options</th><th>Description\n</th></tr></thead><tbody><tr><td>columnCount</td><td>\n(integer) Column count defines the maximum column count of your masonry layout. ms-masonry will adjust the column count automatically based on \n<b>responsive</b> options and some other calculations.</td></tr><tr><td>respectItemOrder</td><td>\n(boolean) Defaults to false to allow classical masonry behaviour, setting it to true enforces that masonry items are kept in order, allowing consistent positioning.\n</td></tr><tr><td>reLayoutDebounce</td><td>\n(integer) Debounce amount in milliseconds before reLayout can happen. This will prevent reLayout action from happening too much if you are resizing your screen or the device rotation is being changed.\n</td></tr><tr><td>responsive</td><td>\n(object) You can define column counts for individual Angular Material media step definitions.</td></tr></tbody></table>\n</div><span class=\"h2 pt-16\">Example:</span><p>\n                <hljs language=\"js\" class=\"source-code\">\n                    <ms-masonry options=\"vm.masonryOptions\">\n                        <ms-masonry-item></ms-masonry-item>\n                        <ms-masonry-item></ms-masonry-item>\n                        <ms-masonry-item></ms-masonry-item>\n                        ...\n                    </ms-masonry>\n                </hljs>\n                </p></div></div></div>");
$templateCache.put("app/main/components/custom-directives/pages/ms-material-color-picker.html","<div class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"column\" \nlayout-align=\"center start\"><div class=\"breadcrumb\"><span class=\"parent\">Custom Directives</span></div><div \nclass=\"title\">ms-material-color-picker</div></div><div class=\"content\" layout=\"column\"><div \nclass=\"card md-whiteframe-4dp\" layout=\"column\"><span class=\"h2 pt-16\">Description:</span><p><b>ms-material-color-picker\n</b> directive allows you to pick any of the Material Design colors.</p><span class=\"h2 pt-16\">Options:</span><div \nclass=\"simple-table-container md-whiteframe-1dp mv-16\"><table class=\"simple\"><thead><tr><th>Options</th><th>Description\n</th></tr></thead><tbody><tr><td>ms-model-type</td><td>\n(string) Model type of the color picker. Can be either `class` or `obj`</td></tr><tr><td>ng-model (required)</td><td>\nValue that will be updated on color pick</td></tr></tbody></table></div><span class=\"h2 pt-16\">Example:</span><p>\nDepending on <b>ms-model-type</b>\n value, color picker will either update the model with the appropriate class name or the object:</p>\n            <hljs language=\"html\" class=\"source-code\">\n                <ms-material-color-picker ms-model-type=\"obj\" ng-model=\"vm.color\"></ms-material-color-picker>\n            </hljs>\n            \n<p>\nYou can also use transclusion to trigger the picker. Like in the below example, you can add a button or any other element to trigger the picker:\n</p>\n            <hljs language=\"html\" class=\"source-code\">\n                <ms-material-color-picker ms-model-type=\"obj\" ng-model=\"vm.color\">\n                    <md-button>Select a Color</md-button>\n                </ms-material-color-picker>\n            </hljs>\n            <p><b>$selectedColor</b>\n variable can be used within the color picker element to access the properties of the selected color:</p>\n\n            <hljs language=\"html\" class=\"source-code\">\n                <ms-material-color-picker ms-model-type=\"obj\" ng-model=\"vm.color\">\n                    <md-button class=\"{{$selectedColor}}\">Select a Color</md-button>\n                </ms-material-color-picker>\n            </hljs>\n            </div></div></div>");
$templateCache.put("app/main/components/custom-directives/pages/ms-nav.html","<div class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"column\" \nlayout-align=\"center start\"><div class=\"breadcrumb\"><span class=\"parent\">Custom Directives</span></div><div \nclass=\"title\">ms-nav</div></div><div class=\"content\" layout=\"column\"><div class=\"card md-whiteframe-4dp\" \nlayout=\"column\"><p class=\"note\"><b>Note:</b> This directive is deprecated. Use <b>ms-navigation</b> instead.</p><span \nclass=\"h2 pt-16\">Description:</span><p>\nNavigation directive has couple other dependent directives. They all together used for creating the main navigation. \n<b>ms-nav</b> directive is compatible with Angular UI Router module.</p><span class=\"h2 pt-16\">Example:</span>\n\n            <hljs language=\"html\" class=\"source-code\">\n                <ms-nav>\n\n                    <ms-nav-item ms-nav-title>\n                        <span>FUSE</span>\n                    </ms-nav-item>\n\n                    <ms-nav-item ms-nav-toggle>\n\n                        <a ms-nav-button md-ink-ripple>\n                            <i class=\"icon-tile-four s16\"></i>\n                            <span class=\"ms-nav-label\" translate=\"NAVIGATION.DASHBOARDS\">Dashboards</span>\n                            <i class=\"icon-chevron-down s16 arrow\"></i>\n                        </a>\n\n                        <ms-nav-toggle-items>\n                            <ms-nav-item>\n                                <a ms-nav-button ui-sref=\"app.dashboard-v1\" ui-sref-active=\"active\" md-ink-ripple>\n                                    <span class=\"ms-nav-label\">Dashboard v1</span>\n                                </a>\n                            </ms-nav-item>\n\n                            <ms-nav-item>\n                                <a ms-nav-button ui-sref=\"app.dashboard-v2\" ui-sref-active=\"active\" md-ink-ripple>\n                                    <span class=\"ms-nav-label\">Dashboard v2</span>\n                                </a>\n                            </ms-nav-item>\n                        </ms-nav-toggle-items>\n\n                    </ms-nav-item>\n\n                </ms-nav>\n            </hljs>\n            </div></div></div>");
$templateCache.put("app/main/components/custom-directives/pages/ms-navigation.html","<div class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"column\" \nlayout-align=\"center start\"><div class=\"breadcrumb\"><span class=\"parent\">Custom Directives</span></div><div \nclass=\"title\">ms-navigation</div></div><div class=\"content\" layout=\"column\"><div class=\"card md-whiteframe-4dp\" \nlayout=\"column\"><p>\n                <hljs language=\"js\" class=\"source-code\">\n                    msNavigationService.saveItem(\'NAVIGATION.ID\', {NAVIGATION_OPTIONS});\n                </hljs>\n                </p><span class=\"h2 pt-16\">Description:</span><p>\nSince version 1.2.0, Fuse no longer uses html based navigation. This way, you can add, update or remove navigation items at anytime from anywhere. To create navigation items, you can use Angular\'s \n<b>run</b> or <b>config</b> blocks as well as <b>services</b> and <b>controllers</b>.</p><p><b>ms-navigation</b>\n directive works parallel with <b>msNavigationService</b> and there are two main navigation styles: <b>Vertical</b>\n and <b>Horizontal</b>. The preferred style can be used by changing the layout of the template.</p><p>\nTo create a navigation item, you have to use either <b>msNavigationService</b> or <b>msNavigationServiceProvider</b>.\n</p><p class=\"mt-24\">Calling <b>saveItem</b> on <em>msNavigationService</em> or <em>msNavigationServiceProvider</em>\n will either create a menu item, or update an existing one. This way you can update any existing menu item at any times by simply referring to it by using its id.\n</p><span class=\"h2 pt-16\">Navigation Id:</span><p>\nNavigation id is a simple string that uses \"dot notation\" to create the hierarchy between the navigation items. For example, if you want to have a \"Post Blog\" navigation item under \"Blog\" navigation item, you should have \"blog.post-blog\" as the id of the navigation.\n</p><p>\nTo create a navigation item, you don\'t have to create its parent(s). If you create a navigation item by using \"dashboard.project\" id, the navigation item with the \"dashboard\" id will be automatically created for you. Then you can simply update the \"dashboard\" navigation item to change its options.\n</p><span class=\"h2 pt-16\">Navigation Options:</span><div class=\"simple-table-container md-whiteframe-1dp mv-16\"><table\n class=\"simple\"><thead><tr><th>Options</th><th>Description</th></tr></thead><tbody><tr><td>title</td><td>\n(string) Title of the navigation item</td></tr><tr><td>group</td><td>\n(bool) Determines if the navigation item is going to be used for grouping</td></tr><tr><td>icon</td><td>\n(string) Icon class name of the navigation item</td></tr><tr><td>state</td><td>\n(string) UI-Router state name for the navigation item to be linked</td></tr><tr><td>stateParams</td><td>\n(object) UI-Router state parameters</td></tr><tr><td>translate</td><td>\n(string) angular-translate translation object id (e.g. \"NAVIGATION.MAIL\")</td></tr><tr><td>class</td><td>\n(string) Custom class name(s) to be applied to the navigation item</td></tr><tr><td>badge</td><td>\n(object) Badge to show in navigation item</td></tr><tr><td>weight</td><td>\n(int) Determines the sort order of the navigation item</td></tr><tr><td>hidden</td><td>\n(function) Determines the visibility of the menu item. The function must return a <b>boolean</b> value.</td></tr>\n</tbody></table></div><span class=\"h2 pt-16\">Example:</span><p>To create a navigation item from <b>Run</b> or <b>Config\n</b> blocks, you must use <b>msNavigationServiceProvider</b>:</p>\n            <hljs language=\"js\" class=\"source-code\">\n                /** @ngInject */\n                function config(msNavigationServiceProvider)\n                {\n                    // Navigation\n                    msNavigationServiceProvider.saveItem(\'apps\', {\n                        title : \'APPS\',\n                        group : true,\n                        weight: 1\n                    });\n\n                    // Apps.Dashboards\n                    msNavigationServiceProvider.saveItem(\'apps.dashboards\', {\n                        title : \'Dashboards\',\n                        icon  : \'icon-tile-four\',\n                        class : \'navigation-dashboards\',\n                        weight: 1\n                    });\n\n                    // Apps.Dashboards.Project\n                    msNavigationServiceProvider.saveItem(\'apps.dashboards.project\', {\n                        title      : \'Project\',\n                        state      : \'app.dashboards_project\',\n                        stateParams: {\'id\': 1},\n                        badge      : {\n                            content: \'21\',\n                            color  : \'red\'\n                        },\n                        translate  : \'NAVIGATION.DASHBOARDS.PROJECT\',\n                        class      : \'navigation-dashboards project-dashboard\',\n                        weight     : 1\n                    });\n\n                    // Apps.Dashboards.Server\n                    msNavigationServiceProvider.saveItem(\'apps.dashboards.server\', {\n                        title      : \'Server\',\n                        state      : \'app.dashboards_server\',\n                        stateParams: {\'id\': 1},\n                        translate  : \'NAVIGATION.DASHBOARDS.SERVER\',\n                        class      : \'navigation-dashboards server-dashboard\',\n                        weight     : 2\n                    });\n\n                    // Apps.Dashboards.Analytics\n                    msNavigationServiceProvider.saveItem(\'apps.dashboards.analytics\', {\n                        title      : \'Analytics\',\n                        state      : \'app.dashboards_analytics\',\n                        stateParams: {\'id\': 1},\n                        translate  : \'NAVIGATION.DASHBOARDS.ANALYTICS\',\n                        class      : \'navigation-dashboards analytics-dashboard\',\n                        weight     : 3\n                    });\n                }\n            </hljs>\n            <p class=\"mt-24\">\nTo do the same thing in <b>services</b> and <b>controllers</b>, you must use <b>msNavigationService</b>:</p>\n\n            <hljs language=\"js\" class=\"source-code\">\n                /** @ngInject */\n                function TestController(msNavigationService)\n                {\n                    // Navigation\n                    msNavigationService.saveItem(\'apps\', {\n                        title : \'APPS\',\n                        group : true,\n                        weight: 1\n                    });\n\n                    // Apps.Dashboards\n                    msNavigationService.saveItem(\'apps.dashboards\', {\n                        title : \'Dashboards\',\n                        icon  : \'icon-tile-four\',\n                        class : \'navigation-dashboards\',\n                        weight: 1\n                    });\n\n                    // Apps.Dashboards.Project\n                    msNavigationService.saveItem(\'apps.dashboards.project\', {\n                        title      : \'Project\',\n                        state      : \'app.dashboards_project\',\n                        stateParams: {\'id\': 1},\n                        badge      : {\n                            content: \'21\',\n                            color  : \'red\'\n                        },\n                        translate  : \'NAVIGATION.DASHBOARDS.PROJECT\',\n                        class      : \'navigation-dashboards project-dashboard\',\n                        weight     : 1\n                    });\n\n                    // Apps.Dashboards.Server\n                    msNavigationService.saveItem(\'apps.dashboards.server\', {\n                        title      : \'Server\',\n                        state      : \'app.dashboards_server\',\n                        stateParams: {\'id\': 1},\n                        translate  : \'NAVIGATION.DASHBOARDS.SERVER\',\n                        class      : \'navigation-dashboards server-dashboard\',\n                        weight     : 2\n                    });\n\n                    // Apps.Dashboards.Analytics\n                    msNavigationService.saveItem(\'apps.dashboards.analytics\', {\n                        title      : \'Analytics\',\n                        state      : \'app.dashboards_analytics\',\n                        stateParams: {\'id\': 1},\n                        translate  : \'NAVIGATION.DASHBOARDS.ANALYTICS\',\n                        class      : \'navigation-dashboards analytics-dashboard\',\n                        weight     : 3\n                    });\n                }\n            </hljs>\n            <p class=\"mt-24\">\nYou can specify a hidden value within your navigation item configuration to have more control on its visibility. It accepts a function and that function must return a boolean value.\n</p><p>\nms-navigation will watch that function and whenever the AuthService.isAdmin value changes, the visibility of the navigation item will be updated automatically.\n</p>\n            <hljs language=\"js\" class=\"source-code\">\n                /** @ngInject */\n                function TestController(msNavigationService)\n                {\n                    // Navigation\n                    msNavigationService.saveItem(\'apps\', {\n                        title : \'APPS\',\n                        group : true,\n                        weight: 1\n                    });\n\n                    // Apps.Dashboards\n                    msNavigationService.saveItem(\'apps.dashboards\', {\n                        title : \'Dashboards\',\n                        icon  : \'icon-tile-four\',\n                        class : \'navigation-dashboards\',\n                        hidden: function ()\n                        {\n                            return AuthService.isAdmin; // must be a boolean value\n                        },\n                        weight: 1\n                    });\n                }\n            </hljs>\n            <p class=\"mt-24\">\nIf you wish to remove an item from the navigation at runtime, you can use deleteItem() method. It\'s available in both \n<b>msNavigationService</b> and <b>msNavigationServiceProvider</b>:</p>\n            <hljs language=\"js\" class=\"source-code\">\n                /** @ngInject */\n                function TestController(msNavigationService)\n                {\n                    // Delete the \'apps\' item\n                    msNavigationService.deleteItem(\'apps\');\n                }\n            </hljs>\n             <span class=\"h2 pt-16\">\nDirective:</span><p>To show the navigation, you can use <b>ms-navigation</b> element:</p>\n            <hljs lang=\"html\" class=\"source-code\">\n                <ms-navigation class=\"scrollable\" folded=\"vm.folded\" root=\"apps.dashboards\"></ms-navigation>\n            </hljs>\n            <div \nclass=\"simple-table-container md-whiteframe-1dp mv-16\"><table class=\"simple\"><thead><tr><th>Options</th><th>Description\n</th></tr></thead><tbody><tr><td>folded</td><td>(boolean) Sets the initial folded status of the navigation</td></tr>\n<tr><td>root</td><td>\n(string) You can specify the root item key in here to make navigation to show only certain navigation group. This might be useful if you are showing different menu groups to different users or using Fuse as both front and backend apps.\n</td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/components/custom-directives/pages/ms-random-class.html","<div class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"column\" \nlayout-align=\"center start\"><div class=\"breadcrumb\"><span class=\"parent\">Custom Directives</span></div><div \nclass=\"title\">ms-random-class</div></div><div class=\"content\" layout=\"column\"><div class=\"card md-whiteframe-4dp\" \nlayout=\"column\">\n            <hljs language=\"html\" class=\"source-code\">\n                <div ms-random-class=\"vm.colors\"></div>\n            </hljs>\n             <span class=\"h2 pt-16\">Description:</span><p><b>ms-random-class</b>\n directive can be used for adding randomly selected class from an array. It\'s used mainly for generating random background colors in the template, but you can use it anywhere if you find it useful.\n</p><div class=\"simple-table-container md-whiteframe-1dp mv-16\"><table class=\"simple\"><thead><tr><th>Attribute</th><th>\nDescription</th></tr></thead><tbody><tr><td>ms-random-class</td><td>\n(Array) This attribute must be present in order to ms-random-class directive to work.</td></tr></tbody></table></div>\n<span class=\"h2 pt-16\">Example:</span>\n            <hljs language=\"js\" class=\"source-code\">\n                vm.colors = [\n                    \'yellow\',\n                    \'red\',\n                    \'blue\',\n                    \'orange\',\n                    \'green\'\n                ]\n            </hljs>\n            \n            <hljs language=\"html\" class=\"source-code\">\n                <div ms-random-class=\"vm.colors\"></div>\n            </hljs>\n            </div></div></div>");
$templateCache.put("app/main/components/custom-directives/pages/ms-responsive-table.html","<div class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"column\" \nlayout-align=\"center start\"><div class=\"breadcrumb\"><span class=\"parent\">Custom Directives</span></div><div \nclass=\"title\">ms-responsive-table</div></div><div class=\"content\" layout=\"column\"><div class=\"card md-whiteframe-4dp\" \nlayout=\"column\">\n            <hljs language=\"html\" class=\"source-code\">\n                <table class=\"simple\" ms-responsive-table>\n                    <!-- Table content -->\n                </table>\n            </hljs>\n             <span class=\"h2 pt-16\">Description:</span><p><b>ms-responsive-table</b>\n directive is useful for making tables responsive. It will simply add a scrollable wrapper around the table to make them usable in smaller screens.\n</p></div></div></div>");
$templateCache.put("app/main/components/custom-directives/pages/ms-scroll.html","<div class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"column\" \nlayout-align=\"center start\"><div class=\"breadcrumb\"><span class=\"parent\">Custom Directives</span></div><div \nclass=\"title\">ms-scroll</div></div><div class=\"content\" layout=\"column\"><div class=\"card md-whiteframe-4dp\" \nlayout=\"column\">\n            <hljs language=\"html\" class=\"source-code\">\n                <div ms-scroll>\n                    <!-- Some long content -->\n                </div>\n            </hljs>\n             <span class=\"h2 pt-16\">Description:</span><p><b>ms-scroll</b>\n directive can be used for adding custom scrollbars to the scrollable content. Fuse uses <a \nhref=\"https://github.com/noraesae/perfect-scrollbar\" target=\"_blank\">Perfect Scrollbar</a>\n as a custom scrollbar. You can also use this directive with <em>scrollable</em> helper class. <em>scrollable</em>\n class will make any content scrollable and then you can add custom scrollbars by adding <b>ms-scroll</b>\n directive to the same element:</p>\n            <hljs language=\"html\" class=\"source-code\">\n                <div class=\"scrollable\" ms-scroll>\n                    <!-- Some long content -->\n                </div>\n            </hljs>\n            </div></div></div>");
$templateCache.put("app/main/components/custom-directives/pages/ms-search-bar.html","<div class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"column\" \nlayout-align=\"center start\"><div class=\"breadcrumb\"><span class=\"parent\">Custom Directives</span></div><div \nclass=\"title\">ms-search-bar</div></div><div class=\"content\" layout=\"column\"><div class=\"card md-whiteframe-4dp\" \nlayout=\"column\">\n            <hljs language=\"html\" class=\"source-code\">\n                <ms-search-bar></ms-search-bar>\n            </hljs>\n             <span class=\"h2 pt-16\">Description:</span><p><b>ms-search-bar</b>\n is an autocomplete supported search bar directive. It has various options and events for you to use.</p><span \nclass=\"h2 pt-16\">Options:</span><div class=\"simple-table-container md-whiteframe-1dp mv-16\"><table class=\"simple\">\n<thead><tr><th>Options</th><th>Description</th></tr></thead><tbody><tr><td>debounce</td><td>\n(integer) Model update debounce. Can be used to stop triggering the on-search event for every keystroke.</td></tr><tr>\n<td>on-search</td><td>\n(function (query)) A callback function that will trigger on model update. Must return an Array or a Promise object that caries an Array. Has \'query\' parameter to access the search query.\n</td></tr><tr><td>on-result-click</td><td>\n(function (item)) A callback function that will trigger on search result click. Has \'item\' parameter to access the clicked item.\n</td></tr><tr><td>on-expand</td><td>(function) A callback function that will trigger when search bar expanded.</td>\n</tr><tr><td>on-collapse</td><td>(function) A callback function that will trigger when search bar collapsed.</td></tr>\n</tbody></table></div><span class=\"h2 pt-16\">Example:</span>\n            <hljs language=\"html\" class=\"source-code\">\n                <ms-search-bar on-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar>\n            </hljs>\n            </div></div></div>");
$templateCache.put("app/main/components/custom-directives/pages/ms-shortcuts.html","<div class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"column\" \nlayout-align=\"center start\"><div class=\"breadcrumb\"><span class=\"parent\">Custom Directives</span></div><div \nclass=\"title\">ms-shortcuts</div></div><div class=\"content\" layout=\"column\"><div class=\"card md-whiteframe-4dp\" \nlayout=\"column\"><span class=\"h2 pt-16\">Description:</span><p><b>ms-shortcuts</b>\n is a directive that you can use to add shortcuts for navigation items. It works in parallel with <b>ms-navigation</b>\n directive to get its data. It has built in search, add and remove shortcut functions.</p><span class=\"h2 pt-16\">\nExample:</span>\n            <hljs language=\"html\" class=\"source-code\">\n                <ms-shortcuts></ms-shortcuts>\n            </hljs>\n            </div></div></div>");
$templateCache.put("app/main/components/custom-directives/pages/ms-sidenav-helper.html","<div class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"column\" \nlayout-align=\"center start\"><div class=\"breadcrumb\"><span class=\"parent\">Custom Directives</span></div><div \nclass=\"title\">ms-sidenav-helper</div></div><div class=\"content\" layout=\"column\"><div class=\"card md-whiteframe-4dp\" \nlayout=\"column\">\n            <hljs language=\"html\" class=\"source-code\">\n                <md-sidenav class=\"sidenav\" md-component-id=\"main-sidenav\" ms-scroll ms-sidenav-helper>\n                    <!-- Sidenav Content -->\n                </md-sidenav>\n            </hljs>\n             <span class=\"h2 pt-16\">Description:</span><p><b>ms-sidenav-helper</b>\n directive is required if you use sidenavs inside the page content. You can check out the <em>\napp/main/ui/layouts/simple/left-sidenav/left-sidenav.html</em> file for the simple usage.</p><p>\nSimply, this directive will add a class to the certain elements in order to page and the sidenav act correctly on all devices.\n</p></div></div></div>");
$templateCache.put("app/main/components/custom-directives/pages/ms-splash-screen.html","<div class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"column\" \nlayout-align=\"center start\"><div class=\"breadcrumb\"><span class=\"parent\">Custom Directives</span></div><div \nclass=\"title\">ms-splash-screen</div></div><div class=\"content\" layout=\"column\"><div class=\"card md-whiteframe-4dp\" \nlayout=\"column\">\n            <hljs language=\"html\" class=\"source-code\">\n                <ms-splash-screen>\n                    <!-- Splash screen content -->\n                </ms-splash-screen>\n            </hljs>\n             <span class=\"h2 pt-16\">Description:</span><p><b>ms-splash-screen</b>\n is a helper directive that helps splash screen to disappear.</p></div></div></div>");
$templateCache.put("app/main/components/custom-directives/pages/ms-stepper.html","<div class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"column\" \nlayout-align=\"center start\"><div class=\"breadcrumb\"><span class=\"parent\">Custom Directives</span></div><div \nclass=\"title\">ms-stepper</div></div><div class=\"content\" layout=\"column\"><div class=\"card md-whiteframe-4dp\" \nlayout=\"column\"><span class=\"h2 pt-16\">Description:</span><p><b>ms-stepper</b>\n is a form step directive that follows Google\'s Material Design specifications. It allows you to create stepped forms. Unlike \n<b>ms-form-wizard</b>\n, this directive doesn\'t use any other material elements, therefore it\'s a lot more flexible and easy to use:</p><span \nclass=\"h3 pt-16\">Horizontal Stepper:</span>\n            <hljs language=\"html\" class=\"source-code\">\n                <form name=\"stepper\" ms-horizontal-stepper ng-submit=\"vm.submitStepper()\" ng-model=\"vm.stepper\" novalidate>\n                    <!-- Step 1 -->\n                    <ms-horizontal-stepper-step ng-form=\"step1\" step=\"1\" step-title=\"\'Personal Information\'\">\n                        <div ng-include=\"\'app/main/ui/forms/stepper-steps/step-1.html\'\"></div>\n                    </ms-horizontal-stepper-step>\n                    <!-- / Step 1 -->\n\n                    <!-- Step 2 -->\n                    <ms-horizontal-stepper-step ng-form=\"step2\" step=\"2\" step-title=\"\'Address\'\" optional-step>\n                        <div ng-include=\"\'app/main/ui/forms/stepper-steps/step-2.html\'\"></div>\n                    </ms-horizontal-stepper-step>\n                    <!-- / Step 2 -->\n\n                    <!-- Step 3 -->\n                    <ms-horizontal-stepper-step ng-form=\"step3\" step=\"3\" step-title=\"\'Payment Method\'\">\n                        <div ng-include=\"\'app/main/ui/forms/stepper-steps/step-3.html\'\"></div>\n                    </ms-horizontal-stepper-step>\n                    <!-- / Step 3 -->\n                </form>\n            </hljs>\n            <hr><span class=\"h3 pt-16\">Vertical Stepper:</span>\n\n            <hljs language=\"html\" class=\"source-code\">\n                <form name=\"stepper\" ms-vertical-stepper ng-submit=\"vm.submitStepper()\" ng-model=\"vm.stepper\" novalidate>\n                    <!-- Step 1 -->\n                    <ms-vertical-stepper-step ng-form=\"step1\" step=\"1\" step-title=\"\'Personal Information\'\">\n                        <div ng-include=\"\'app/main/ui/forms/stepper-steps/step-1.html\'\"></div>\n                    </ms-vertical-stepper-step>\n                    <!-- / Step 1 -->\n\n                    <!-- Step 2 -->\n                    <ms-vertical-stepper-step ng-form=\"step2\" step=\"2\" step-title=\"\'Address\'\" optional-step>\n                        <div ng-include=\"\'app/main/ui/forms/stepper-steps/step-2.html\'\"></div>\n                    </ms-vertical-stepper-step>\n                    <!-- / Step 2 -->\n\n                    <!-- Step 3 -->\n                    <ms-vertical-stepper-step ng-form=\"step3\" step=\"3\" step-title=\"\'Payment Method\'\">\n                        <div ng-include=\"\'app/main/ui/forms/stepper-steps/step-3.html\'\"></div>\n                    </ms-vertical-stepper-step>\n                    <!-- / Step 3 -->\n                </form>\n            </hljs>\n             <span class=\"h2 pt-16\">ms-*-stepper-step</span><p>This directive requires <b>ms-*-stepper</b>\n directive and it\'s used for creating individual steps. You can either directly wrap your forms with this directive, or you can use ng-include to include them.\n</p><span class=\"h2 pt-16\">ms-stepper-step Attributes</span><div \nclass=\"simple-table-container md-whiteframe-1dp mv-16\"><table class=\"simple\"><thead><tr><th>Attribute</th><th>\nDescription</th></tr></thead><tbody><tr><td>ng-form</td><td>\n(string) This attribute/directive is required for steps to work correctly. It requires a unique, string value. You can think this as the unique name of the step.\n</td></tr><tr><td>step [Optional]</td><td>\n(integer) Optional value for the step number. If you want to manually order your steps, you can use this attribute.\n</td></tr><tr><td>step-title</td><td>(string) Step title that will show up in the step navigation.</td></tr><tr><td>\noptional-step [Optional]</td><td>\nIf given, this attribute will make the step optional. Therefore, that step can be passed through without filling its input fields and it will not be included into the main form validity check.\n</td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/components/custom-directives/pages/ms-timeline.html","<div class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"column\" \nlayout-align=\"center start\"><div class=\"breadcrumb\"><span class=\"parent\">Custom Directives</span></div><div \nclass=\"title\">ms-timeline</div></div><div class=\"content\" layout=\"column\"><div class=\"card md-whiteframe-4dp\" \nlayout=\"column\">\n            <hljs language=\"html\" class=\"source-code\">\n                <div id=\"timeline\" ms-timeline ms-timeline-load-more=\"vm.loadNextPage()\">\n\n                    <!-- TIMELINE ITEM -->\n                    <div ms-timeline-item ng-repeat=\"timelineItem in vm.timeline\">\n\n                        <div class=\"timeline-card\">\n                            <!-- MS-CARD -->\n                            <ms-card template=\"timelineItem.card.template\" ng-model=\"timelineItem.card\"></ms-card>\n                            <!-- / MS-CARD -->\n                        </div>\n\n                        <div class=\"timeline-point md-accent-bg md-whiteframe-2dp\">\n                            <md-icon md-font-icon=\"{{timelineItem.icon}}\"></md-icon>\n                        </div>\n\n                        <div class=\"timeline-detail\">\n                            <div class=\"time\">\n                                {{timelineItem.time}}\n                            </div>\n                            <div class=\"event\">\n                                {{timelineItem.event}}\n                            </div>\n                        </div>\n                    </div>\n                    <!-- / TIMELINE ITEM -->\n\n                </div>\n            </hljs>\n             <span class=\"h2 pt-16\">Description:</span><p><b>ms-timeline</b>\n directive is required for timeline. It will help loading and animating the timeline items properly. We highly recommend you to check \n<em>app/main/pages/timeline/timeline.html</em> and <em>app/main/pages/timeline/timeline.controller.js</em>\n to fully understand how to use it.</p></div></div></div>");
$templateCache.put("app/main/components/custom-directives/pages/ms-widget.html","<div class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"column\" \nlayout-align=\"center start\"><div class=\"breadcrumb\"><span class=\"parent\">Custom Directives</span></div><div \nclass=\"title\">ms-widget</div></div><div class=\"content\" layout=\"column\"><div class=\"card md-whiteframe-4dp\" \nlayout=\"column\">\n            <hljs language=\"html\" class=\"source-code\">\n                <ms-widget flippable=\"true\">\n\n                    <ms-widget-front class=\"padding-16 md-white-bg\">\n                        <!-- Front content -->\n                    </ms-widget-front>\n\n                    <ms-widget-back class=\"padding-16 md-white-bg\">\n                        <!-- Back content -->\n                    </ms-widget-back>\n\n                </ms-widget>\n            </hljs>\n             <span class=\"h2 pt-16\">Description:</span><p><b>ms-widget</b>\n directive is a helper directive for creating widgets. When it used with helper classes such as padding, margin, height helpers, it\'s very easy to create custom widgets.\n</p><div class=\"simple-table-container md-whiteframe-1dp mv-16\"><table class=\"simple\"><thead><tr><th>Attribute</th><th>\nDescription</th></tr></thead><tbody><tr><td>flippable</td><td>\nIf it\'s true, widget will be flippable. If you don\'t want to make the widget flippable, you can make this attribute false and use only \n<b>&lt;ms-widget-front&gt;&lt;/ms-widget-front&gt;</b> wrapper to show widget content.</td></tr></tbody></table></div>\n</div></div></div>");
$templateCache.put("app/main/components/maps/tabs/custom-marker.html","<ui-gmap-google-map center=\"vm.customMarkerMap.center\" zoom=\"vm.customMarkerMap.zoom\"><ui-gmap-marker \ncoords=\"vm.customMarkerMap.marker.coords\" idkey=\"vm.customMarkerMap.marker.id\" \noptions=\"vm.customMarkerMap.marker.options\"></ui-gmap-marker></ui-gmap-google-map>");
$templateCache.put("app/main/components/maps/tabs/info-window.html","<ui-gmap-google-map center=\"vm.simpleMarkerMap.center\" zoom=\"vm.simpleMarkerMap.zoom\"><ui-gmap-marker \ncoords=\"vm.simpleMarkerMap.marker.coords\" idkey=\"vm.simpleMarkerMap.marker.id\"><ui-gmap-window show=\"\'true\'\"><div \nng-non-bindable=\"\"><div id=\"siteNotice\"></div><h1 id=\"firstHeading\" class=\"firstHeading\">Uluru</h1><div \nid=\"bodyContent\"><p><b>Uluru</b>, also referred to as <b>Ayers Rock</b>\n, is a large sandstone rock formation in the southern part of the Northern Territory, central Australia.</p><p>\nAttribution: Uluru, <a href=\"//en.wikipedia.org/w/index.php?title=Uluru&amp;oldid=297882194\">\nhttp://en.wikipedia.org/w/index.php?title=Uluru</a> (last visited June 22, 2009).</p></div></div></ui-gmap-window>\n</ui-gmap-marker></ui-gmap-google-map>");
$templateCache.put("app/main/components/maps/tabs/satellite.html","<ui-gmap-google-map center=\"vm.satelliteMap.center\" zoom=\"vm.satelliteMap.zoom\" options=\"vm.satelliteMap.options\">\n</ui-gmap-google-map>");
$templateCache.put("app/main/components/maps/tabs/simple-marker.html","<ui-gmap-google-map center=\"vm.simpleMarkerMap.center\" zoom=\"vm.simpleMarkerMap.zoom\"><ui-gmap-marker \ncoords=\"vm.simpleMarkerMap.marker.coords\" idkey=\"vm.simpleMarkerMap.marker.id\"></ui-gmap-marker></ui-gmap-google-map>");
$templateCache.put("app/main/components/maps/tabs/simple.html","<ui-gmap-google-map center=\"vm.simpleMap.center\" zoom=\"vm.simpleMap.zoom\"></ui-gmap-google-map>");
$templateCache.put("app/main/components/maps/tabs/terrain.html","<ui-gmap-google-map center=\"vm.terrainMap.center\" zoom=\"vm.terrainMap.zoom\" options=\"vm.terrainMap.options\">\n</ui-gmap-google-map>");
$templateCache.put("app/main/dashboard/views/dashboard/dashboard.html","<div id=\"dashboard\" class=\"page-layout blank\" layout=\"row\"><div class=\"center\" flex ms-scroll><div class=\"content\">\n<md-tabs md-dynamic-height><md-tab label=\"Overview\" ng-click=\"vm.changeSelectedDiv(\'activitylog\');\"><div \nng-include=\"\'app/main/dashboard/views/reports/overview.html\'\"></div></md-tab><md-tab label=\"Zero Sales\" \nng-click=\"vm.zerosales.loadData();vm.zerosales1.loadData();vm.zerosales2.loadData();\"><div \nng-include=\"\'app/main/dashboard/views/reports/zerosales.html\'\"></div></md-tab><md-tab label=\"New Outlet\" \nng-click=\"vm.newoutlet.loadData();\"><div ng-include=\"\'app/main/dashboard/views/reports/newoutlet.html\'\"></div></md-tab>\n<md-tab label=\"SKU Dispersion\" ng-click=\"vm.skudispersion.loadData();\"><div \nng-include=\"\'app/main/dashboard/views/reports/skudispersion.html\'\"></div></md-tab><md-tab label=\"Revenue Dispersion\" \nng-click=\"vm.revenuedispersion.loadData();\"><div \nng-include=\"\'app/main/dashboard/views/reports/revenuedispersion.html\'\"></div></md-tab><md-tab \nlabel=\"Coverage and Productivity\" \nng-click=\"vm.coverageandproductvity.loadData();vm.coverageandproductvitygraph.loadData();\"><div \nng-include=\"\'app/main/dashboard/views/reports/coverage_and_productivity.html\'\"></div></md-tab><md-tab \nlabel=\"MSS Sales By Outlet\" ng-click=\"vm.msssalesbyoutlet.loadData();\"><div \nng-include=\"\'app/main/dashboard/views/reports/mss_sales_by_outlet.html\'\"></div></md-tab><md-tab \nlabel=\"Salesman Productivity Measures\" ng-click=\"vm.salesmanproductivitymeasures.loadData();\"><div \nng-include=\"\'app/main/dashboard/views/reports/salesman_productivity_measures.html\'\"></div></md-tab><md-tab \nlabel=\"No Sales Consecutive Visits\" ng-click=\"vm.nosalesconsecutivevisits.loadData();\"><div \nng-include=\"\'app/main/dashboard/views/reports/no_sales_consecutive_visits.html\'\"></div></md-tab><md-tab \nlabel=\"Sales By Customer Type\" ng-click=\"vm.salesbycustomertype.loadData();\"><div \nng-include=\"\'app/main/dashboard/views/reports/sales_by_customer_type.html\'\"></div></md-tab><md-tab \nlabel=\"Outletwise Sales\" ng-click=\"vm.outletwisesales.loadData();\"><div \nng-include=\"\'app/main/dashboard/views/reports/outletwise_sales.html\'\"></div></md-tab><md-tab label=\"SR Score Card\" \nng-click=\"vm.sr_score_card.loadData();\"><div ng-include=\"\'app/main/dashboard/views/reports/sr_score_card.html\'\"></div>\n</md-tab><md-tab label=\"Weekly Sales Report\" ng-click=\"vm.weeklysalesreport.loadData();\"><div \nng-include=\"\'app/main/dashboard/views/reports/weekly_sales_report.html\'\"></div></md-tab></md-tabs></div></div></div>");
$templateCache.put("app/main/dashboard/views/reports/coverage_and_productivity.html","<md-content id=\"\" class=\"ps-active-y\" flex=\"\" data-ps-id=\"\" ms-scroll><div layout=\"row\" \nlayout-align=\"space-between center\"><div style=\"width: 100%\"><div style=\"float: left;width: 20%\"><md-input-container \nclass=\"align-datepicker\" style=\"margin: 1%\"><md-datepicker md-open-on-focus class=\"datepicker\" \nng-model=\"vm.start_date\" md-placeholder=\"Start Date\"></md-datepicker></md-input-container></div><div \nstyle=\"float:left;width: 20%\"><md-input-container class=\"align-datepicker\" style=\"margin: 1%\"><md-datepicker \nmd-open-on-focus class=\"datepicker\" ng-model=\"vm.end_date\" md-placeholder=\"End Date\"></md-datepicker>\n</md-input-container></div></div><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"25\" style=\"padding: 1%\">\n<ms-widget-front class=\"white-bg\"><input type=\"text\" ng-model=\"vm.searchaggrid\" ng-change=\"vm.searchGrid()\" \nplaceholder=\"Type to Search\" style=\"padding: 10px\"></ms-widget-front></ms-widget></div><div layout=\"row\" \nlayout-align=\"space-between center\"><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"25\"><ms-widget-front \nclass=\"white-bg\"><form ng-submit=\"$event.preventDefault()\"><md-autocomplete ng-disabled=\"vm.zoneFilter.isDisabled\" \nmd-no-cache=\"vm.zoneFilter.noCache\" md-selected-item=\"vm.zoneFilter.selectedZone\" \nmd-search-text-change=\"vm.zoneFilter.searchTextChange(vm.zoneFilter.searchText)\" \nmd-search-text=\"vm.zoneFilter.searchText\" md-selected-item-change=\"vm.zoneFilter.selectedZoneChange(zone)\" \nmd-items=\"zone in vm.zoneFilter.querySearch(vm.zoneFilter.searchText)\" md-item-text=\"zone.name\" md-min-length=\"0\" \nplaceholder=\"Filter by Zone\"><md-item-template><span md-highlight-text=\"vm.zoneFilter.searchText\" \nmd-highlight-flags=\"^i\">{{zone.name}}</span></md-item-template><md-not-found>\nNo teams matching \"{{vm.zoneFilter.searchText}}\" were found. <a \nng-click=\"vm.zoneFilter.resetZones(vm.zoneFilter.searchText)\">Take All Zones</a></md-not-found></md-autocomplete>\n</form></ms-widget-front></ms-widget><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"25\"><ms-widget-front \nclass=\"white-bg\"><form ng-submit=\"$event.preventDefault()\"><md-autocomplete ng-disabled=\"vm.empcodeFilter.isDisabled\" \nmd-no-cache=\"vm.empcodeFilter.noCache\" md-selected-item=\"vm.empcodeFilter.selectedEmployee\" \nmd-search-text-change=\"vm.empcodeFilter.searchTextChange(vm.empcodeFilter.searchText)\" \nmd-search-text=\"vm.empcodeFilter.searchText\" \nmd-selected-item-change=\"vm.empcodeFilter.selectedEmployeeChange(employee)\" \nmd-items=\"employee in vm.empcodeFilter.querySearch(vm.empcodeFilter.searchText)\" \nmd-item-text=\"employee.identification_id\" md-min-length=\"0\" placeholder=\"Filter by Emp Code\"><md-item-template><span \nmd-highlight-text=\"vm.empcodeFilter.searchText\" md-highlight-flags=\"^i\">{{employee.identification_id}}</span>\n</md-item-template><md-not-found>No Emp matching \"{{vm.empcodeFilter.searchText}}\" were found. <a \nng-click=\"vm.empcodeFilter.resetEmployees(vm.empcodeFilter.searchText)\">Take All Emps</a></md-not-found>\n</md-autocomplete></form></ms-widget-front></ms-widget><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"25\">\n<ms-widget-front class=\"white-bg\"><form ng-submit=\"$event.preventDefault()\"><md-autocomplete \nng-disabled=\"vm.SalesmanFilter.isDisabled\" md-no-cache=\"vm.SalesmanFilter.noCache\" \nmd-selected-item=\"vm.SalesmanFilter.selectedUser\" \nmd-search-text-change=\"vm.SalesmanFilter.searchTextChange(vm.SalesmanFilter.searchText)\" \nmd-search-text=\"vm.SalesmanFilter.searchText\" md-selected-item-change=\"vm.SalesmanFilter.selectedUserChange(user)\" \nmd-items=\"user in vm.SalesmanFilter.querySearch(vm.SalesmanFilter.searchText)\" md-item-text=\"user.name\" \nmd-min-length=\"0\" placeholder=\"Filter by Saleman\"><md-item-template><span \nmd-highlight-text=\"vm.SalesmanFilter.searchText\" md-highlight-flags=\"^i\">{{user.name}}</span></md-item-template>\n<md-not-found>No teams matching \"{{vm.SalesmanFilter.searchText}}\" were found. <a \nng-click=\"vm.SalesmanFilter.resetUsers(vm.SalesmanFilter.searchText)\">Take All Teams</a></md-not-found>\n</md-autocomplete></form></ms-widget-front></ms-widget><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"25\">\n<ms-widget-front class=\"white-bg\"><form ng-submit=\"$event.preventDefault()\"><md-autocomplete \nng-disabled=\"vm.beatFilter.isDisabled\" md-no-cache=\"vm.beatFilter.noCache\" \nmd-selected-item=\"vm.beatFilter.selectedBeat\" \nmd-search-text-change=\"vm.beatFilter.searchTextChange(vm.beatFilter.searchText)\" \nmd-search-text=\"vm.beatFilter.searchText\" md-selected-item-change=\"vm.beatFilter.selectedbeatChange(beat)\" \nmd-items=\"beat in vm.beatFilter.querySearch(vm.beatFilter.searchText)\" md-item-text=\"beat.name\" md-min-length=\"0\" \nplaceholder=\"Filter by Beat\"><md-item-template><span md-highlight-text=\"vm.beatFilter.searchText\" \nmd-highlight-flags=\"^i\">{{beat.name}}</span></md-item-template><md-not-found>\nNo beats matching \"{{vm.beatFilter.searchText}}\" were found. <a \nng-click=\"vm.beatFilter.resetBeats(vm.beatFilter.searchText)\">Take All Beats</a></md-not-found></md-autocomplete>\n</form></ms-widget-front></ms-widget><md-button class=\"md-raised md-accent\" \nng-click=\"vm.coverageandproductvity.loadData()\">Filter</md-button><md-button id=\"\" \nng-disabled=\"!vm.coverageandproductvity.loaded\" ng-click=\"vm.exportAsCsv(\'Coverage and Productivity Data\')\" \nclass=\"add-file-button md-fab md-deep-purple-400-bg md-mini fab-rounded\"><md-tooltip md-direction=\"bottom\">\nExport As Csv</md-tooltip><md-icon md-font-icon=\"icon-arrow-down-bold-circle-outline\"></md-icon></md-button></div><div \nng-show=\"!vm.coverageandproductvity.loaded\"><div class=\"h-240\" layout=\"column\" layout-sm=\"column\" \nlayout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular>\nLoading</div></div><div ng-if=\"vm.loadCandPGrid\" ag-grid=\"vm.gridOptions\" class=\"ag-theme-material\" \nstyle=\"height: 600px\"></div><div><ms-widget layout=\"column\"><ms-widget-front class=\"white-bg\"><div \nclass=\"ph-16 border-bottom\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">\n{{vm.coverageandproductvitygraph.widget1.title}}</div><div class=\"pv-16\"></div></div><div class=\"p-16\" \nstyle=\"overflow-y: scroll;overflow-x: scroll\"><nvd3 config=\"vm.coverageandproductvitygraph.widget1.mainChart.config\" \noptions=\"vm.coverageandproductvitygraph.widget1.mainChart.options\" \ndata=\"vm.coverageandproductvitygraph.widget1.mainChart.data\"></nvd3></div></ms-widget-front></ms-widget></div>\n</md-content>");
$templateCache.put("app/main/dashboard/views/reports/mss_sales_by_outlet.html","<md-content id=\"\" class=\"ps-active-y\" flex=\"\" data-ps-id=\"\" ms-scroll><div layout=\"row\" \nlayout-align=\"space-between center\"><div style=\"width: 100%\"><div style=\"float: left;width: 20%\"><md-input-container \nclass=\"align-datepicker\" style=\"margin: 1%\"><md-datepicker md-open-on-focus class=\"datepicker\" \nng-model=\"vm.start_date\" md-placeholder=\"Start Date\"></md-datepicker></md-input-container></div><div \nstyle=\"float:left;width: 20%\"><md-input-container class=\"align-datepicker\" style=\"margin: 1%\"><md-datepicker \nmd-open-on-focus class=\"datepicker\" ng-model=\"vm.end_date\" md-placeholder=\"End Date\"></md-datepicker>\n</md-input-container></div></div><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"25\" style=\"padding: 1%\">\n<ms-widget-front class=\"white-bg\"><input type=\"text\" ng-model=\"vm.searchaggrid\" ng-change=\"vm.searchGrid()\" \nplaceholder=\"Type to Search\" style=\"padding: 10px\"></ms-widget-front></ms-widget></div><div layout=\"row\" \nlayout-align=\"space-between center\"><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"25\"><ms-widget-front \nclass=\"white-bg\"><form ng-submit=\"$event.preventDefault()\"><md-autocomplete ng-disabled=\"vm.zoneFilter.isDisabled\" \nmd-no-cache=\"vm.zoneFilter.noCache\" md-selected-item=\"vm.zoneFilter.selectedZone\" \nmd-search-text-change=\"vm.zoneFilter.searchTextChange(vm.zoneFilter.searchText)\" \nmd-search-text=\"vm.zoneFilter.searchText\" md-selected-item-change=\"vm.zoneFilter.selectedZoneChange(zone)\" \nmd-items=\"zone in vm.zoneFilter.querySearch(vm.zoneFilter.searchText)\" md-item-text=\"zone.name\" md-min-length=\"0\" \nplaceholder=\"Filter by Zone\"><md-item-template><span md-highlight-text=\"vm.zoneFilter.searchText\" \nmd-highlight-flags=\"^i\">{{zone.name}}</span></md-item-template><md-not-found>\nNo teams matching \"{{vm.zoneFilter.searchText}}\" were found. <a \nng-click=\"vm.zoneFilter.resetZones(vm.zoneFilter.searchText)\">Take All Zones</a></md-not-found></md-autocomplete>\n</form></ms-widget-front></ms-widget><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"25\"><ms-widget-front \nclass=\"white-bg\"><form ng-submit=\"$event.preventDefault()\"><md-autocomplete \nng-disabled=\"vm.partnerTypeFilter.isDisabled\" md-no-cache=\"vm.partnerTypeFilter.noCache\" \nmd-selected-item=\"vm.partnerTypeFilter.selectedPartnerType\" \nmd-search-text-change=\"vm.partnerTypeFilter.searchTextChange(vm.partnerTypeFilter.searchText)\" \nmd-search-text=\"vm.partnerTypeFilter.searchText\" \nmd-selected-item-change=\"vm.partnerTypeFilter.selectedPartnerTypeChange(partnerType)\" \nmd-items=\"partnerType in vm.partnerTypeFilter.querySearch(vm.partnerTypeFilter.searchText)\" \nmd-item-text=\"partnerType.name\" md-min-length=\"0\" placeholder=\"Filter by Type\"><md-item-template><span \nmd-highlight-text=\"vm.partnerTypeFilter.searchText\" md-highlight-flags=\"^i\">{{partnerType.name}}</span>\n</md-item-template><md-not-found>No partner types matching \"{{vm.partnerTypeFilter.searchText}}\" were found. <a \nng-click=\"vm.partnerTypeFilter.resetPartnerTypes(vm.partnerTypeFilter.searchText)\">Take All Types</a></md-not-found>\n</md-autocomplete></form></ms-widget-front></ms-widget><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"25\">\n<ms-widget-front class=\"white-bg\"><form ng-submit=\"$event.preventDefault()\"><md-autocomplete \nng-disabled=\"vm.distnameFilter.isDisabled\" md-no-cache=\"vm.distnameFilter.noCache\" \nmd-selected-item=\"vm.distnameFilter.selectedDistributor\" \nmd-search-text-change=\"vm.distnameFilter.searchTextChange(vm.distnameFilter.searchText)\" \nmd-search-text=\"vm.distnameFilter.searchText\" \nmd-selected-item-change=\"vm.distnameFilter.selecteddistributorChange(distributor)\" \nmd-items=\"distributor in vm.distnameFilter.querySearch(vm.distnameFilter.searchText)\" md-item-text=\"distributor.name\" \nmd-min-length=\"0\" placeholder=\"Filter by Distributor\"><md-item-template><span \nmd-highlight-text=\"vm.distnameFilter.searchText\" md-highlight-flags=\"^i\">{{distributor.name}}</span></md-item-template>\n<md-not-found>No Distributor matching \"{{vm.distnameFilter.searchText}}\" were found. <a \nng-click=\"vm.distnameFilter.resetDistributors(vm.distnameFilter.searchText)\">Take All Distributor</a></md-not-found>\n</md-autocomplete></form></ms-widget-front></ms-widget><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"25\">\n<ms-widget-front class=\"white-bg\"><form ng-submit=\"$event.preventDefault()\"><md-autocomplete \nng-disabled=\"vm.distcodeFilter.isDisabled\" md-no-cache=\"vm.distcodeFilter.noCache\" \nmd-selected-item=\"vm.distcodeFilter.selectedDistributor\" \nmd-search-text-change=\"vm.distnameFilter.searchTextChange(vm.distcodeFilter.searchText)\" \nmd-search-text=\"vm.distcodeFilter.searchText\" \nmd-selected-item-change=\"vm.distcodeFilter.selectedDistributorChange(distributor)\" \nmd-items=\"distributor in vm.distcodeFilter.querySearch(vm.distcodeFilter.searchText)\" md-item-text=\"distributor.code\" \nmd-min-length=\"0\" placeholder=\"Filter by Code\"><md-item-template><span \nmd-highlight-text=\"vm.distcodeFilter.searchText\" md-highlight-flags=\"^i\">{{distributor.code}}</span></md-item-template>\n<md-not-found>No Distributor matching \"{{vm.distcodeFilter.searchText}}\" were found. <a \nng-click=\"vm.distcodeFilter.resetDistributors(vm.distcodeFilter.searchText)\">Take All Distributor</a></md-not-found>\n</md-autocomplete></form></ms-widget-front></ms-widget><md-button class=\"md-raised md-accent\" \nng-click=\"vm.msssalesbyoutlet.loadData()\">Filter</md-button><md-button id=\"\" ng-disabled=\"!vm.msssalesbyoutlet.loaded\" \nng-click=\"vm.exportAsCsv(\'MSS Sales less than 50% Data\')\" \nclass=\"add-file-button md-fab md-deep-purple-400-bg md-mini fab-rounded\"><md-tooltip md-direction=\"bottom\">\nExport As Csv</md-tooltip><md-icon md-font-icon=\"icon-arrow-down-bold-circle-outline\"></md-icon></md-button></div><div \nng-show=\"!vm.msssalesbyoutlet.loaded\"><div class=\"h-240\" layout=\"column\" layout-sm=\"column\" \nlayout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular>\nLoading</div></div><div ng-if=\"vm.loadMssSalesGrid\" ag-grid=\"vm.gridOptions\" class=\"ag-theme-material\" \nstyle=\"height: 600px\"></div></md-content>");
$templateCache.put("app/main/dashboard/views/reports/newoutlet.html","<md-content id=\"\" class=\"ps-active-y\" flex=\"\" data-ps-id=\"\" ms-scroll><div layout=\"row\" \nlayout-align=\"space-between center\"><div style=\"width: 100%\"><div style=\"float: left;width: 20%\"><md-input-container \nclass=\"align-datepicker\" style=\"margin: 1%\"><md-datepicker md-open-on-focus class=\"datepicker\" \nng-model=\"vm.start_date\" md-placeholder=\"Start Date\"></md-datepicker></md-input-container></div><div \nstyle=\"float:left;width: 20%\"><md-input-container class=\"align-datepicker\" style=\"margin: 1%\"><md-datepicker \nmd-open-on-focus class=\"datepicker\" ng-model=\"vm.end_date\" md-placeholder=\"End Date\"></md-datepicker>\n</md-input-container></div></div><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"25\" style=\"padding: 1%\">\n<ms-widget-front class=\"white-bg\"><input type=\"text\" ng-model=\"vm.searchaggrid\" ng-change=\"vm.searchGrid()\" \nplaceholder=\"Type to Search\" style=\"padding: 10px\"></ms-widget-front></ms-widget></div><div layout=\"row\" \nlayout-align=\"space-between center\"><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"25\"><ms-widget-front \nclass=\"white-bg\"><form ng-submit=\"$event.preventDefault()\"><md-autocomplete ng-disabled=\"vm.zoneFilter.isDisabled\" \nmd-no-cache=\"vm.zoneFilter.noCache\" md-selected-item=\"vm.zoneFilter.selectedZone\" \nmd-search-text-change=\"vm.zoneFilter.searchTextChange(vm.zoneFilter.searchText)\" \nmd-search-text=\"vm.zoneFilter.searchText\" md-selected-item-change=\"vm.zoneFilter.selectedZoneChange(zone)\" \nmd-items=\"zone in vm.zoneFilter.querySearch(vm.zoneFilter.searchText)\" md-item-text=\"zone.name\" md-min-length=\"0\" \nplaceholder=\"Filter by Zone\"><md-item-template><span md-highlight-text=\"vm.zoneFilter.searchText\" \nmd-highlight-flags=\"^i\">{{zone.name}}</span></md-item-template><md-not-found>\nNo Zones matching \"{{vm.zoneFilter.searchText}}\" were found. <a \nng-click=\"vm.zoneFilter.resetZones(vm.zoneFilter.searchText)\">Take All Zones</a></md-not-found></md-autocomplete>\n</form></ms-widget-front></ms-widget><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"25\"><ms-widget-front \nclass=\"white-bg\"><form ng-submit=\"$event.preventDefault()\"><md-autocomplete ng-disabled=\"vm.SalesmanFilter.isDisabled\" \nmd-no-cache=\"vm.SalesmanFilter.noCache\" md-selected-item=\"vm.SalesmanFilter.selectedUser\" \nmd-search-text-change=\"vm.SalesmanFilter.searchTextChange(vm.SalesmanFilter.searchText)\" \nmd-search-text=\"vm.SalesmanFilter.searchText\" md-selected-item-change=\"vm.SalesmanFilter.selectedUserChange(user)\" \nmd-items=\"user in vm.SalesmanFilter.querySearch(vm.SalesmanFilter.searchText)\" md-item-text=\"user.name\" \nmd-min-length=\"0\" placeholder=\"Filter by Saleman\"><md-item-template><span \nmd-highlight-text=\"vm.SalesmanFilter.searchText\" md-highlight-flags=\"^i\">{{user.name}}</span></md-item-template>\n<md-not-found>No teams matching \"{{vm.SalesmanFilter.searchText}}\" were found. <a \nng-click=\"vm.SalesmanFilter.resetUsers(vm.SalesmanFilter.searchText)\">Take All Teams</a></md-not-found>\n</md-autocomplete></form></ms-widget-front></ms-widget><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"25\">\n<ms-widget-front class=\"white-bg\"><form ng-submit=\"$event.preventDefault()\"><md-autocomplete \nng-disabled=\"vm.empcodeFilter.isDisabled\" md-no-cache=\"vm.empcodeFilter.noCache\" \nmd-selected-item=\"vm.empcodeFilter.selectedEmployee\" \nmd-search-text-change=\"vm.empcodeFilter.searchTextChange(vm.empcodeFilter.searchText)\" \nmd-search-text=\"vm.empcodeFilter.searchText\" \nmd-selected-item-change=\"vm.empcodeFilter.selectedEmployeeChange(employee)\" \nmd-items=\"employee in vm.empcodeFilter.querySearch(vm.empcodeFilter.searchText)\" \nmd-item-text=\"employee.identification_id\" md-min-length=\"0\" placeholder=\"Filter by Emp Code\"><md-item-template><span \nmd-highlight-text=\"vm.empcodeFilter.searchText\" md-highlight-flags=\"^i\">{{employee.identification_id}}</span>\n</md-item-template><md-not-found>No Emp matching \"{{vm.empcodeFilter.searchText}}\" were found. <a \nng-click=\"vm.empcodeFilter.resetEmployees(vm.empcodeFilter.searchText)\">Take All Emps</a></md-not-found>\n</md-autocomplete></form></ms-widget-front></ms-widget><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"25\">\n<ms-widget-front class=\"white-bg\"><form ng-submit=\"$event.preventDefault()\"><md-autocomplete \nng-disabled=\"vm.beatFilter.isDisabled\" md-no-cache=\"vm.beatFilter.noCache\" \nmd-selected-item=\"vm.beatFilter.selectedBeat\" \nmd-search-text-change=\"vm.beatFilter.searchTextChange(vm.beatFilter.searchText)\" \nmd-search-text=\"vm.beatFilter.searchText\" md-selected-item-change=\"vm.beatFilter.selectedbeatChange(beat)\" \nmd-items=\"beat in vm.beatFilter.querySearch(vm.beatFilter.searchText)\" md-item-text=\"beat.name\" md-min-length=\"0\" \nplaceholder=\"Filter by Beat\"><md-item-template><span md-highlight-text=\"vm.beatFilter.searchText\" \nmd-highlight-flags=\"^i\">{{beat.name}}</span></md-item-template><md-not-found>\nNo beats matching \"{{vm.beatFilter.searchText}}\" were found. <a \nng-click=\"vm.beatFilter.resetBeats(vm.beatFilter.searchText)\">Take All Beats</a></md-not-found></md-autocomplete>\n</form></ms-widget-front></ms-widget><md-button class=\"md-raised md-accent\" ng-click=\"vm.newoutlet.loadData()\">Filter\n</md-button><md-button id=\"\" ng-disabled=\"!vm.newoutlet.loaded\" ng-click=\"vm.exportAsCsv(\'New Outlet Data\')\" \nclass=\"add-file-button md-fab md-deep-purple-400-bg md-mini fab-rounded\"><md-tooltip md-direction=\"bottom\">\nExport As Csv</md-tooltip><md-icon md-font-icon=\"icon-arrow-down-bold-circle-outline\"></md-icon></md-button></div><div \nng-show=\"!vm.newoutlet.loaded\"><div class=\"h-240\" layout=\"column\" layout-sm=\"column\" layout-align=\"center center\">\n<md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular>Loading</div></div><div \nng-if=\"vm.loadnewoutletGrid\" ag-grid=\"vm.gridOptions\" class=\"ag-theme-material\" style=\"height: 600px\"></div><div>\n<ms-widget layout=\"column\"><ms-widget-front class=\"white-bg\"><div class=\"ph-16 border-bottom\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\">{{vm.newoutletzonegraph.widget2.title}}</div><div class=\"pv-16\">\n</div></div><div class=\"p-16\" style=\"overflow-y: scroll;overflow-x: scroll\"><nvd3 \nconfig=\"vm.newoutletzonegraph.widget2.mainChart.config\" options=\"vm.newoutletzonegraph.widget2.mainChart.options\" \ndata=\"vm.newoutletzonegraph.widget2.mainChart.data\"></nvd3></div></ms-widget-front></ms-widget></div><div><ms-widget \nlayout=\"column\"><ms-widget-front class=\"white-bg\"><div class=\"ph-16 border-bottom\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\">{{vm.newoutlettypegraph.widget2.title}}</div><div class=\"pv-16\">\n</div></div><div class=\"p-16\" style=\"overflow-y: scroll;overflow-x: scroll\"><nvd3 \nconfig=\"vm.newoutlettypegraph.widget2.mainChart.config\" options=\"vm.newoutlettypegraph.widget2.mainChart.options\" \ndata=\"vm.newoutlettypegraph.widget2.mainChart.data\"></nvd3></div></ms-widget-front></ms-widget></div><div><ms-widget \nlayout=\"column\" flex=\"100\" flex-gt-sm=\"50\"><ms-widget-front class=\"white-bg\"><div class=\"ph-16 border-bottom\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">{{vm.newoutletinstancegraph.widget2.title}}</div><div \nclass=\"pv-16\"></div></div><div class=\"p-16\"><nvd3 class=\"h-400\" \nconfig=\"vm.newoutletinstancegraph.widget2.mainChart.config\" \noptions=\"vm.newoutletinstancegraph.widget2.mainChart.options\" data=\"vm.newoutletinstancegraph.widget2.mainChart.data\">\n</nvd3></div></ms-widget-front></ms-widget></div></md-content>");
$templateCache.put("app/main/dashboard/views/reports/no_sales_consecutive_visits.html","<md-content id=\"\" class=\"ps-active-y\" flex=\"\" data-ps-id=\"\" ms-scroll><div layout=\"row\" \nlayout-align=\"space-between center\"><div style=\"width: 100%\"><div style=\"float: left;width: 20%\"><md-input-container \nclass=\"align-datepicker\" style=\"margin: 1%\"><md-datepicker md-open-on-focus class=\"datepicker\" \nng-model=\"vm.start_date\" md-placeholder=\"Start Date\"></md-datepicker></md-input-container></div><div \nstyle=\"float:left;width: 20%\"><md-input-container class=\"align-datepicker\" style=\"margin: 1%\"><md-datepicker \nmd-open-on-focus class=\"datepicker\" ng-model=\"vm.end_date\" md-placeholder=\"End Date\"></md-datepicker>\n</md-input-container></div></div><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"25\" style=\"padding: 1%\">\n<ms-widget-front class=\"white-bg\"><input type=\"text\" ng-model=\"vm.searchaggrid\" ng-change=\"vm.searchGrid()\" \nplaceholder=\"Type to Search\" style=\"padding: 10px\"></ms-widget-front></ms-widget></div><div layout=\"row\" \nlayout-align=\"space-between center\"><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"25\"><ms-widget-front \nclass=\"white-bg\"><form ng-submit=\"$event.preventDefault()\"><md-autocomplete ng-disabled=\"vm.zoneFilter.isDisabled\" \nmd-no-cache=\"vm.zoneFilter.noCache\" md-selected-item=\"vm.zoneFilter.selectedZone\" \nmd-search-text-change=\"vm.zoneFilter.searchTextChange(vm.zoneFilter.searchText)\" \nmd-search-text=\"vm.zoneFilter.searchText\" md-selected-item-change=\"vm.zoneFilter.selectedZoneChange(zone)\" \nmd-items=\"zone in vm.zoneFilter.querySearch(vm.zoneFilter.searchText)\" md-item-text=\"zone.name\" md-min-length=\"0\" \nplaceholder=\"Filter by Zone\"><md-item-template><span md-highlight-text=\"vm.zoneFilter.searchText\" \nmd-highlight-flags=\"^i\">{{zone.name}}</span></md-item-template><md-not-found>\nNo Zones matching \"{{vm.zoneFilter.searchText}}\" were found. <a \nng-click=\"vm.zoneFilter.resetZones(vm.zoneFilter.searchText)\">Take All Zones</a></md-not-found></md-autocomplete>\n</form></ms-widget-front></ms-widget><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"25\"><ms-widget-front \nclass=\"white-bg\"><form ng-submit=\"$event.preventDefault()\"><md-autocomplete ng-disabled=\"vm.empcodeFilter.isDisabled\" \nmd-no-cache=\"vm.empcodeFilter.noCache\" md-selected-item=\"vm.empcodeFilter.selectedEmployee\" \nmd-search-text-change=\"vm.empcodeFilter.searchTextChange(vm.empcodeFilter.searchText)\" \nmd-search-text=\"vm.empcodeFilter.searchText\" \nmd-selected-item-change=\"vm.empcodeFilter.selectedEmployeeChange(employee)\" \nmd-items=\"employee in vm.empcodeFilter.querySearch(vm.empcodeFilter.searchText)\" \nmd-item-text=\"employee.identification_id\" md-min-length=\"0\" placeholder=\"Filter by Emp Code\"><md-item-template><span \nmd-highlight-text=\"vm.empcodeFilter.searchText\" md-highlight-flags=\"^i\">{{employee.identification_id}}</span>\n</md-item-template><md-not-found>No Emp matching \"{{vm.empcodeFilter.searchText}}\" were found. <a \nng-click=\"vm.empcodeFilter.resetEmployees(vm.empcodeFilter.searchText)\">Take All Emps</a></md-not-found>\n</md-autocomplete></form></ms-widget-front></ms-widget><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"25\">\n<ms-widget-front class=\"white-bg\"><form ng-submit=\"$event.preventDefault()\"><md-autocomplete \nng-disabled=\"vm.SalesmanFilter.isDisabled\" md-no-cache=\"vm.SalesmanFilter.noCache\" \nmd-selected-item=\"vm.SalesmanFilter.selectedUser\" \nmd-search-text-change=\"vm.SalesmanFilter.searchTextChange(vm.SalesmanFilter.searchText)\" \nmd-search-text=\"vm.SalesmanFilter.searchText\" md-selected-item-change=\"vm.SalesmanFilter.selectedUserChange(user)\" \nmd-items=\"user in vm.SalesmanFilter.querySearch(vm.SalesmanFilter.searchText)\" md-item-text=\"user.name\" \nmd-min-length=\"0\" placeholder=\"Filter by Saleman\"><md-item-template><span \nmd-highlight-text=\"vm.SalesmanFilter.searchText\" md-highlight-flags=\"^i\">{{user.name}}</span></md-item-template>\n<md-not-found>No Salesman matching \"{{vm.SalesmanFilter.searchText}}\" were found. <a \nng-click=\"vm.SalesmanFilter.resetUsers(vm.SalesmanFilter.searchText)\">Take All Salesmans</a></md-not-found>\n</md-autocomplete></form></ms-widget-front></ms-widget><md-button class=\"md-raised md-accent\" \nng-click=\"vm.nosalesconsecutivevisits.loadData()\">Filter</md-button><md-button id=\"\" \nng-disabled=\"!vm.nosalesconsecutivevisits.loaded\" \nng-click=\"vm.exportAsCsv(\'No Sales Consecutive Visits Measures Data\')\" \nclass=\"add-file-button md-fab md-deep-purple-400-bg md-mini fab-rounded\"><md-tooltip md-direction=\"bottom\">\nExport As Csv</md-tooltip><md-icon md-font-icon=\"icon-arrow-down-bold-circle-outline\"></md-icon></md-button></div><div \nng-show=\"!vm.nosalesconsecutivevisits.loaded\"><div class=\"h-240\" layout=\"column\" layout-sm=\"column\" \nlayout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular>\nLoading</div></div><div ng-if=\"vm.loadnosalesconsecutivevisitsGrid\" ag-grid=\"vm.gridOptions\" class=\"ag-theme-material\" \nstyle=\"height: 600px\"></div><div layout=\"row\"><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"50\"><ms-widget-front \nclass=\"white-bg\"><div class=\"ph-16 border-bottom\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">\n{{vm.nosalesvisitsoutletgraph.widget2.title}}</div><div class=\"pv-16\"></div></div><div class=\"p-16\"><nvd3 \nclass=\"h-400\" config=\"vm.nosalesvisitsoutletgraph.widget2.mainChart.config\" \noptions=\"vm.nosalesvisitsoutletgraph.widget2.mainChart.options\" \ndata=\"vm.nosalesvisitsoutletgraph.widget2.mainChart.data\"></nvd3></div></ms-widget-front></ms-widget></div><div>\n<ms-widget layout=\"column\"><ms-widget-front class=\"white-bg\"><div class=\"ph-16 border-bottom\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\">{{vm.nosalesvisitszonegraph.widget1.title}}</div><div \nclass=\"pv-16\"></div></div><div class=\"p-16\" style=\"overflow-y: scroll;overflow-x: scroll\"><nvd3 \nconfig=\"vm.nosalesvisitszonegraph.widget1.mainChart.config\" \noptions=\"vm.nosalesvisitszonegraph.widget1.mainChart.options\" data=\"vm.nosalesvisitszonegraph.widget1.mainChart.data\">\n</nvd3></div></ms-widget-front></ms-widget></div></md-content>");
$templateCache.put("app/main/dashboard/views/reports/outletwise_sales.html","<md-content id=\"\" class=\"ps-active-y\" flex=\"\" data-ps-id=\"\" ms-scroll><div layout=\"row\" \nlayout-align=\"space-between center\"><div style=\"width: 100%\"><div style=\"float: left;width: 20%\"><md-input-container \nclass=\"align-datepicker\" style=\"margin: 1%\"><md-datepicker md-open-on-focus class=\"datepicker\" \nng-model=\"vm.start_date\" md-placeholder=\"Start Date\"></md-datepicker></md-input-container></div><div \nstyle=\"float:left;width: 20%\"><md-input-container class=\"align-datepicker\" style=\"margin: 1%\"><md-datepicker \nmd-open-on-focus class=\"datepicker\" ng-model=\"vm.end_date\" md-placeholder=\"End Date\"></md-datepicker>\n</md-input-container></div></div><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"25\" style=\"padding: 1%\">\n<ms-widget-front class=\"white-bg\"><input type=\"text\" ng-model=\"vm.searchaggrid\" ng-change=\"vm.searchGrid()\" \nplaceholder=\"Type to Search\" style=\"padding: 10px\"></ms-widget-front></ms-widget></div><div layout=\"row\" \nlayout-align=\"space-between center\"><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"25\"><ms-widget-front \nclass=\"white-bg\"><form ng-submit=\"$event.preventDefault()\"><md-autocomplete ng-disabled=\"vm.zoneFilter.isDisabled\" \nmd-no-cache=\"vm.zoneFilter.noCache\" md-selected-item=\"vm.zoneFilter.selectedZone\" \nmd-search-text-change=\"vm.zoneFilter.searchTextChange(vm.zoneFilter.searchText)\" \nmd-search-text=\"vm.zoneFilter.searchText\" md-selected-item-change=\"vm.zoneFilter.selectedZoneChange(zone)\" \nmd-items=\"zone in vm.zoneFilter.querySearch(vm.zoneFilter.searchText)\" md-item-text=\"zone.name\" md-min-length=\"0\" \nplaceholder=\"Filter by Zone\"><md-item-template><span md-highlight-text=\"vm.zoneFilter.searchText\" \nmd-highlight-flags=\"^i\">{{zone.name}}</span></md-item-template><md-not-found>\nNo teams matching \"{{vm.zoneFilter.searchText}}\" were found. <a \nng-click=\"vm.zoneFilter.resetZones(vm.zoneFilter.searchText)\">Take All Zones</a></md-not-found></md-autocomplete>\n</form></ms-widget-front></ms-widget><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"25\"><ms-widget-front \nclass=\"white-bg\"><form ng-submit=\"$event.preventDefault()\"><md-autocomplete ng-disabled=\"vm.empcodeFilter.isDisabled\" \nmd-no-cache=\"vm.empcodeFilter.noCache\" md-selected-item=\"vm.empcodeFilter.selectedEmployee\" \nmd-search-text-change=\"vm.empcodeFilter.searchTextChange(vm.empcodeFilter.searchText)\" \nmd-search-text=\"vm.empcodeFilter.searchText\" \nmd-selected-item-change=\"vm.empcodeFilter.selectedEmployeeChange(employee)\" \nmd-items=\"employee in vm.empcodeFilter.querySearch(vm.empcodeFilter.searchText)\" \nmd-item-text=\"employee.identification_id\" md-min-length=\"0\" placeholder=\"Filter by Emp Code\"><md-item-template><span \nmd-highlight-text=\"vm.empcodeFilter.searchText\" md-highlight-flags=\"^i\">{{employee.identification_id}}</span>\n</md-item-template><md-not-found>No Emp matching \"{{vm.empcodeFilter.searchText}}\" were found. <a \nng-click=\"vm.empcodeFilter.resetEmployees(vm.empcodeFilter.searchText)\">Take All Emps</a></md-not-found>\n</md-autocomplete></form></ms-widget-front></ms-widget><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"25\">\n<ms-widget-front class=\"white-bg\"><form ng-submit=\"$event.preventDefault()\"><md-autocomplete \nng-disabled=\"vm.distcodeFilter.isDisabled\" md-no-cache=\"vm.distcodeFilter.noCache\" \nmd-selected-item=\"vm.distcodeFilter.selectedDistributor\" \nmd-search-text-change=\"vm.distnameFilter.searchTextChange(vm.distcodeFilter.searchText)\" \nmd-search-text=\"vm.distcodeFilter.searchText\" \nmd-selected-item-change=\"vm.distcodeFilter.selectedDistributorChange(distributor)\" \nmd-items=\"distributor in vm.distcodeFilter.querySearch(vm.distcodeFilter.searchText)\" md-item-text=\"distributor.code\" \nmd-min-length=\"0\" placeholder=\"Filter by Code\"><md-item-template><span \nmd-highlight-text=\"vm.distcodeFilter.searchText\" md-highlight-flags=\"^i\">{{distributor.code}}</span></md-item-template>\n<md-not-found>No Distributor matching \"{{vm.distcodeFilter.searchText}}\" were found. <a \nng-click=\"vm.distcodeFilter.resetDistributors(vm.distcodeFilter.searchText)\">Take All Distributor</a></md-not-found>\n</md-autocomplete></form></ms-widget-front></ms-widget><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"25\">\n<ms-widget-front class=\"white-bg\"><form ng-submit=\"$event.preventDefault()\"><md-autocomplete \nng-disabled=\"vm.partnerTypeFilter.isDisabled\" md-no-cache=\"vm.partnerTypeFilter.noCache\" \nmd-selected-item=\"vm.partnerTypeFilter.selectedPartnerType\" \nmd-search-text-change=\"vm.partnerTypeFilter.searchTextChange(vm.partnerTypeFilter.searchText)\" \nmd-search-text=\"vm.partnerTypeFilter.searchText\" \nmd-selected-item-change=\"vm.partnerTypeFilter.selectedPartnerTypeChange(partnerType)\" \nmd-items=\"partnerType in vm.partnerTypeFilter.querySearch(vm.partnerTypeFilter.searchText)\" \nmd-item-text=\"partnerType.name\" md-min-length=\"0\" placeholder=\"Filter by Type\"><md-item-template><span \nmd-highlight-text=\"vm.partnerTypeFilter.searchText\" md-highlight-flags=\"^i\">{{partnerType.name}}</span>\n</md-item-template><md-not-found>No partner types matching \"{{vm.partnerTypeFilter.searchText}}\" were found. <a \nng-click=\"vm.partnerTypeFilter.resetPartnerTypes(vm.partnerTypeFilter.searchText)\">Take All Types</a></md-not-found>\n</md-autocomplete></form></ms-widget-front></ms-widget><md-button class=\"md-raised md-accent\" \nng-click=\"vm.outletwisesales.loadData()\">Filter</md-button><md-button id=\"\" ng-disabled=\"!vm.outletwisesales.loaded\" \nng-click=\"vm.exportAsCsv(\'Outletwise Sales\')\" class=\"add-file-button md-fab md-deep-purple-400-bg md-mini fab-rounded\">\n<md-tooltip md-direction=\"bottom\">Export As Csv</md-tooltip><md-icon \nmd-font-icon=\"icon-arrow-down-bold-circle-outline\"></md-icon></md-button></div><div \nng-show=\"!vm.outletwisesales.loaded\"><div class=\"h-240\" layout=\"column\" layout-sm=\"column\" \nlayout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular>\nLoading</div></div><div ng-if=\"vm.loadoutletwisesalesGrid\" ag-grid=\"vm.gridOptions\" class=\"ag-theme-material\" \nstyle=\"height: 600px\"></div></md-content>");
$templateCache.put("app/main/dashboard/views/reports/overview.html","<md-content id=\"\" class=\"ps-active-y\" flex=\"\" data-ps-id=\"\" ms-scroll><div class=\"content\"><div class=\"widget-group\" \nlayout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"25\"><ms-widget-front \nclass=\"white-bg\"><div class=\"ph-8 pv-16 h-40\" layout=\"row\" layout-align=\"space-between center\"><md-select \nclass=\"simplified font-size-16\" ng-model=\"vm.DateFilter.currentRange\" \nng-change=\"vm.DateFilter.loadData(vm.DateFilter.currentRange)\" aria-label=\"Change range\"><md-option \nng-repeat=\"(key, range) in vm.DateFilter.ranges\" value=\"{{key}}\">{{range}}</md-option></md-select></div>\n</ms-widget-front></ms-widget><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"25\"><ms-widget-front class=\"white-bg\">\n<form ng-submit=\"$event.preventDefault()\"><md-autocomplete ng-disabled=\"vm.overviewzoneFilter.isDisabled\" \nmd-no-cache=\"vm.overviewzoneFilter.noCache\" md-selected-item=\"vm.overviewzoneFilter.selectedZone\" \nmd-search-text-change=\"vm.overviewzoneFilter.searchTextChange(vm.overviewzoneFilter.searchText)\" \nmd-search-text=\"vm.overviewzoneFilter.searchText\" \nmd-selected-item-change=\"vm.overviewzoneFilter.selectedZoneChange(zone)\" \nmd-items=\"zone in vm.overviewzoneFilter.querySearch(vm.overviewzoneFilter.searchText)\" md-item-text=\"zone.name\" \nmd-min-length=\"0\" placeholder=\"Filter by Zone\"><md-item-template><span \nmd-highlight-text=\"vm.overviewzoneFilter.searchText\" md-highlight-flags=\"^i\">{{zone.name}}</span></md-item-template>\n<md-not-found>No teams matching \"{{vm.overviewzoneFilter.searchText}}\" were found. <a \nng-click=\"vm.overviewzoneFilter.resetZones(vm.overviewzoneFilter.searchText)\">Take All Zones</a></md-not-found>\n</md-autocomplete></form></ms-widget-front></ms-widget><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"25\">\n<ms-widget-front class=\"white-bg\"><form ng-submit=\"$event.preventDefault()\"><md-autocomplete \nng-disabled=\"vm.overviewteamFilter.isDisabled\" md-no-cache=\"vm.overviewteamFilter.noCache\" \nmd-selected-item=\"vm.overviewteamFilter.selectedTeam\" \nmd-search-text-change=\"vm.overviewteamFilter.searchTextChange(vm.overviewteamFilter.searchText)\" \nmd-search-text=\"vm.overviewteamFilter.searchText\" \nmd-selected-item-change=\"vm.overviewteamFilter.selectedTeamChange(team)\" \nmd-items=\"team in vm.overviewteamFilter.querySearch(vm.overviewteamFilter.searchText)\" md-item-text=\"team.name\" \nmd-min-length=\"0\" placeholder=\"Filter by Team\"><md-item-template><span \nmd-highlight-text=\"vm.overviewteamFilter.searchText\" md-highlight-flags=\"^i\">{{team.name}}</span></md-item-template>\n<md-not-found>No teams matching \"{{vm.overviewteamFilter.searchText}}\" were found. <a \nng-click=\"vm.overviewteamFilter.resetTeams(vm.overviewteamFilter.searchText)\">Take All Teams</a></md-not-found>\n</md-autocomplete></form></ms-widget-front></ms-widget><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"25\">\n<ms-widget-front class=\"white-bg\"><form ng-submit=\"$event.preventDefault()\"><md-autocomplete \nng-disabled=\"vm.overviewSalesmanFilter.isDisabled\" md-no-cache=\"vm.overviewSalesmanFilter.noCache\" \nmd-selected-item=\"vm.overviewSalesmanFilter.selectedUser\" \nmd-search-text-change=\"vm.overviewSalesmanFilter.searchTextChange(vm.overviewSalesmanFilter.searchText)\" \nmd-search-text=\"vm.overviewSalesmanFilter.searchText\" \nmd-selected-item-change=\"vm.overviewSalesmanFilter.selectedUserChange(user)\" \nmd-items=\"user in vm.overviewSalesmanFilter.querySearch(vm.overviewSalesmanFilter.searchText)\" \nmd-item-text=\"user.name\" md-min-length=\"0\" placeholder=\"Filter by Saleman\"><md-item-template><span \nmd-highlight-text=\"vm.overviewSalesmanFilter.searchText\" md-highlight-flags=\"^i\">{{user.name}}</span>\n</md-item-template><md-not-found>No teams matching \"{{vm.overviewSalesmanFilter.searchText}}\" were found. <a \nng-click=\"vm.overviewSalesmanFilter.resetUsers(vm.overviewSalesmanFilter.searchText)\">Take All Teams</a></md-not-found>\n</md-autocomplete></form></ms-widget-front></ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" \nlayout-wrap><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front \nclass=\"white-bg\" ng-show=\"!vm.summary_data.loaded\"><div class=\"h-240\" layout=\"row\" layout-sm=\"column\" \nlayout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular>\n</div></ms-widget-front><ms-widget-front class=\"light-blue-bg white-fg\" ng-show=\"vm.summary_data.loaded\"><div \nclass=\"pl-16 pr-8 pv-16 h-55 font-weight-500 secondary-text\">TARGET / ACHIVEMENT</div><div class=\"pt-8 pb-8\" \nlayout=\"column\" layout-align=\"center center\"><div class=\"font-size-72 line-height-72\">\n{{vm.summary_data.achivement_pct}}%</div><div layout=\"row\" layout-align=\"start center\" \nclass=\"pt-20 layout-align-start-center layout-row\"><span class=\"h4 text-truncate font-size-13 ng-binding\">\nPrevious : &#8377;{{vm.summary_data.previous_revenue}}</span> <span class=\"h3 text-boxed-light ng-binding\" \nng-class=\"vm.widget1.getChangeTextColor()\">{{vm.summary_data.previous_achivement_pct}}%</span></div></div><div \nclass=\"p-10 pl-16 pr-16 border-top\" layout=\"row\" layout-align=\"space-between center\"><div layout-align=\"start center\">\n<span class=\"white-fg text-semibold h3\">&#8377;{{vm.summary_data.schedule_target}}</span> <span \nclass=\"h4 text-semibold text-truncate font-size-10\">{{vm.widget1.data.extra.target.label}}</span></div><div \nlayout=\"column\" layout-align=\"center end\"><span class=\"white-fg text-semibold h3\">&#8377;{{vm.summary_data.revenue}}\n</span> <span class=\"h4 text-semibold text-truncate font-size-10\">{{vm.widget1.data.extra.achieved.label}}</span></div>\n</div></ms-widget-front><ms-widget-back class=\"p-16 white-bg\"><div class=\"flip-to-front\"><md-button \nclass=\"md-icon-button\" ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\">\n</md-icon></md-button></div><div>{{vm.widget1.detail}}</div></ms-widget-back></ms-widget><ms-widget flippable=\"true\" \nlayout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\" \nng-show=\"!vm.summary_data.loaded\"><div class=\"h-240\" layout=\"row\" layout-sm=\"column\" layout-align=\"center center\">\n<md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular></div></ms-widget-front>\n<ms-widget-front class=\"green-bg white-fg\" ng-show=\"vm.summary_data.loaded\"><div \nclass=\"pl-16 pr-8 pv-16 h-55 font-weight-500 secondary-text\">COVERAGE</div><div class=\"pt-8 pb-8\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"font-size-72 line-height-72\">{{vm.summary_data.coverage_pct}}%</div><div \nlayout=\"row\" layout-align=\"start center\" class=\"pt-20 layout-align-start-center layout-row\"><span \nclass=\"h4 text-truncate font-size-13 ng-binding\">Previous : {{vm.summary_data.previous_visited_count}}</span> <span \nclass=\"text-semibold h3 text-boxed-light ng-binding\" ng-class=\"vm.widget2.getChangeTextColor()\">\n{{vm.summary_data.previous_coverage_pct}}%</span></div></div><div class=\"p-10 pl-16 pr-16 border-top\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout-align=\"start center\"><span class=\"white-fg text-semibold h3\">\n{{vm.summary_data.visited_count}}</span> <span class=\"h4 text-semibold text-truncate font-size-10\">\n{{vm.widget2.data.extra.visited.label}}</span></div><div layout=\"column\" layout-align=\"center end\"><span \nclass=\"white-fg text-semibold h3\">{{vm.summary_data.planned_visit}}</span> <span \nclass=\"h4 text-semibold text-truncate font-size-10\">{{vm.widget2.data.extra.planned_visit.label}}</span></div></div>\n</ms-widget-front><ms-widget-back class=\"p-16 white-bg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" \nng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button>\n</div><div>{{vm.widget2.detail}}</div></ms-widget-back></ms-widget><ms-widget flippable=\"true\" layout=\"column\" \nflex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\" ng-show=\"!vm.summary_data.loaded\"><div \nclass=\"h-240\" layout=\"row\" layout-sm=\"column\" layout-align=\"center center\"><md-progress-circular \nmd-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular></div></ms-widget-front><ms-widget-front \nclass=\"blue-grey-bg white-fg\" ng-show=\"vm.summary_data.loaded\"><div \nclass=\"pl-16 pr-8 pv-16 h-55 font-weight-500 secondary-text\">ACTIVE USER</div><div class=\"pt-8 pb-8\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"font-size-72 line-height-72\">{{vm.summary_data.active_users}}</div><div \nlayout=\"row\" layout-align=\"start center\" class=\"pt-20 layout-align-start-center layout-row\"><span \nclass=\"pb-10 white-fg h3 text-truncate font-size-13 ng-binding\">\nAvg Sales : &#8377;{{vm.summary_data.avg_sales_per_user}}</span></div></div><div class=\"p-10 pl-16 pr-16 border-top\" \nlayout=\"row\" layout-align=\"space-between center\"><div layout-align=\"start center\"><span \nclass=\"white-fg text-semibold h3\">{{vm.summary_data.sr_user_count}}</span> <span \nclass=\"h4 text-semibold text-truncate font-size-10\">SR Count</span></div><div layout=\"column\" \nlayout-align=\"center end\"><span class=\"white-fg text-semibold h3\">{{vm.summary_data.so_user_count}}</span> <span \nclass=\"h4 text-semibold text-truncate font-size-10\">SO Count</span></div></div></ms-widget-front><ms-widget-back \nclass=\"p-16 white-bg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" \naria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><div>\n{{vm.widget3.detail}}</div></ms-widget-back></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\" ng-show=\"!vm.summary_data.loaded\"><div class=\"h-240\" \nlayout=\"row\" layout-sm=\"column\" layout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\" \nclass=\"md-accent\"></md-progress-circular></div></ms-widget-front><ms-widget-front class=\"teal-bg white-fg\" \nng-show=\"vm.summary_data.loaded\"><div class=\"pl-16 pr-8 pv-16 h-55 font-weight-500 secondary-text\">NEW OUTLETS</div>\n<div class=\"pt-8 pb-8\" layout=\"column\" layout-align=\"center center\"><div class=\"font-size-72 line-height-72\">\n{{vm.summary_data.new_outlets}}</div><div layout=\"row\" layout-align=\"start center\" \nclass=\"pt-20 layout-align-start-center layout-row\"><span \nclass=\"pb-10 white-fg h3 text-truncate font-size-13 ng-binding\">Population : {{vm.summary_data.population}}</span>\n</div></div><div class=\"p-10 pl-16 pr-16 border-top\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout-align=\"start center\"><span class=\"white-fg text-semibold h3\">{{vm.summary_data.total_retailer}}</span> <span \nclass=\"h4 text-semibold text-truncate font-size-13\">{{vm.widget4.data.extra.total_outlets.label}}</span></div><div \nlayout=\"column\" layout-align=\"center end\"><span class=\"white-fg text-semibold h3\">\n&#8377;{{vm.summary_data.new_outlet_sales}}</span> <span class=\"h4 text-semibold text-truncate font-size-10\">\n{{vm.widget4.data.extra.sales.label}}</span></div></div></ms-widget-front><ms-widget-back class=\"p-16 white-bg\"><div \nclass=\"flip-to-front\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon \nmd-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><div>{{vm.widget4.detail}}</div></ms-widget-back>\n</ms-widget></div><div class=\"widget-group layout-wrap layout-row flex-100\" layout=\"row\" flex=\"100\" layout-wrap=\"\">\n<ms-widget flippable=\"false\" layout=\"row\" flex=\"100\" class=\"ms-widget ng-isolate-scope layout-row flex-100\">\n<ms-widget-front class=\"white-bg ms-widget-front ng-scope\"><div layout=\"row\" layout-align=\"start center\" \nlayout-wrap=\"\" class=\"layout-wrap ng-scope layout-align-start-center layout-row\"><div class=\"p-15\" layout=\"row\" \nlayout-align=\"center center\" flex-gt-xs=\"20\" flex-gt-md=\"20\"><div layout-align=\"center center\"><div \nclass=\"font-size-32 line-height-32 pb-10 ng-binding\">{{vm.summary_data.total_beat}}</div><div \nclass=\"h3 secondary-text pb-8 ng-binding\">Total Beats</div></div></div><div class=\"p-15 pl-15 vertical-divider\" \nlayout=\"row\" layout-align=\"center center\" flex-gt-xs=\"20\" flex-gt-md=\"20\"><div layout-align=\"center center\" \nclass=\"layout-column flex\"><div class=\"font-size-32 line-height-32 pb-10 ng-binding\">{{vm.summary_data.planned_beat}}\n</div><div class=\"h3 secondary-text pb-8 ng-binding\">Scheduled Beats</div></div></div><div \nclass=\"p-15 vertical-divider\" layout=\"row\" layout-align=\"center center\" flex-gt-xs=\"20\" flex-gt-md=\"20\"><div \nlayout-align=\"center center\" class=\"layout-column flex\"><div class=\"font-size-32 line-height-32 pb-10 ng-binding\">\n{{vm.summary_data.visited_count_beat}}</div><div class=\"h3 secondary-text pb-8 ng-binding\">Visits / Beat</div></div>\n</div><div class=\"p-15 vertical-divider\" layout=\"row\" layout-align=\"center center\" flex-gt-xs=\"20\" flex-gt-md=\"20\"><div\n layout-align=\"center center\" class=\"layout-column flex\"><div class=\"font-size-32 line-height-32 pb-10 ng-binding\">\n{{vm.summary_data.prod_call_beat}}</div><div class=\"h3 secondary-text pb-8 ng-binding\">Orders / Beat</div></div></div>\n<div class=\"p-15 vertical-divider\" layout=\"row\" layout-align=\"center center\" flex-gt-xs=\"20\" flex-gt-md=\"20\"><div \nlayout-align=\"center center\" class=\"layout-column flex\"><div class=\"font-size-32 line-height-32 pb-10 ng-binding\">\n{{vm.summary_data.revenue_beat}}</div><div class=\"h3 secondary-text pb-8 ng-binding\">Revenue / Beat</div></div></div>\n</div></ms-widget-front></ms-widget></div><div class=\"widget-group layout-wrap layout-row flex-100\" layout=\"row\" \nflex=\"100\" layout-wrap=\"\"><ms-widget flippable=\"false\" layout=\"row\" flex=\"100\" \nclass=\"ms-widget ng-isolate-scope layout-row flex-100\"><ms-widget-front class=\"white-bg ms-widget-front ng-scope\"><div \nlayout=\"row\" layout-align=\"start center\" layout-wrap=\"\" \nclass=\"layout-wrap ng-scope layout-align-start-center layout-row\"><div class=\"p-15\" layout=\"row\" \nlayout-align=\"center center\" flex-gt-xs=\"20\" flex-gt-md=\"20\"><div layout-align=\"center center\"><div \nclass=\"font-size-32 line-height-32 pb-10 ng-binding\">{{vm.summary_data.not_visited}}</div><div \nclass=\"h3 secondary-text pb-8 ng-binding\">Not Visited</div></div></div><div class=\"p-15 pl-15 vertical-divider\" \nlayout=\"row\" layout-align=\"center center\" flex-gt-xs=\"20\" flex-gt-md=\"20\"><div layout-align=\"center center\" \nclass=\"layout-column flex\"><div class=\"font-size-32 line-height-32 pb-10 ng-binding\">\n{{vm.summary_data.productive_calls}}</div><div class=\"h3 secondary-text pb-8 ng-binding\">Orders</div></div></div><div \nclass=\"p-15 vertical-divider\" layout=\"row\" layout-align=\"center center\" flex-gt-xs=\"20\" flex-gt-md=\"20\"><div \nlayout-align=\"center center\" class=\"layout-column flex\"><div class=\"font-size-32 line-height-32 pb-10 ng-binding\">\n{{vm.summary_data.avg_sales_per_order}}</div><div class=\"h3 secondary-text pb-8 ng-binding\">Revenue / Bill</div></div>\n</div><div class=\"p-15 vertical-divider\" layout=\"row\" layout-align=\"center center\" flex-gt-xs=\"20\" flex-gt-md=\"20\"><div\n layout-align=\"center center\" class=\"layout-column flex\"><div class=\"font-size-32 line-height-32 pb-10 ng-binding\">\n{{vm.summary_data.avg_sku_per_order}}</div><div class=\"h3 secondary-text pb-8 ng-binding\">SKU / Bill</div></div></div>\n<div class=\"p-15 vertical-divider\" layout=\"row\" layout-align=\"center center\" flex-gt-xs=\"20\" flex-gt-md=\"20\"><div \nlayout-align=\"center center\" class=\"layout-column flex\"><div class=\"font-size-32 line-height-32 pb-10 ng-binding\">\n{{vm.summary_data.unique_sku}}</div><div class=\"h3 secondary-text pb-8 ng-binding\">Unique SKU</div></div></div></div>\n</ms-widget-front></ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget \nlayout=\"column\" flex=\"100\" flex-gt-sm=\"50\"><ms-widget-front class=\"white-bg\"><div class=\"ph-16 border-bottom\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">{{vm.widget5.title}}</div><div class=\"pv-16\">\n<md-select class=\"simplified\" ng-model=\"vm.widget5.currentRange\" \nng-change=\"vm.widget5.loadData(vm.widget5.currentRange)\" aria-label=\"Change range\"><md-option \nng-repeat=\"(key, range) in vm.widget5.ranges\" value=\"{{key}}\">{{range}}</md-option></md-select></div></div><div \nclass=\"p-16\"><nvd3 class=\"h-400\" config=\"vm.widget5.mainChart.config\" options=\"vm.widget5.mainChart.options\" \ndata=\"vm.widget5.mainChart.data\"></nvd3></div><div class=\"pv-8 mh-16 border-top\" layout=\"row\" \nlayout-align=\"start center\" layout-wrap><div class=\"pv-8 border-right\" layout=\"column\" layout-align=\"center center\" \nflex=\"100\" flex-gt-xs=\"50\"><span class=\"font-size-32\">&#8377; {{vm.widget5.footerLeft.count}} </span><span class=\"h4\">\n{{vm.widget5.footerLeft.title}}</span></div><div class=\"pv-8\" layout=\"column\" layout-align=\"center center\" flex=\"100\" \nflex-gt-xs=\"50\"><span class=\"font-size-32\">&#8377; {{vm.widget5.footerRight.count}} </span><span class=\"h4\">\n{{vm.widget5.footerRight.title}}</span></div></div></ms-widget-front></ms-widget><ms-widget layout=\"column\" flex=\"100\" \nflex-gt-sm=\"50\"><ms-widget-front class=\"white-bg\"><div class=\"ph-16 border-bottom\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\">{{vm.widget6.title}}</div><div class=\"pv-16\"><md-select \nclass=\"simplified\" ng-model=\"vm.widget6.currentRange\" ng-change=\"vm.widget6.loadData(vm.widget6.currentRange)\" \naria-label=\"Change range\"><md-option ng-repeat=\"(key, range) in vm.widget6.ranges\" value=\"{{key}}\">{{range}}\n</md-option></md-select></div></div><div class=\"p-16\"><nvd3 class=\"h-420 remove-x-lines\" \nconfig=\"vm.widget6.mainChart.config\" options=\"vm.widget6.mainChart.options\" data=\"vm.widget6.mainChart.data\"></nvd3>\n</div></ms-widget-front></ms-widget></div></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap>\n<ms-widget layout=\"row\" flex=\"100\"><ms-widget-front class=\"white-bg\"><div class=\"ph-16 pv-8 border-bottom\" \nlayout=\"row\" layout-align=\"space-between center\" layout-wrap><div class=\"pv-8 h3\">{{vm.widget7.title}}</div><div \nclass=\"pv-8\" layout=\"row\" layout-align=\"start center\" layout-align-sm=\"end\" flex-sm=\"100\"><md-button class=\"ph-16\" \nng-repeat=\"(key, range) in vm.widget7.ranges\" ng-click=\"vm.widget7.loadData(key)\" \nng-disabled=\"vm.widget7.currentRange == key\">{{range}}</md-button></div></div><div class=\"p-16\"><nvd3 \nclass=\"h-420 remove-x-lines\" options=\"vm.widget7.mainChart.options\" data=\"vm.widget7.mainChart.data\"></nvd3></div>\n</ms-widget-front></ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget \nlayout=\"row\" flex=\"100\"><ms-widget-front class=\"white-bg\"><div class=\"ph-16 pv-8 border-bottom\" layout=\"row\" \nlayout-align=\"space-between center\" layout-wrap><div class=\"pv-8 h3\">{{vm.widget8.title}}</div><div class=\"pv-8\" \nlayout=\"row\" layout-align=\"start center\" layout-align-sm=\"end\" flex-sm=\"100\"><md-button class=\"ph-16\" \nng-repeat=\"(key, range) in vm.widget8.ranges\" ng-click=\"vm.widget8.loadData(key)\" \nng-disabled=\"vm.widget8.currentRange == key\">{{range}}</md-button></div></div><div class=\"p-16\"><nvd3 \nclass=\"h-420 remove-x-lines\" options=\"vm.widget8.mainChart.options\" data=\"vm.widget8.mainChart.data\"></nvd3></div>\n</ms-widget-front></ms-widget></div></md-content>");
$templateCache.put("app/main/dashboard/views/reports/report2.html","<md-content id=\"\" class=\"ps-active-y\" flex=\"\" data-ps-id=\"\" ms-scroll><div class=\"p-24 mb-8 border-bottom\" \nlayout=\"row\" layout-align=\"space-between center\"><md-button class=\"md-raised md-accent\" ui-sref=\"app.create_app\">\nNew App</md-button><div class=\"text-boxed red-bg white-fg m-0\">{{vm.allapps.length}} apps</div></div><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Name</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Package Name</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Created Date</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Status</span></div></th></tr></thead><tbody><tr class=\"approw\" \nng-repeat=\"app in vm.allapps track by $index\"><td>{{ $index+1 }}</td><td>{{app.appName}}</td><td>{{app.packageName}}\n</td><td>{{app.appCreatedAt}}</td><td><span \nng-class=\"{\'status md-warn-bg\': app.appStatus === \'blocked\', \'status md-green-800-bg\': app.appStatus === \'allowed\'}\">\n{{ app.appStatus }}</span></td></tr></tbody></table></md-content>");
$templateCache.put("app/main/dashboard/views/reports/revenuedispersion.html","<md-content id=\"\" class=\"ps-active-y\" flex=\"\" data-ps-id=\"\" ms-scroll><div class=\"border-bottom\" layout=\"row\" \nlayout-align=\"space-between center\" flex=\"100\"><md-input-container class=\"align-datepicker\" flex=\"20\"><md-datepicker \nmd-open-on-focus class=\"datepicker\" ng-model=\"vm.start_date\" md-placeholder=\"Start Date *\"></md-datepicker>\n</md-input-container><md-input-container class=\"align-datepicker\" flex=\"20\"><md-datepicker md-open-on-focus \nclass=\"datepicker\" ng-model=\"vm.end_date\" md-placeholder=\"End Date *\"></md-datepicker></md-input-container><ms-widget \nlayout=\"column\" flex=\"100\" flex-gt-sm=\"25\"><ms-widget-front class=\"white-bg\"><form ng-submit=\"$event.preventDefault()\">\n<md-autocomplete ng-disabled=\"vm.zoneFilter.isDisabled\" md-no-cache=\"vm.zoneFilter.noCache\" \nmd-selected-item=\"vm.zoneFilter.selectedZone\" \nmd-search-text-change=\"vm.zoneFilter.searchTextChange(vm.zoneFilter.searchText)\" \nmd-search-text=\"vm.zoneFilter.searchText\" md-selected-item-change=\"vm.zoneFilter.selectedZoneChange(zone)\" \nmd-items=\"zone in vm.zoneFilter.querySearch(vm.zoneFilter.searchText)\" md-item-text=\"zone.name\" md-min-length=\"0\" \nplaceholder=\"Filter by Zone\"><md-item-template><span md-highlight-text=\"vm.zoneFilter.searchText\" \nmd-highlight-flags=\"^i\">{{zone.name}}</span></md-item-template><md-not-found>\nNo teams matching \"{{vm.zoneFilter.searchText}}\" were found. <a \nng-click=\"vm.zoneFilter.resetZones(vm.zoneFilter.searchText)\">Take All Zones</a></md-not-found></md-autocomplete>\n</form></ms-widget-front></ms-widget><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"25\"><ms-widget-front \nclass=\"white-bg\"><form ng-submit=\"$event.preventDefault()\"><md-autocomplete \nng-disabled=\"vm.partnerTypeFilter.isDisabled\" md-no-cache=\"vm.partnerTypeFilter.noCache\" \nmd-selected-item=\"vm.partnerTypeFilter.selectedPartnerType\" \nmd-search-text-change=\"vm.partnerTypeFilter.searchTextChange(vm.partnerTypeFilter.searchText)\" \nmd-search-text=\"vm.partnerTypeFilter.searchText\" \nmd-selected-item-change=\"vm.partnerTypeFilter.selectedPartnerTypeChange(partnerType)\" \nmd-items=\"partnerType in vm.partnerTypeFilter.querySearch(vm.partnerTypeFilter.searchText)\" \nmd-item-text=\"partnerType.name\" md-min-length=\"0\" placeholder=\"Filter by Type\"><md-item-template><span \nmd-highlight-text=\"vm.partnerTypeFilter.searchText\" md-highlight-flags=\"^i\">{{partnerType.name}}</span>\n</md-item-template><md-not-found>No types matching \"{{vm.partnerTypeFilter.searchText}}\" were found. <a \nng-click=\"vm.partnerTypeFilter.resetPartnerTypes(vm.partnerTypeFilter.searchText)\">Take All Types</a></md-not-found>\n</md-autocomplete></form></ms-widget-front></ms-widget><md-button class=\"md-raised md-accent\" \nng-disabled=\"!vm.revenuedispersion.loaded\" ng-click=\"vm.revenuedispersion.loadData()\">Filter</md-button><div \nng-show=\"!vm.revenuedispersion.loaded\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"20\" \nclass=\"md-accent\"></md-progress-circular></div></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap>\n<ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"65\"><ms-widget-front class=\"white-bg\"><div \nclass=\"ph-16 border-bottom\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">\n{{vm.revenuedispersion.widget1.title}}</div><div class=\"pv-16\"></div></div><div class=\"p-16\"><nvd3 \nclass=\"h-420 remove-x-lines\" config=\"vm.revenuedispersion.widget1.mainChart.config\" \noptions=\"vm.revenuedispersion.widget1.mainChart.options\" data=\"vm.revenuedispersion.widget1.mainChart.data\"></nvd3>\n</div></ms-widget-front></ms-widget><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"35\"><ms-widget-front \nclass=\"white-bg\"><div class=\"ph-16 border-bottom\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">\n{{vm.revenuedispersion.widget2.title}}</div><div class=\"pv-16\"></div></div><div class=\"p-16\"><nvd3 class=\"h-400\" \nconfig=\"vm.revenuedispersion.widget2.mainChart.config\" options=\"vm.revenuedispersion.widget2.mainChart.options\" \ndata=\"vm.revenuedispersion.widget2.mainChart.data\"></nvd3></div></ms-widget-front></ms-widget></div><div layout=\"row\" \nlayout-align=\"end\"><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"25\"><ms-widget-front class=\"white-bg\"><input \ntype=\"text\" ng-model=\"vm.searchaggrid\" ng-change=\"vm.searchGrid()\" placeholder=\"Type to Search\" style=\"padding: 3%\">\n</ms-widget-front></ms-widget><md-button id=\"\" ng-disabled=\"!vm.revenuedispersion.loaded\" \nng-click=\"vm.exportAsCsv(\'Revenue Dispersion Data\')\" \nclass=\"add-file-button md-fab md-deep-purple-400-bg md-mini fab-rounded\"><md-tooltip md-direction=\"bottom\">\nExport As Csv</md-tooltip><md-icon md-font-icon=\"icon-arrow-down-bold-circle-outline\"></md-icon></md-button></div><div \nng-show=\"!vm.revenuedispersion.loaded\"><div class=\"h-240\" layout=\"column\" layout-sm=\"column\" \nlayout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular>\nLoading</div></div><div ng-if=\"vm.loadrevenuedispersionGrid\" ag-grid=\"vm.gridOptions\" class=\"ag-theme-material\" \nstyle=\"height: 600px\"></div></md-content>");
$templateCache.put("app/main/dashboard/views/reports/sales_by_customer_type.html","<md-content id=\"\" class=\"ps-active-y\" flex=\"\" data-ps-id=\"\" ms-scroll><div layout=\"row\" \nlayout-align=\"space-between center\"><div style=\"width: 100%\"><div style=\"float: left;width: 20%\"><md-input-container \nclass=\"align-datepicker\" style=\"margin: 1%\"><md-datepicker md-open-on-focus class=\"datepicker\" \nng-model=\"vm.start_date\" md-placeholder=\"Start Date\"></md-datepicker></md-input-container></div><div \nstyle=\"float:left;width: 20%\"><md-input-container class=\"align-datepicker\" style=\"margin: 1%\"><md-datepicker \nmd-open-on-focus class=\"datepicker\" ng-model=\"vm.end_date\" md-placeholder=\"End Date\"></md-datepicker>\n</md-input-container></div></div><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"25\" style=\"padding: 1%\">\n<ms-widget-front class=\"white-bg\"><input type=\"text\" ng-model=\"vm.searchaggrid\" ng-change=\"vm.searchGrid()\" \nplaceholder=\"Type to Search\" style=\"padding: 10px\"></ms-widget-front></ms-widget></div><div layout=\"row\" \nlayout-align=\"space-between center\"><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"25\"><ms-widget-front \nclass=\"white-bg\"><form ng-submit=\"$event.preventDefault()\"><md-autocomplete ng-disabled=\"vm.zoneFilter.isDisabled\" \nmd-no-cache=\"vm.zoneFilter.noCache\" md-selected-item=\"vm.zoneFilter.selectedZone\" \nmd-search-text-change=\"vm.zoneFilter.searchTextChange(vm.zoneFilter.searchText)\" \nmd-search-text=\"vm.zoneFilter.searchText\" md-selected-item-change=\"vm.zoneFilter.selectedZoneChange(zone)\" \nmd-items=\"zone in vm.zoneFilter.querySearch(vm.zoneFilter.searchText)\" md-item-text=\"zone.name\" md-min-length=\"0\" \nplaceholder=\"Filter by Zone\"><md-item-template><span md-highlight-text=\"vm.zoneFilter.searchText\" \nmd-highlight-flags=\"^i\">{{zone.name}}</span></md-item-template><md-not-found>\nNo Zones matching \"{{vm.zoneFilter.searchText}}\" were found. <a \nng-click=\"vm.zoneFilter.resetZones(vm.zoneFilter.searchText)\">Take All Zones</a></md-not-found></md-autocomplete>\n</form></ms-widget-front></ms-widget><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"25\"><ms-widget-front \nclass=\"white-bg\"><form ng-submit=\"$event.preventDefault()\"><md-autocomplete ng-disabled=\"vm.empcodeFilter.isDisabled\" \nmd-no-cache=\"vm.empcodeFilter.noCache\" md-selected-item=\"vm.empcodeFilter.selectedEmployee\" \nmd-search-text-change=\"vm.empcodeFilter.searchTextChange(vm.empcodeFilter.searchText)\" \nmd-search-text=\"vm.empcodeFilter.searchText\" \nmd-selected-item-change=\"vm.empcodeFilter.selectedEmployeeChange(employee)\" \nmd-items=\"employee in vm.empcodeFilter.querySearch(vm.empcodeFilter.searchText)\" \nmd-item-text=\"employee.identification_id\" md-min-length=\"0\" placeholder=\"Filter by Emp Code\"><md-item-template><span \nmd-highlight-text=\"vm.empcodeFilter.searchText\" md-highlight-flags=\"^i\">{{employee.identification_id}}</span>\n</md-item-template><md-not-found>No Emp matching \"{{vm.empcodeFilter.searchText}}\" were found. <a \nng-click=\"vm.empcodeFilter.resetEmployees(vm.empcodeFilter.searchText)\">Take All Emps</a></md-not-found>\n</md-autocomplete></form></ms-widget-front></ms-widget><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"25\">\n<ms-widget-front class=\"white-bg\"><form ng-submit=\"$event.preventDefault()\"><md-autocomplete \nng-disabled=\"vm.SalesmanFilter.isDisabled\" md-no-cache=\"vm.SalesmanFilter.noCache\" \nmd-selected-item=\"vm.SalesmanFilter.selectedUser\" \nmd-search-text-change=\"vm.SalesmanFilter.searchTextChange(vm.SalesmanFilter.searchText)\" \nmd-search-text=\"vm.SalesmanFilter.searchText\" md-selected-item-change=\"vm.SalesmanFilter.selectedUserChange(user)\" \nmd-items=\"user in vm.SalesmanFilter.querySearch(vm.SalesmanFilter.searchText)\" md-item-text=\"user.name\" \nmd-min-length=\"0\" placeholder=\"Filter by Saleman\"><md-item-template><span \nmd-highlight-text=\"vm.SalesmanFilter.searchText\" md-highlight-flags=\"^i\">{{user.name}}</span></md-item-template>\n<md-not-found>No teams matching \"{{vm.SalesmanFilter.searchText}}\" were found. <a \nng-click=\"vm.SalesmanFilter.resetUsers(vm.SalesmanFilter.searchText)\">Take All Teams</a></md-not-found>\n</md-autocomplete></form></ms-widget-front></ms-widget><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"25\">\n<ms-widget-front class=\"white-bg\"><form ng-submit=\"$event.preventDefault()\"><md-autocomplete \nng-disabled=\"vm.CategoryFilter.isDisabled\" md-no-cache=\"vm.CategoryFilter.noCache\" \nmd-selected-item=\"vm.CategoryFilter.selectedCategory\" \nmd-search-text-change=\"vm.CategoryFilter.searchTextChange(vm.CategoryFilter.searchText)\" \nmd-search-text=\"vm.CategoryFilter.searchText\" \nmd-selected-item-change=\"vm.CategoryFilter.selectedCategoryChange(category)\" \nmd-items=\"category in vm.CategoryFilter.querySearch(vm.CategoryFilter.searchText)\" md-item-text=\"category.name\" \nmd-min-length=\"0\" placeholder=\"Filter by Category\"><md-item-template><span \nmd-highlight-text=\"vm.CategoryFilter.searchText\" md-highlight-flags=\"^i\">{{category.name}}</span></md-item-template>\n<md-not-found>No Category matching \"{{vm.CategoryFilter.searchText}}\" were found. <a \nng-click=\"vm.CategoryFilter.resetCategories(vm.CategoryFilter.searchText)\">Take All Categories</a></md-not-found>\n</md-autocomplete></form></ms-widget-front></ms-widget></div><div layout=\"row\" layout-align=\"space-between center\">\n<ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"25\"><ms-widget-front class=\"white-bg\"><form \nng-submit=\"$event.preventDefault()\"><md-autocomplete ng-disabled=\"vm.BrandFilter.isDisabled\" \nmd-no-cache=\"vm.BrandFilter.noCache\" md-selected-item=\"vm.BrandFilter.selectedBrand\" \nmd-search-text-change=\"vm.BrandFilter.searchTextChange(vm.BrandFilter.searchText)\" \nmd-search-text=\"vm.BrandFilter.searchText\" md-selected-item-change=\"vm.BrandFilter.selectedBrandChange(brand)\" \nmd-items=\"brand in vm.BrandFilter.querySearch(vm.BrandFilter.searchText)\" md-item-text=\"brand.name\" md-min-length=\"0\" \nplaceholder=\"Filter by Brand\"><md-item-template><span md-highlight-text=\"vm.BrandFilter.searchText\" \nmd-highlight-flags=\"^i\">{{brand.name}}</span></md-item-template><md-not-found>\nNo Brand matching \"{{vm.BrandFilter.searchText}}\" were found. <a \nng-click=\"vm.BrandFilter.resetBrands(vm.BrandFilter.searchText)\">Take All Brands</a></md-not-found></md-autocomplete>\n</form></ms-widget-front></ms-widget><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"25\"><ms-widget-front \nclass=\"white-bg\"><form ng-submit=\"$event.preventDefault()\"><md-autocomplete ng-disabled=\"vm.distnameFilter.isDisabled\" \nmd-no-cache=\"vm.distnameFilter.noCache\" md-selected-item=\"vm.distnameFilter.selectedDistributor\" \nmd-search-text-change=\"vm.distnameFilter.searchTextChange(vm.distnameFilter.searchText)\" \nmd-search-text=\"vm.distnameFilter.searchText\" \nmd-selected-item-change=\"vm.distnameFilter.selecteddistributorChange(distributor)\" \nmd-items=\"distributor in vm.distnameFilter.querySearch(vm.distnameFilter.searchText)\" md-item-text=\"distributor.name\" \nmd-min-length=\"0\" placeholder=\"Filter by Dist Name\"><md-item-template><span \nmd-highlight-text=\"vm.distnameFilter.searchText\" md-highlight-flags=\"^i\">{{distributor.name}}</span></md-item-template>\n<md-not-found>No Distributor matching \"{{vm.distnameFilter.searchText}}\" were found. <a \nng-click=\"vm.distnameFilter.resetDistributors(vm.distnameFilter.searchText)\">Take All Distributor</a></md-not-found>\n</md-autocomplete></form></ms-widget-front></ms-widget><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"25\">\n<ms-widget-front class=\"white-bg\"><form ng-submit=\"$event.preventDefault()\"><md-autocomplete \nng-disabled=\"vm.distcodeFilter.isDisabled\" md-no-cache=\"vm.distcodeFilter.noCache\" \nmd-selected-item=\"vm.distcodeFilter.selectedDistributor\" \nmd-search-text-change=\"vm.distnameFilter.searchTextChange(vm.distcodeFilter.searchText)\" \nmd-search-text=\"vm.distcodeFilter.searchText\" \nmd-selected-item-change=\"vm.distcodeFilter.selectedDistributorChange(distributor)\" \nmd-items=\"distributor in vm.distcodeFilter.querySearch(vm.distcodeFilter.searchText)\" md-item-text=\"distributor.code\" \nmd-min-length=\"0\" placeholder=\"Filter by Dist Code\"><md-item-template><span \nmd-highlight-text=\"vm.distcodeFilter.searchText\" md-highlight-flags=\"^i\">{{distributor.code}}</span></md-item-template>\n<md-not-found>No Distributor matching \"{{vm.distcodeFilter.searchText}}\" were found. <a \nng-click=\"vm.distcodeFilter.resetDistributors(vm.distcodeFilter.searchText)\">Take All Distributor</a></md-not-found>\n</md-autocomplete></form></ms-widget-front></ms-widget><md-button class=\"md-raised md-accent\" \nng-click=\"vm.salesbycustomertype.loadData()\">Filter</md-button><md-button id=\"\" \nng-disabled=\"!vm.salesbycustomertype.loaded\" ng-click=\"vm.exportAsCsv(\'Sales By Outlet Type Data\')\" \nclass=\"add-file-button md-fab md-deep-purple-400-bg md-mini fab-rounded\"><md-tooltip md-direction=\"bottom\">\nExport As Csv</md-tooltip><md-icon md-font-icon=\"icon-arrow-down-bold-circle-outline\"></md-icon></md-button></div><div \nng-show=\"!vm.salesbycustomertype.loaded\"><div class=\"h-240\" layout=\"column\" layout-sm=\"column\" \nlayout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular>\nLoading</div></div><div ng-if=\"vm.loadsalesbycustomertypeGrid\" ag-grid=\"vm.gridOptions\" class=\"ag-theme-material\" \nstyle=\"height: 600px\"></div><div style=\"width :100%\"><div style=\"width :55%;float: left\"><ms-widget layout=\"column\" \nflex=\"100\" flex-gt-sm=\"100\"><ms-widget-front class=\"white-bg\"><div class=\"ph-16 border-bottom\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\">{{vm.salesbycustomertypegraph.widget2.title}}</div><div \nclass=\"pv-16\"></div></div><div class=\"p-16\"><nvd3 class=\"h-400\" \nconfig=\"vm.salesbycustomertypegraph.widget2.mainChart.config\" \noptions=\"vm.salesbycustomertypegraph.widget2.mainChart.options\" \ndata=\"vm.salesbycustomertypegraph.widget2.mainChart.data\"></nvd3></div></ms-widget-front></ms-widget></div><div \nng-if=\"vm.loadsalesbycustomertypegraphGrid\" ag-grid=\"vm.gridOptions1\" class=\"ag-theme-material\" \nstyle=\"height: 500px;width :45%;float: right\"></div></div></md-content>");
$templateCache.put("app/main/dashboard/views/reports/salesman_productivity_measures.html","<md-content id=\"\" class=\"ps-active-y\" flex=\"\" data-ps-id=\"\" ms-scroll><div layout=\"row\" \nlayout-align=\"space-between center\"><div style=\"width: 100%\"><div style=\"float: left;width: 20%\"><md-input-container \nclass=\"align-datepicker\" style=\"margin: 1%\"><md-datepicker md-open-on-focus class=\"datepicker\" \nng-model=\"vm.start_date\" md-placeholder=\"Start Date\"></md-datepicker></md-input-container></div><div \nstyle=\"float:left;width: 20%\"><md-input-container class=\"align-datepicker\" style=\"margin: 1%\"><md-datepicker \nmd-open-on-focus class=\"datepicker\" ng-model=\"vm.end_date\" md-placeholder=\"End Date\"></md-datepicker>\n</md-input-container></div></div><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"25\" style=\"padding: 1%\">\n<ms-widget-front class=\"white-bg\"><input type=\"text\" ng-model=\"vm.searchaggrid\" ng-change=\"vm.searchGrid()\" \nplaceholder=\"Type to Search\" style=\"padding: 10px\"></ms-widget-front></ms-widget></div><div layout=\"row\" \nlayout-align=\"space-between center\"><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"25\"><ms-widget-front \nclass=\"white-bg\"><form ng-submit=\"$event.preventDefault()\"><md-autocomplete ng-disabled=\"vm.zoneFilter.isDisabled\" \nmd-no-cache=\"vm.zoneFilter.noCache\" md-selected-item=\"vm.zoneFilter.selectedZone\" \nmd-search-text-change=\"vm.zoneFilter.searchTextChange(vm.zoneFilter.searchText)\" \nmd-search-text=\"vm.zoneFilter.searchText\" md-selected-item-change=\"vm.zoneFilter.selectedZoneChange(zone)\" \nmd-items=\"zone in vm.zoneFilter.querySearch(vm.zoneFilter.searchText)\" md-item-text=\"zone.name\" md-min-length=\"0\" \nplaceholder=\"Filter by Zone\"><md-item-template><span md-highlight-text=\"vm.zoneFilter.searchText\" \nmd-highlight-flags=\"^i\">{{zone.name}}</span></md-item-template><md-not-found>\nNo Zones matching \"{{vm.zoneFilter.searchText}}\" were found. <a \nng-click=\"vm.zoneFilter.resetZones(vm.zoneFilter.searchText)\">Take All Zones</a></md-not-found></md-autocomplete>\n</form></ms-widget-front></ms-widget><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"25\"><ms-widget-front \nclass=\"white-bg\"><form ng-submit=\"$event.preventDefault()\"><md-autocomplete ng-disabled=\"vm.SalesmanFilter.isDisabled\" \nmd-no-cache=\"vm.SalesmanFilter.noCache\" md-selected-item=\"vm.SalesmanFilter.selectedUser\" \nmd-search-text-change=\"vm.SalesmanFilter.searchTextChange(vm.SalesmanFilter.searchText)\" \nmd-search-text=\"vm.SalesmanFilter.searchText\" md-selected-item-change=\"vm.SalesmanFilter.selectedUserChange(user)\" \nmd-items=\"user in vm.SalesmanFilter.querySearch(vm.SalesmanFilter.searchText)\" md-item-text=\"user.name\" \nmd-min-length=\"0\" placeholder=\"Filter by Saleman\"><md-item-template><span \nmd-highlight-text=\"vm.SalesmanFilter.searchText\" md-highlight-flags=\"^i\">{{user.name}}</span></md-item-template>\n<md-not-found>No Salesman matching \"{{vm.SalesmanFilter.searchText}}\" were found. <a \nng-click=\"vm.SalesmanFilter.resetUsers(vm.SalesmanFilter.searchText)\">Take All Salesman</a></md-not-found>\n</md-autocomplete></form></ms-widget-front></ms-widget><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"25\">\n<ms-widget-front class=\"white-bg\"><form ng-submit=\"$event.preventDefault()\"><md-autocomplete \nng-disabled=\"vm.empcodeFilter.isDisabled\" md-no-cache=\"vm.empcodeFilter.noCache\" \nmd-selected-item=\"vm.empcodeFilter.selectedEmployee\" \nmd-search-text-change=\"vm.empcodeFilter.searchTextChange(vm.empcodeFilter.searchText)\" \nmd-search-text=\"vm.empcodeFilter.searchText\" \nmd-selected-item-change=\"vm.empcodeFilter.selectedEmployeeChange(employee)\" \nmd-items=\"employee in vm.empcodeFilter.querySearch(vm.empcodeFilter.searchText)\" \nmd-item-text=\"employee.identification_id\" md-min-length=\"0\" placeholder=\"Filter by Emp Code\"><md-item-template><span \nmd-highlight-text=\"vm.empcodeFilter.searchText\" md-highlight-flags=\"^i\">{{employee.identification_id}}</span>\n</md-item-template><md-not-found>No Emp matching \"{{vm.empcodeFilter.searchText}}\" were found. <a \nng-click=\"vm.empcodeFilter.resetEmployees(vm.empcodeFilter.searchText)\">Take All Emps</a></md-not-found>\n</md-autocomplete></form></ms-widget-front></ms-widget><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"25\">\n<ms-widget-front class=\"white-bg\"><form ng-submit=\"$event.preventDefault()\"><md-autocomplete \nng-disabled=\"vm.beatFilter.isDisabled\" md-no-cache=\"vm.beatFilter.noCache\" \nmd-selected-item=\"vm.beatFilter.selectedBeat\" \nmd-search-text-change=\"vm.beatFilter.searchTextChange(vm.beatFilter.searchText)\" \nmd-search-text=\"vm.beatFilter.searchText\" md-selected-item-change=\"vm.beatFilter.selectedbeatChange(beat)\" \nmd-items=\"beat in vm.beatFilter.querySearch(vm.beatFilter.searchText)\" md-item-text=\"beat.name\" md-min-length=\"0\" \nplaceholder=\"Filter by Beat\"><md-item-template><span md-highlight-text=\"vm.beatFilter.searchText\" \nmd-highlight-flags=\"^i\">{{beat.name}}</span></md-item-template><md-not-found>\nNo beats matching \"{{vm.beatFilter.searchText}}\" were found. <a \nng-click=\"vm.beatFilter.resetBeats(vm.beatFilter.searchText)\">Take All Beats</a></md-not-found></md-autocomplete>\n</form></ms-widget-front></ms-widget><md-button class=\"md-raised md-accent\" \nng-click=\"vm.salesmanproductivitymeasures.loadData()\">Filter</md-button><md-button id=\"\" \nng-disabled=\"!vm.salesmanproductivitymeasures.loaded\" ng-click=\"vm.exportAsCsv(\'Salesman Productivity Measures Data\')\" \nclass=\"add-file-button md-fab md-deep-purple-400-bg md-mini fab-rounded\"><md-tooltip md-direction=\"bottom\">\nExport As Csv</md-tooltip><md-icon md-font-icon=\"icon-arrow-down-bold-circle-outline\"></md-icon></md-button></div><div \nng-show=\"!vm.salesmanproductivitymeasures.loaded\"><div class=\"h-240\" layout=\"column\" layout-sm=\"column\" \nlayout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular>\nLoading</div></div><div ng-if=\"vm.loadsalesmanproductivitymeasuresGrid\" ag-grid=\"vm.gridOptions\" \nclass=\"ag-theme-material\" style=\"height: 600px\"></div><div><ms-widget layout=\"column\"><ms-widget-front \nclass=\"white-bg\"><div class=\"ph-16 border-bottom\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">\n{{vm.salesmanproductivitymeasures.widget1.title}}</div><div class=\"pv-16\"></div></div><div class=\"p-16\" \nstyle=\"overflow-y: scroll;overflow-x: auto\"><nvd3 config=\"vm.salesmanproductivitymeasures.widget1.mainChart.config\" \noptions=\"vm.salesmanproductivitymeasures.widget1.mainChart.options\" \ndata=\"vm.salesmanproductivitymeasures.widget1.mainChart.data\"></nvd3></div></ms-widget-front></ms-widget></div><div>\n<ms-widget layout=\"column\"><ms-widget-front class=\"white-bg\"><div class=\"ph-16 border-bottom\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\">{{vm.salesmanproductivitymeasures.widget2.title}}</div><div \nclass=\"pv-16\"></div></div><div class=\"p-16\" style=\"overflow-y: scroll;overflow-x: auto\"><nvd3 \nconfig=\"vm.salesmanproductivitymeasures.widget2.mainChart.config\" \noptions=\"vm.salesmanproductivitymeasures.widget2.mainChart.options\" \ndata=\"vm.salesmanproductivitymeasures.widget2.mainChart.data\"></nvd3></div></ms-widget-front></ms-widget></div>\n</md-content>");
$templateCache.put("app/main/dashboard/views/reports/skudispersion.html","<md-content id=\"\" class=\"ps-active-y\" flex=\"\" data-ps-id=\"\" ms-scroll><div class=\"border-bottom\" layout=\"row\" \nlayout-align=\"space-between center\" flex=\"100\"><md-input-container class=\"align-datepicker\" flex=\"20\"><md-datepicker \nmd-open-on-focus class=\"datepicker\" ng-model=\"vm.start_date\" md-placeholder=\"Start Date *\"></md-datepicker>\n</md-input-container><md-input-container class=\"align-datepicker\" flex=\"20\"><md-datepicker md-open-on-focus \nclass=\"datepicker\" ng-model=\"vm.end_date\" md-placeholder=\"End Date *\"></md-datepicker></md-input-container><ms-widget \nlayout=\"column\" flex=\"100\" flex-gt-sm=\"25\"><ms-widget-front class=\"white-bg\"><form ng-submit=\"$event.preventDefault()\">\n<md-autocomplete ng-disabled=\"vm.zoneFilter.isDisabled\" md-no-cache=\"vm.zoneFilter.noCache\" \nmd-selected-item=\"vm.zoneFilter.selectedZone\" \nmd-search-text-change=\"vm.zoneFilter.searchTextChange(vm.zoneFilter.searchText)\" \nmd-search-text=\"vm.zoneFilter.searchText\" md-selected-item-change=\"vm.zoneFilter.selectedZoneChange(zone)\" \nmd-items=\"zone in vm.zoneFilter.querySearch(vm.zoneFilter.searchText)\" md-item-text=\"zone.name\" md-min-length=\"0\" \nplaceholder=\"Filter by Zone\"><md-item-template><span md-highlight-text=\"vm.zoneFilter.searchText\" \nmd-highlight-flags=\"^i\">{{zone.name}}</span></md-item-template><md-not-found>\nNo teams matching \"{{vm.zoneFilter.searchText}}\" were found. <a \nng-click=\"vm.zoneFilter.resetZones(vm.zoneFilter.searchText)\">Take All Zones</a></md-not-found></md-autocomplete>\n</form></ms-widget-front></ms-widget><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"25\"><ms-widget-front \nclass=\"white-bg\"><form ng-submit=\"$event.preventDefault()\"><md-autocomplete \nng-disabled=\"vm.partnerTypeFilter.isDisabled\" md-no-cache=\"vm.partnerTypeFilter.noCache\" \nmd-selected-item=\"vm.partnerTypeFilter.selectedPartnerType\" \nmd-search-text-change=\"vm.partnerTypeFilter.searchTextChange(vm.partnerTypeFilter.searchText)\" \nmd-search-text=\"vm.partnerTypeFilter.searchText\" \nmd-selected-item-change=\"vm.partnerTypeFilter.selectedPartnerTypeChange(partnerType)\" \nmd-items=\"partnerType in vm.partnerTypeFilter.querySearch(vm.partnerTypeFilter.searchText)\" \nmd-item-text=\"partnerType.name\" md-min-length=\"0\" placeholder=\"Filter by Type\"><md-item-template><span \nmd-highlight-text=\"vm.partnerTypeFilter.searchText\" md-highlight-flags=\"^i\">{{partnerType.name}}</span>\n</md-item-template><md-not-found>No partner types matching \"{{vm.partnerTypeFilter.searchText}}\" were found. <a \nng-click=\"vm.partnerTypeFilter.resetPartnerTypes(vm.partnerTypeFilter.searchText)\">Take All Types</a></md-not-found>\n</md-autocomplete></form></ms-widget-front></ms-widget><md-button class=\"md-raised md-accent\" \nng-disabled=\"!vm.skudispersion.loaded\" ng-click=\"vm.skudispersion.loadData()\">Filter</md-button><div \nng-show=\"!vm.skudispersion.loaded\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"20\" class=\"md-accent\">\n</md-progress-circular></div></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget \nlayout=\"column\" flex=\"100\" flex-gt-sm=\"50\"><ms-widget-front class=\"white-bg\"><div class=\"ph-16 border-bottom\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">{{vm.skudispersion.widget1.title}}</div><div \nclass=\"pv-16\"></div></div><div class=\"p-16\"><nvd3 class=\"h-420 remove-x-lines\" \nconfig=\"vm.skudispersion.widget1.mainChart.config\" options=\"vm.skudispersion.widget1.mainChart.options\" \ndata=\"vm.skudispersion.widget1.mainChart.data\"></nvd3></div></ms-widget-front></ms-widget><ms-widget layout=\"column\" \nflex=\"100\" flex-gt-sm=\"50\"><ms-widget-front class=\"white-bg\"><div class=\"ph-16 border-bottom\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\">{{vm.skudispersion.widget2.title}}</div><div class=\"pv-16\"></div>\n</div><div class=\"p-16\"><nvd3 class=\"h-400\" config=\"vm.skudispersion.widget2.mainChart.config\" \noptions=\"vm.skudispersion.widget2.mainChart.options\" data=\"vm.skudispersion.widget2.mainChart.data\"></nvd3></div>\n</ms-widget-front></ms-widget></div><div layout=\"row\" layout-align=\"end\"><ms-widget layout=\"column\" flex=\"100\" \nflex-gt-sm=\"25\"><ms-widget-front class=\"white-bg\"><input type=\"text\" ng-model=\"vm.searchaggrid\" \nng-change=\"vm.searchGrid()\" placeholder=\"Type to Search\" style=\"padding: 3%\"></ms-widget-front></ms-widget><md-button \nid=\"\" ng-disabled=\"!vm.skudispersion.loaded\" ng-click=\"vm.exportAsCsv(\'SKU Dispersion Data\')\" \nclass=\"add-file-button md-fab md-deep-purple-400-bg md-mini fab-rounded\"><md-tooltip md-direction=\"bottom\">\nExport As Csv</md-tooltip><md-icon md-font-icon=\"icon-arrow-down-bold-circle-outline\"></md-icon></md-button></div><div \nng-show=\"!vm.skudispersion.loaded\"><div class=\"h-240\" layout=\"column\" layout-sm=\"column\" layout-align=\"center center\">\n<md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular>Loading</div></div><div \nng-if=\"vm.loadskudispersionGrid\" ag-grid=\"vm.gridOptions\" class=\"ag-theme-material\" style=\"height: 600px\"></div>\n</md-content>");
$templateCache.put("app/main/dashboard/views/reports/sr_score_card.html","<md-content id=\"\" class=\"ps-active-y\" flex=\"\" data-ps-id=\"\" ms-scroll><div layout=\"row\" \nlayout-align=\"space-between center\"><div style=\"width: 100%\"><div style=\"float: left;width: 40%\"><md-input-container \nclass=\"align-datepicker\" style=\"margin: 1%\"><md-datepicker md-open-on-focus class=\"datepicker\" \nng-model=\"vm.start_date\" md-placeholder=\"Start Date\"></md-datepicker></md-input-container></div><div \nstyle=\"float:left;width: 40%\"><md-input-container class=\"align-datepicker\" style=\"margin: 1%\"><md-datepicker \nmd-open-on-focus class=\"datepicker\" ng-model=\"vm.end_date\" md-placeholder=\"End Date\"></md-datepicker>\n</md-input-container></div></div><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"25\" \nstyle=\"float:right;width: 80%; margin-left: 30px;padding: 1%\"><ms-widget-front class=\"white-bg\"><input type=\"text\" \nng-model=\"vm.searchaggrid\" ng-change=\"vm.searchGrid()\" placeholder=\"Type to Search\" style=\"padding: 10px\">\n</ms-widget-front></ms-widget></div><div layout=\"row\" layout-align=\"space-between center\" style=\"width:100%\"><div \nstyle=\"width:10%\"><md-input-container class=\"md-block\" \nstyle=\"float:left;width: 20%;margin-top: 20px; margin-left: 10px\" required><div><span>Set Weights</span></div>\n</md-input-container></div><div style=\"width:15%\"><ms-widget layout=\"column\" \nstyle=\"width: 80%; margin-left: 20px;padding: 1%\"><ms-widget-front class=\"white-bg\"><input min=\"0\" max=\"100\" \ntype=\"number\" value=\"40\" name=\"achievedweight\" ng-model=\"vm.achievedweight\" placeholder=\"Acheivement\" \nstyle=\"padding: 10px\" required></ms-widget-front></ms-widget></div><div style=\"width:15%\"><ms-widget layout=\"column\" \nstyle=\"width: 80%; margin-left: 20px;padding: 1%\"><ms-widget-front class=\"white-bg\"><input min=\"0\" max=\"100\" value=\"5\" \ntype=\"number\" name=\"bpaweight\" ng-model=\"vm.bpaweight\" placeholder=\"JPA \" style=\"padding: 10px\" required>\n</ms-widget-front></ms-widget></div><div style=\"width:15%\"><ms-widget layout=\"column\" \nstyle=\"width: 80%; margin-left: 20px;padding: 1%\"><ms-widget-front class=\"white-bg\"><input min=\"0\" max=\"100\" \ntype=\"number\" value=\"20\" name=\"uobweight\" ng-model=\"vm.uobweight\" placeholder=\"UPC \" style=\"padding: 10px\" required>\n</ms-widget-front></ms-widget></div><div style=\"width:15%\"><ms-widget layout=\"column\" \nstyle=\"width: 80%; margin-left: 20px;padding: 1%\"><ms-widget-front class=\"white-bg\"><input min=\"0\" max=\"100\" \ntype=\"number\" value=\"15\" name=\"bcweight\" ng-model=\"vm.bcweight\" placeholder=\"PC \" style=\"padding: 10px\" required>\n</ms-widget-front></ms-widget></div><div style=\"width:15%\"><ms-widget layout=\"column\" \nstyle=\"width: 80%; margin-left: 20px;padding: 1%\"><ms-widget-front class=\"white-bg\"><input min=\"0\" max=\"100\" \ntype=\"number\" value=\"20\" name=\"mssweight\" ng-model=\"vm.mssweight\" placeholder=\"MSS \" style=\"padding: 10px\" required>\n</ms-widget-front></ms-widget></div></div><div layout=\"row\" layout-align=\"space-between center\"><ms-widget \nlayout=\"column\" flex=\"100\" flex-gt-sm=\"25\"><ms-widget-front class=\"white-bg\"><form ng-submit=\"$event.preventDefault()\">\n<md-autocomplete ng-disabled=\"vm.zoneFilter.isDisabled\" md-no-cache=\"vm.zoneFilter.noCache\" \nmd-selected-item=\"vm.zoneFilter.selectedZone\" \nmd-search-text-change=\"vm.zoneFilter.searchTextChange(vm.zoneFilter.searchText)\" \nmd-search-text=\"vm.zoneFilter.searchText\" md-selected-item-change=\"vm.zoneFilter.selectedZoneChange(zone)\" \nmd-items=\"zone in vm.zoneFilter.querySearch(vm.zoneFilter.searchText)\" md-item-text=\"zone.name\" md-min-length=\"0\" \nplaceholder=\"Filter by Zone\"><md-item-template><span md-highlight-text=\"vm.zoneFilter.searchText\" \nmd-highlight-flags=\"^i\">{{zone.name}}</span></md-item-template><md-not-found>\nNo Zones matching \"{{vm.zoneFilter.searchText}}\" were found. <a \nng-click=\"vm.zoneFilter.resetZones(vm.zoneFilter.searchText)\">Take All Zones</a></md-not-found></md-autocomplete>\n</form></ms-widget-front></ms-widget><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"25\"><ms-widget-front \nclass=\"white-bg\"><form ng-submit=\"$event.preventDefault()\"><md-autocomplete ng-disabled=\"vm.empcodeFilter.isDisabled\" \nmd-no-cache=\"vm.empcodeFilter.noCache\" md-selected-item=\"vm.empcodeFilter.selectedEmployee\" \nmd-search-text-change=\"vm.empcodeFilter.searchTextChange(vm.empcodeFilter.searchText)\" \nmd-search-text=\"vm.empcodeFilter.searchText\" \nmd-selected-item-change=\"vm.empcodeFilter.selectedEmployeeChange(employee)\" \nmd-items=\"employee in vm.empcodeFilter.querySearch(vm.empcodeFilter.searchText)\" \nmd-item-text=\"employee.identification_id\" md-min-length=\"0\" placeholder=\"Filter by Emp Code\"><md-item-template><span \nmd-highlight-text=\"vm.empcodeFilter.searchText\" md-highlight-flags=\"^i\">{{employee.identification_id}}</span>\n</md-item-template><md-not-found>No Emp matching \"{{vm.empcodeFilter.searchText}}\" were found. <a \nng-click=\"vm.empcodeFilter.resetEmployees(vm.empcodeFilter.searchText)\">Take All Emps</a></md-not-found>\n</md-autocomplete></form></ms-widget-front></ms-widget><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"25\">\n<ms-widget-front class=\"white-bg\"><form ng-submit=\"$event.preventDefault()\"><md-autocomplete \nng-disabled=\"vm.SalesmanFilter.isDisabled\" md-no-cache=\"vm.SalesmanFilter.noCache\" \nmd-selected-item=\"vm.SalesmanFilter.selectedUser\" \nmd-search-text-change=\"vm.SalesmanFilter.searchTextChange(vm.SalesmanFilter.searchText)\" \nmd-search-text=\"vm.SalesmanFilter.searchText\" md-selected-item-change=\"vm.SalesmanFilter.selectedUserChange(user)\" \nmd-items=\"user in vm.SalesmanFilter.querySearch(vm.SalesmanFilter.searchText)\" md-item-text=\"user.name\" \nmd-min-length=\"0\" placeholder=\"Filter by Saleman\"><md-item-template><span \nmd-highlight-text=\"vm.SalesmanFilter.searchText\" md-highlight-flags=\"^i\">{{user.name}}</span></md-item-template>\n<md-not-found>No Salesman matching \"{{vm.SalesmanFilter.searchText}}\" were found. <a \nng-click=\"vm.SalesmanFilter.resetUsers(vm.SalesmanFilter.searchText)\">Take All salesmans</a></md-not-found>\n</md-autocomplete></form></ms-widget-front></ms-widget><md-button class=\"md-raised md-accent\" \nng-click=\"vm.sr_score_card.loadData()\">Filter</md-button><md-button ng-disabled=\"!vm.sr_score_card.loaded\" \nng-click=\"vm.exportAsCsv(\'SR Score Card\')\" class=\"add-file-button md-fab md-deep-purple-400-bg md-mini fab-rounded\">\n<md-tooltip md-direction=\"bottom\">Export As Csv</md-tooltip><md-icon \nmd-font-icon=\"icon-arrow-down-bold-circle-outline\"></md-icon></md-button></div><div ng-show=\"!vm.sr_score_card.loaded\">\n<div class=\"h-240\" layout=\"column\" layout-sm=\"column\" layout-align=\"center center\"><md-progress-circular \nmd-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular>Loading</div></div><div \nng-if=\"vm.loadSRScoreCardGrid\" ag-grid=\"vm.gridOptions\" class=\"ag-theme-material\" style=\"height: 600px\"></div>\n</md-content>");
$templateCache.put("app/main/dashboard/views/reports/weekly_sales_report.html","<md-content id=\"\" class=\"ps-active-y\" flex=\"\" data-ps-id=\"\" ms-scroll><div class=\"pl-5 mb-8 border-bottom row\" \nlayout=\"row\" layout-align=\"end center\" flex><md-input-container class=\"align-datepicker\" flex=\"20\"><md-datepicker \nmd-open-on-focus class=\"datepicker\" ng-model=\"vm.start_date\" md-placeholder=\"Month\"></md-datepicker>\n</md-input-container><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"25\"><ms-widget-front class=\"white-bg\"><form \nng-submit=\"$event.preventDefault()\"><md-autocomplete ng-disabled=\"vm.zoneFilter.isDisabled\" \nmd-no-cache=\"vm.zoneFilter.noCache\" md-selected-item=\"vm.zoneFilter.selectedZone\" \nmd-search-text-change=\"vm.zoneFilter.searchTextChange(vm.zoneFilter.searchText)\" \nmd-search-text=\"vm.zoneFilter.searchText\" md-selected-item-change=\"vm.zoneFilter.selectedZoneChange(zone)\" \nmd-items=\"zone in vm.zoneFilter.querySearch(vm.zoneFilter.searchText)\" md-item-text=\"zone.name\" md-min-length=\"0\" \nplaceholder=\"Filter by Zone\"><md-item-template><span md-highlight-text=\"vm.zoneFilter.searchText\" \nmd-highlight-flags=\"^i\">{{zone.name}}</span></md-item-template><md-not-found>\nNo Zones matching \"{{vm.zoneFilter.searchText}}\" were found. <a \nng-click=\"vm.zoneFilter.resetZones(vm.zoneFilter.searchText)\">Take All Zones</a></md-not-found></md-autocomplete>\n</form></ms-widget-front></ms-widget><md-button class=\"md-raised md-accent\" ng-click=\"vm.weeklysalesreport.loadData()\">\nFilter</md-button><md-button id=\"\" ng-disabled=\"!vm.weeklysalesreport.loaded\" \nng-click=\"vm.exportAsCsv(\'Weekly Sales Report\')\" \nclass=\"add-file-button md-fab md-deep-purple-400-bg md-mini fab-rounded\"><md-tooltip md-direction=\"bottom\">\nExport As Csv</md-tooltip><md-icon md-font-icon=\"icon-arrow-down-bold-circle-outline\"></md-icon></md-button><ms-widget \nlayout=\"column\" flex=\"100\" flex-gt-sm=\"25\"><ms-widget-front class=\"white-bg\"><input type=\"text\" \nng-model=\"vm.searchaggrid\" ng-change=\"vm.searchGrid()\" placeholder=\"Type to Search\" style=\"padding: 3%\">\n</ms-widget-front></ms-widget></div><div ng-show=\"!vm.weeklysalesreport.loaded\"><div class=\"h-240\" layout=\"column\" \nlayout-sm=\"column\" layout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\">\n</md-progress-circular>Loading</div></div><div ng-if=\"vm.loadweeklysalesreportGrid\" ag-grid=\"vm.gridOptions\" \nclass=\"ag-theme-material\" style=\"height: 400px\"></div><ms-widget layout=\"row\" flex=\"100\"><ms-widget-front \nclass=\"white-bg\"><div class=\"ph-16 pv-8 border-bottom\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"pv-8 h3\">{{vm.weeklysalesreport.widget11.title}}</div></div><div class=\"p-16\"><nvd3 class=\"h-420\" \nconfig=\"vm.weeklysalesreport.widget11.mainChart.config\" options=\"vm.weeklysalesreport.widget11.mainChart.options\" \ndata=\"vm.weeklysalesreport.widget11.mainChart.data\"></nvd3></div></ms-widget-front></ms-widget><ms-widget layout=\"row\" \nflex=\"100\"><ms-widget-front class=\"white-bg\"><div class=\"ph-16 pv-8 border-bottom\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"pv-8 h3\">{{vm.weeklysalesreport.widget12.title}}</div></div><div \nclass=\"p-16\"><nvd3 class=\"h-420\" config=\"vm.weeklysalesreport.widget12.mainChart.config\" \noptions=\"vm.weeklysalesreport.widget12.mainChart.options\" data=\"vm.weeklysalesreport.widget12.mainChart.data\"></nvd3>\n</div></ms-widget-front></ms-widget></md-content>");
$templateCache.put("app/main/dashboard/views/reports/zerosales.html","<md-content id=\"\" class=\"ps-active-y\" flex=\"\" data-ps-id=\"\" ms-scroll><div layout=\"row\" \nlayout-align=\"space-between center\"><div style=\"width: 100%\"><div style=\"float: left;width: 20%\"><md-input-container \nclass=\"align-datepicker\" style=\"margin: 1%\"><md-datepicker md-open-on-focus class=\"datepicker\" \nng-model=\"vm.start_date\" md-placeholder=\"Start Date\"></md-datepicker></md-input-container></div><div \nstyle=\"float:left;width: 20%\"><md-input-container class=\"align-datepicker\" style=\"margin: 1%\"><md-datepicker \nmd-open-on-focus class=\"datepicker\" ng-model=\"vm.end_date\" md-placeholder=\"End Date\"></md-datepicker>\n</md-input-container></div></div><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"25\" style=\"padding: 1%\">\n<ms-widget-front class=\"white-bg\"><input type=\"text\" ng-model=\"vm.searchaggrid\" ng-change=\"vm.searchGrid()\" \nplaceholder=\"Type to Search\" style=\"padding: 10px\"></ms-widget-front></ms-widget></div><div layout=\"row\" \nlayout-align=\"space-between center\"><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"25\"><ms-widget-front \nclass=\"white-bg\"><form ng-submit=\"$event.preventDefault()\"><md-autocomplete ng-disabled=\"vm.zoneFilter.isDisabled\" \nmd-no-cache=\"vm.zoneFilter.noCache\" md-selected-item=\"vm.zoneFilter.selectedZone\" \nmd-search-text-change=\"vm.zoneFilter.searchTextChange(vm.zoneFilter.searchText)\" \nmd-search-text=\"vm.zoneFilter.searchText\" md-selected-item-change=\"vm.zoneFilter.selectedZoneChange(zone)\" \nmd-items=\"zone in vm.zoneFilter.querySearch(vm.zoneFilter.searchText)\" md-item-text=\"zone.name\" md-min-length=\"0\" \nplaceholder=\"Filter by Zone\"><md-item-template><span md-highlight-text=\"vm.zoneFilter.searchText\" \nmd-highlight-flags=\"^i\">{{zone.name}}</span></md-item-template><md-not-found>\nNo Zones matching \"{{vm.zoneFilter.searchText}}\" were found. <a \nng-click=\"vm.zoneFilter.resetZones(vm.zoneFilter.searchText)\">Take All Zones</a></md-not-found></md-autocomplete>\n</form></ms-widget-front></ms-widget><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"25\"><ms-widget-front \nclass=\"white-bg\"><form ng-submit=\"$event.preventDefault()\"><md-autocomplete ng-disabled=\"vm.empcodeFilter.isDisabled\" \nmd-no-cache=\"vm.empcodeFilter.noCache\" md-selected-item=\"vm.empcodeFilter.selectedEmployee\" \nmd-search-text-change=\"vm.empcodeFilter.searchTextChange(vm.empcodeFilter.searchText)\" \nmd-search-text=\"vm.empcodeFilter.searchText\" \nmd-selected-item-change=\"vm.empcodeFilter.selectedEmployeeChange(employee)\" \nmd-items=\"employee in vm.empcodeFilter.querySearch(vm.empcodeFilter.searchText)\" \nmd-item-text=\"employee.identification_id\" md-min-length=\"0\" placeholder=\"Filter by Emp Code\"><md-item-template><span \nmd-highlight-text=\"vm.empcodeFilter.searchText\" md-highlight-flags=\"^i\">{{employee.identification_id}}</span>\n</md-item-template><md-not-found>No Emp matching \"{{vm.empcodeFilter.searchText}}\" were found. <a \nng-click=\"vm.empcodeFilter.resetEmployees(vm.empcodeFilter.searchText)\">Take All Emps</a></md-not-found>\n</md-autocomplete></form></ms-widget-front></ms-widget><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"25\">\n<ms-widget-front class=\"white-bg\"><form ng-submit=\"$event.preventDefault()\"><md-autocomplete \nng-disabled=\"vm.SalesmanFilter.isDisabled\" md-no-cache=\"vm.SalesmanFilter.noCache\" \nmd-selected-item=\"vm.SalesmanFilter.selectedUser\" \nmd-search-text-change=\"vm.SalesmanFilter.searchTextChange(vm.SalesmanFilter.searchText)\" \nmd-search-text=\"vm.SalesmanFilter.searchText\" md-selected-item-change=\"vm.SalesmanFilter.selectedUserChange(user)\" \nmd-items=\"user in vm.SalesmanFilter.querySearch(vm.SalesmanFilter.searchText)\" md-item-text=\"user.name\" \nmd-min-length=\"0\" placeholder=\"Filter by Saleman\"><md-item-template><span \nmd-highlight-text=\"vm.SalesmanFilter.searchText\" md-highlight-flags=\"^i\">{{user.name}}</span></md-item-template>\n<md-not-found>No Salesman matching \"{{vm.SalesmanFilter.searchText}}\" were found. <a \nng-click=\"vm.SalesmanFilter.resetUsers(vm.SalesmanFilter.searchText)\">Take All Salesman</a></md-not-found>\n</md-autocomplete></form></ms-widget-front></ms-widget><md-button class=\"md-raised md-accent\" \nng-click=\"vm.zerosales.loadData()\">Filter</md-button><md-button id=\"\" ng-disabled=\"!vm.zerosales.loaded\" \nng-click=\"vm.exportAsCsv(\'Zero Sales Data\')\" class=\"add-file-button md-fab md-deep-purple-400-bg md-mini fab-rounded\">\n<md-tooltip md-direction=\"bottom\">Export As Csv</md-tooltip><md-icon \nmd-font-icon=\"icon-arrow-down-bold-circle-outline\"></md-icon></md-button></div><div ng-show=\"!vm.zerosales.loaded\"><div\n class=\"h-240\" layout=\"column\" layout-sm=\"column\" layout-align=\"center center\"><md-progress-circular \nmd-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular>Loading</div></div><div ng-if=\"vm.loadZsalesGrid\" \nag-grid=\"vm.gridOptions\" class=\"ag-theme-material\" style=\"height: 600px\"></div><div layout=\"row\"><ms-widget \nlayout=\"column\" flex=\"100\" flex-gt-sm=\"50\"><ms-widget-front class=\"white-bg\"><div class=\"ph-16 border-bottom\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">{{vm.zerosales1.widget2.title}}</div><div \nclass=\"pv-16\"></div></div><div class=\"p-16\"><nvd3 class=\"h-400\" config=\"vm.zerosales1.widget2.mainChart.config\" \noptions=\"vm.zerosales1.widget2.mainChart.options\" data=\"vm.zerosales1.widget2.mainChart.data\"></nvd3></div>\n</ms-widget-front></ms-widget><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"50\"><ms-widget-front class=\"white-bg\">\n<div class=\"ph-16 border-bottom\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">\n{{vm.zerosales2.widget2.title}}</div><div class=\"pv-16\"></div></div><div class=\"p-16\"><nvd3 class=\"h-400\" \nconfig=\"vm.zerosales2.widget2.mainChart.config\" options=\"vm.zerosales2.widget2.mainChart.options\" \ndata=\"vm.zerosales2.widget2.mainChart.data\"></nvd3></div></ms-widget-front></ms-widget></div></md-content>");
$templateCache.put("app/main/devicedetails/tabs/clean/clean.html","<div id=\"reset-password\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"reset-password-form-wrapper\" \nlayout=\"column\" layout-align=\"center center\"><div id=\"reset-password-form\" class=\"md-whiteframe-8dp\"><div \nclass=\"title\">Device Clean</div><form name=\"requestForm\" novalidate ng-cloak ng-submit=\"vm.requestFundLoadByUser()\">\n<md-input-container class=\"md-block\"><label>Device ID</label><input type=\"text\" name=\"amount\" \nng-model=\"vm.requestForm.deviceid\"></md-input-container><md-button type=\"submit\" \nclass=\"md-raised md-accent submit-button\" aria-label=\"Request\" \nng-disabled=\"requestForm.$invalid || requestForm.$pristine\">Clean</md-button></form></div></div></div>");
$templateCache.put("app/main/devicedetails/tabs/fcm/fcm.html","<div id=\"reset-password\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"reset-password-form-wrapper\" \nlayout=\"column\" layout-align=\"center center\"><div id=\"reset-password-form\" class=\"md-whiteframe-8dp\"><div \nclass=\"title\">Push Notification</div><form name=\"requestForm\" novalidate ng-cloak ng-submit=\"vm.notification()\">\n<md-input-container class=\"md-block\"><label>IMEI Number</label><input type=\"text\" name=\"amount\" ng-disabled=\"true\" \nng-model=\"vm.requestForm.deviceid\"></md-input-container><md-input-container class=\"md-block\"><label>Message</label>\n<textarea ng-model=\"vm.requestForm.message\" md-maxlength=\"150\" rows=\"3\" md-select-on-focus></textarea>\n</md-input-container><md-button type=\"submit\" class=\"md-raised md-accent submit-button\" aria-label=\"Request\" \nng-disabled=\"requestForm.$invalid || requestForm.$pristine\">Send Notification</md-button></form></div></div></div>");
$templateCache.put("app/main/devicedetails/tabs/loc/loc.html","<ui-gmap-google-map center=\"vm.simpleMarkerMap.center\" zoom=\"vm.simpleMarkerMap.zoom\"><ui-gmap-marker \ncoords=\"vm.simpleMarkerMap.marker.coords\" idkey=\"vm.simpleMarkerMap.marker.id\"></ui-gmap-marker></ui-gmap-google-map>");
$templateCache.put("app/main/devicedetails/tabs/lock/lock.html","<div id=\"reset-password\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"reset-password-form-wrapper\" \nlayout=\"column\" layout-align=\"center center\"><div id=\"reset-password-form\" class=\"md-whiteframe-8dp\"><div \nclass=\"title\">Screen Lock</div><form name=\"requestForm\" novalidate ng-cloak ng-submit=\"vm.requestFundLoadByUser()\">\n<md-input-container class=\"md-block\"><label>Device ID</label><input type=\"text\" name=\"amount\" \nng-model=\"vm.requestForm.deviceid\"></md-input-container><md-button type=\"submit\" \nclass=\"md-raised md-accent submit-button\" aria-label=\"Request\" \nng-disabled=\"requestForm.$invalid || requestForm.$pristine\">Lock</md-button></form></div></div></div>");
$templateCache.put("app/main/devicedetails/tabs/lost/lost.html","<div id=\"reset-password\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"reset-password-form-wrapper\" \nlayout=\"column\" layout-align=\"center center\"><div id=\"reset-password-form\" class=\"md-whiteframe-8dp\"><div \nclass=\"title\">Device Lost</div><form name=\"requestForm\" novalidate ng-cloak ng-submit=\"vm.DeviceLost()\">\n<md-input-container class=\"md-block\"><label>IMEI Number</label><input type=\"text\" name=\"amount\" ng-disabled=\"true\" \nng-model=\"vm.requestForm.deviceid\"></md-input-container><md-button type=\"submit\" \nclass=\"md-raised md-accent submit-button\" aria-label=\"Request\" \nng-disabled=\"requestForm.$invalid || requestForm.$pristine\">Find Device</md-button></form></div></div></div>");
$templateCache.put("app/main/devicemanagement/tabs/clean/clean.html","<div id=\"reset-password\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"reset-password-form-wrapper\" \nlayout=\"column\" layout-align=\"center center\"><div id=\"reset-password-form\" class=\"md-whiteframe-8dp\"><div \nclass=\"title\">Device Clean</div><form name=\"requestForm\" novalidate ng-cloak ng-submit=\"vm.requestFundLoadByUser()\">\n<md-input-container class=\"md-block\"><label>Device ID</label><input type=\"text\" name=\"amount\" \nng-model=\"vm.requestForm.deviceid\"></md-input-container><md-button type=\"submit\" \nclass=\"md-raised md-accent submit-button\" aria-label=\"Request\" \nng-disabled=\"requestForm.$invalid || requestForm.$pristine\">Clean</md-button></form></div></div></div>");
$templateCache.put("app/main/devicemanagement/tabs/fcm/fcm.html","<div id=\"reset-password\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"reset-password-form-wrapper\" \nlayout=\"column\" layout-align=\"center center\"><div id=\"reset-password-form\" class=\"md-whiteframe-8dp\"><div \nclass=\"title\">Push Notification</div><form name=\"requestForm\" novalidate ng-cloak ng-submit=\"vm.notification()\">\n<md-input-container class=\"md-block\"><label>IMEI Number</label><input type=\"text\" name=\"amount\" ng-disabled=\"true\" \nng-model=\"vm.requestForm.deviceid\"></md-input-container><md-input-container class=\"md-block\"><label>Message</label>\n<textarea ng-model=\"vm.requestForm.message\" md-maxlength=\"150\" rows=\"3\" md-select-on-focus></textarea>\n</md-input-container><md-button type=\"submit\" class=\"md-raised md-accent submit-button\" aria-label=\"Request\" \nng-disabled=\"requestForm.$invalid || requestForm.$pristine\">Send Notification</md-button></form></div></div></div>");
$templateCache.put("app/main/devicemanagement/tabs/loc/loc.html","<ui-gmap-google-map center=\"vm.simpleMarkerMap.center\" zoom=\"vm.simpleMarkerMap.zoom\"><ui-gmap-marker \ncoords=\"vm.simpleMarkerMap.marker.coords\" idkey=\"vm.simpleMarkerMap.marker.id\"></ui-gmap-marker></ui-gmap-google-map>");
$templateCache.put("app/main/devicemanagement/tabs/lock/lock.html","<div id=\"reset-password\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"reset-password-form-wrapper\" \nlayout=\"column\" layout-align=\"center center\"><div id=\"reset-password-form\" class=\"md-whiteframe-8dp\"><div \nclass=\"title\">Screen Lock</div><form name=\"requestForm\" novalidate ng-cloak ng-submit=\"vm.requestFundLoadByUser()\">\n<md-input-container class=\"md-block\"><label>Device ID</label><input type=\"text\" name=\"amount\" \nng-model=\"vm.requestForm.deviceid\"></md-input-container><md-button type=\"submit\" \nclass=\"md-raised md-accent submit-button\" aria-label=\"Request\" \nng-disabled=\"requestForm.$invalid || requestForm.$pristine\">Lock</md-button></form></div></div></div>");
$templateCache.put("app/main/devicemanagement/tabs/lost/lost.html","<div id=\"reset-password\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"reset-password-form-wrapper\" \nlayout=\"column\" layout-align=\"center center\"><div id=\"reset-password-form\" class=\"md-whiteframe-8dp\"><div \nclass=\"title\">Device Lost</div><form name=\"requestForm\" novalidate ng-cloak ng-submit=\"vm.DeviceLost()\">\n<md-input-container class=\"md-block\"><label>IMEI Number</label><input type=\"text\" name=\"amount\" ng-disabled=\"true\" \nng-model=\"vm.requestForm.deviceid\"></md-input-container><md-button type=\"submit\" \nclass=\"md-raised md-accent submit-button\" aria-label=\"Request\" \nng-disabled=\"requestForm.$invalid || requestForm.$pristine\">Find Device</md-button></form></div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-1/template-1.html","<div class=\"template-1\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-10/template-10.html","<div class=\"template-10 p-16\"><div class=\"pb-16\" layout=\"row\" layout-align=\"space-between center\"><div class=\"info\">\n<div class=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle h2\" \nng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"media ml-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div><div \nclass=\"text\">{{card.text}}</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-2/template-2.html","<div class=\"template-2\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"text p-16\" ng-if=\"card.text\">{{card.text}}\n</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-3/template-3.html","<div class=\"template-3 p-16 teal-bg white-fg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" \nlayout-align=\"space-between\"><div class=\"info\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}</div><div \nclass=\"subtitle h3 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"cta\"><md-button \nclass=\"m-0\">{{card.cta}}</md-button></div></div><div class=\"media pl-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-4/template-4.html","<div class=\"template-4\"><div class=\"info white-fg ph-16 pv-24\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"text\" ng-if=\"card.text\">{{card.text}}</div></div><div class=\"media\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-5/template-5.html","<div class=\"template-5 p-16\" layout=\"row\" layout-align=\"space-between start\"><div class=\"info\"><div \nclass=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"event h2\" ng-if=\"card.event\">\n{{card.event}}</div></div><div class=\"media ml-16\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-6/template-6.html","<div class=\"template-6\"><div class=\"content pv-24 ph-16\"><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div><div class=\"title h2\" ng-if=\"card.title\">{{card.title}}</div><div class=\"text pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-7/template-7.html","<div class=\"template-7\" layout=\"row\" layout-align=\"space-between\"><div class=\"info\" layout=\"column\" \nlayout-align=\"space-between\" layout-fill flex><div class=\"p-16\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"subtitle h4 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div><div class=\"text h4 pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div><div><md-divider></md-divider><div class=\"p-8\" layout=\"row\"><md-icon \nmd-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\">\n</md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" \nclass=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon></div></div></div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-8/template-8.html","<div class=\"template-8\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"buttons pt-16\"><md-button class=\"m-0\">{{card.button1}}</md-button><md-button class=\"m-0 md-accent\">\n{{card.button2}}</md-button></div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-9/template-9.html","<div class=\"template-9\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"text ph-16 pb-16\" ng-if=\"card.text\">{{card.text}}</div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div><div class=\"buttons m-8\"><md-button class=\"md-icon-button mr-16\" \naria-label=\"Favorite\"><md-icon md-font-icon=\"icon-heart-outline\" class=\"s24\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" aria-label=\"Share\"><md-icon md-font-icon=\"icon-share\" class=\"s24\"></md-icon></md-button></div>\n</div>");
$templateCache.put("app/core/directives/ms-stepper/templates/horizontal/horizontal.html","<div class=\"ms-stepper-horizontal\"><div class=\"ms-stepper-navigation-wrapper\"><div class=\"ms-stepper-navigation\" \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(step.stepNumber), \'valid\': MsStepper.isStepValid(step.stepNumber), \'disabled\': MsStepper.isStepDisabled(step.stepNumber), \'optional\': MsStepper.isStepOptional(step.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(step.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(step.stepNumber)\" \nng-repeat=\"step in MsStepper.steps | filter:MsStepper.filterHiddenStep\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"step md-accent-bg\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(step.stepNumber) || MsStepper.isStepOptional(step.stepNumber)\">{{$index + 1}} </span>\n<span ng-if=\"MsStepper.isStepValid(step.stepNumber) && !MsStepper.isStepOptional(step.stepNumber)\"><i \nclass=\"icon icon-check s18\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div class=\"title\" \ntranslate=\"{{step.stepTitleTranslate}}\">{{step.stepTitle}}</div><div class=\"subtitle\" \nng-if=\"MsStepper.isStepOptional(step.stepNumber)\">Optional</div></div></md-button></div></div><div \nclass=\"ms-stepper-steps\" ng-transclude></div><div class=\"ms-stepper-controls\" layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" \nng-click=\"MsStepper.gotoPreviousStep()\">Back</md-button><div class=\"ms-stepper-dots\"><span \nng-repeat=\"step in MsStepper.steps\" ng-hide=\"MsStepper.isStepHidden(step.stepNumber)\" \nng-class=\"{\'selected md-accent-bg\':MsStepper.currentStepNumber === $index + 1}\"></span></div><md-button \nclass=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/vertical.html","<div class=\"ms-stepper-vertical\"><div class=\"ms-stepper-vertical-line\"></div><div class=\"ms-stepper-steps\" \nng-transclude></div></div>");
$templateCache.put("app/main/pages/profile/tabs/about/about.html","<div layout=\"row\" layout-wrap><div class=\"about\" layout=\"column\" flex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"100\"><div \nclass=\"profile-box info-box work md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\"><div class=\"title\">\nAccout Information</div></header><div class=\"content\"><div class=\"info-line\"><div class=\"title\">User Name</div><div \nclass=\"info\">{{vm.about.username}}</div></div><div class=\"info-line\"><div class=\"title\">Status</div><div class=\"info\">\n{{vm.about.status}}</div></div><div class=\"info-line\"><div class=\"title\">Created On</div><div class=\"info\">\n{{vm.about.createdAt}}</div></div><div class=\"info-line\"><div class=\"title\">kycApproved</div><div class=\"info\">\n{{vm.about.kycApproved}}</div></div></div></div><div class=\"profile-box info-box general md-whiteframe-1dp\" \nlayout=\"column\"><header class=\"md-accent-bg\"><div class=\"title\" translate=\"PROFILE.GENERAL_INFORMATION\">\nGeneral Information</div></header><div class=\"content\"><div class=\"info-line\"><div class=\"title\">Customer Name</div>\n<div class=\"info\">{{vm.about.customername}}</div></div><div class=\"info-line\"><div class=\"title\">Organization Name\n</div><div class=\"info\">{{vm.about.organizationname}}</div></div><div class=\"info-line\"><div class=\"title\">PAN No.\n</div><div class=\"info\">{{vm.about.panno}}</div></div></div></div><div \nclass=\"profile-box info-box contact md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\"><div class=\"title\" \ntranslate=\"PROFILE.CONTACT\">Contact</div></header><div class=\"content\"><div class=\"info-line\"><div class=\"title\" \ntranslate=\"PROFILE.ADDRESS\">Address</div><div class=\"info\">{{vm.about.organizationaddress}}</div></div><div \nclass=\"info-line\"><div class=\"title\">City</div><div class=\"info\">{{vm.about.city}}</div></div><div class=\"info-line\">\n<div class=\"title\">State</div><div class=\"info\">{{vm.about.state}}</div></div><div class=\"info-line\"><div \nclass=\"title\">Email</div><div class=\"info\">{{vm.about.email}}</div></div><div class=\"info-line\"><div class=\"title\">\nContact No</div><div class=\"info\">{{vm.about.contactno}}</div></div></div></div></div></div>");
$templateCache.put("app/main/pages/search/tabs/classic/classic.html","<div class=\"result-info\" layout=\"row\" layout-align=\"space-between center\" layout-xs=\"column\" \nlayout-align-xs=\"start start\"><span class=\"result-count h3 secondary-text\"><span>54</span> <span \ntranslate=\"SEARCH.RESULTS\">Results</span></span><div class=\"pager\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"secondary-text\"><span translate=\"SEARCH.RESULTS\">Results</span> <span>:</span> </span><span class=\"page-info\">\n<span>1</span> <span>-</span> <span>10</span> <span translate=\"SEARCH.OF\">of</span> <span>100</span></span><md-button \nclass=\"md-icon-button\" aria-label=\"previous page\" translate translate-attr-aria-label=\"SEARCH.PREVIOUS_PAGE\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon></md-button><md-button class=\"md-icon-button\" aria-label=\"next page\" \ntranslate translate-attr-aria-label=\"SEARCH.NEXT_PAGE\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon>\n</md-button></div></div><div class=\"results\"><div class=\"result-item\" ng-repeat=\"item in vm.classic\"><div \nclass=\"title\">{{item.title}}</div><div class=\"url\">{{item.url}}</div><div class=\"excerpt\">{{item.excerpt}}</div></div>\n</div><div class=\"simple-pagination\"><md-button class=\"pagination-item disabled\" md-no-ink ng-href=\"#\" \naria-label=\"Go to previous page\" translate translate-attr-aria-label=\"SEARCH.GO_TO_PREVIOUS\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon></md-button><md-button class=\"pagination-item active\" md-no-ink ng-href=\"#\" \naria-label=\"Go to page 1\"><span>1</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 2\" hide-xs><span>2</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 3\" hide-xs><span>3</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 4\" hide-xs><span>4</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 5\" hide-xs><span>5</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 6\" hide-xs><span>6</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 7\" hide-xs><span>7</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 8\" hide-xs><span>8</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 9\" hide-xs><span>9</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 10\" hide-xs><span>10</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to next page\" translate translate-attr-aria-label=\"SEARCH.GO_TO_NEXT\"><md-icon \nmd-font-icon=\"icon-chevron-right\"></md-icon></md-button></div>");
$templateCache.put("app/main/pages/search/tabs/contacts/contacts.html","<div class=\"result-info\" layout=\"row\" layout-align=\"space-between center\" layout-xs=\"column\" \nlayout-align-xs=\"start start\"><div><span class=\"md-title\" translate=\"SEARCH.CONTACTS\">Contacts</span> <span \nclass=\"secondary-text\"><span>13</span> <span translate=\"SEARCH.RESULTS\">Results</span></span></div><div class=\"pager\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"secondary-text\"><span translate=\"SEARCH.RESULTS\">Results</span> \n<span>:</span> </span><span class=\"page-info\"><span>1</span> <span>-</span> <span>10</span> <span \ntranslate=\"SEARCH.OF\">of</span> <span>100</span></span><md-button class=\"md-icon-button\" aria-label=\"previous page\" \ntranslate translate-attr-aria-label=\"SEARCH.PREVIOUS_PAGE\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon>\n</md-button><md-button class=\"md-icon-button\" aria-label=\"next page\" translate \ntranslate-attr-aria-label=\"SEARCH.NEXT_PAGE\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button></div>\n</div><table class=\"results simple clickable\" ms-responsive-table><thead><tr><th></th><th translate=\"SEARCH.NAME\">Name\n</th><th translate=\"SEARCH.POSITION\">Position</th><th translate=\"SEARCH.PHONE\">Phone</th><th translate=\"SEARCH.EMAIL\">\nEmail</th></tr></thead><tbody><tr class=\"result-item\" ng-repeat=\"contact in vm.contacts\"><td \nclass=\"text-left avatar-cell\" ng-if=\"contact.avatar\"><img class=\"avatar\" alt=\"{{contact.name}}\" \nng-src=\"{{contact.avatar}}\"></td><td class=\"text-left avatar-cell\" ng-if=\"!contact.avatar\"><div class=\"avatar\" \nms-random-class=\"vm.colors\">{{contact.name[0]}}</div></td><td class=\"name\">{{contact.name}}</td><td class=\"position\">\n{{contact.position}}</td><td class=\"phone\">{{contact.phone}}</td><td class=\"email\">{{contact.email}}</td></tr></tbody>\n</table><div class=\"simple-pagination\"><md-button class=\"pagination-item disabled\" md-no-ink ng-href=\"#\" \naria-label=\"Go to previous page\" translate translate-attr-aria-label=\"SEARCH.GO_TO_PREVIOUS\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon></md-button><md-button class=\"pagination-item active\" md-no-ink ng-href=\"#\" \naria-label=\"Go to page 1\"><span>1</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 2\" hide-xs><span>2</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 3\" hide-xs><span>3</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 4\" hide-xs><span>4</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 5\" hide-xs><span>5</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 6\" hide-xs><span>6</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 7\" hide-xs><span>7</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 8\" hide-xs><span>8</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 9\" hide-xs><span>9</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 10\" hide-xs><span>10</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to next page\" translate translate-attr-aria-label=\"SEARCH.GO_TO_NEXT\"><md-icon \nmd-font-icon=\"icon-chevron-right\"></md-icon></md-button></div>");
$templateCache.put("app/main/pages/search/tabs/emails/emails.html","<div class=\"result-info\" layout=\"row\" layout-align=\"space-between center\" layout-xs=\"column\" \nlayout-align-xs=\"start start\"><div><span class=\"md-title\" translate=\"SEARCH.EMAILS\">E-Mails</span> <span \nclass=\"secondary-text\"><span>87</span> <span translate=\"SEARCH.RESULTS\">Results</span></span></div><div class=\"pager\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"secondary-text\"><span translate=\"SEARCH.RESULTS\">Results</span> \n<span>:</span> </span><span class=\"page-info\"><span>1</span> <span>-</span> <span>10</span> <span \ntranslate=\"SEARCH.OF\">of</span> <span>100</span></span><md-button class=\"md-icon-button\" aria-label=\"previous page\" \ntranslate translate-attr-aria-label=\"SEARCH.PREVIOUS_PAGE\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon>\n</md-button><md-button class=\"md-icon-button\" aria-label=\"next page\" translate \ntranslate-attr-aria-label=\"SEARCH.NEXT_PAGE\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button></div>\n</div><div class=\"results\"><div class=\"result-item {{mail.status}}\" ng-repeat=\"mail in vm.mails | filter: vm.search\" \nmd-ink-ripple><div layout=\"row\" layout-align=\"start center\"><img class=\"avatar\" ng-if=\"mail.from.avatar\" \nalt=\"{{mail.from.name}}\" ng-src=\"{{mail.from.avatar}}\"><div class=\"avatar\" ng-if=\"!mail.from.avatar\" \nms-random-class=\"vm.colors\">{{mail.from.name[0]}}</div><div class=\"info\" flex layout=\"column\"><div \nclass=\"name text-truncate\">{{mail.from.name}}</div><div class=\"subject secondary-text text-truncate\">{{mail.subject}}\n</div><div class=\"message secondary-text text-truncate\">{{mail.message | htmlToPlaintext}}</div></div><div \nlayout=\"column\" layout-align=\"center end\"><div class=\"time secondary-text\">{{mail.time}}</div></div></div></div></div>\n<div class=\"simple-pagination\"><md-button class=\"pagination-item disabled\" md-no-ink ng-href=\"#\" \naria-label=\"Go to previous page\" translate translate-attr-aria-label=\"SEARCH.GO_TO_PREVIOUS\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon></md-button><md-button class=\"pagination-item active\" md-no-ink ng-href=\"#\" \naria-label=\"Go to page 1\"><span>1</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 2\" hide-xs><span>2</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 3\" hide-xs><span>3</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 4\" hide-xs><span>4</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 5\" hide-xs><span>5</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 6\" hide-xs><span>6</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 7\" hide-xs><span>7</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 8\" hide-xs><span>8</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 9\" hide-xs><span>9</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 10\" hide-xs><span>10</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to next page\" translate translate-attr-aria-label=\"SEARCH.GO_TO_NEXT\"><md-icon \nmd-font-icon=\"icon-chevron-right\"></md-icon></md-button></div>");
$templateCache.put("app/main/pages/search/tabs/users/users.html","<div class=\"result-info\" layout=\"row\" layout-align=\"space-between center\" layout-xs=\"column\" \nlayout-align-xs=\"start start\"><div><span class=\"md-title\" translate=\"SEARCH.USERS\">Users</span> <span \nclass=\"secondary-text\"><span>87</span> <span translate=\"SEARCH.RESULTS\">Results</span></span></div><div class=\"pager\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"secondary-text\"><span translate=\"SEARCH.RESULTS\">Results</span> \n<span>:</span> </span><span class=\"page-info\"><span>1</span> <span>-</span> <span>10</span> <span \ntranslate=\"SEARCH.OF\">of</span> <span>100</span></span><md-button class=\"md-icon-button\" aria-label=\"previous page\" \ntranslate translate-attr-aria-label=\"SEARCH.PREVIOUS_PAGE\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon>\n</md-button><md-button class=\"md-icon-button\" aria-label=\"next page\" translate \ntranslate-attr-aria-label=\"SEARCH.NEXT_PAGE\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button></div>\n</div><table class=\"results simple clickable\" ms-responsive-table><thead><tr><th translate=\"SEARCH.NAME\">Name</th><th \ntranslate=\"SEARCH.POSITION\">Position</th><th translate=\"SEARCH.OFFICE\">Office</th><th class=\"text-right\" \ntranslate=\"SEARCH.AGE\">Age</th><th class=\"text-right\" translate=\"SEARCH.START_DATE\">Start Date</th><th \nclass=\"text-right\" translate=\"SEARCH.SALARY\">Salary</th><th class=\"text-left\" translate=\"SEARCH.EMAIL\">Email</th></tr>\n</thead><tbody><tr class=\"result-item user\" ng-repeat=\"user in vm.users\"><td class=\"name\">{{user.name}}</td><td \nclass=\"position\">{{user.position}}</td><td class=\"office\">{{user.office}}</td><td class=\"age text-right\">{{user.age}}\n</td><td class=\"start-date text-right\">{{user.startDate}}</td><td class=\"salary text-right\">{{user.salary | currency}}\n</td><td class=\"email text-left\">{{user.email}}</td></tr></tbody></table><div class=\"simple-pagination\"><md-button \nclass=\"pagination-item disabled\" md-no-ink ng-href=\"#\" aria-label=\"Go to previous page\" translate \ntranslate-attr-aria-label=\"SEARCH.GO_TO_PREVIOUS\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon></md-button>\n<md-button class=\"pagination-item active\" md-no-ink ng-href=\"#\" aria-label=\"Go to page 1\"><span>1</span></md-button>\n<md-button class=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 2\" hide-xs><span>2</span></md-button><md-button \nclass=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 3\" hide-xs><span>3</span></md-button><md-button \nclass=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 4\" hide-xs><span>4</span></md-button><md-button \nclass=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 5\" hide-xs><span>5</span></md-button><md-button \nclass=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 6\" hide-xs><span>6</span></md-button><md-button \nclass=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 7\" hide-xs><span>7</span></md-button><md-button \nclass=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 8\" hide-xs><span>8</span></md-button><md-button \nclass=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 9\" hide-xs><span>9</span></md-button><md-button \nclass=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 10\" hide-xs><span>10</span></md-button><md-button \nclass=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to next page\" translate \ntranslate-attr-aria-label=\"SEARCH.GO_TO_NEXT\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html","<md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(stepInfo.stepNumber), \'valid\': MsStepper.isStepValid(stepInfo.stepNumber), \'disabled\': MsStepper.isStepDisabled(stepInfo.stepNumber), \'optional\': MsStepper.isStepOptional(stepInfo.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(stepInfo.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(stepInfo.stepNumber)\" \nng-hide=\"MsStepper.isStepHidden(stepInfo.stepNumber)\" aria-label=\"Stepper navigation button\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"step\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(stepInfo.stepNumber) || MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-checkbox-blank-circle-outline s18 md-accent-fg\"></i> </span><span \nng-if=\"MsStepper.isStepValid(stepInfo.stepNumber) && !MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-check-circle s18 md-accent-fg\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"title\" ng-if=\"stepInfo.stepTitleTranslate\">{{stepInfo.stepTitleTranslate | translate }}</div><div class=\"title\" \nng-if=\"!stepInfo.stepTitleTranslate\">{{stepInfo.stepTitle}}</div><div class=\"subtitle\" \nng-if=\"MsStepper.isStepOptional(stepInfo.stepNumber)\">Optional</div></div></md-button><div \nclass=\"ms-stepper-step-content\" ng-transclude></div><div class=\"ms-stepper-controls\" layout=\"row\" \nlayout-align=\"start center\" ng-show=\"MsStepper.isStepCurrent(stepInfo.stepNumber)\"><md-button \nclass=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" ng-click=\"MsStepper.gotoPreviousStep()\">Back\n</md-button><md-button class=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div>");}]);